/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(7);
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(13);
	
	__webpack_require__(17);
	
	__webpack_require__(18);

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _elements = __webpack_require__(4);
	
	var _inViewport = __webpack_require__(5);
	
	var _inViewport2 = _interopRequireDefault(_inViewport);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debouncedCancelMoveNav = (0, _lodash.debounce)(cancelMoveNav, 500);
	
	var lastScrollTop = 0;
	var scrolling = void 0;
	
	startAnimation();
	_windowDimensions2.default.onResize(moveNav);
	_windowDimensions2.default.onResize(setFixedInnerHeight);
	
	function onScroll() {
	    debouncedCancelMoveNav();
	
	    if (scrolling) {
	        return;
	    }
	
	    scrolling = true;
	    startAnimation();
	}
	
	function startAnimation() {
	    window.requestAnimationFrame(onTick);
	}
	
	function onTick() {
	    var scrollTop = window.pageYOffset;
	    scrollTop = scrollTop < 0 ? 0 : scrollTop;
	
	    if (scrollTop !== lastScrollTop) {
	        lastScrollTop = scrollTop;
	        moveNav();
	    }
	
	    if (!scrolling) {
	        return;
	    }
	
	    window.requestAnimationFrame(onTick);
	}
	
	function moveNav() {
	    var visible = (0, _inViewport2.default)(_elements.articles, lastScrollTop, _windowDimensions2.default.height);
	
	    (0, _lodash.forEach)(_elements.articles, function (article) {
	        var isVisible = visible.indexOf(article) !== -1,
	            offset = article.offset - lastScrollTop,
	            height = _windowDimensions2.default.height - offset,
	            clipped = offset > 0;
	
	        var css = {
	            visibility: isVisible ? 'visible' : 'hidden',
	            height: clipped ? height + 'px' : '',
	            top: clipped ? 'auto' : ''
	        };
	
	        applyCss(article, css);
	    });
	}
	
	function cancelMoveNav() {
	    scrolling = false;
	}
	
	function applyCss(article, css) {
	    if ((0, _lodash.isEqual)(article.css, css)) {
	        return;
	    }
	
	    article.css = css;
	
	    (0, _lodash.forEach)(css, function (value, property) {
	        article.fixed.style[property] = value;
	    });
	}
	
	function setFixedInnerHeight() {
	    (0, _lodash.forEach)(_elements.articles, function (article) {
	        article.fixed.children[0].style.height = _windowDimensions2.default.height + 'px';
	    });
	}
	
	window.addEventListener('scroll', onScroll);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)(module), (function() { return this; }())))

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reCalc = exports.backgrounds = exports.images = exports.articles = undefined;
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var articles = _lodash2.default.map(document.getElementsByTagName('article'), buildArticlesObject);
	var images = _lodash2.default.map(document.getElementsByClassName('image'), buildImageObject);
	var backgrounds = _lodash2.default.compact(_lodash2.default.map(articles, buildBackgroundObject));
	
	window.addEventListener('load', updateOffsets);
	window.addEventListener('resize', _lodash2.default.debounce(updateOffsets, 20));
	document.addEventListener('typekitLoaded', updateOffsets);
	
	exports.articles = articles;
	exports.images = images;
	exports.backgrounds = backgrounds;
	exports.reCalc = updateOffsets;
	
	
	function buildArticlesObject($article) {
	    return {
	        el: $article,
	        fixed: $article.getElementsByClassName('fixed')[0]
	    };
	}
	
	function buildImageObject($image) {
	    return {
	        el: $image,
	        path: $image.getAttribute('data-src')
	    };
	}
	
	function buildBackgroundObject(article) {
	    var $el = article.el.getElementsByClassName('fixed-inner')[0];
	    var imageObject = _lodash2.default.assign({
	        article: article,
	        background: true
	    }, buildImageObject($el));
	    return imageObject.path && imageObject;
	}
	
	function updateOffsets() {
	    updateArticlesOffsets();
	    updateImagesOffsets();
	    updateBackgroundOffsets();
	}
	
	function updateArticlesOffsets() {
	    _lodash2.default.forEach(articles, function (article) {
	        article.offset = article.el.offsetTop;
	    });
	}
	
	function updateImagesOffsets() {
	    _lodash2.default.forEach(images, function (image) {
	        image.hidden = !image.el.offsetParent;
	        image.offset = image.el.offsetParent && image.el.offsetParent.offsetTop + image.el.offsetTop;
	    });
	}
	
	function updateBackgroundOffsets() {
	    _lodash2.default.forEach(backgrounds, function (background) {
	        background.offset = background.article.offset;
	    });
	}

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (elements, scrollPos, offset) {
	    var inViewport = [];
	
	    for (var i = elements.length - 1; i >= 0; i--) {
	        if (!elements[i].hidden) {
	            if (elements[i].offset < scrollPos) {
	                inViewport.push(elements[i]);
	                break;
	            }
	
	            if (elements[i].offset < scrollPos + offset) {
	                inViewport.push(elements[i]);
	            }
	        }
	    }
	
	    return inViewport;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(2);
	
	var _elements = __webpack_require__(4);
	
	var callbacks = [];
	
	var win = {
	    width: window.innerWidth,
	    height: window.innerHeight,
	    onResize: function onResize(callback) {
	        callbacks.push(callback);
	    },
	    reflow: resizeHandler
	};
	
	exports.default = win;
	
	
	window.addEventListener('resize', resizeHandler);
	
	function resizeHandler(event) {
	    win.width = window.innerWidth;
	    win.height = window.innerHeight;
	    (0, _elements.reCalc)();
	    (0, _lodash.forEach)(callbacks, function (callback) {
	        callback(event);
	    });
	}

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// init
	
	setLanguage(window.localStorage.getItem('language') || (window.navigator.language.indexOf('de') !== -1 ? 'de' : 'en'));
	
	(0, _lodash.forEach)(document.getElementsByClassName('language-switch'), addListeners);
	
	function setLanguage(language) {
	    document.documentElement.setAttribute('lang', language);
	    window.localStorage.setItem('language', language);
	    _windowDimensions2.default.reflow();
	}
	
	function addListeners(element) {
	    element.addEventListener('click', function (event) {
	        setLanguage(event.target.getAttribute('data-lang'));
	    });
	}

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _elements = __webpack_require__(4);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	var _inViewport = __webpack_require__(5);
	
	var _inViewport2 = _interopRequireDefault(_inViewport);
	
	var _loadImage = __webpack_require__(9);
	
	var _loadImage2 = _interopRequireDefault(_loadImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_windowDimensions2.default.onResize(setPicSrc);
	window.addEventListener('scroll', setPicSrc);
	setPicSrc();
	
	function setPicSrc() {
	    _lodash2.default.forEach((0, _inViewport2.default)(_elements.backgrounds, window.pageYOffset, _windowDimensions2.default.height * 4), _loadImage2.default);
	    _lodash2.default.forEach((0, _inViewport2.default)(_elements.images, window.pageYOffset, _windowDimensions2.default.height * 2), _loadImage2.default);
	}

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (image) {
	    var url = (0, _getImageUrl2.default)(image);
	
	    if (url === image.url) {
	        return;
	    }
	
	    image.url = url;
	
	    var loadIndicator = document.createElement('img');
	    loadIndicator.addEventListener('load', setSrc);
	    loadIndicator.src = url;
	    image.el.classList.add('is-loading');
	
	    function setSrc() {
	        image.el.style.backgroundImage = 'url(' + url + ')';
	        image.el.classList.remove('is-loading');
	        loadIndicator.removeEventListener('load', setSrc);
	    }
	};
	
	var _getImageUrl = __webpack_require__(10);
	
	var _getImageUrl2 = _interopRequireDefault(_getImageUrl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(2);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sizes = [400, 800, 1200, 1600, 2000];
	var breakPoints = [{
	    size: 600,
	    ratio: 1
	}, {
	    size: 900,
	    ratio: 0.75
	}, {
	    ratio: 0.375
	}];
	
	exports.default = getUrl;
	
	
	function getCurrentSize(full) {
	    var width = full ? _windowDimensions2.default.width : getContentWidth() - 40;
	    return (0, _lodash.find)(sizes, function (size) {
	        return width * window.devicePixelRatio < size;
	    }) || (0, _lodash.last)(sizes);
	}
	
	function getUrl(image) {
	    var parts = image.path.split('.');
	    var name = parts[0];
	    var size = image.background ? '' : '-' + getCurrentSize(image.full);
	    var suffix = parts[1] || 'jpg';
	    return name + size + '.' + suffix;
	}
	
	function getContentWidth() {
	    var breakPoint = (0, _lodash.find)(breakPoints, function (point) {
	        return !point.size || point.size > _windowDimensions2.default.width;
	    });
	
	    return _windowDimensions2.default.width * breakPoint.ratio;
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _elements = __webpack_require__(4);
	
	var _loadImage = __webpack_require__(9);
	
	var _loadImage2 = _interopRequireDefault(_loadImage);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	var _touch = __webpack_require__(12);
	
	var _touch2 = _interopRequireDefault(_touch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = _lodash2.default.isUndefined(document.body.style.transform) ? 'webkitTransform' : 'transform';
	
	var $viewer = document.createElement('div');
	var touch = (0, _touch2.default)($viewer);
	
	var current = void 0;
	var gallery = void 0;
	
	$viewer.classList.add('image-view');
	$viewer.addEventListener('click', hideImageViewer);
	document.body.appendChild($viewer);
	
	_windowDimensions2.default.onResize(initImageViewer);
	initImageViewer();
	
	touch.on('move', touchMoveHandler);
	touch.on('end', touchEndHandler);
	
	document.addEventListener('keydown', function (event) {
	    switch (event.keyCode) {
	        case 27:
	            hideImageViewer();
	            break;
	        case 37:
	            goToImage(-1);
	            break;
	        case 39:
	            goToImage(1);
	            break;
	    }
	});
	
	_lodash2.default.forEach(_elements.images, addListener);
	
	function addListener(image) {
	    image.el.addEventListener('click', function () {
	        showImage(_lodash2.default.find(gallery, 'trigger', image.el), image.url);
	        showImageViewer();
	    });
	}
	
	function touchMoveHandler(distance) {
	    $viewer.classList.remove('is-animating');
	
	    setViewerCss(convertToVw(distance));
	}
	
	function touchEndHandler(distance) {
	    $viewer.classList.add('is-animating');
	
	    var vw = convertToVw(distance);
	
	    if (vw > 20) {
	        goToImage(1);
	    } else if (vw < -20) {
	        goToImage(-1);
	    } else {
	        goToImage(0);
	    }
	}
	
	function convertToVw(distance) {
	    return distance / _windowDimensions2.default.width * 100;
	}
	
	function setViewerCss(offset) {
	    var vw = _lodash2.default.findIndex(gallery, current) * -100 - (offset ? offset : 0);
	
	    if (vw > 0 || vw < (gallery.length - 1) * -100) {
	        return;
	    }
	
	    $viewer.style[transform] = 'translateX(' + vw + 'vw)';
	}
	
	function goToImage(offset) {
	    if (!current) {
	        return;
	    }
	
	    var image = gallery[gallery.indexOf(current) + offset];
	
	    if (!image) {
	        return;
	    }
	
	    showImage(image);
	}
	
	function showImage(image, oldUrl) {
	    if (oldUrl) {
	        image.url = oldUrl;
	        image.el.style.backgroundImage = 'url(' + oldUrl + ')';
	    }
	
	    current = image;
	    (0, _loadImage2.default)(image);
	    loadAround(image);
	
	    setViewerCss();
	}
	
	function initImageViewer(event) {
	    if (event) {
	        return;
	    }
	
	    while ($viewer.firstChild) {
	        $viewer.removeChild($viewer.firstChild);
	    }
	
	    gallery = visibleImages().map(function (image) {
	        var newImage = _lodash2.default.clone(image);
	        newImage.trigger = image.el;
	        newImage.el = document.createElement('div');
	        newImage.el.classList.add('image');
	        newImage.full = true;
	        delete newImage.url;
	
	        $viewer.appendChild(newImage.el);
	
	        return newImage;
	    });
	}
	
	function showImageViewer() {
	    $viewer.classList.add('is-active');
	    document.body.classList.add('no-scroll');
	}
	
	function hideImageViewer() {
	    current = null;
	    $viewer.classList.remove('is-active', 'is-animating');
	    document.body.classList.remove('no-scroll');
	}
	
	function visibleImages() {
	    return _elements.images.filter(function (image) {
	        return !image.hidden;
	    });
	}
	
	function loadAround(image) {
	    var index = gallery.indexOf(image);
	
	    if (index === -1) {
	        return;
	    }
	
	    [index - 1, index + 1].forEach(function (i) {
	        if (!gallery[i]) {
	            return;
	        }
	
	        (0, _loadImage2.default)(gallery[i]);
	    });
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(2);
	
	exports.default = touchHandler;
	
	
	function touchHandler(el) {
	    var callbacks = {};
	
	    var currentTouch = void 0;
	    var currentX = void 0;
	
	    el.addEventListener('touchstart', startHandler);
	    el.addEventListener('touchmove', moveHandler);
	    el.addEventListener('touchleave', endHandler);
	    el.addEventListener('touchend', endHandler);
	    el.addEventListener('touchcancel', endHandler);
	
	    function startHandler(event) {
	        if (currentTouch) {
	            return;
	        }
	
	        currentTouch = event.changedTouches[0];
	        currentX = currentTouch.clientX;
	    }
	
	    function moveHandler(event) {
	        event.preventDefault();
	
	        var touch = findTouch(event.touches, currentTouch);
	
	        if (!touch) {
	            return;
	        }
	
	        callback('move', currentX - touch.clientX);
	    }
	
	    function endHandler(event) {
	        var touch = findTouch(event.changedTouches, currentTouch);
	
	        if (!touch) {
	            return;
	        }
	
	        callback('end', currentX - touch.clientX);
	        currentTouch = null;
	    }
	
	    function registerHandler(type, fn) {
	        callbacks[type] = fn;
	    }
	
	    function callback(type, value) {
	        if (callbacks[type]) {
	            callbacks[type](value);
	        }
	    }
	
	    return {
	        on: registerHandler
	    };
	}
	
	function findTouch(touches, touch) {
	    return (0, _lodash.findWhere)(touches, { identifier: touch.identifier });
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _d = __webpack_require__(14);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _topojsonClient = __webpack_require__(15);
	
	var topojson = _interopRequireWildcard(_topojsonClient);
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _elements = __webpack_require__(4);
	
	var _mapProvider = __webpack_require__(16);
	
	var _mapProvider2 = _interopRequireDefault(_mapProvider);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapData = JSON.parse(_mapProvider2.default);
	var subMap = _elements.articles[0].fixed.getElementsByTagName('svg')[1];
	
	var map = {
	    world: mapData.map,
	    svg: _d2.default.select('#map'),
	    $stops: document.getElementsByClassName('stop'),
	    stops: {}
	};
	
	_lodash2.default.assign(map, getSize());
	
	map.projection = _d2.default.geo.mercator().translate([0, 0]).scale(1);
	
	map.path = _d2.default.geo.path().projection(map.projection);
	
	map.svg.append('path').datum(topojson.feature(map.world, map.world.objects.countries)).attr('d', map.path).attr('class', 'country');
	
	map.svg.append('path').datum(topojson.mesh(map.world, map.world.objects.countries, function (a, b) {
	    return a !== b;
	})).attr('d', map.path).attr('class', 'border');
	
	setRoute(mapData.route);
	
	function setRoute(path) {
	    var feature = topojson.feature(path, path.objects.route);
	
	    map.bounds = map.path.bounds(feature);
	
	    map.svg.append('path').datum(feature).attr('d', map.path).attr('class', 'route');
	
	    refreshMap();
	}
	
	window.addEventListener('resize', _lodash2.default.debounce(resize, 500));
	
	function setStop(el) {
	    var id = el.getAttribute('data-for');
	    if (map.stops[id]) {
	        var pos = map.projection(map.stops[id]);
	        el.style.top = pos[1] + 'px';
	        el.style.left = pos[0] + 'px';
	    }
	}
	
	function resize() {
	    _lodash2.default.assign(map, getSize());
	
	    refreshMap();
	}
	
	function getSize() {
	    var rect = subMap.getBoundingClientRect();
	
	    return {
	        width: rect.width,
	        height: rect.height
	    };
	}
	
	function refreshMap() {
	    if (!map.bounds) {
	        return;
	    }
	
	    var b = map.bounds,
	        s = 0.9 / Math.max((b[1][0] - b[0][0]) / map.width, (b[1][1] - b[0][1]) / map.height),
	        t = [(map.width - s * (b[1][0] + b[0][0])) / 2, (map.height - s * (b[1][1] + b[0][1])) / 2];
	
	    map.projection.scale(s).translate(t);
	
	    map.svg.select('.country').attr('d', map.path);
	    map.svg.select('.border').attr('d', map.path);
	    map.svg.select('.route').attr('d', map.path);
	
	    _lodash2.default.forEach(map.$stops, setStop);
	}
	
	_lodash2.default.forEach(_elements.articles, function (article) {
	    var location = article.el.dataset.location.split(',').map(parseFloat);
	    var id = article.el.id;
	    map.stops[id] = location;
	    _lodash2.default.forEach(document.querySelectorAll('[data-for="' + id + '"]'), setStop);
	});

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/topojson/topojson-client v3.1.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.topojson = global.topojson || {}));
	}(this, function (exports) { 'use strict';
	
	function identity(x) {
	  return x;
	}
	
	function transform(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2, n = input.length, output = new Array(n);
	    output[0] = (x0 += input[0]) * kx + dx;
	    output[1] = (y0 += input[1]) * ky + dy;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	}
	
	function bbox(topology) {
	  var t = transform(topology.transform), key,
	      x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
	
	  function bboxPoint(p) {
	    p = t(p);
	    if (p[0] < x0) x0 = p[0];
	    if (p[0] > x1) x1 = p[0];
	    if (p[1] < y0) y0 = p[1];
	    if (p[1] > y1) y1 = p[1];
	  }
	
	  function bboxGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
	      case "Point": bboxPoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
	    }
	  }
	
	  topology.arcs.forEach(function(arc) {
	    var i = -1, n = arc.length, p;
	    while (++i < n) {
	      p = t(arc[i], i);
	      if (p[0] < x0) x0 = p[0];
	      if (p[0] > x1) x1 = p[0];
	      if (p[1] < y0) y0 = p[1];
	      if (p[1] > y1) y1 = p[1];
	    }
	  });
	
	  for (key in topology.objects) {
	    bboxGeometry(topology.objects[key]);
	  }
	
	  return [x0, y0, x1, y1];
	}
	
	function reverse(array, n) {
	  var t, j = array.length, i = j - n;
	  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
	}
	
	function feature(topology, o) {
	  if (typeof o === "string") o = topology.objects[o];
	  return o.type === "GeometryCollection"
	      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature$1(topology, o); })}
	      : feature$1(topology, o);
	}
	
	function feature$1(topology, o) {
	  var id = o.id,
	      bbox = o.bbox,
	      properties = o.properties == null ? {} : o.properties,
	      geometry = object(topology, o);
	  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
	      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
	      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
	}
	
	function object(topology, o) {
	  var transformPoint = transform(topology.transform),
	      arcs = topology.arcs;
	
	  function arc(i, points) {
	    if (points.length) points.pop();
	    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
	      points.push(transformPoint(a[k], k));
	    }
	    if (i < 0) reverse(points, n);
	  }
	
	  function point(p) {
	    return transformPoint(p);
	  }
	
	  function line(arcs) {
	    var points = [];
	    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
	    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
	    return points;
	  }
	
	  function ring(arcs) {
	    var points = line(arcs);
	    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
	    return points;
	  }
	
	  function polygon(arcs) {
	    return arcs.map(ring);
	  }
	
	  function geometry(o) {
	    var type = o.type, coordinates;
	    switch (type) {
	      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
	      case "Point": coordinates = point(o.coordinates); break;
	      case "MultiPoint": coordinates = o.coordinates.map(point); break;
	      case "LineString": coordinates = line(o.arcs); break;
	      case "MultiLineString": coordinates = o.arcs.map(line); break;
	      case "Polygon": coordinates = polygon(o.arcs); break;
	      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
	      default: return null;
	    }
	    return {type: type, coordinates: coordinates};
	  }
	
	  return geometry(o);
	}
	
	function stitch(topology, arcs) {
	  var stitchedArcs = {},
	      fragmentByStart = {},
	      fragmentByEnd = {},
	      fragments = [],
	      emptyIndex = -1;
	
	  // Stitch empty arcs first, since they may be subsumed by other arcs.
	  arcs.forEach(function(i, j) {
	    var arc = topology.arcs[i < 0 ? ~i : i], t;
	    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
	      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
	    }
	  });
	
	  arcs.forEach(function(i) {
	    var e = ends(i),
	        start = e[0],
	        end = e[1],
	        f, g;
	
	    if (f = fragmentByEnd[start]) {
	      delete fragmentByEnd[f.end];
	      f.push(i);
	      f.end = end;
	      if (g = fragmentByStart[end]) {
	        delete fragmentByStart[g.start];
	        var fg = g === f ? f : f.concat(g);
	        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else if (f = fragmentByStart[end]) {
	      delete fragmentByStart[f.start];
	      f.unshift(i);
	      f.start = start;
	      if (g = fragmentByEnd[start]) {
	        delete fragmentByEnd[g.end];
	        var gf = g === f ? f : g.concat(f);
	        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else {
	      f = [i];
	      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
	    }
	  });
	
	  function ends(i) {
	    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
	    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
	    else p1 = arc[arc.length - 1];
	    return i < 0 ? [p1, p0] : [p0, p1];
	  }
	
	  function flush(fragmentByEnd, fragmentByStart) {
	    for (var k in fragmentByEnd) {
	      var f = fragmentByEnd[k];
	      delete fragmentByStart[f.start];
	      delete f.start;
	      delete f.end;
	      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
	      fragments.push(f);
	    }
	  }
	
	  flush(fragmentByEnd, fragmentByStart);
	  flush(fragmentByStart, fragmentByEnd);
	  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });
	
	  return fragments;
	}
	
	function mesh(topology) {
	  return object(topology, meshArcs.apply(this, arguments));
	}
	
	function meshArcs(topology, object, filter) {
	  var arcs, i, n;
	  if (arguments.length > 1) arcs = extractArcs(topology, object, filter);
	  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
	  return {type: "MultiLineString", arcs: stitch(topology, arcs)};
	}
	
	function extractArcs(topology, object, filter) {
	  var arcs = [],
	      geomsByArc = [],
	      geom;
	
	  function extract0(i) {
	    var j = i < 0 ? ~i : i;
	    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
	  }
	
	  function extract1(arcs) {
	    arcs.forEach(extract0);
	  }
	
	  function extract2(arcs) {
	    arcs.forEach(extract1);
	  }
	
	  function extract3(arcs) {
	    arcs.forEach(extract2);
	  }
	
	  function geometry(o) {
	    switch (geom = o, o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "LineString": extract1(o.arcs); break;
	      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
	      case "MultiPolygon": extract3(o.arcs); break;
	    }
	  }
	
	  geometry(object);
	
	  geomsByArc.forEach(filter == null
	      ? function(geoms) { arcs.push(geoms[0].i); }
	      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });
	
	  return arcs;
	}
	
	function planarRingArea(ring) {
	  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
	  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
	  return Math.abs(area); // Note: doubled area!
	}
	
	function merge(topology) {
	  return object(topology, mergeArcs.apply(this, arguments));
	}
	
	function mergeArcs(topology, objects) {
	  var polygonsByArc = {},
	      polygons = [],
	      groups = [];
	
	  objects.forEach(geometry);
	
	  function geometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "Polygon": extract(o.arcs); break;
	      case "MultiPolygon": o.arcs.forEach(extract); break;
	    }
	  }
	
	  function extract(polygon) {
	    polygon.forEach(function(ring) {
	      ring.forEach(function(arc) {
	        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
	      });
	    });
	    polygons.push(polygon);
	  }
	
	  function area(ring) {
	    return planarRingArea(object(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
	  }
	
	  polygons.forEach(function(polygon) {
	    if (!polygon._) {
	      var group = [],
	          neighbors = [polygon];
	      polygon._ = 1;
	      groups.push(group);
	      while (polygon = neighbors.pop()) {
	        group.push(polygon);
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
	              if (!polygon._) {
	                polygon._ = 1;
	                neighbors.push(polygon);
	              }
	            });
	          });
	        });
	      }
	    }
	  });
	
	  polygons.forEach(function(polygon) {
	    delete polygon._;
	  });
	
	  return {
	    type: "MultiPolygon",
	    arcs: groups.map(function(polygons) {
	      var arcs = [], n;
	
	      // Extract the exterior (unique) arcs.
	      polygons.forEach(function(polygon) {
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
	              arcs.push(arc);
	            }
	          });
	        });
	      });
	
	      // Stitch the arcs into one or more rings.
	      arcs = stitch(topology, arcs);
	
	      // If more than one ring is returned,
	      // at most one of these rings can be the exterior;
	      // choose the one with the greatest absolute area.
	      if ((n = arcs.length) > 1) {
	        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
	          if ((ki = area(arcs[i])) > k) {
	            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
	          }
	        }
	      }
	
	      return arcs;
	    }).filter(function(arcs) {
	      return arcs.length > 0;
	    })
	  };
	}
	
	function bisect(a, x) {
	  var lo = 0, hi = a.length;
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	    if (a[mid] < x) lo = mid + 1;
	    else hi = mid;
	  }
	  return lo;
	}
	
	function neighbors(objects) {
	  var indexesByArc = {}, // arc index -> array of object indexes
	      neighbors = objects.map(function() { return []; });
	
	  function line(arcs, i) {
	    arcs.forEach(function(a) {
	      if (a < 0) a = ~a;
	      var o = indexesByArc[a];
	      if (o) o.push(i);
	      else indexesByArc[a] = [i];
	    });
	  }
	
	  function polygon(arcs, i) {
	    arcs.forEach(function(arc) { line(arc, i); });
	  }
	
	  function geometry(o, i) {
	    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
	    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
	  }
	
	  var geometryType = {
	    LineString: line,
	    MultiLineString: polygon,
	    Polygon: polygon,
	    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
	  };
	
	  objects.forEach(geometry);
	
	  for (var i in indexesByArc) {
	    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
	      for (var k = j + 1; k < m; ++k) {
	        var ij = indexes[j], ik = indexes[k], n;
	        if ((n = neighbors[ij])[i = bisect(n, ik)] !== ik) n.splice(i, 0, ik);
	        if ((n = neighbors[ik])[i = bisect(n, ij)] !== ij) n.splice(i, 0, ij);
	      }
	    }
	  }
	
	  return neighbors;
	}
	
	function untransform(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2,
	        n = input.length,
	        output = new Array(n),
	        x1 = Math.round((input[0] - dx) / kx),
	        y1 = Math.round((input[1] - dy) / ky);
	    output[0] = x1 - x0, x0 = x1;
	    output[1] = y1 - y0, y0 = y1;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	}
	
	function quantize(topology, transform) {
	  if (topology.transform) throw new Error("already quantized");
	
	  if (!transform || !transform.scale) {
	    if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be ≥2");
	    box = topology.bbox || bbox(topology);
	    var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
	    transform = {scale: [x1 - x0 ? (x1 - x0) / (n - 1) : 1, y1 - y0 ? (y1 - y0) / (n - 1) : 1], translate: [x0, y0]};
	  } else {
	    box = topology.bbox;
	  }
	
	  var t = untransform(transform), box, key, inputs = topology.objects, outputs = {};
	
	  function quantizePoint(point) {
	    return t(point);
	  }
	
	  function quantizeGeometry(input) {
	    var output;
	    switch (input.type) {
	      case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(quantizeGeometry)}; break;
	      case "Point": output = {type: "Point", coordinates: quantizePoint(input.coordinates)}; break;
	      case "MultiPoint": output = {type: "MultiPoint", coordinates: input.coordinates.map(quantizePoint)}; break;
	      default: return input;
	    }
	    if (input.id != null) output.id = input.id;
	    if (input.bbox != null) output.bbox = input.bbox;
	    if (input.properties != null) output.properties = input.properties;
	    return output;
	  }
	
	  function quantizeArc(input) {
	    var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
	    output[0] = t(input[0], 0);
	    while (++i < n) if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
	    if (j === 1) output[j++] = [0, 0]; // an arc must have at least two points
	    output.length = j;
	    return output;
	  }
	
	  for (key in inputs) outputs[key] = quantizeGeometry(inputs[key]);
	
	  return {
	    type: "Topology",
	    bbox: box,
	    transform: transform,
	    objects: outputs,
	    arcs: topology.arcs.map(quantizeArc)
	  };
	}
	
	exports.bbox = bbox;
	exports.feature = feature;
	exports.merge = merge;
	exports.mergeArcs = mergeArcs;
	exports.mesh = mesh;
	exports.meshArcs = meshArcs;
	exports.neighbors = neighbors;
	exports.quantize = quantize;
	exports.transform = transform;
	exports.untransform = untransform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = "{\"map\":{\"type\":\"Topology\",\"objects\":{\"countries\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"MultiPolygon\",\"arcs\":[[[0,1]],[[2,3]],[[4,5,6,7,8,9,10,11,12,13,14,15,16,17]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[18]],[[19]]]},{\"type\":\"Polygon\",\"arcs\":[[20,21]]},{\"type\":\"Polygon\",\"arcs\":[[22,23,24,25,26,27,28,29,30,31]]},{\"type\":\"Polygon\",\"arcs\":[[32,33,34,35,36,37,38]]},{\"type\":\"Polygon\",\"arcs\":[[39,40,41,42,43,44]]},{\"type\":\"Polygon\",\"arcs\":[[45,46,47,48,49]]},{\"type\":\"Polygon\",\"arcs\":[[50,51,52,53,54]]},{\"type\":\"Polygon\",\"arcs\":[[55,56,57,-29,58,-27,59,60,61,62,63]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[64,65,66,67]],[[-69,-70,-71,-72]],[[72,73,74,75]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[76,-71]],[[-68,77,-76,78]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[79,80]],[[81]],[[82,83,-66]],[[84,85,86,87,-69,88,-74]]]},{\"type\":\"Polygon\",\"arcs\":[[89,90,-32,91]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-57,92]],[[93,94]],[[95]],[[96]],[[97,98,-92,-31,99,-64,100,101,-33,102,103,104]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[105]],[[106]],[[107]],[[108]],[[109]],[[110]],[[111]],[[112]],[[113]],[[114]],[[-105,115]]]},{\"type\":\"Polygon\",\"arcs\":[[116,117,118,119,120]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[121,122,123,124,125]]]},{\"type\":\"Polygon\",\"arcs\":[[-67,-84,126,-81,127,-85,-73,-78],[-82]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[128]],[[129]],[[130]],[[131]],[[132,-21,133,134]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[135]],[[136]],[[137]],[[138]],[[139,140,141,142,143,144,145,146,147]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[148]],[[149]],[[150]],[[151,152]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[153]],[[154,-101,-63,155,-61,156,157,158,159,-134,-22,-133,160,-35],[-132]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[161]],[[162]],[[163]],[[164]]]},{\"type\":\"Polygon\",\"arcs\":[[165,166]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[167]],[[168]],[[169]],[[170]],[[171]],[[172]],[[173]],[[174]],[[175]],[[176]],[[177]],[[178]],[[179]],[[180]],[[181]],[[182]],[[183]],[[184]],[[185]],[[186]],[[187]],[[188]],[[189]],[[190]],[[191]],[[192]],[[193]],[[194]],[[195]],[[196]],[[197]],[[198]],[[199]],[[200]],[[201]],[[202,-42,203,204,-14,205,-12,206]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[207]],[[-48,208,209]],[[210]],[[211]],[[212]],[[213]],[[214]],[[215]],[[216]],[[217,218,-50,219,220]]]},{\"type\":\"Polygon\",\"arcs\":[[221,222,223,-218,224,-24,225]]},{\"type\":\"Polygon\",\"arcs\":[[226,227,228,229]]},{\"type\":\"Polygon\",\"arcs\":[[230,231,232,233,234,235,236,-123,237,238,239,240]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[241]],[[242]],[[243]],[[244]],[[245,246,-157,-60,-26],[247],[248]]]},{\"type\":\"Polygon\",\"arcs\":[[249,250,-236,251,-234,252,253,-231,254,-228]]},{\"type\":\"Polygon\",\"arcs\":[[255,-5,256,257]]},{\"type\":\"Polygon\",\"arcs\":[[-240,258,259]]},{\"type\":\"Polygon\",\"arcs\":[[-125,260,-118,261,262]]},{\"type\":\"Polygon\",\"arcs\":[[-59,-28]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[263,264]],[[-54,265,266,267,268]]]},{\"type\":\"Polygon\",\"arcs\":[[-102,-155,-34]]},{\"type\":\"Polygon\",\"arcs\":[[269,-55,-269,270,-147]]},{\"type\":\"Polygon\",\"arcs\":[[-120,271]]},{\"type\":\"Polygon\",\"arcs\":[[272,-159]]},{\"type\":\"Polygon\",\"arcs\":[[273,274]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-10,275]],[[-43,-203,276,-2,277,-8,278,-6,-256,279]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[280]]]},{\"type\":\"Polygon\",\"arcs\":[[281,-257,-18,282,-3,283,-16,284,-209,-47]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-37,285]],[[286]],[[287]],[[288]],[[-103,-39,289],[290]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[291]],[[292]],[[293]],[[294]],[[295]],[[296]],[[297]],[[298]],[[299]],[[300]],[[301]],[[302]],[[303]],[[304]],[[305]],[[306]],[[307]],[[308,309]]]},{\"type\":\"Polygon\",\"arcs\":[[310,311,312,-266,-53,313,314,-90,-99,315,-94,316]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-122,317,-238]],[[-254,318,-232]]]},{\"type\":\"Polygon\",\"arcs\":[[319,320,-45,321,-223,322,-274]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-313,323,-311,324,-264,325,-267]],[[326,-142]],[[-166,327,328,-51,-270,-146,329,-144,330,-140,331,-152,332]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[333,-250,-227]]]},{\"type\":\"Polygon\",\"arcs\":[[-248]]},{\"type\":\"Polygon\",\"arcs\":[[-322,-44,-280,-258,-282,-46,-219,-224]]},{\"type\":\"Polygon\",\"arcs\":[[334,-226,-23,-91,-315]]},{\"type\":\"Polygon\",\"arcs\":[[-221,335,-246,-25,-225]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[336]],[[337]],[[338]],[[339]],[[340]],[[-309,341]]]},{\"type\":\"Polygon\",\"arcs\":[[-229,-255,-241,-260,342,343,344]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[345]],[[346]],[[-262,-117,347]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[348]],[[349]],[[350,-204,-41]],[[-344,351]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[352]],[[353,-320,-275,-323,-222,-335,-314,-52,-329],[354],[355]]]},{\"type\":\"Polygon\",\"arcs\":[[-249]]},{\"type\":\"Polygon\",\"arcs\":[[356,-87]]}]}},\"arcs\":[[[5343,4235],[-4,5]],[[5339,4240],[4,-5]],[[4956,4576],[2,4]],[[4958,4580],[-2,-4]],[[5127,4643],[17,-9],[24,-47],[53,-17],[23,-31],[12,-44],[-8,-18]],[[5248,4477],[-16,-34],[5,-41],[-19,-4],[24,-37],[-16,-20],[24,-55],[14,-3]],[[5264,4283],[4,-41],[18,-2]],[[5286,4240],[53,0]],[[5339,4240],[5,-12]],[[5344,4228],[0,-1]],[[5344,4227],[0,-14]],[[5344,4213],[12,-25]],[[5356,4188],[2,-2]],[[5358,4186],[-2,-35],[-42,-18],[-34,-47],[-12,-47],[-52,-6],[-33,-19],[24,-41],[-30,-7],[6,-18],[-28,-20],[-44,14]],[[5111,3942],[4,37],[-27,17],[-12,33],[-92,41],[-45,52],[30,-23],[16,30],[-43,49],[18,39],[36,32],[-19,15],[-1,34],[18,28],[-24,15],[24,48],[-18,18],[30,0],[4,56],[-53,9]],[[4957,4472],[2,58]],[[4959,4530],[26,13],[-28,22],[9,24]],[[4966,4589],[66,78],[19,-37],[18,-8],[58,21]],[[5135,8952],[30,-20],[-48,7],[18,13]],[[5091,9019],[87,-22],[-28,-28],[-33,27],[5,-46],[-69,-3],[-28,47],[37,8],[6,-25],[23,42]],[[684,4631],[-48,-18],[-24,15],[5,27]],[[617,4655],[9,11],[62,-8],[-4,-27]],[[4372,6130],[-25,-58],[27,-23],[6,-28],[41,-39]],[[4421,5982],[-35,-34],[12,-39],[-62,-8],[-65,18],[-29,-20],[48,-8],[20,-23],[-12,-22],[-48,-9],[6,-36],[-14,-15],[19,-50],[-48,2],[-47,-36]],[[4166,5702],[-30,-10],[4,-31],[-85,5],[-42,-24],[-97,8],[-51,-12],[-71,-54],[-39,14],[-63,0],[-17,11],[-88,9]],[[3587,5618],[-53,11],[-61,-4],[-40,12],[-130,15],[-62,31],[-5,23],[-34,27],[22,23],[-63,-10],[-47,-17],[-69,9],[-70,-11],[-43,-48],[-68,7],[-16,16],[-47,0]],[[2801,5702],[-21,33],[-57,-38],[-56,18],[-10,25],[-67,10]],[[2590,5750],[8,11],[-23,40]],[[2575,5801],[31,45],[-23,16]],[[2583,5862],[40,7]],[[2623,5869],[52,-2],[33,-23],[3,-20],[31,4],[-13,-25],[36,7],[35,34],[-9,33],[47,-4],[59,-16],[31,-25],[56,1],[82,29],[17,19],[132,2],[3,26],[87,-18],[54,9],[4,-28],[37,-21],[26,6],[9,38],[-44,19],[24,30],[-61,59],[67,42],[62,12],[32,17],[28,51],[47,-16],[22,26],[2,35]],[[3614,6170],[41,-16],[14,-25],[66,-11],[35,22],[57,-14],[29,46],[30,-3],[6,51],[41,6],[77,-13],[56,-20],[33,3],[65,-33],[66,-3],[18,16],[106,-18],[18,-28]],[[1722,6657],[45,-33],[4,-32],[33,-1],[10,-41],[-53,-22],[-10,-26]],[[1751,6502],[-28,13],[-31,-18],[-38,-54],[3,-19],[38,-40],[-23,-25]],[[1672,6359],[-81,-9],[-17,28],[-23,2],[-77,43],[-30,-1],[-14,44],[18,27],[-18,17],[-32,-40],[-47,-14],[-78,10],[17,22],[-21,16],[19,28],[-44,24],[-87,-5],[-4,31],[-35,17],[-52,0],[-15,47],[-29,18],[-53,-20],[-72,36],[5,29],[-21,31]],[[881,6740],[146,59],[55,12]],[[1082,6811],[12,-34],[50,13],[77,-22],[59,23],[13,18]],[[1293,6809],[9,0]],[[1302,6809],[32,-5],[-4,23],[33,9],[34,-13],[19,15],[43,-24],[25,21],[49,-53],[67,7],[13,-17],[69,-15],[-27,-61],[-23,-14],[16,-22],[74,-3]],[[7187,4936],[6,-46],[-35,-43],[-22,10],[-61,-7],[-41,-55],[-15,-33],[2,-79],[-39,1],[-68,-62],[58,-9],[20,-47],[45,-35],[14,-29]],[[7051,4502],[-51,5],[-62,-17],[-59,37],[-69,0],[-20,-20],[-96,-18],[-4,-24],[-36,-2],[-11,-25]],[[6643,4438],[-24,7],[-45,-13],[29,-42],[-12,-40],[-57,-13],[-83,3],[-67,-19],[-35,20],[-59,21],[-24,-14],[-43,20],[-21,32],[-54,-10],[-58,1],[1,-14],[-36,0],[-78,-23],[-71,7],[-23,-18],[-66,2]],[[5817,4345],[5,73],[17,21],[-32,40],[-8,33],[-76,28],[-45,45]],[[5678,4585],[19,3],[28,38],[-26,23],[13,40],[-14,18],[33,18],[40,0],[12,23],[38,27],[11,27],[-20,5],[-40,40],[-52,23],[-12,43],[-29,38],[12,46],[47,18],[3,27],[21,13]],[[5762,5055],[82,-33],[-38,-30],[-2,-28],[65,-3],[85,9],[161,-32],[85,12],[61,-15],[51,3],[106,-24],[92,19],[89,70],[112,16],[100,23],[55,-12],[32,-27],[66,2],[15,-18],[46,10],[17,-34],[58,-22],[87,-5]],[[4873,5212],[38,15],[48,-11],[-13,-41],[-46,-48],[2,-53],[41,-7],[14,-21],[60,-42],[-15,-9],[-78,-7],[57,-47],[4,-49],[-28,10],[-41,-18]],[[4916,4884],[-69,-5],[39,-50],[-19,-9],[-23,19],[-53,-24],[-10,-56],[-37,-2],[-10,-48],[26,-44],[-27,-19]],[[4733,4646],[-44,12],[-96,51],[-12,23],[-38,-6]],[[4543,4726],[-18,13]],[[4525,4739],[20,7],[-18,28],[-63,44],[-21,52],[-38,9],[-63,49],[-78,69],[-37,18],[-32,36],[-2,34],[-22,43],[-55,49],[-22,-5],[-20,24],[16,90],[55,13],[49,-46],[31,-6],[14,28],[32,24],[62,-10],[36,24],[61,-32],[20,10],[71,-17],[30,11],[31,-23],[49,19],[23,-11],[30,14],[59,-23],[48,6],[23,-36],[28,-20],[31,1]],[[7083,7980],[39,-23],[75,10],[21,-32],[78,17],[84,-17],[-8,-41],[28,-25],[99,36],[84,5],[61,-16],[66,-47],[41,-7],[2,-39],[-30,-30],[40,-31],[11,-34],[-46,-23],[-13,-31],[98,-44],[-25,-32],[35,-12],[28,-54],[103,-34],[24,-23],[-26,-48],[82,3],[88,-23],[-3,-38],[70,-30],[-1,-25],[-34,-4],[-41,-32],[-70,-27],[-79,8],[-13,19],[-78,3],[-41,-46],[62,-42],[16,-29],[-21,-10],[29,-84],[40,-59]],[[7958,6989],[-93,4],[-37,-21],[-23,11],[-52,-5],[-43,-39],[-55,-72],[30,-67],[-24,-24],[-52,23],[1,15],[-43,22],[-100,-10],[-13,13],[-52,-26],[-41,-4],[-36,61],[-21,2],[-64,-23],[-17,-32],[-28,33],[-37,9],[-27,-12],[-39,30],[-28,-23],[-47,14],[-20,-23],[-32,-6],[7,24],[-52,9],[-54,-7],[-18,37],[-78,0],[-109,25],[-154,18],[-101,0],[-41,7],[-112,-17],[-80,-1],[-35,-39],[-64,-33],[-61,15],[-27,-5],[-3,-27]],[[5983,6845],[-16,22],[5,37],[28,58],[-9,23],[-45,25],[-58,11],[-11,14],[55,54],[115,39],[13,18],[-7,101],[-27,28],[-46,85],[-26,80]],[[5954,7440],[38,-10],[128,15],[50,-18],[72,27],[32,-5],[11,42],[42,-5],[48,33],[60,9],[17,-39],[48,2],[12,22],[-26,22],[-37,5],[28,42],[23,13],[-4,52],[35,39],[57,4],[50,46],[65,-6],[54,37],[-86,16],[36,57],[0,24]],[[6707,7864],[60,12],[33,27],[68,-9],[21,11],[59,-9],[13,30],[64,45],[58,9]],[[2493,5901],[1,-1]],[[2494,5900],[3,-4]],[[2497,5896],[72,-41],[14,7]],[[2575,5801],[-11,-50],[26,-1]],[[2801,5702],[-21,-46],[22,-13],[-8,-21],[-82,16],[-11,-41],[22,-5],[6,-37],[-28,-11],[-19,34],[-59,-1],[-39,-15],[-28,21],[-1,28],[-47,-7],[8,-33],[-13,-24],[-37,-27],[-22,-38],[20,-16],[-39,-18],[-10,32],[-22,5],[16,22],[-56,14],[-43,31],[4,45],[-89,-45],[9,-31],[-30,-32],[-39,-19],[-69,17],[-43,-20],[-66,-6],[-18,10]],[[1969,5471],[-39,50],[-20,3],[13,33],[-10,35]],[[1913,5592],[36,3],[-81,24],[-64,-15],[-27,-42]],[[1777,5562],[8,-18],[-28,-18],[-44,-3],[0,20],[32,8],[11,28],[-19,14],[18,44],[72,40],[3,45],[54,19],[8,15],[62,40],[22,23],[-43,4],[25,32],[51,0],[15,-16],[33,3],[50,38]],[[2107,5880],[18,-11],[38,13],[65,-8],[40,15],[25,-11],[40,11],[-31,19],[40,24],[84,-36],[67,5]],[[8502,2805],[2,-2]],[[8504,2803],[-30,2]],[[8474,2805],[2,0]],[[8476,2805],[26,0]],[[8173,2835],[-17,-3]],[[8169,2835],[4,0]],[[8160,2832],[9,3]],[[8156,2832],[4,0]],[[8421,2798],[6,-11]],[[8427,2787],[-62,0],[-6,40],[-29,-10],[-31,11],[-58,-21],[-54,14],[-6,14]],[[8181,2835],[6,-1]],[[8187,2834],[35,-25],[81,27],[51,1],[24,-32],[43,-7]],[[8160,2832],[9,3]],[[8476,2805],[-55,-7]],[[8187,2834],[28,-8],[25,20],[-3,40],[16,-6],[107,-10],[56,7],[91,27],[36,21],[96,34],[-1,-10],[-106,-58],[-23,-25],[-29,-9],[-6,-27],[28,-25]],[[8446,2784],[0,0]],[[8446,2784],[0,0]],[[8437,2790],[0,0]],[[8504,2803],[19,-22],[-51,-3]],[[8472,2778],[-22,21],[24,6]],[[8427,2787],[-1,-5]],[[8426,2782],[-16,-29],[-94,-39],[-42,-1],[-14,-14]],[[8260,2699],[-44,16],[-17,-11]],[[8199,2704],[-23,0],[-61,24],[-19,31],[-16,53],[35,-12],[41,32]],[[8173,2835],[8,0]],[[3855,6683],[42,0],[5,40],[60,-13],[23,-46],[23,5],[125,-27],[16,-20],[67,11],[22,-32],[-47,-20],[35,-17],[58,-60],[29,-8],[66,33],[-27,48],[78,-12],[36,-27],[97,4],[-4,-22],[-33,-11],[62,-43],[47,8],[63,-24],[61,1],[22,-53],[38,-9],[9,-36]],[[4828,6353],[-72,-7],[-36,-35],[-47,-17],[-21,-45],[-46,-19],[-13,-22],[-79,-27],[-89,12],[-34,-28],[-19,-35]],[[3614,6170],[-50,43],[-30,-1],[-48,40],[-26,4],[-71,55],[-26,-2],[-35,26],[-33,57],[-27,18],[34,38],[-14,18],[-53,18],[-41,48],[22,15],[25,-32],[49,49],[83,18],[24,-10],[22,22],[37,1],[17,20],[52,4],[38,29],[51,2],[17,13],[112,26],[-26,25],[54,9],[40,-24],[-4,-19],[48,3]],[[2494,5900],[3,-4]],[[3710,7440],[-3,-16]],[[3707,7424],[-63,-7],[-8,37],[35,-13],[-20,30],[-47,-11],[10,38],[96,-58]],[[2995,7573],[14,-16],[-75,13],[28,16],[33,-13]],[[3511,7614],[19,-18],[42,3],[-8,-42],[38,-17],[-64,0],[-34,-17],[-59,14],[33,13],[-19,14],[47,35],[15,-23],[18,15],[-28,23]],[[2555,7654],[34,14],[59,-27],[22,8],[29,-29],[-3,-31],[-33,-21],[58,9],[4,-31],[43,18],[111,-32],[38,16],[49,2],[-11,-45],[-82,-39],[40,-21],[62,14],[17,-17],[52,-10],[8,23],[40,35],[107,8],[59,32],[44,43],[41,-11],[-62,-12],[-17,-29],[75,29],[45,-7],[35,20],[28,-40],[40,-10],[39,-31],[60,10],[14,-29],[36,-22],[-21,-22],[108,-38]],[[3723,7381],[9,-48],[24,-55],[-14,-58],[-48,-20],[-5,-27],[126,-67],[-25,-39],[10,-32],[28,-9],[-3,-32],[18,-11],[-42,-67],[32,-32],[3,-39],[52,-16],[18,-44],[-16,-51],[-35,-51]],[[2623,5869],[-51,25],[-45,10],[-35,19],[1,-22]],[[2107,5880],[-18,30],[26,65],[-2,51],[34,40],[14,67],[71,50],[23,34],[-65,18],[-69,0],[-45,31],[-47,-13],[-104,26],[-26,-14],[-52,67],[-40,7]],[[1807,6339],[2,30],[33,29],[3,25],[-68,22],[-31,39],[5,18]],[[1722,6657],[16,39],[-34,30],[55,29],[-23,9],[34,39],[0,40],[-23,34],[-39,23],[-2,18],[48,21],[62,-17],[87,18],[16,18],[-33,14],[84,49],[7,32],[-19,22],[-56,0],[-16,22],[15,23],[67,-2],[16,56],[28,35],[0,61]],[[2012,7270],[26,21],[-64,4],[12,59],[34,19],[175,14],[53,-42],[-27,-12],[36,-23],[28,25],[-16,23],[75,-14],[-20,33],[35,51],[67,-14],[89,8],[71,-66],[-41,58],[-43,14],[-51,0],[-42,36],[39,-2],[-10,30],[-23,-6],[-5,32],[30,14],[-69,-11],[-19,16],[100,42],[-78,57],[-7,39]],[[2367,7675],[39,2],[149,-23]],[[2995,7689],[82,-35],[32,16],[31,-32],[-22,-24],[-76,-5],[-102,32],[-3,36],[58,12]],[[3305,7700],[-75,-26],[-24,15],[50,19],[49,-8]],[[2641,7720],[56,-30],[10,-19],[-61,5],[-5,44]],[[2894,7685],[-26,-49],[-22,26],[52,49],[-4,-26]],[[3873,7758],[64,-25],[-19,-34],[-94,26],[19,51],[30,-18]],[[2773,7849],[36,-14],[-4,-27],[32,13],[1,30],[33,-31],[-21,-8],[34,-23],[4,-31],[-23,-42],[-44,-8],[-114,14],[22,13],[-60,22],[-37,77],[44,-6],[97,21]],[[3315,7837],[7,36],[16,-24],[-23,-12]],[[3254,7977],[71,-20],[-26,-31],[22,-52],[-34,-25],[-52,-14],[-6,-28],[51,-17],[7,-18],[-68,-16],[-8,-57],[-46,-11],[51,-27],[-51,-36],[-60,63],[42,7],[-60,50],[-95,8],[-33,28],[26,18],[-31,32],[0,32],[-51,20],[91,-3],[54,27],[0,25],[40,0],[41,-65],[35,43],[23,-19],[-34,-28],[37,-3],[8,20],[-17,52],[-39,7],[73,32],[39,6]],[[2427,8181],[-7,-37],[-56,-31],[-25,27],[26,26],[62,15]],[[2979,8272],[-39,-31],[-38,13],[77,18]],[[2367,7675],[5,58],[-48,-16],[1,32],[49,-14],[-24,76],[-85,27],[18,-22],[-53,23],[24,61],[47,19],[-26,45],[-43,6],[7,21],[-2,91],[40,10],[67,-4],[43,-20],[-10,24],[61,51],[37,0],[17,-23],[-29,-18],[65,9],[-40,55],[31,24],[44,8],[33,-14],[45,34],[-133,-26],[-31,14],[-106,-27],[-47,-41],[30,-38],[-17,-8],[-73,44],[8,17],[77,65],[48,-1],[47,14],[105,1],[39,19],[95,86],[56,2],[89,37],[-33,-44],[28,-33],[-2,-49],[-31,-23],[-35,-58],[18,-47],[-47,2],[-48,-16],[94,10],[-1,-25],[34,-19],[77,3],[42,-21],[-12,-28],[-40,-30],[-29,6],[-27,-33],[-3,43],[-32,-1],[-37,-31],[14,-31],[-23,-46],[-16,12],[-54,-11],[40,-21],[-64,-19],[15,-13],[-36,-20],[-26,-43],[21,-41],[-48,-10],[20,-26],[41,-18],[1,-36],[-38,24],[-36,-29]],[[2353,3266],[9,-27],[-48,-9],[-8,-37],[-58,-29],[46,-23],[-10,-70],[-19,-78],[20,-44],[3,-36],[-11,-25],[7,-27],[27,-13],[-28,-34],[-16,-50],[-3,-61],[-34,-29],[-64,-29],[-14,-37],[-34,-16],[-28,-25],[-9,-49],[18,-58],[34,-50],[14,-62],[81,-27],[51,-72],[5,-59],[40,-31],[130,-80],[6,-9],[32,-129],[83,-323]],[[2575,1618],[-57,-28],[64,-77],[29,-48],[38,-117],[6,-85],[-18,-127],[38,-99],[-27,-89],[-25,-52],[28,-96],[18,-13],[-3,-48],[-15,-36],[-85,-37],[-26,-46],[6,-13],[138,-176],[12,-31],[3,-102],[39,-26],[16,-43],[32,-23],[79,18],[181,-56],[24,-14],[81,-154]],[[3151,0],[-3151,0],[0,2156]],[[0,2156],[21,18],[-21,16]],[[0,2190],[0,750],[18,16],[59,23],[38,-13],[41,35],[31,10],[21,-21],[36,-7],[35,18],[23,46],[125,68],[53,13],[44,27],[78,14],[26,-4],[142,10],[60,14],[70,-9],[47,25],[34,29],[50,-18],[21,18],[56,-9],[46,12],[23,17],[41,5],[46,-7],[38,7],[59,-7],[64,3],[81,-28],[4,-20],[45,-14],[38,5],[27,23],[45,18],[26,-2],[80,20],[18,30],[46,17],[50,-34],[37,-1],[21,-15],[60,6],[22,15],[-16,23],[49,2],[49,-22],[42,-6],[3,-18],[33,-11],[78,27],[64,-13],[26,9]],[[8547,1884],[12,-25]],[[8559,1859],[56,-137],[11,-60],[18,-17],[33,-82],[36,-127]],[[8713,1436],[-36,-44],[-28,-114],[1,-27],[-53,-105],[12,-32],[-7,-49],[-53,-49],[-37,9],[-16,18],[-55,34],[-48,67],[-31,16],[-50,49],[-8,27],[-4,78],[-71,61],[-17,43],[-18,9],[-15,35],[2,34],[-20,23],[-11,35],[-40,-58],[-14,-34],[62,-61],[15,-63],[-8,-29],[48,-56],[12,-41],[32,-21],[30,-51],[52,-48],[42,-31],[19,-43],[-27,15],[19,-42],[-13,-3],[32,-43],[11,-33],[38,-27],[-1,-31],[41,-66],[-14,-5],[-2,-44],[16,-7],[81,-152],[50,-68],[33,-73],[74,-128],[60,-125],[32,-22],[30,-50],[34,-26],[20,-1],[-8,-20],[-41,16],[-9,-45],[7,-38],[-2547,0]],[[6316,0],[0,1361],[-26,70],[-1,41],[-15,30],[1,33],[-30,62],[18,42],[31,37],[26,79],[-28,62],[-5,84],[40,28],[30,38]],[[6357,1967],[10,-29],[48,-7],[116,29],[24,-2],[95,-23],[146,-18],[37,-14],[49,-2],[31,-39],[52,-10],[49,13],[8,-30],[102,-13],[21,6],[100,-33],[51,-30],[39,1],[76,31],[81,47],[56,44],[36,-27],[28,40],[6,30],[42,-10],[80,20],[-74,-30],[41,-8],[11,11],[49,0],[33,26],[-33,10],[58,-1],[92,-34],[66,24],[12,-4],[-37,-58],[35,-19],[31,3],[-6,-21],[22,-21],[40,17],[15,38],[49,-46],[57,-10],[52,16],[28,19],[11,-30],[58,12],[5,9],[58,-8],[50,11],[84,37]],[[8472,2778],[-26,6]],[[8446,2784],[-20,-2]],[[653,3797],[11,-18],[-53,-48],[-47,17],[35,42],[54,7]],[[1040,4010],[-20,-22],[24,-31],[68,-1],[-8,-26],[-54,-70],[-38,-22],[-25,23],[-48,9],[-1,24],[-30,14],[-34,-21],[-32,34],[55,27],[55,37],[88,25]],[[1267,4032],[34,-16],[11,-42],[-13,-3],[-65,31],[-36,0],[-2,26],[71,4]],[[752,4617],[0,0]],[[0,4756],[34,-13],[53,-2],[43,-38],[63,12],[39,-12],[20,-24],[60,8],[29,-14],[91,6],[-2,35],[100,-16],[16,-14],[50,-2],[21,-27]],[[684,4631],[53,-15],[17,-22],[68,19],[58,-25],[46,22],[55,14],[60,-11]],[[1041,4613],[5,-21],[28,-4],[-13,-21],[-27,4],[-7,-28],[22,-18],[4,-30],[-20,-25],[-52,-32],[-154,-61],[-57,-47],[-126,-21],[-87,-31],[-31,0],[-43,-27],[-44,-41],[43,-14],[-6,-13],[-65,-18],[-55,-78],[-69,-62],[-63,-78],[-33,-57],[7,-39],[21,-35],[1,-26],[25,-34],[63,-26],[20,-18],[-71,-50],[-66,-21],[-43,-32],[1,-33],[-33,-17],[-3,-36],[-16,-11],[-33,-54],[36,-25],[-53,-16],[-47,1],[0,1338]],[[5750,8582],[63,8],[86,-30],[-41,-26],[-101,-42],[-33,8],[-63,-19],[-20,-48],[-35,-17],[-12,17],[50,41],[-81,28],[35,22],[-44,39],[46,-3],[19,-18],[21,29],[99,21],[11,-10]],[[5921,8591],[13,-17],[-43,-5],[-40,16],[28,20],[42,-14]],[[5887,8694],[43,-16],[-57,-2],[14,18]],[[5769,8686],[52,-7],[26,-35],[-74,-9],[-13,-20],[-44,-7],[-17,39],[-91,24],[99,5],[32,29],[30,-19]],[[7051,8801],[39,-31]],[[7090,8770],[-43,-5]],[[7047,8765],[23,-4]],[[7070,8761],[-52,-10],[-9,-28]],[[7009,8723],[-31,-41]],[[6978,8682],[-104,1],[-67,-19],[-15,-25],[52,-39],[24,-62],[36,-8],[0,-21],[56,-71]],[[6960,8438],[35,-38],[-63,-10],[-29,-29],[-13,-40]],[[6890,8321],[-65,6],[-56,18],[-9,-11],[-76,-16],[-58,26],[-57,38],[-3,17],[-105,18],[-76,39],[-232,-51]],[[6153,8405],[38,50],[16,68],[-41,12],[-60,-39],[-32,19],[-54,6],[-19,45],[-39,7],[-6,30],[22,15],[54,-1],[2,17],[-93,-9],[23,14],[-25,21],[49,16],[-40,5],[3,54],[69,17],[81,8],[-18,13],[70,13],[7,12],[106,-5],[7,30],[26,-15],[48,5],[72,-10],[31,10],[-12,34],[33,-22],[89,14],[23,-12],[150,-11],[57,-23],[114,1],[112,-11],[35,18]],[[5796,8976],[-23,-46],[-64,-2],[-5,47],[92,1]],[[5583,9027],[-38,-7],[9,24],[29,-17]],[[5372,9736],[28,-16],[55,6],[-43,-24],[-40,34]],[[7554,9998],[112,-33],[-12,-57],[-75,-48],[-53,-13],[116,-66],[87,-24],[98,-44],[5,-20],[78,-51],[-31,-29],[-47,-70],[-82,-52],[-66,-26],[-159,-112],[-106,-60],[-81,-59],[-98,-36],[-240,-134]],[[7000,9064],[-21,-16],[-51,7],[-13,-13],[-67,26],[-44,-20],[-75,-17],[-51,17],[-13,-22],[-122,-9],[-38,-30],[-22,31],[-41,-29],[-73,0],[-5,-16],[-133,-11],[-51,-36],[-12,21],[-145,-26],[-77,-3],[-48,-29],[-84,-7],[83,27],[-36,5],[25,27],[-41,-2],[-40,35],[34,22],[-32,6],[-78,-23],[-25,10],[43,32],[-82,1],[-82,34],[-40,-10],[13,37],[-68,-34],[-50,49],[21,-3],[-29,46],[26,9],[-31,39],[38,-2],[25,37],[8,69],[-32,19],[62,-9],[-43,31],[-40,71],[-33,11],[37,55],[-12,36],[-50,12],[-6,89],[86,45],[10,65],[94,11],[75,-5],[41,20],[-44,34],[57,7],[24,42],[36,11],[20,-20],[57,47],[102,27],[-4,32],[41,10],[102,64],[1478,0]],[[2558,4676],[19,-29],[6,-111],[-37,-39],[0,-61],[-33,-43],[-8,-38],[-95,38],[-15,15],[35,24],[-65,15],[32,18],[-2,26],[-39,-7],[-7,16],[38,18],[-38,22],[-10,26],[35,10],[-32,17],[25,20],[12,38],[74,16],[22,20],[57,5],[-9,22],[10,41],[28,-3],[5,-47],[-8,-29]],[[1672,6359],[41,-24],[43,13],[51,-9]],[[1777,5562],[17,20],[50,9],[69,1]],[[1969,5471],[-49,-22],[0,-33],[38,-17],[3,-28],[43,-26],[-13,-37],[-64,-31],[-26,7],[-32,-14],[29,-22],[1,-21],[67,-27],[12,-32],[-23,-1],[-30,-36],[20,-24],[-12,-18],[43,-30],[69,-29],[79,12],[8,-27],[-51,-50],[6,-18]],[[2087,4947],[-16,-11]],[[2071,4936],[-18,-5]],[[2053,4931],[-52,-16],[-3,-25],[-42,-3],[-10,-23],[-46,-10],[-33,-30],[20,-22],[-178,-31],[-80,22],[-21,13],[-43,1],[-2,29],[-66,-2],[-15,13],[41,12],[-35,32],[8,-26],[-32,-4],[-27,-23],[-61,7],[-13,21],[-74,0],[-18,20],[-43,1],[-107,-64],[-31,1],[-65,-44],[-19,-41],[4,-95],[31,-31]],[[0,4756],[0,618],[49,-18],[37,-31],[12,-48],[19,-14],[-28,86],[-22,22],[-67,39],[0,902],[11,13],[61,-9],[73,-1],[73,-19],[68,18],[24,15],[61,9],[-75,10],[16,49],[103,41],[140,25],[53,28],[31,35],[37,-6],[-32,21],[10,73],[0,72],[82,32],[145,22]],[[498,6809],[-35,0],[-10,18],[45,-18]],[[0,7609],[79,-16],[56,-21],[40,-51],[78,-39],[-35,-22],[16,-30],[69,-63],[-50,-4],[-36,23],[-104,-3],[30,-7],[54,9],[127,-72],[30,-48],[-2,-33],[-79,-48],[58,-25],[32,-2],[34,41],[40,8],[142,-14],[90,-39],[25,-37],[6,-33],[-34,-53],[-12,-46],[-27,-6],[-66,-44],[19,-8],[-58,-17],[-15,17],[-31,-27],[23,0],[-4,-36],[-26,-13],[-88,-7],[58,-7],[-26,-22],[94,-10],[109,10],[-17,-64],[-79,-22],[-13,-30],[-42,5],[-43,-20],[-63,-10],[-22,-18],[-108,21],[-96,-7],[-59,-16],[-12,16],[-62,12],[0,928]],[[10,9109],[20,-1],[-9,-57],[-21,-1],[10,59]],[[83,9123],[-42,-27],[3,29],[39,-2]],[[9947,4848],[18,36],[34,11]],[[9999,4895],[0,-61],[-52,14]],[[6055,2918],[30,-2],[22,20],[21,-14],[-32,-10],[44,-5],[3,-27],[18,-5],[92,19],[81,-5],[5,-16],[73,0],[25,-10],[69,9],[-13,-38],[26,-16],[19,17],[41,11],[21,-9],[20,18],[15,-20],[-14,-36],[-26,-10],[-34,10],[-45,-8],[-50,2],[-72,-8],[-47,-12],[-90,0],[-4,39],[-38,4],[-39,16],[-139,20],[-58,-4],[-17,14],[25,56],[38,13],[30,-13]],[[6860,2988],[-17,-48],[19,-29],[-35,-11],[16,86],[17,2]],[[5850,3085],[-32,-5],[-5,37],[13,12],[36,-37],[-12,-7]],[[7105,3141],[-1,-15],[-42,-63],[6,-14],[-34,-5],[-40,-36],[-17,14],[12,27],[-19,25],[22,9],[30,36],[53,20],[30,2]],[[6674,3182],[-38,-22],[-10,18],[48,4]],[[6188,3219],[23,-16],[-53,-9],[7,25],[23,0]],[[6417,3214],[-6,-18],[-29,18],[13,16],[22,-16]],[[6851,3234],[-52,-18],[45,38],[47,-8],[-40,-12]],[[6581,3255],[-53,-12],[36,23],[17,-11]],[[6238,3293],[26,-23],[-13,-13],[-13,36]],[[6798,3291],[15,-22],[-27,-1],[12,23]],[[6388,3311],[-18,-33],[-24,6],[11,23],[31,4]],[[6465,3305],[-11,-32],[-24,-12],[-19,41],[39,27],[15,-24]],[[6196,3331],[12,-18],[-28,1],[16,17]],[[6405,3404],[28,-9],[-38,-13],[10,22]],[[6312,3379],[-20,-9],[3,36],[17,-27]],[[6341,3440],[39,-7],[-7,-23],[-53,27],[21,3]],[[6169,3449],[6,-16],[-30,-23],[1,23],[23,16]],[[6640,3436],[-63,-28],[-21,3],[21,24],[63,1]],[[5956,3447],[-16,22],[33,0],[-17,-22]],[[6794,3465],[20,-9],[-58,-18],[-53,25],[47,18],[44,-16]],[[5293,3490],[24,-4],[32,-30],[-22,4],[-19,-20],[-47,43],[16,25],[16,-18]],[[6284,3505],[26,-2],[9,-34],[-10,-18],[-62,57],[15,16],[22,-19]],[[5966,3521],[-4,-20],[-28,4],[32,16]],[[5249,3643],[14,-32],[43,-56],[-21,-13],[-51,11],[-15,41],[-5,-25],[-20,2],[20,43],[25,-5],[10,34]],[[6579,3668],[23,-9],[0,-59],[-34,-36],[-35,30],[28,17],[-35,57],[53,0]],[[5280,3694],[5,-12],[-41,-16],[20,61],[21,0],[-5,-33]],[[6218,3743],[26,-19],[-36,-2],[-18,41],[28,-20]],[[5944,3747],[36,-31],[44,-16],[88,-11],[23,-35],[-11,-31],[14,-38],[24,-21],[59,0],[-5,-41],[-33,8],[-18,-10],[-35,29],[-22,52],[-20,21],[-97,4],[0,28],[-45,36],[-74,43],[-70,-3],[68,43],[39,7],[35,-34]],[[5983,3822],[46,-21],[-31,-6],[-15,27]],[[6662,3851],[41,-61],[-8,-22],[-34,-5],[-61,14],[-13,16],[47,22],[-29,5],[-22,-25],[-60,21],[5,18],[77,19],[-3,12],[44,0],[16,-14]],[[5094,3966],[-22,-22],[21,-20],[1,-35],[37,-8],[5,-20],[-58,26],[-9,25],[-49,43],[55,19],[19,-8]],[[6426,4023],[-21,-30],[0,-28],[-69,14],[-7,37],[52,2],[9,-12],[36,17]],[[6483,4137],[-20,-22],[-33,17],[23,12],[30,-7]],[[6268,4170],[-34,-14],[-30,18],[30,41],[34,-15],[0,-30]],[[5381,4227],[70,13],[43,-10],[44,14],[35,43],[66,14],[58,-10],[71,8],[16,46],[33,0]],[[6643,4438],[35,-9],[24,-21],[14,-42],[-73,-41],[7,-71],[-24,-12],[-43,-45],[-10,2]],[[6573,4199],[-22,25],[-93,6],[-128,34],[-57,-37],[-42,1],[-27,25],[-50,-20],[7,-12],[-56,-25],[-64,14],[-36,-16],[33,-38],[11,-39],[43,-3],[43,-19],[37,-34],[-21,-13],[-31,36],[-60,24],[-46,-3],[-9,-17],[20,-22],[52,-20],[0,-40],[-49,24],[-28,40],[-57,16],[-25,-18],[40,-40],[41,-14],[8,-18],[-78,22],[-18,25],[-2,32],[-65,22],[-50,44],[39,11],[-18,24],[-80,-44],[20,-24],[-27,-51],[12,-37],[61,-54],[21,-52],[38,-18],[42,-45],[18,-32],[-34,-22],[-8,41],[-57,22],[-22,-17],[14,-27],[41,-35],[-22,-22],[-60,-19],[-27,10],[-23,-14],[43,-2],[11,-12],[71,-13],[12,-23],[23,9],[35,-15],[-1,-30],[66,-7],[27,-34],[58,-11],[31,-31],[-22,-12],[6,-56],[18,-27],[-13,-32],[-32,32],[-33,15],[-21,26],[-38,24],[-71,-18],[-52,-30],[41,-11],[-3,-47],[86,-43],[-64,-9],[-22,-25],[-24,14],[15,23],[-68,15],[-18,21],[-13,-16],[8,-34],[48,-66],[14,-45],[24,-39],[-21,-16],[13,-35],[28,-35],[-24,3],[-67,54],[-13,35],[-35,-1],[-33,-48],[7,-38],[-38,16],[1,45],[-34,48],[-20,5],[4,26],[-48,-4],[0,-50],[-18,-20],[-14,22],[-33,9],[4,27],[-30,28],[3,36],[22,16],[-2,27],[-25,38],[-41,27],[-25,4],[-3,26],[-40,14],[11,22],[39,23],[11,49],[56,-18],[39,37],[46,10],[64,-38],[27,-2],[84,-27],[46,-32],[18,36],[38,-5],[27,25],[-77,19],[-49,20],[-11,16],[-24,-21],[-35,37],[-3,-25],[-58,4],[-39,11],[-38,-4],[-17,-16],[-39,5],[-27,-10],[-29,24],[-47,-26],[-22,11],[1,46],[-39,34],[-10,27],[-38,4],[6,30],[41,9],[39,-23],[19,32],[-19,16],[-19,-11],[-44,24],[-28,-15],[-55,42],[1,14],[-39,6],[-24,33],[10,18],[-28,6],[8,21],[-44,18]],[[5358,4186],[-2,2]],[[5344,4213],[37,14]],[[4329,4747],[64,3],[40,-16],[-84,-4],[-52,8],[32,9]],[[4733,4646],[14,-35]],[[4747,4611],[-169,96],[-12,-4],[-75,20],[-54,27],[-48,7],[54,3],[54,-26],[46,-8]],[[4279,4810],[40,-17],[113,-9],[-127,0],[-72,18],[46,8]],[[4338,4838],[10,-18],[-69,0],[-34,12],[1,19],[92,-13]],[[3897,5022],[56,-44],[-23,0],[-33,44]],[[3863,5146],[49,-39],[50,-25],[-31,-6],[-68,70]],[[3841,5207],[23,-35],[-39,36],[16,-1]],[[3773,5234],[-5,-39],[20,-40],[-34,18],[-24,57],[23,-7],[-25,47],[45,-36]],[[3795,5306],[23,-34],[38,-32],[-26,-8],[-20,22],[-48,13],[25,10],[8,29]],[[4268,5614],[81,-32],[9,-20],[51,-41],[24,-1],[35,-40],[51,-2],[27,-26],[158,-23],[51,10],[35,30],[55,5]],[[4845,5474],[-14,-30],[29,-37],[-15,-22],[26,-18],[-8,-25],[36,-24],[58,-12],[7,-20],[-84,-9],[9,-36],[-16,-29]],[[4525,4739],[-64,45],[-49,22],[-56,48],[-62,10],[-37,22],[-121,-9],[-5,37],[-117,65],[-79,69],[0,21],[37,-9],[-8,21],[58,-18],[-48,24],[-73,54],[-24,27],[4,67],[-18,36],[-73,44],[-51,16],[-45,-73],[5,-14],[-45,-24],[-8,-21],[-34,24],[-50,56],[1,36],[-25,52],[22,-2]],[[3560,5365],[72,-16],[23,13],[94,0],[46,46],[57,-50],[29,14],[54,-21],[45,5],[-14,37],[25,9],[-30,18],[46,24],[54,5],[9,51],[-26,18],[11,24],[27,0],[74,27],[1,14],[53,-1],[-11,25],[27,18],[42,-11]],[[5627,6081],[34,0],[20,-40],[30,0],[29,-34],[56,-7],[11,-32]],[[5807,5968],[-58,-42],[-44,4],[-60,-29],[-14,-23],[-39,-21],[3,-24],[-34,-24],[-23,-48],[-32,-19],[4,-20],[-32,-30],[-8,-33],[-41,-17],[-41,-82],[-27,-13],[-47,10],[-56,-36],[-34,12],[-54,-17]],[[5170,5516],[-76,14],[-34,-9],[-58,9],[-69,-45],[-48,9],[-40,-20]],[[4268,5614],[-36,34],[-23,54],[-43,0]],[[4421,5982],[46,-1],[32,-27],[86,-35],[99,2],[77,10],[34,-4],[29,14],[-17,34],[23,16],[95,5],[60,13],[8,23],[32,4],[63,-24],[52,28],[49,10],[38,61],[77,11],[75,-20],[77,18],[73,-55],[98,16]],[[9999,2044],[-255,38]],[[9744,2082],[35,31],[-13,26],[-49,-9],[-13,40],[18,5],[-68,214]],[[9654,2389],[214,108],[131,68]],[[9999,2565],[0,-521]],[[8924,2235],[-48,-25],[0,-63]],[[8876,2147],[-37,7],[-3,20],[-44,12],[-36,-19],[-28,-69],[7,-59],[17,-25],[33,-9],[-51,-43],[-25,-57],[14,-13],[58,4],[56,30]],[[8837,1926],[6,-39]],[[8843,1887],[-5,-24]],[[8838,1863],[7,-34]],[[8845,1829],[-11,-31],[-44,-85],[-15,-46],[1,-75],[-14,-23],[-9,-46],[-23,-70]],[[8730,1453],[-17,-17]],[[8559,1859],[25,19],[4,26],[39,31],[-12,14]],[[8615,1949],[56,92],[30,81],[29,136],[26,5],[10,57]],[[8766,2320],[45,3],[10,-11],[36,8],[11,37],[56,23],[15,18]],[[8939,2398],[-13,-18],[16,-36],[14,-59],[-32,-50]],[[4055,3591],[-103,-123],[-11,-48],[-18,-23],[5,-38],[34,-16],[-17,-11],[36,-50],[-38,-16],[-19,-36],[9,-27],[-69,9],[-16,-5],[-71,23],[-23,36],[-45,34],[-29,9],[-47,-4],[-107,49],[-67,46],[-36,1],[-12,17],[-77,1],[-41,28],[-6,36],[7,48],[65,40],[34,-38],[31,8],[20,32],[51,7],[17,-29],[96,-32],[56,18],[21,-6],[86,4],[41,11],[24,18],[52,7],[34,-13],[102,41],[31,-8]],[[2294,3801],[25,-15],[-13,-25],[-12,40]],[[2507,4323],[49,-28],[28,-1],[-11,-27],[13,-27],[35,-16],[-13,-10],[41,-69],[-19,-35],[-30,-28],[26,-45],[-11,-30],[-10,-117],[-19,-82],[-30,-6],[-55,26],[-48,-20],[7,-24],[-49,-43],[-25,13],[-34,-7],[-10,39],[-45,40],[15,20],[-15,19],[22,47],[-5,45],[18,-13],[9,40],[-38,9],[2,35],[21,15],[-7,52],[-19,9],[-18,55],[-36,-3],[9,31],[-16,9],[19,34],[75,-11],[77,34],[40,39],[37,12],[20,19]],[[2795,4709],[-10,-13],[-58,-7],[-4,18],[72,2]],[[3587,5618],[-6,-16],[-59,-24],[-3,-31],[52,-13],[-42,-42],[39,-10],[-14,-33],[51,-21],[27,-31],[-43,-7]],[[3589,5390],[23,6],[-62,44],[-31,-18],[-48,13],[-39,-34],[-158,-49],[31,24],[-64,-18],[-14,-41],[22,-15],[5,-32],[49,-30],[-21,-40],[-36,7],[-10,-23],[8,-65],[25,-65],[78,-59],[57,-21],[74,-47],[88,-43],[53,-100],[26,-81],[32,-48],[117,-92],[37,-12],[4,-18],[100,-43],[74,-4],[140,9],[37,-14],[4,-24],[-65,-37],[8,-44],[154,-62],[112,-31],[35,-15],[66,-47],[129,-44],[7,-23],[64,-39],[33,-32],[19,-40],[-20,-20],[-12,-52],[-11,-4],[-65,29],[-18,22],[0,28],[-36,42],[-81,4],[-73,25],[27,23],[-66,5],[-33,-18],[-44,-61],[-31,-29],[7,-28],[-34,-39],[6,-29],[26,-17],[42,-4],[12,-14],[75,-35],[-9,-17],[0,-53],[14,-26],[-18,-28],[-41,10],[-78,-30],[-18,-23],[6,-77],[-54,-27],[-41,-40],[-22,-50],[-78,-2],[-27,15],[0,62],[33,9],[33,67],[-18,27],[38,16],[29,-1],[23,22],[0,27],[-32,38],[-21,89],[-29,27],[-17,36],[-6,42],[-41,50],[-44,-18],[-39,8],[-35,35],[-52,18],[21,38],[-39,58],[-20,10],[-44,-14],[-59,-4],[36,23],[-48,36],[-44,-2],[-59,77],[-31,26],[-36,-11],[-61,21],[-67,-16],[-37,42],[-62,12],[-46,45],[-48,25],[-24,42],[-56,33],[-22,-1],[-41,59],[-71,32],[-67,5],[25,13],[-8,21],[-64,49],[-39,10],[11,22],[-35,16],[-28,-9],[4,75],[-23,38],[-27,22],[-15,82],[-38,52],[-64,22],[-6,-11],[-142,71],[-98,19],[-25,-1],[-62,-31],[-18,-29],[-30,-11],[-30,-45],[-45,-25],[-64,-16],[-46,0]],[[3272,4976],[0,0]],[[3284,4485],[0,0]],[[9744,2082],[-36,-27],[-145,-38],[-348,-89],[126,-119],[121,-125],[-84,-45],[-40,-79],[-172,-31],[-13,-9],[-55,-83],[-99,-72],[-12,-2],[-259,39]],[[8728,1402],[12,45],[-10,6]],[[8845,1829],[23,24],[-30,10]],[[8843,1887],[22,-6],[14,41],[4,70],[-7,2]],[[8876,1994],[-9,72],[12,45],[-3,36]],[[8924,2235],[33,-7],[42,-49],[29,2],[45,-33],[108,-17],[39,23],[434,235]],[[5489,4569],[-35,-2],[-31,-37],[-46,27],[-76,-28],[-20,-58],[-33,6]],[[5127,4643],[9,26],[-19,22],[38,0],[39,21]],[[5194,4712],[32,5],[0,29],[34,13],[13,21],[-18,18],[48,21],[11,-23],[61,-21],[41,-50],[36,-9],[-8,-25],[40,-4],[56,-20],[-63,-82],[12,-16]],[[8766,2320],[17,19],[23,72],[19,14],[31,71],[2,27],[23,0],[16,53],[2,37],[37,43],[43,20],[-4,28]],[[8975,2704],[56,-8],[30,14],[28,-12],[-26,-33],[47,-18],[19,-55],[-31,-36],[-21,-1],[-30,-33],[25,-13],[-77,-11],[-31,-43],[28,-13],[-53,-44]],[[6316,0],[-3165,0]],[[2575,1618],[54,25],[31,5],[77,92],[19,46],[-6,40],[-33,82],[2,21],[48,54],[41,4],[48,55],[30,19],[16,25],[138,57],[29,34],[-27,31],[1,66],[12,68]],[[3055,2342],[32,-18],[51,-5],[67,-40],[54,-23],[115,-7],[88,29],[40,-4],[53,-25],[52,0],[94,-20],[71,-50],[63,-16],[113,-14],[43,-58],[-3,-47],[36,-82],[60,-59],[70,-29],[76,-12],[89,0],[105,-26],[49,-8],[25,-13],[75,-24],[36,-19],[60,-17],[36,-32],[80,-59],[66,-30],[32,-7],[68,8],[67,29],[32,23],[70,76],[28,65],[-2,33],[-30,44],[-16,40],[-9,60],[5,37],[26,47],[68,63],[57,38],[129,54],[46,-2],[41,10],[37,29],[55,-7],[64,6],[68,-13],[23,-16],[156,-44],[-10,-73],[77,-34],[66,-2],[79,-23],[23,-21],[110,-3],[45,10],[60,-17],[41,-77]],[[5350,7767],[-15,3]],[[5335,7770],[38,52],[6,-19],[-29,-36]],[[5954,7440],[-5,47],[-36,26],[-116,41],[-17,-11]],[[5780,7543],[-21,23],[11,66],[26,13],[-5,30],[-46,18],[-10,22],[-79,2],[-49,-9],[-163,64],[-26,-10]],[[5418,7762],[-11,66],[-35,54],[-6,82]],[[5366,7964],[131,58],[121,26],[101,-5],[41,-11],[66,13],[38,-22],[43,15],[46,-11],[57,5],[95,-22],[43,9],[39,-9],[46,24],[66,16],[48,-59],[134,-11],[11,-14],[114,-57],[24,-26],[77,-19]],[[6890,8321],[43,0],[-5,-24],[77,-30],[2,-31],[-33,-15],[12,-19],[-29,-49],[49,5],[8,-29],[35,-39],[28,-9],[22,-67],[-16,-34]],[[5366,7964],[-20,39],[9,90],[14,61],[71,34],[13,70],[69,70],[73,11],[147,38],[12,-41],[114,-53],[29,-63],[22,-14],[86,-22],[41,4],[84,34],[41,26],[6,28],[-24,129]],[[0,2156],[0,34]],[[2071,4936],[-18,-5]],[[7095,5358],[-33,32],[25,9],[-20,95],[40,111],[0,34],[-31,56],[-9,34],[-58,35],[-29,42],[-21,4],[-51,68],[-30,22],[-32,75],[-42,48],[-46,22],[-46,0]],[[6712,6045],[41,29],[58,5],[44,-9],[72,28],[60,-5],[42,-28],[31,-4],[6,-20],[70,-3],[29,-40],[21,22],[56,-13],[26,-37],[51,6],[27,-26],[0,-27],[-29,-56],[79,-62],[31,7],[-6,-43],[14,-22],[-9,-27],[88,-32],[-4,-70],[40,-35],[-56,-9],[-32,32],[-32,-26],[-36,27],[-31,0],[-26,-29],[-4,45],[-57,-21],[-4,-45],[19,-16],[-19,-52],[-49,-13],[2,-25],[-64,-44],[16,-20],[-14,-20],[-51,5],[-17,-14]],[[5344,4228],[0,-1]],[[5381,4227],[-18,37],[-33,-13],[13,-16]],[[5339,4240],[0,0]],[[5286,4240],[14,5],[9,45],[-40,15],[-5,-22]],[[5489,4569],[28,-3],[61,24],[40,-7],[40,16],[20,-14]],[[3796,2997],[-9,-11],[-45,20],[-5,22],[45,-11],[14,-20]],[[4916,4884],[6,-23],[37,-14],[50,-47],[33,-5],[22,-20],[30,7],[45,-34],[53,-18],[2,-18]],[[4966,4589],[-8,-9]],[[4956,4576],[-52,-1],[19,-28],[36,-17]],[[4957,4472],[-47,21],[-7,25],[-65,62],[-23,-5],[-23,46],[-45,-10]],[[1082,6811],[46,10],[77,-18],[41,15],[47,-9]],[[1243,6890],[-9,-19],[-70,24],[66,4],[13,-9]],[[1684,7103],[-14,-36],[-57,-15],[-30,-22],[-65,18],[-5,10],[126,56],[45,-11]],[[1455,7237],[-23,-27],[-20,13],[34,33],[9,-19]],[[1302,6809],[-77,20],[-28,-15],[-70,17],[-21,17],[27,15],[65,5],[66,-41],[44,0],[-11,18],[-61,18],[49,7],[-50,47],[23,9],[-17,32],[32,7],[89,82],[21,41],[36,114],[41,-16],[113,47],[16,31],[35,20],[94,25],[89,2],[93,12],[40,-27],[72,-26]],[[1497,7191],[14,-38],[39,-5],[-14,-24],[-47,-8],[14,-45],[-30,-16],[95,-25],[42,0],[60,34],[23,28],[-12,22],[-40,0],[-12,39],[27,17],[-76,4],[-9,54],[-74,-37]],[[1548,8755],[5,-31],[-32,7],[10,54],[17,-30]],[[1533,8887],[25,-19],[-59,3],[34,16]],[[1601,8880],[-45,-2],[-14,28],[33,12],[26,-38]],[[1641,8945],[-32,-41],[-37,25],[69,16]],[[1504,9007],[-7,-32],[-32,24],[4,37],[35,-29]],[[1487,9057],[44,-18],[-20,-12],[-24,30]],[[1645,9045],[-46,-8],[-40,26],[88,32],[-2,-50]],[[1470,9394],[65,-12],[-51,-13],[-51,12],[37,13]],[[1652,9493],[22,-17],[-63,-9],[6,24],[35,2]],[[1739,9505],[-47,-23],[-14,32],[31,11],[30,-20]],[[1941,9599],[-53,-18],[5,19],[48,-1]],[[2130,9670],[-38,-18],[-36,15],[74,3]],[[2253,9704],[-63,5],[44,15],[19,-20]],[[2324,9726],[20,-17],[-54,-1],[-16,25],[50,-7]],[[2231,9749],[-71,7],[1,13],[70,10],[0,-30]],[[2441,9826],[34,-30],[-169,-25],[-32,9],[65,33],[102,13]],[[2400,9863],[7,-21],[-85,-14],[-49,5],[127,30]],[[3691,9998],[4,-46],[-51,-39],[-170,20],[-61,-8],[-73,-25],[-94,-74],[-30,-14],[8,-35],[-51,-41],[56,-71],[-29,-19],[13,-46],[-16,-37],[55,-86],[-38,-125],[62,-35],[40,-5],[74,-49],[-50,-79],[-97,-6],[23,-64],[53,-59],[0,-30],[-26,-24],[6,-44],[-89,-54],[-71,-6],[10,-41],[-52,-36],[32,-76],[-35,-81],[-52,-6],[-3,24]],[[3039,8681],[-16,27],[-133,15],[-55,64],[15,42],[-24,32],[32,46],[-52,-15],[10,-40],[24,-20],[-18,-18],[-74,6],[59,-36],[-2,-40],[-27,5],[-32,-59],[-65,-18],[-79,43],[23,-28],[-49,-29],[-55,-4],[37,-12],[-61,-40],[-60,-22],[-5,-17],[-104,-63],[-24,3],[-67,-41],[-23,30],[-27,-35],[-82,-15],[-140,3],[-111,19],[38,28],[-72,12],[-97,29],[-11,22],[-61,10],[-54,58],[23,34],[-6,35],[66,-18],[65,-29],[-53,59],[92,47],[-34,-1],[-8,32],[-37,-12],[-26,45],[-13,-26],[23,-20],[-57,-14],[-61,3],[-45,52],[73,54],[7,-49],[11,34],[39,-3],[44,25],[-57,22],[104,58],[10,30],[51,38],[70,12],[8,20],[-98,-27],[-35,-35],[-26,6],[-63,-69],[-12,46],[-37,-7],[19,54],[-54,-58],[-45,19],[-11,44],[29,2],[2,32],[65,-28],[32,14],[10,61],[-108,-39],[-77,54],[78,-17],[31,-20],[-34,47],[-60,6],[-7,49],[29,8],[72,-13],[41,16],[120,8],[40,-16],[68,11],[13,18],[86,-21],[95,13],[3,12],[-103,-19],[-11,12],[-94,24],[-16,-36],[-119,14],[-98,-10],[-39,-12],[-57,35],[-45,7],[28,40],[53,16],[-35,28],[-43,10],[5,27],[85,24],[14,17],[133,-18],[-53,14],[57,5],[-108,5],[-87,-10],[55,34],[-67,18],[18,26],[65,-37],[-5,30],[103,5],[65,-30],[-48,35],[25,20],[160,35],[-107,4],[69,17],[-65,-2],[13,20],[148,11],[105,-15],[39,20],[133,26],[-167,-23],[-17,14],[-83,-4],[10,28],[-33,17],[95,26],[56,-26],[115,16],[43,-39],[100,-33],[-93,41],[-8,25],[-45,19],[13,18],[50,-17],[3,29],[75,-4],[16,17],[-33,22],[55,8],[-15,16],[58,2],[33,17],[17,-36],[84,14],[-65,22],[49,23],[80,20],[63,-53],[-30,-24],[64,-1],[-1,28],[50,7],[123,-12],[-34,32],[88,42],[99,16],[-7,16],[-73,0],[27,23],[66,19],[-57,2],[-94,-33],[44,-8],[-35,-32],[-58,-11],[-61,-27],[-106,-21],[-44,49],[56,22],[-117,-29],[0,27],[148,47],[-53,-1],[57,58],[77,24],[-10,14],[891,1]],[[5016,7567],[3,-1]],[[5019,7566],[-43,-20],[-52,-9],[38,-14],[81,27],[9,12]],[[5052,7562],[370,-12],[342,-11],[16,4]],[[5983,6845],[23,-27],[-16,-16],[56,-47],[11,-36],[53,-41],[-41,-7],[29,-23],[7,-43],[-31,-33],[-65,-5],[-148,-106],[-111,-104],[18,-34],[-2,-54],[35,-21],[1,-22],[-77,18]],[[5725,6244],[-36,5],[-91,30],[-5,17],[-42,24],[-53,12],[-42,-4],[-40,10],[-87,-40],[-51,27],[-36,-7],[-54,5],[-46,-21],[-14,-31],[-32,12],[-37,-10],[-6,52],[-32,0],[-47,48],[-49,-21],[-14,-27],[-53,0],[1,23],[-31,5]],[[3723,7381],[6,11],[54,-19],[26,42],[-102,9]],[[3710,7440],[38,-5],[100,29],[328,62],[48,17],[40,43],[106,18],[97,35],[132,18],[105,4],[61,-71],[4,-28],[100,-22],[91,8],[56,19]],[[8547,1884],[68,65]],[[8876,1994],[-20,-7],[-17,-30],[-2,-31]],[[7095,5358],[32,-34],[59,-18],[49,-4],[9,23],[38,0],[87,29],[77,-24],[2,-32]],[[7448,5298],[4,-17],[-15,-73],[-111,-17],[-37,-23],[24,72],[-31,8],[-25,-17],[16,-45],[-31,-9],[-6,-18],[33,8],[-45,-28],[3,-20],[40,24],[-63,-61],[-5,-45],[10,-37],[-22,-64]],[[5762,5055],[-52,62],[22,19],[48,7],[-82,37],[-26,-12],[-32,-42],[-15,-3],[-29,36],[-36,12],[-37,-5],[-26,21],[-61,17],[43,12],[-41,27],[34,38],[-124,46],[-53,39],[4,65],[-16,-6],[-37,41],[-50,19],[-26,31]],[[5807,5968],[35,9],[23,27],[59,-24],[102,-2],[109,-23],[75,13],[86,-58],[54,15],[34,32],[209,19],[32,23],[11,35],[76,11]],[[5052,7562],[157,61],[-55,3],[-52,-12],[-83,-48]],[[5016,7567],[68,50],[18,28],[-6,40],[103,1],[65,27],[71,57]],[[5350,7767],[-111,-75],[133,-16],[37,10],[-12,63],[21,13]],[[7047,8765],[23,-4]],[[9947,4848],[-28,27],[-37,18],[-94,81],[-51,31],[-34,31],[-92,45],[-101,18],[-30,38],[-17,0],[-50,41],[5,-23],[-78,11],[-26,16],[-15,41],[-28,20],[-85,29],[-34,-1],[-27,24],[88,18],[-39,4],[10,37],[74,-27],[-12,-24],[104,31],[53,-14],[-11,65],[-25,-34],[3,53],[55,26],[27,66],[24,9],[10,-32],[21,47],[25,4],[43,-26],[26,21],[-62,25],[-56,45],[-23,-10],[-35,28],[-22,49],[59,-14],[70,28],[11,-14],[63,-5],[-42,41],[97,18],[66,34],[45,-6],[15,22],[-14,40],[-43,6],[-36,-23],[-102,-18],[-73,-4]],[[9519,5761],[20,43],[-26,10],[39,71],[92,16],[15,36],[20,11],[52,-8],[161,1],[1,43],[56,65],[-43,8],[26,17],[-28,51],[-43,1],[18,39],[60,25],[-41,9],[-25,32],[58,8],[8,19],[44,27],[6,20],[-28,34],[21,31],[-27,7],[-52,-17],[-44,18],[-15,27],[-56,1],[-35,32],[-60,-13],[-62,27],[-78,16],[-14,20],[-30,0],[-2,-31],[-40,-10],[-21,27],[-45,18],[-34,34],[3,18],[-40,33],[-58,-16],[-84,-10],[-51,-27],[-55,23],[-34,-5],[-40,34],[-69,0],[-35,-20],[-55,34],[-17,36],[22,11],[-46,80],[-26,11],[-19,39],[-35,4],[-48,-12],[-31,14],[-105,7],[23,11],[-16,18],[2,36],[-23,41],[60,6],[2,26],[-70,34],[-6,49],[-65,50],[-66,-16],[-12,17],[-69,3],[-69,-33],[-93,20],[-42,1],[-18,-54],[-89,-18],[-35,18]],[[6960,8438],[57,-10],[15,-25],[45,0],[8,35],[-51,42],[-82,-10],[-18,44],[61,39],[4,86],[-21,43]],[[7009,8723],[25,28],[67,6],[-11,13]],[[7051,8801],[13,24],[-16,44],[20,10],[70,-33],[34,49],[48,-19],[71,17],[27,34],[35,1],[224,-29],[5,30],[-64,7],[-24,33],[-36,9],[-68,-8],[-98,7],[-48,40],[-50,7],[-41,42],[59,-26],[-7,56],[-61,-4],[-14,-18],[-75,-17],[-55,7]],[[7554,9998],[1264,0],[7,-15],[112,12],[40,-36],[63,-18],[13,-28],[100,-21],[119,-8],[23,-18],[77,-1],[12,21],[79,11],[25,21],[-45,52],[10,28],[546,0],[0,-5103]],[[9999,2044],[0,-2044],[-412,0],[-11,34],[-21,23],[-44,24],[-25,24],[-52,19],[-46,35],[-37,-5],[-22,25],[6,18],[-74,99],[26,6],[0,64],[-37,46],[-7,28],[-34,53],[-29,27],[-22,-1],[-15,24],[8,41],[-38,16],[-86,147],[-21,18],[-16,36],[-29,24],[-27,36],[-4,21],[-63,70],[-7,28],[-41,60],[-39,32],[12,13],[-39,14],[-30,-10],[-53,16],[-18,-26],[-15,18],[21,16],[35,87],[-6,34],[16,52],[2,41],[23,75]],[[5725,6244],[-43,-55],[-19,-45],[-35,-22],[-1,-41]],[[3560,5365],[29,25]],[[4403,8276],[-2,-29],[-47,-63],[-57,-100],[-35,-79],[-20,0],[-3,75],[54,80],[23,5],[87,111]],[[4817,8398],[12,18],[39,0],[-13,-45],[-30,2],[-14,-30],[7,-41],[29,-2],[-137,-88],[-11,-35],[-39,-5],[15,36],[-21,109],[85,72],[68,28],[10,-19]],[[3112,8452],[-35,-31],[-22,28],[57,3]],[[3124,8498],[4,-30],[-73,-10],[-18,19],[58,30],[29,-9]],[[4792,8814],[-31,-27],[-11,14],[42,13]],[[3691,9998],[1739,0],[-90,-55],[-41,-64],[-95,-48],[-88,-7],[-65,-30],[-16,-23],[-26,22],[-22,-26],[-50,11],[-3,-29],[-33,-8],[-24,-31],[-31,21],[-36,-6],[-78,-56],[10,-34],[-46,0],[-22,-25],[-65,11],[28,-48],[-36,-24],[-80,-21],[-30,23],[-24,-9],[5,-35],[36,-34],[-14,-54],[-26,-18],[13,-50],[-83,-34],[30,-24],[-18,-21],[24,-15],[-9,-85],[35,-61],[-29,-10],[113,-23],[-5,-23],[68,21],[12,-22],[51,-28],[65,-14],[28,-28],[-35,-8],[97,-19],[20,-42],[21,-6],[-48,-35],[61,2],[-69,-23],[-28,-27],[-55,-23],[-90,-23],[106,-12],[-13,22],[51,-30],[-87,0],[35,-42],[-99,-24],[-27,-32],[-31,11],[-4,41],[-35,-8],[4,-43],[-66,-41],[-54,-4],[-50,-27],[-168,11],[124,-18],[47,-26],[-68,-19],[34,-22],[-5,-48],[-39,18],[33,-44],[-23,-8],[24,-28],[-82,4],[66,-41],[-41,-34],[41,-28],[-35,-22],[-20,-51],[29,-32],[-55,-71],[6,-21],[-33,-7],[-50,-95],[-45,-42],[-6,18],[-62,11],[-50,-16],[-99,9],[-61,-3],[16,-33],[-66,2],[-70,-54],[-3,-22],[41,-50],[-44,-32],[-61,10],[-68,-4],[-89,-18],[-73,14],[-15,36],[35,31],[-34,19],[-76,90],[-25,39],[46,-13],[34,10],[-52,37],[73,17],[-9,37],[-37,2],[-32,43],[-62,30],[-30,37],[-40,91],[-29,-25],[-4,64],[-51,25],[23,13],[-35,16],[35,45],[10,42],[-28,33],[-54,-12],[40,35],[-28,3],[-14,-30],[-19,29],[-48,-21],[18,31],[-28,65],[5,46],[-22,7],[21,32],[31,4],[28,-26]],[[8975,2704],[-25,67],[7,47],[17,19],[-11,54],[-44,36],[25,45],[-10,25],[27,18]],[[8961,3015],[60,-25],[9,32],[39,12],[4,56],[70,0],[-32,63],[18,65],[13,19],[65,-14],[21,-30],[55,3],[50,-5],[35,19],[55,11],[98,36],[74,-18],[47,-34],[74,2],[51,-11],[127,20],[105,38]],[[9999,3254],[0,-689]],[[2916,2518],[32,-23],[-41,-35],[-39,18],[1,38],[47,2]],[[3001,2731],[-36,-25],[29,40],[7,-15]],[[2353,3266],[73,20],[32,32],[42,20],[32,0],[97,27],[28,-4],[-21,-29],[26,-16],[0,29],[43,1],[52,-22],[-22,-37],[40,-36],[-18,-17],[40,-20],[31,32],[40,9],[73,47],[25,-54],[-28,-20],[-53,-82],[-61,-18],[-17,-40],[9,-59],[25,-34],[54,-18],[-1,-16],[52,-21],[-3,-68],[29,-24],[-59,-70],[0,-20],[-81,-84],[-37,-9],[-73,-41],[-27,-59],[13,-34],[63,-61],[38,-13],[55,15],[0,-56],[47,14],[17,25],[32,-25],[-5,-20],[19,-30],[2,-30],[79,-8]],[[6554,4055],[-53,-14],[-20,6],[23,21],[38,9],[12,-22]],[[6958,4179],[23,-5],[-30,-15],[-19,15],[26,5]],[[7051,4502],[-11,-37],[27,-44],[36,-31],[37,-17],[127,-45],[48,-7],[-30,-58],[-39,-10],[-48,2],[-94,28],[-61,-14],[-6,-12],[-44,8],[-61,-5],[-24,-39],[-60,-48],[-32,-5],[-88,-39],[-16,-23],[-66,-40],[8,-11],[-53,-25],[28,43],[-15,23],[93,46],[56,23],[-9,14],[-69,-15],[-104,4],[-8,31]],[[8961,3015],[16,25],[-45,74],[31,30],[65,39],[3,45],[-34,33],[-18,-1],[-43,-35],[-30,-2],[-25,-20],[11,-20],[-29,4],[-39,-20],[-147,70],[-46,-14],[-58,-39],[-56,-47],[1,-22],[-28,-26],[-26,21],[-37,-30],[-37,-15],[-101,2],[-11,-13],[-36,6],[-33,-18],[-71,18],[-35,19],[-82,90],[-51,11],[-115,54],[-158,20],[-21,-13],[-11,-49],[4,-27],[-23,-32],[11,-14],[-29,-23],[-36,14],[-35,-16],[-46,-5],[-60,-24],[-17,20],[-46,16],[-15,-9],[-49,29],[-7,50],[-23,9],[20,16],[-40,23],[-23,-30],[-55,18],[-10,29],[-46,10],[3,-18],[-39,6],[13,-18],[-49,-23],[-11,19],[20,18],[-50,-14],[-48,5],[-12,-25],[-64,2],[-12,12],[128,24],[34,-7],[0,34],[39,5],[31,27],[-82,-5],[-100,-15],[-30,14],[-43,-15],[-8,24],[38,22],[22,-16],[32,27],[2,18],[-38,-1],[-31,21],[-34,1],[5,56],[-48,20],[52,14],[11,50],[-79,34],[-18,-7],[-27,43],[-30,-2],[-7,-23],[-56,31],[-34,9],[19,16],[39,7],[-21,21],[-8,52],[32,0],[36,-39],[-12,-11],[21,-37],[0,23],[29,-11],[87,25],[-53,-7],[-44,45],[-4,29],[47,6],[-8,15],[40,16],[-5,14],[-45,-7],[-12,29],[18,9],[-66,50],[78,52],[-9,25],[-106,-16],[-23,-9],[-69,-2],[18,36],[0,77],[12,18],[37,10],[13,35],[23,6],[52,43],[67,0],[25,15],[50,1],[8,-21],[28,-12],[82,0],[-26,45],[12,6],[73,-14],[-32,-18],[139,0],[39,-9],[37,9],[63,-9],[24,18],[-20,12],[-36,-3],[-35,13],[51,30],[72,5],[55,15],[12,-9],[88,5],[-62,18],[-75,-6],[-22,27],[-57,27],[-5,11],[29,45],[25,8],[158,-23],[61,-1],[32,16],[136,-32],[81,3],[54,24],[3,32],[62,20],[121,52],[25,27],[33,5],[58,25],[70,9],[96,34],[244,-18],[27,7],[61,-7],[47,14],[14,24],[41,-24],[-6,-19],[50,-52],[67,-21],[97,24],[35,-24],[3,-41],[29,-28],[48,-26],[41,33],[52,-6],[36,-14],[13,-28],[54,-8],[59,-26],[25,1],[20,22],[27,-23],[128,-31],[91,9],[53,22],[55,9],[33,-6],[31,14],[42,-21],[69,-18],[29,7],[49,-10],[0,-994]],[[8169,5505],[83,-2],[14,-9],[-97,11]],[[9519,5761],[-18,-16],[-17,15],[-87,-6],[-32,4],[-59,-52],[-18,14],[-78,-23],[-27,-27],[-47,12],[-64,-17],[-25,-22],[-19,12],[-69,-4],[-135,-72],[-43,32],[8,-27],[-30,-27],[-41,-4],[-23,-19],[15,-63],[41,-61],[70,-74],[36,-18],[52,8],[29,32],[50,-23],[28,23],[35,4],[61,-17],[-24,-33],[5,-44],[-56,-21],[-43,10],[-48,-14],[-52,29],[-55,-13],[-9,-28],[-23,5],[-47,-42],[-18,11],[-60,-5],[-70,-22],[-33,-46],[-95,-40],[-53,6],[-34,24],[-48,15],[41,13],[-1,55],[18,22],[-14,41],[-40,23],[-33,-8],[-88,48],[-94,-2],[4,29],[99,50],[80,22],[52,25],[51,1],[12,22],[-29,1],[7,33],[-13,17],[-42,-26],[-31,21],[-66,8],[-1,-11],[-61,3],[-63,-15],[-59,12],[2,20],[-37,2],[-77,32],[64,12],[-13,14],[-104,23],[124,-8],[65,-11],[17,19],[-44,15],[-26,-11],[-29,17],[-21,42],[-17,-5],[11,-30],[-80,-10],[-22,12],[-37,-16],[-43,7],[-86,-17],[-2,-28],[-73,-90],[-86,-64],[-41,5],[-9,-29],[-48,-26],[-20,41],[-11,-75],[37,-13],[-7,-46],[-17,-5]],[[7562,5582],[-4,-13],[46,-23],[29,-34],[19,13],[-21,28],[-50,35],[-19,-6]],[[8536,5557],[-4,-36],[-40,21],[-74,4],[53,-39],[13,8],[95,-18],[41,-36],[30,17],[-19,-38],[49,27],[-25,-29],[17,-16],[63,-14],[27,-51],[-19,-6],[27,-24],[72,-20],[-81,82],[-57,80],[-13,29],[-32,14],[26,13],[-29,10],[-23,-50],[-35,7],[27,29],[-49,22],[-7,-13],[-33,27]],[[8260,2699],[-18,-16],[-6,22],[-37,-1]]],\"transform\":{\"scale\":[0.004132413241324132,0.004072407240724072],\"translate\":[-1.12,23.64]}},\"route\":{\"type\":\"Topology\",\"bbox\":[11.763718,36.630289,35.85061,52.501756],\"objects\":{\"route\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"LineString\",\"arcs\":[0,1]}]}},\"arcs\":[[[13.437502,52.482969],[13.437502,52.482969]],[[13.437502,52.482969],[13.459883,52.471876],[13.464029,52.47001],[13.456178,52.465669],[13.453382,52.463194],[13.458844,52.457652],[13.463443,52.450949],[13.467339,52.448475],[13.491285,52.43701],[13.504843,52.430278],[13.508108,52.428983],[13.5179,52.427449],[13.521465,52.424612],[13.521809,52.420264],[13.523588,52.41186],[13.521374,52.406447],[13.520122,52.400993],[13.518597,52.398647],[13.519733,52.395738],[13.528571,52.388017],[13.539556,52.381051],[13.543737,52.377152],[13.546673,52.372967],[13.548427,52.366795],[13.547908,52.362509],[13.548856,52.358091],[13.553918,52.349049],[13.554905,52.346026],[13.555003,52.342227],[13.553622,52.333505],[13.553647,52.328517],[13.555074,52.31111],[13.556183,52.299741],[13.558295,52.293855],[13.589853,52.244762],[13.590921,52.242194],[13.595584,52.224169],[13.597128,52.220712],[13.599162,52.218092],[13.605648,52.211235],[13.613345,52.200835],[13.615231,52.195872],[13.615925,52.189243],[13.617669,52.185479],[13.623468,52.177638],[13.628085,52.173476],[13.638014,52.167834],[13.642397,52.164303],[13.646509,52.159307],[13.648571,52.154693],[13.649136,52.146894],[13.646321,52.12405],[13.646424,52.107893],[13.649437,52.079247],[13.653383,52.05959],[13.654255,52.056078],[13.657077,52.051384],[13.686098,52.021493],[13.69201,52.017363],[13.713633,52.007203],[13.717297,52.005024],[13.722575,51.999556],[13.726815,51.991536],[13.730147,51.987482],[13.745575,51.974951],[13.748526,51.973113],[13.75585,51.969633],[13.760197,51.966983],[13.764077,51.963212],[13.766746,51.957277],[13.766291,51.952228],[13.763062,51.941734],[13.763048,51.937379],[13.765302,51.932597],[13.769483,51.92836],[13.789195,51.914626],[13.808366,51.902809],[13.816078,51.897333],[13.823955,51.893362],[13.836841,51.889297],[13.852631,51.885776],[13.876216,51.880736],[13.885809,51.877728],[13.890977,51.875024],[13.895891,51.871162],[13.898563,51.868004],[13.906375,51.854975],[13.908461,51.852649],[13.914024,51.848437],[13.920208,51.845563],[13.922089,51.842878],[13.920684,51.840523],[13.909543,51.82897],[13.889568,51.811592],[13.887125,51.808948],[13.884826,51.804253],[13.882027,51.794094],[13.881096,51.791983],[13.868199,51.772966],[13.866173,51.768877],[13.861407,51.748399],[13.861728,51.742644],[13.865492,51.736756],[13.891531,51.714712],[13.89523,51.710029],[13.900085,51.699742],[13.901577,51.693303],[13.900257,51.678026],[13.900644,51.675067],[13.902962,51.670407],[13.906328,51.66698],[13.913152,51.663035],[13.917824,51.661457],[13.925829,51.659462],[13.933662,51.656075],[13.938715,51.651882],[13.941468,51.647407],[13.942227,51.643839],[13.940896,51.633568],[13.941497,51.630246],[13.943268,51.626529],[13.952305,51.609533],[13.953831,51.603392],[13.952712,51.59883],[13.949216,51.59398],[13.945154,51.59094],[13.93903,51.587156],[13.934627,51.583055],[13.932585,51.579637],[13.93045,51.571076],[13.928644,51.567143],[13.924786,51.563055],[13.916625,51.557114],[13.9137,51.554219],[13.911056,51.549341],[13.909758,51.540287],[13.908928,51.53685],[13.905229,51.527082],[13.905104,51.523406],[13.906036,51.518113],[13.90585,51.513915],[13.901567,51.500301],[13.898207,51.495534],[13.893559,51.491998],[13.884104,51.487075],[13.879511,51.483802],[13.863669,51.469057],[13.843254,51.450313],[13.834105,51.440674],[13.81517,51.425023],[13.805761,51.414159],[13.800649,51.410907],[13.757708,51.392339],[13.753876,51.390211],[13.750418,51.387044],[13.747926,51.382828],[13.74593,51.370863],[13.74355,51.366862],[13.741192,51.364922],[13.725245,51.354901],[13.718261,51.349685],[13.71655,51.346208],[13.718132,51.336615],[13.718351,51.327135],[13.719677,51.322965],[13.728534,51.307083],[13.730359,51.302969],[13.734305,51.290739],[13.734192,51.286203],[13.73246,51.283458],[13.72721,51.277545],[13.72545,51.274656],[13.722438,51.261132],[13.722868,51.256876],[13.725345,51.251468],[13.726339,51.247937],[13.726989,51.242567],[13.727075,51.233567],[13.728092,51.228814],[13.733515,51.219875],[13.737595,51.207425],[13.739224,51.198503],[13.74097,51.193619],[13.745863,51.182018],[13.747403,51.174239],[13.749779,51.168293],[13.750826,51.157832],[13.749465,51.153294],[13.746494,51.147977],[13.746538,51.144913],[13.749894,51.139113],[13.750547,51.135561],[13.74603,51.120394],[13.743421,51.114998],[13.740263,51.11105],[13.736786,51.10879],[13.72998,51.105577],[13.724179,51.103682],[13.705196,51.099116],[13.700785,51.097233],[13.696329,51.094048],[13.692726,51.089611],[13.688612,51.081771],[13.684148,51.077721],[13.681509,51.076026],[13.676141,51.074185],[13.667147,51.072345],[13.663129,51.071908],[13.651244,51.071733],[13.64441,51.07135],[13.631299,51.069002],[13.611552,51.064362],[13.606927,51.064028],[13.605427,51.061915],[13.60551,51.059098],[13.604032,51.05365],[13.604721,51.05112],[13.607548,51.047153],[13.608188,51.041338],[13.612585,51.037965],[13.617237,51.03698],[13.626267,51.036926],[13.635683,51.034995],[13.639583,51.034855],[13.654999,51.036157],[13.661535,51.03566],[13.66496,51.034548],[13.671397,51.029819],[13.687657,51.022664],[13.688856,51.020893],[13.71822,51.012631],[13.724357,51.009459],[13.727659,51.008311],[13.737681,51.005963],[13.745733,51.001656],[13.751718,50.999081],[13.757795,50.997315],[13.764137,50.994744],[13.772773,50.98936],[13.784078,50.984374],[13.791962,50.980378],[13.798813,50.977881],[13.810122,50.975442],[13.8236,50.970607],[13.828741,50.969572],[13.838436,50.968694],[13.8465,50.967051],[13.852653,50.96445],[13.866049,50.957765],[13.869994,50.954229],[13.871605,50.951237],[13.872704,50.946953],[13.874858,50.94355],[13.881446,50.938588],[13.886795,50.933642],[13.889203,50.929594],[13.890267,50.926055],[13.893605,50.907278],[13.893473,50.90337],[13.892586,50.900348],[13.890257,50.896296],[13.887639,50.893506],[13.879931,50.887426],[13.875573,50.88273],[13.872076,50.876091],[13.87129,50.873022],[13.871144,50.867617],[13.872214,50.863041],[13.87429,50.858856],[13.880179,50.849562],[13.88157,50.844704],[13.88318,50.836301],[13.886513,50.829844],[13.887629,50.82526],[13.887016,50.819759],[13.885218,50.815714],[13.881861,50.810071],[13.88098,50.806693],[13.881214,50.801892],[13.881999,50.799529],[13.885396,50.794437],[13.895001,50.785312],[13.900708,50.781842],[13.906845,50.779953],[13.914608,50.778871],[13.92729,50.778078],[13.934863,50.777191],[13.942393,50.77561],[13.94895,50.773579],[13.955328,50.77115],[13.963405,50.768735],[13.96735,50.766836],[13.970888,50.763738],[13.992473,50.751385],[13.998885,50.749877],[14.002722,50.748367],[14.008381,50.743045],[14.008769,50.739759],[14.008002,50.735986],[14.005772,50.73033],[14.003115,50.726036],[13.998769,50.721845],[13.991042,50.717876],[13.98273,50.71511],[13.977421,50.713873],[13.965625,50.711754],[13.959549,50.709313],[13.956607,50.706095],[13.956021,50.702977],[13.956255,50.698592],[13.955443,50.696139],[13.952347,50.690712],[13.95313,50.687407],[13.958363,50.682133],[13.961484,50.677221],[13.964108,50.674483],[13.974606,50.668711],[13.977415,50.665967],[13.980844,50.65872],[13.98346,50.656094],[13.989863,50.652152],[13.992565,50.648918],[13.992958,50.646667],[13.991793,50.632187],[13.99015,50.627662],[13.9859,50.624036],[13.977018,50.621073],[13.973079,50.618755],[13.969121,50.615666],[13.962714,50.612727],[13.958495,50.614888],[13.953201,50.616589],[13.94858,50.616817],[13.941944,50.615974],[13.928171,50.613307],[13.924878,50.613547],[13.918199,50.615385],[13.909396,50.616912],[13.898196,50.619945],[13.890192,50.619998],[13.881387,50.621419],[13.876834,50.621521],[13.871712,50.623138],[13.877141,50.618027],[13.883431,50.615882],[13.884861,50.614089],[13.882589,50.603756],[13.881819,50.597907],[13.883696,50.596224],[13.889715,50.595015],[13.897769,50.592568],[13.900742,50.591278],[13.903065,50.58928],[13.905774,50.588228],[13.910798,50.587533],[13.918546,50.584434],[13.922328,50.583722],[13.928976,50.579687],[13.928766,50.576959],[13.931417,50.575309],[13.936705,50.574739],[13.939208,50.572217],[13.943418,50.570882],[13.949093,50.571537],[13.953848,50.570981],[13.956129,50.569843],[13.957748,50.566416],[13.962102,50.562975],[13.963962,50.557205],[13.965781,50.554591],[13.967012,50.548921],[13.969,50.546703],[13.978143,50.54157],[13.977237,50.538708],[13.977914,50.537345],[13.984129,50.534083],[13.993922,50.528051],[14.000537,50.526069],[14.005004,50.522847],[14.024723,50.512387],[14.031591,50.509371],[14.036997,50.507649],[14.056591,50.502645],[14.063925,50.49981],[14.070252,50.495669],[14.073935,50.491754],[14.078425,50.485283],[14.084803,50.478985],[14.093832,50.4733],[14.100764,50.469833],[14.103711,50.467804],[14.107383,50.463947],[14.110465,50.459664],[14.114398,50.45552],[14.120074,50.451335],[14.128494,50.447146],[14.132983,50.445595],[14.143145,50.443277],[14.162516,50.440746],[14.173267,50.439075],[14.184304,50.435719],[14.191171,50.432455],[14.201602,50.425677],[14.207631,50.420701],[14.213376,50.414853],[14.216538,50.410902],[14.224183,50.399284],[14.228542,50.394235],[14.232894,50.39038],[14.240629,50.384671],[14.244353,50.381482],[14.252547,50.372059],[14.258782,50.366596],[14.26702,50.361036],[14.271098,50.357639],[14.27526,50.352719],[14.27765,50.348254],[14.280491,50.341608],[14.284594,50.335714],[14.288483,50.332147],[14.295904,50.327336],[14.302768,50.32373],[14.30859,50.319913],[14.312759,50.3155],[14.316216,50.310636],[14.321292,50.307234],[14.337649,50.299984],[14.342871,50.297047],[14.346663,50.29407],[14.350065,50.289876],[14.351776,50.286202],[14.353051,50.2813],[14.355006,50.276674],[14.359717,50.270491],[14.367041,50.263973],[14.369956,50.258804],[14.371471,50.252744],[14.373247,50.249025],[14.378302,50.243507],[14.383771,50.239753],[14.391467,50.235515],[14.401511,50.228307],[14.408385,50.224473],[14.417537,50.220358],[14.426128,50.215173],[14.430456,50.211643],[14.433677,50.208326],[14.437632,50.202905],[14.439741,50.198907],[14.442335,50.192304],[14.445503,50.185457],[14.451982,50.176141],[14.451173,50.174371],[14.452813,50.16545],[14.452339,50.159886],[14.44996,50.148904],[14.450905,50.142761],[14.452932,50.133131],[14.451775,50.1292],[14.452057,50.124339],[14.455852,50.121322],[14.45236,50.122077],[14.446313,50.121722],[14.436852,50.119857],[14.433163,50.118005],[14.423214,50.117955],[14.423479,50.116076],[14.420877,50.116843],[14.42495,50.117508],[14.432754,50.117348],[14.433646,50.116095],[14.443418,50.114722],[14.445463,50.114955],[14.444767,50.110787],[14.443262,50.107842],[14.443015,50.101146],[14.440683,50.09863],[14.436985,50.097716],[14.437482,50.091682],[14.437287,50.086543],[14.433769,50.081926],[14.429893,50.079058],[14.429147,50.075102],[14.43027,50.067942],[14.430495,50.062409],[14.431394,50.060997],[14.441175,50.052896],[14.461877,50.04318],[14.468042,50.040729],[14.473373,50.039694],[14.481716,50.04016],[14.484907,50.039805],[14.489096,50.038003],[14.491159,50.035718],[14.493061,50.031474],[14.495479,50.028523],[14.499594,50.025944],[14.533576,50.012559],[14.543107,50.009439],[14.557845,50.006857],[14.565705,50.004891],[14.571326,50.002454],[14.595251,49.988717],[14.602908,49.983381],[14.644823,49.948759],[14.649009,49.946466],[14.681402,49.937684],[14.68637,49.935687],[14.694062,49.93098],[14.701784,49.92449],[14.708083,49.917183],[14.711025,49.914698],[14.717125,49.912082],[14.72368,49.910711],[14.730537,49.908129],[14.734743,49.904985],[14.746759,49.893893],[14.752327,49.889996],[14.75578,49.886068],[14.757193,49.880353],[14.760462,49.875685],[14.764388,49.873132],[14.7704,49.870869],[14.779406,49.868781],[14.781999,49.867425],[14.788452,49.862169],[14.794202,49.858359],[14.79629,49.855673],[14.796529,49.850367],[14.797449,49.846472],[14.800524,49.843597],[14.807075,49.841521],[14.821245,49.840087],[14.825913,49.839323],[14.849131,49.83438],[14.854639,49.833076],[14.861341,49.83034],[14.865915,49.827103],[14.877178,49.816294],[14.884662,49.810788],[14.890431,49.808127],[14.913084,49.799525],[14.919981,49.796726],[14.923158,49.794609],[14.92707,49.787988],[14.936276,49.775688],[14.939944,49.772608],[14.94897,49.766841],[14.952978,49.761735],[14.958377,49.759083],[14.96426,49.758064],[14.968285,49.756643],[14.975801,49.752521],[14.980779,49.750847],[14.988066,49.749505],[14.993816,49.749303],[15.00371,49.750674],[15.011675,49.752802],[15.025158,49.751303],[15.032399,49.744295],[15.038433,49.739899],[15.040233,49.737662],[15.051997,49.718368],[15.056325,49.714809],[15.059023,49.713777],[15.081037,49.70824],[15.085682,49.706029],[15.088095,49.704062],[15.090069,49.701219],[15.091453,49.694843],[15.094102,49.691386],[15.097003,49.689658],[15.10842,49.685464],[15.111335,49.683584],[15.1145,49.680138],[15.115797,49.677136],[15.123908,49.649871],[15.126566,49.64017],[15.129477,49.631056],[15.136623,49.616096],[15.140397,49.612085],[15.14686,49.609847],[15.173187,49.605518],[15.177949,49.604528],[15.187157,49.60141],[15.19587,49.599151],[15.202159,49.596524],[15.208437,49.596009],[15.213392,49.596913],[15.21956,49.598826],[15.223933,49.599108],[15.230626,49.597885],[15.235916,49.595665],[15.243356,49.59158],[15.255228,49.586326],[15.259807,49.583021],[15.268827,49.574725],[15.275058,49.57092],[15.282753,49.568157],[15.293359,49.563596],[15.298295,49.562402],[15.311212,49.560781],[15.317396,49.558825],[15.321395,49.556762],[15.325169,49.553852],[15.327966,49.550373],[15.329599,49.546738],[15.331413,49.539922],[15.333028,49.536349],[15.335728,49.532976],[15.342438,49.528471],[15.350317,49.526067],[15.355207,49.525422],[15.368377,49.524725],[15.378471,49.523426],[15.382838,49.5224],[15.397273,49.517482],[15.403302,49.515932],[15.411828,49.514907],[15.417807,49.514939],[15.429622,49.516347],[15.437523,49.516847],[15.447031,49.518258],[15.451946,49.517791],[15.457987,49.515472],[15.460869,49.513002],[15.463635,49.509591],[15.467172,49.506617],[15.472303,49.503268],[15.479011,49.497962],[15.486169,49.494409],[15.49134,49.492854],[15.505861,49.489572],[15.508709,49.487813],[15.512288,49.489612],[15.506135,49.493444],[15.50232,49.493876],[15.500293,49.495346],[15.498268,49.502301],[15.496743,49.504759],[15.497576,49.507702],[15.492273,49.507269],[15.485479,49.504878],[15.478017,49.505401],[15.475919,49.508908],[15.473337,49.50945],[15.473751,49.512782],[15.471983,49.516086],[15.472184,49.517508],[15.46441,49.523822],[15.460689,49.525368],[15.459754,49.529534],[15.45307,49.532127],[15.453743,49.533561],[15.451959,49.536809],[15.452174,49.540133],[15.448329,49.546546],[15.445691,49.549357],[15.445859,49.551272],[15.44409,49.554209],[15.44367,49.556953],[15.440634,49.557605],[15.450284,49.561515],[15.454343,49.561667],[15.460489,49.564225],[15.460989,49.569057],[15.4595,49.571298],[15.461459,49.574367],[15.459682,49.57733],[15.460522,49.581074],[15.457125,49.584318],[15.455516,49.588697],[15.45719,49.589754],[15.458623,49.595429],[15.460039,49.598216],[15.462485,49.599149],[15.467739,49.599735],[15.472491,49.606442],[15.472014,49.613316],[15.470151,49.612856],[15.465614,49.61349],[15.459906,49.612407],[15.455067,49.614564],[15.447414,49.619003],[15.43889,49.620191],[15.433971,49.618765],[15.424759,49.619416],[15.421268,49.620201],[15.418557,49.6195],[15.415496,49.616248],[15.410081,49.616085],[15.405791,49.613359],[15.404507,49.611178],[15.396343,49.610293],[15.394529,49.609493],[15.390667,49.611508],[15.383691,49.609032],[15.38311,49.604222],[15.384884,49.599559],[15.388349,49.59768],[15.391179,49.594305],[15.390281,49.591413],[15.395174,49.58576],[15.386977,49.58302],[15.384538,49.579729],[15.384816,49.574126],[15.381329,49.569238],[15.380406,49.566288],[15.37875,49.565363],[15.375876,49.559473],[15.371894,49.556537],[15.370833,49.551079],[15.370065,49.550215],[15.362273,49.547227],[15.357312,49.544543],[15.353635,49.543254],[15.345496,49.542171],[15.345987,49.539782],[15.352889,49.534493],[15.350358,49.531065],[15.34933,49.524677],[15.352635,49.525647],[15.36727,49.524777],[15.376403,49.52386],[15.382251,49.522605],[15.400457,49.516639],[15.40683,49.515398],[15.416459,49.514937],[15.428374,49.51624],[15.43905,49.517097],[15.445757,49.518186],[15.450855,49.518034],[15.455465,49.516787],[15.460731,49.513206],[15.464059,49.509183],[15.47152,49.503872],[15.479874,49.497447],[15.486938,49.49415],[15.491803,49.49274],[15.51129,49.488427],[15.530652,49.483022],[15.534914,49.482001],[15.557485,49.478477],[15.56364,49.475855],[15.568724,49.469693],[15.571014,49.46822],[15.576736,49.465868],[15.579104,49.464326],[15.58505,49.458447],[15.590094,49.455661],[15.595203,49.454297],[15.604835,49.45321],[15.609552,49.451979],[15.630152,49.442917],[15.642605,49.436847],[15.6546,49.430593],[15.660185,49.428157],[15.669239,49.425439],[15.67665,49.424153],[15.693471,49.421821],[15.700493,49.419614],[15.709135,49.415458],[15.716089,49.412946],[15.720829,49.412089],[15.737211,49.410657],[15.749521,49.409182],[15.755945,49.40883],[15.768817,49.408663],[15.780708,49.407295],[15.787712,49.407175],[15.803549,49.407607],[15.80856,49.407254],[15.820035,49.405738],[15.840204,49.403971],[15.849141,49.402544],[15.870733,49.398663],[15.88189,49.397479],[15.887287,49.396358],[15.901076,49.391573],[15.91148,49.389375],[15.919039,49.387355],[15.964856,49.372549],[15.98706,49.36497],[15.996274,49.363382],[16.004496,49.362871],[16.009045,49.362193],[16.01497,49.360524],[16.021225,49.357898],[16.02827,49.35558],[16.032217,49.353608],[16.039002,49.348195],[16.061427,49.335604],[16.070819,49.331305],[16.07452,49.329189],[16.081648,49.323524],[16.086762,49.320767],[16.101856,49.315633],[16.109801,49.311698],[16.117661,49.308318],[16.123631,49.306518],[16.1316,49.304879],[16.147971,49.302464],[16.159179,49.300098],[16.172047,49.295799],[16.181416,49.291314],[16.192278,49.285139],[16.198669,49.282113],[16.208324,49.278942],[16.22154,49.276383],[16.234711,49.273247],[16.239138,49.272443],[16.261204,49.271199],[16.277638,49.270065],[16.28465,49.269185],[16.294808,49.265986],[16.307153,49.260917],[16.313308,49.258983],[16.32174,49.257606],[16.334433,49.257332],[16.338876,49.256881],[16.346836,49.254686],[16.351297,49.25246],[16.365024,49.244493],[16.367912,49.242437],[16.373987,49.237016],[16.382064,49.231467],[16.387948,49.22592],[16.392731,49.223156],[16.402239,49.219929],[16.409965,49.216452],[16.414262,49.213141],[16.416129,49.211019],[16.422217,49.201479],[16.427559,49.196954],[16.433236,49.193655],[16.442203,49.190011],[16.448563,49.188291],[16.474074,49.18368],[16.480386,49.182085],[16.494548,49.177264],[16.51019,49.174437],[16.517986,49.171759],[16.522718,49.170849],[16.535021,49.169299],[16.538818,49.168416],[16.542535,49.166564],[16.543945,49.16684],[16.558817,49.172067],[16.561189,49.173368],[16.563062,49.175667],[16.564755,49.181349],[16.566209,49.183988],[16.567223,49.18845],[16.569225,49.189946],[16.569315,49.194362],[16.567791,49.196596],[16.568018,49.203551],[16.572613,49.210707],[16.578196,49.215054],[16.58552,49.217127],[16.578989,49.225464],[16.579686,49.229491],[16.583425,49.231858],[16.590215,49.234729],[16.590788,49.236256],[16.589258,49.239748],[16.58907,49.248633],[16.588078,49.252588],[16.584168,49.256161],[16.576872,49.260259],[16.574993,49.264466],[16.575719,49.269723],[16.573921,49.274131],[16.565078,49.285514],[16.56205,49.288734],[16.557618,49.29853],[16.5516,49.314463],[16.551636,49.317641],[16.55402,49.323773],[16.552613,49.337648],[16.552647,49.340562],[16.550617,49.352671],[16.552992,49.358276],[16.566465,49.368572],[16.577575,49.379094],[16.583141,49.387428],[16.584497,49.391029],[16.582821,49.397001],[16.583801,49.39955],[16.581843,49.402962],[16.581152,49.405748],[16.582126,49.408274],[16.586974,49.412134],[16.587839,49.414529],[16.585934,49.418413],[16.592005,49.419393],[16.597296,49.417983],[16.600473,49.418345],[16.606109,49.416697],[16.610841,49.414703],[16.616507,49.411026],[16.621099,49.409554],[16.627982,49.404387],[16.630012,49.403971],[16.635439,49.404346],[16.641639,49.404213],[16.644205,49.405912],[16.646449,49.410169],[16.650993,49.414033],[16.657179,49.41718],[16.661173,49.4186],[16.66396,49.420539],[16.666968,49.421239],[16.669149,49.420466],[16.666081,49.418902],[16.665947,49.417501],[16.668279,49.415331],[16.67851,49.415661],[16.682418,49.414342],[16.688727,49.414173],[16.694528,49.413493],[16.702391,49.413539],[16.70822,49.415115],[16.722005,49.414844],[16.726316,49.413901],[16.72897,49.414639],[16.734247,49.413634],[16.739326,49.414613],[16.738501,49.416316],[16.735185,49.419276],[16.735809,49.422502],[16.73818,49.411522],[16.739266,49.414581],[16.734018,49.41367],[16.729088,49.414646],[16.72671,49.41343],[16.727626,49.409704],[16.726528,49.408418],[16.722782,49.406946],[16.721085,49.403035],[16.718834,49.401778],[16.715214,49.40106],[16.712751,49.397501],[16.712296,49.395616],[16.709207,49.39135],[16.708958,49.389885],[16.713025,49.381753],[16.70805,49.379561],[16.706513,49.376798],[16.706717,49.37487],[16.703968,49.373128],[16.701322,49.370294],[16.693493,49.367428],[16.69033,49.367587],[16.686118,49.36635],[16.679627,49.361917],[16.677192,49.359681],[16.667913,49.361881],[16.66389,49.359685],[16.660835,49.359584],[16.65926,49.358505],[16.660156,49.357186],[16.658282,49.356648],[16.650848,49.358267],[16.644731,49.356522],[16.648896,49.353696],[16.652455,49.349581],[16.648981,49.344041],[16.650592,49.340956],[16.648794,49.338751],[16.649042,49.335903],[16.645706,49.334757],[16.642929,49.32735],[16.641461,49.326945],[16.638853,49.328756],[16.636094,49.328959],[16.626226,49.323985],[16.624159,49.326013],[16.61495,49.330176],[16.612044,49.330887],[16.607238,49.330583],[16.603507,49.328667],[16.60132,49.328362],[16.596773,49.32926],[16.591409,49.33155],[16.582401,49.331827],[16.563375,49.335396],[16.553239,49.33587],[16.552892,49.33401],[16.553911,49.324093],[16.553504,49.321777],[16.551181,49.316573],[16.545601,49.315548],[16.53341,49.309132],[16.53111,49.306556],[16.530924,49.298712],[16.526344,49.296885],[16.522767,49.298],[16.521929,49.297424],[16.523505,49.294477],[16.524033,49.291437],[16.522242,49.289026],[16.525594,49.28125],[16.527224,49.267686],[16.527323,49.258861],[16.52457,49.254531],[16.524386,49.251694],[16.5292,49.246664],[16.530448,49.239029],[16.527403,49.237267],[16.52884,49.234129],[16.536186,49.224793],[16.536849,49.220724],[16.539566,49.219006],[16.544154,49.218412],[16.549078,49.219012],[16.553873,49.21754],[16.557761,49.214017],[16.560128,49.212918],[16.56915,49.211487],[16.571346,49.210257],[16.570805,49.20771],[16.568032,49.203653],[16.567746,49.196181],[16.569632,49.19208],[16.568863,49.189968],[16.566315,49.187879],[16.562638,49.175256],[16.560362,49.17296],[16.54749,49.168121],[16.542494,49.166705],[16.542344,49.167936],[16.549451,49.166102],[16.561616,49.162027],[16.568845,49.160646],[16.574329,49.160635],[16.582763,49.161482],[16.585835,49.161421],[16.605523,49.159166],[16.611546,49.158898],[16.625685,49.159196],[16.627919,49.158991],[16.63018,49.156832],[16.629918,49.151353],[16.63077,49.147757],[16.632716,49.143488],[16.644855,49.121998],[16.649203,49.114024],[16.653393,49.103494],[16.660301,49.077081],[16.663165,49.069232],[16.667945,49.060006],[16.675135,49.048651],[16.678854,49.042006],[16.682152,49.034661],[16.685215,49.02463],[16.686332,49.019191],[16.68715,49.011197],[16.687984,48.999413],[16.689198,48.994322],[16.69081,48.990067],[16.695252,48.982342],[16.69889,48.977855],[16.705924,48.971283],[16.714582,48.964664],[16.724968,48.955282],[16.731948,48.951115],[16.735714,48.948232],[16.738119,48.944879],[16.739963,48.940288],[16.741507,48.938221],[16.746271,48.934527],[16.755661,48.929111],[16.761125,48.92546],[16.78315,48.906884],[16.787392,48.904057],[16.797915,48.895756],[16.803908,48.890602],[16.810685,48.884259],[16.826022,48.869343],[16.831518,48.864377],[16.856574,48.843196],[16.864744,48.835988],[16.889492,48.813204],[16.898159,48.805703],[16.920035,48.787641],[16.93069,48.77788],[16.940392,48.767476],[16.945755,48.762098],[16.952296,48.756393],[16.967232,48.744505],[16.974456,48.737648],[16.978209,48.732926],[16.981797,48.726807],[16.983498,48.722772],[16.986277,48.712928],[16.987139,48.706695],[16.98747,48.698578],[16.987132,48.690038],[16.987306,48.681855],[16.988366,48.672428],[16.989706,48.665842],[16.993348,48.654231],[16.996234,48.647922],[17.002396,48.637776],[17.006059,48.631261],[17.009688,48.62338],[17.012662,48.615086],[17.014856,48.606165],[17.016131,48.595769],[17.015987,48.583792],[17.01484,48.574768],[17.011581,48.561521],[17.011114,48.554278],[17.012554,48.544435],[17.013952,48.539922],[17.017156,48.533071],[17.025626,48.519062],[17.029733,48.511313],[17.031686,48.504121],[17.032075,48.498986],[17.031573,48.489254],[17.031955,48.480302],[17.03311,48.473686],[17.035393,48.46609],[17.039509,48.455924],[17.041588,48.449147],[17.042942,48.440198],[17.042874,48.433336],[17.041586,48.425344],[17.039897,48.41961],[17.038052,48.415125],[17.034673,48.408758],[17.028071,48.397995],[17.025184,48.391853],[17.023156,48.386535],[17.021312,48.380134],[17.019911,48.372326],[17.019497,48.366396],[17.019794,48.358083],[17.020878,48.351035],[17.022972,48.341987],[17.023781,48.337001],[17.023902,48.32914],[17.022998,48.322868],[17.021177,48.316561],[17.014831,48.302995],[17.010923,48.291431],[17.009656,48.285621],[17.008595,48.273552],[17.009139,48.264677],[17.010185,48.258436],[17.011894,48.251701],[17.015134,48.242929],[17.019051,48.235103],[17.024724,48.22623],[17.031599,48.217687],[17.0362,48.211335],[17.039597,48.205317],[17.042041,48.199684],[17.045326,48.188749],[17.047406,48.18541],[17.052275,48.181823],[17.059293,48.179077],[17.062784,48.175677],[17.064815,48.175046],[17.076195,48.168826],[17.078764,48.166971],[17.083926,48.164868],[17.090751,48.163243],[17.095612,48.162905],[17.101353,48.1613],[17.103704,48.160006],[17.106396,48.155268],[17.119794,48.157679],[17.129881,48.158075],[17.130568,48.156957],[17.127195,48.154397],[17.130301,48.152818],[17.129276,48.152226],[17.131744,48.145492],[17.128769,48.140203],[17.127755,48.135945],[17.128434,48.131905],[17.123628,48.131262],[17.096029,48.132264],[17.090735,48.131366],[17.08273,48.128164],[17.07651,48.126582],[17.075697,48.124389],[17.078655,48.118757],[17.084672,48.110655],[17.087394,48.107934],[17.093268,48.103725],[17.096803,48.099817],[17.098227,48.096887],[17.098737,48.08899],[17.097713,48.087231],[17.099246,48.08491],[17.101475,48.074615],[17.101762,48.062717],[17.103251,48.057218],[17.106211,48.051752],[17.110029,48.047286],[17.114071,48.043819],[17.120398,48.039912],[17.126759,48.037095],[17.135338,48.034299],[17.148848,48.030636],[17.158572,48.027339],[17.162652,48.025439],[17.166949,48.022712],[17.170863,48.019242],[17.173888,48.015284],[17.182895,48.00185],[17.184517,47.998793],[17.186131,47.992599],[17.185754,47.986794],[17.184599,47.983428],[17.181226,47.977435],[17.171245,47.962002],[17.168891,47.958014],[17.166571,47.952044],[17.165869,47.947774],[17.16618,47.941591],[17.167979,47.935743],[17.170967,47.930045],[17.17845,47.917505],[17.181258,47.912291],[17.182663,47.908284],[17.183118,47.904093],[17.180937,47.889885],[17.182481,47.888458],[17.185773,47.887573],[17.194572,47.882491],[17.226435,47.865998],[17.233559,47.861986],[17.242963,47.8557],[17.268514,47.836972],[17.275466,47.83114],[17.296382,47.809919],[17.300432,47.806347],[17.306668,47.80158],[17.316093,47.795599],[17.321255,47.792821],[17.329009,47.789233],[17.38572,47.765611],[17.399118,47.759888],[17.409042,47.754891],[17.418625,47.749005],[17.445083,47.730832],[17.454902,47.724733],[17.500157,47.699943],[17.509101,47.695535],[17.519022,47.691875],[17.530679,47.688617],[17.533829,47.687434],[17.537925,47.684923],[17.54565,47.678787],[17.55033,47.676407],[17.548589,47.676468],[17.556316,47.678549],[17.570799,47.681427],[17.572479,47.682194],[17.589792,47.677254],[17.592732,47.676768],[17.606188,47.675958],[17.613909,47.676973],[17.626516,47.680911],[17.65081,47.689469],[17.654625,47.693105],[17.660401,47.695837],[17.668762,47.700805],[17.674507,47.707079],[17.677618,47.712335],[17.683934,47.715001],[17.687249,47.715892],[17.706464,47.716294],[17.717273,47.716101],[17.722735,47.715634],[17.731484,47.714352],[17.740229,47.712326],[17.748382,47.70968],[17.754878,47.707114],[17.777229,47.69734],[17.787478,47.693351],[17.800036,47.689346],[17.806076,47.685254],[17.80878,47.684974],[17.812057,47.686039],[17.815898,47.686094],[17.829234,47.684679],[17.845764,47.684208],[17.86964,47.684479],[17.878932,47.684185],[17.886252,47.683621],[17.909297,47.680824],[17.920853,47.679694],[17.929089,47.679181],[17.940983,47.678929],[17.958224,47.679625],[17.967691,47.680317],[17.988071,47.682153],[17.997895,47.682845],[18.009358,47.683015],[18.018413,47.682544],[18.025578,47.681748],[18.038063,47.679613],[18.053449,47.676387],[18.065788,47.674564],[18.075509,47.674041],[18.091631,47.674678],[18.097876,47.674707],[18.107764,47.674141],[18.113289,47.673464],[18.122285,47.671731],[18.137002,47.66768],[18.146387,47.665392],[18.160776,47.662855],[18.175072,47.661102],[18.183627,47.659082],[18.189973,47.656482],[18.202507,47.649535],[18.210227,47.645526],[18.219728,47.641442],[18.22462,47.639706],[18.237464,47.636175],[18.247973,47.632942],[18.257105,47.62983],[18.267055,47.627006],[18.272141,47.626028],[18.279256,47.625417],[18.296771,47.625691],[18.308046,47.62525],[18.319561,47.623722],[18.32701,47.622013],[18.336615,47.618983],[18.380562,47.60258],[18.387097,47.599599],[18.393835,47.595944],[18.398691,47.592386],[18.409536,47.58117],[18.412471,47.579135],[18.418083,47.577601],[18.443888,47.574778],[18.448502,47.574892],[18.45574,47.576113],[18.462919,47.576047],[18.467395,47.575033],[18.472882,47.572424],[18.477159,47.56829],[18.481136,47.561174],[18.48424,47.558053],[18.488794,47.554611],[18.492901,47.550769],[18.497943,47.543681],[18.499768,47.538881],[18.501037,47.532675],[18.50224,47.529582],[18.504272,47.52708],[18.509368,47.524173],[18.52599,47.518695],[18.533558,47.514045],[18.541602,47.507198],[18.545103,47.505096],[18.568528,47.494453],[18.573577,47.493082],[18.577263,47.492911],[18.583598,47.494085],[18.587793,47.496282],[18.600803,47.503995],[18.605854,47.506659],[18.610777,47.508212],[18.616443,47.509133],[18.640851,47.510797],[18.646519,47.511017],[18.656076,47.510571],[18.68349,47.507561],[18.694204,47.507844],[18.719785,47.510593],[18.727865,47.511026],[18.734091,47.510994],[18.745436,47.509969],[18.752524,47.508732],[18.779776,47.502346],[18.787483,47.500722],[18.81276,47.496291],[18.820892,47.493879],[18.826609,47.491257],[18.831003,47.488496],[18.841363,47.481183],[18.851566,47.475146],[18.867382,47.467236],[18.880841,47.462325],[18.903726,47.454585],[18.910639,47.45279],[18.920379,47.45187],[18.957494,47.452201],[18.965622,47.452841],[18.972633,47.454366],[18.984292,47.457846],[18.991036,47.459261],[19.001475,47.460975],[19.010532,47.463254],[19.014228,47.464927],[19.017432,47.467601],[19.022811,47.474105],[19.035463,47.476424],[19.046747,47.473892],[19.052387,47.473376],[19.053035,47.469552],[19.063989,47.468782],[19.079871,47.468567],[19.088878,47.470109],[19.097069,47.472487],[19.102522,47.469494],[19.104838,47.465297],[19.110758,47.459122],[19.113481,47.455258],[19.12922,47.444528],[19.136179,47.440106],[19.142327,47.437009],[19.146178,47.434459],[19.149406,47.430604],[19.155317,47.414533],[19.158318,47.408625],[19.161101,47.404233],[19.166248,47.397457],[19.198393,47.357567],[19.205973,47.349224],[19.210187,47.345321],[19.216423,47.340231],[19.225212,47.334157],[19.237643,47.327236],[19.258821,47.317268],[19.271928,47.310503],[19.280617,47.305356],[19.286829,47.301222],[19.302115,47.290327],[19.313736,47.282508],[19.320838,47.278106],[19.33389,47.270702],[19.344767,47.264927],[19.358547,47.256958],[19.368051,47.250896],[19.383672,47.239825],[19.394799,47.230896],[19.404178,47.221973],[19.410195,47.215025],[19.419008,47.202407],[19.424574,47.19537],[19.43104,47.188224],[19.438361,47.178688],[19.443289,47.170948],[19.451238,47.160384],[19.456851,47.15403],[19.464748,47.146373],[19.470064,47.141741],[19.477846,47.135592],[19.489809,47.126733],[19.495553,47.121742],[19.50115,47.116247],[19.508603,47.107496],[19.530518,47.078071],[19.538004,47.068351],[19.545545,47.05985],[19.552962,47.052336],[19.564669,47.041953],[19.583225,47.027216],[19.590513,47.021021],[19.595085,47.016335],[19.600884,47.009011],[19.604143,47.003751],[19.606686,46.998452],[19.609459,46.98996],[19.613441,46.987922],[19.619599,46.981486],[19.633905,46.970649],[19.638636,46.966696],[19.647585,46.955778],[19.651932,46.947232],[19.657765,46.941584],[19.66253,46.935581],[19.66382,46.929642],[19.665806,46.927485],[19.671716,46.925009],[19.688983,46.914344],[19.692921,46.912639],[19.634185,46.667948],[19.63397,46.668567],[19.637938,46.67059],[19.652139,46.67589],[19.654064,46.673951],[19.662376,46.663305],[19.663623,46.658832],[19.664685,46.657412],[19.669826,46.653584],[19.657931,46.646288],[19.656702,46.644199],[19.664933,46.636536],[19.674768,46.629108],[19.688984,46.618072],[19.689495,46.616615],[19.679843,46.604817],[19.680074,46.602897],[19.700107,46.595702],[19.710139,46.591465],[19.755445,46.569813],[19.759799,46.573312],[19.77184,46.577408],[19.774451,46.579116],[19.788737,46.603098],[19.79234,46.607908],[19.797523,46.618347],[19.798339,46.621471],[19.809021,46.638863],[19.821365,46.67292],[19.823867,46.676668],[19.828946,46.668443],[19.83105,46.662916],[19.832599,46.655444],[19.833896,46.627475],[19.835061,46.620214],[19.836178,46.616603],[19.838728,46.610961],[19.841047,46.607148],[19.844871,46.602118],[19.853195,46.59374],[19.870298,46.577301],[19.873895,46.573248],[19.879445,46.564596],[19.882537,46.556237],[19.884767,46.546285],[19.886723,46.540195],[19.888556,46.536308],[19.893122,46.529145],[19.907994,46.509621],[19.910407,46.505896],[19.913356,46.499848],[19.931222,46.457319],[19.934777,46.449593],[19.940419,46.439435],[19.943935,46.434162],[19.949787,46.426508],[19.954392,46.4212],[19.962322,46.413098],[19.982445,46.393755],[19.988133,46.387304],[19.994009,46.378996],[19.999006,46.369537],[20.004501,46.356678],[20.007122,46.351997],[20.011111,46.346209],[20.018504,46.338152],[20.028678,46.329066],[20.032893,46.324395],[20.038194,46.31641],[20.041222,46.308872],[20.039974,46.305716],[20.041722,46.303305],[20.052124,46.29913],[20.058197,46.298228],[20.072524,46.293491],[20.077045,46.293042],[20.083278,46.293636],[20.089867,46.295283],[20.096499,46.296007],[20.126376,46.294671],[20.135679,46.294817],[20.135386,46.292678],[20.137845,46.290819],[20.142456,46.284281],[20.143979,46.2813],[20.144042,46.278847],[20.145824,46.275406],[20.150877,46.269191],[20.151362,46.26722],[20.150738,46.261691],[20.143153,46.258762],[20.139827,46.254866],[20.144856,46.252664],[20.144546,46.251219],[20.13886,46.251881],[20.139558,46.254411],[20.142697,46.258296],[20.14747,46.260741],[20.150852,46.261705],[20.151391,46.266601],[20.151058,46.269086],[20.145316,46.276122],[20.142816,46.283779],[20.137747,46.29098],[20.134977,46.293277],[20.138247,46.29515],[20.150239,46.297901],[20.155581,46.298641],[20.16451,46.298194],[20.179926,46.294223],[20.188225,46.293064],[20.212398,46.292527],[20.231187,46.293198],[20.235025,46.293024],[20.240614,46.291373],[20.25147,46.28617],[20.258435,46.28346],[20.263516,46.282745],[20.26939,46.28307],[20.277793,46.284739],[20.284125,46.285499],[20.289493,46.285087],[20.30232,46.281476],[20.311372,46.280414],[20.315175,46.280509],[20.343979,46.282252],[20.353408,46.281846],[20.377191,46.278568],[20.385693,46.277634],[20.403125,46.276712],[20.418683,46.274779],[20.442239,46.274437],[20.453703,46.273932],[20.459633,46.273042],[20.477723,46.268448],[20.48207,46.265782],[20.485516,46.251803],[20.484596,46.249478],[20.481986,46.247124],[20.481447,46.24298],[20.489007,46.242296],[20.491713,46.241331],[20.499069,46.237296],[20.504539,46.233687],[20.518359,46.222961],[20.51972,46.220797],[20.520532,46.216247],[20.530913,46.208135],[20.545456,46.203677],[20.551844,46.201269],[20.577046,46.175057],[20.59919,46.169679],[20.619052,46.169983],[20.623835,46.168108],[20.637008,46.164125],[20.640176,46.163908],[20.671903,46.168145],[20.684488,46.168477],[20.69722,46.167442],[20.71812,46.168025],[20.723916,46.166928],[20.735539,46.167232],[20.752144,46.169852],[20.75314,46.169335],[20.75536,46.162665],[20.756802,46.161712],[20.78083,46.15742],[20.811731,46.152806],[20.835377,46.149661],[20.852804,46.147182],[20.859419,46.145478],[20.874057,46.143741],[20.889015,46.145299],[20.936317,46.149752],[20.93781,46.150099],[20.955849,46.159445],[21.00437,46.17198],[21.01787,46.175378],[21.019562,46.175385],[21.043627,46.171735],[21.051205,46.170266],[21.067137,46.170691],[21.069371,46.171038],[21.084678,46.17143],[21.100018,46.173858],[21.102638,46.174845],[21.153917,46.196785],[21.160975,46.200122],[21.166722,46.200776],[21.171383,46.201868],[21.182994,46.205537],[21.195328,46.206162],[21.203164,46.204578],[21.224001,46.201469],[21.235266,46.203856],[21.244603,46.203152],[21.262975,46.20661],[21.286528,46.21313],[21.291479,46.215275],[21.30853,46.216288],[21.32344,46.215885],[21.331263,46.215901],[21.344495,46.212049],[21.359034,46.208054],[21.360868,46.206525],[21.373325,46.18415],[21.374681,46.180094],[21.366429,46.175526],[21.378567,46.172535],[21.380977,46.171272],[21.388728,46.168436],[21.413225,46.160763],[21.436239,46.154994],[21.468205,46.14732],[21.474417,46.146091],[21.487627,46.145603],[21.510049,46.144994],[21.519726,46.141969],[21.527828,46.139944],[21.540625,46.135082],[21.553771,46.130509],[21.55985,46.129096],[21.572572,46.12457],[21.5884,46.120032],[21.591075,46.117789],[21.596181,46.112007],[21.602281,46.1093],[21.613303,46.107384],[21.62434,46.107174],[21.636501,46.106604],[21.638577,46.105818],[21.640469,46.103227],[21.643656,46.103046],[21.647364,46.10485],[21.654583,46.104654],[21.663901,46.101718],[21.672058,46.099554],[21.67427,46.098098],[21.678931,46.096512],[21.681483,46.094024],[21.683976,46.093164],[21.686614,46.094703],[21.687584,46.097032],[21.690257,46.099254],[21.694967,46.100663],[21.699102,46.102578],[21.70863,46.104891],[21.721099,46.106467],[21.728232,46.108753],[21.735081,46.108737],[21.744377,46.104994],[21.751414,46.103638],[21.754041,46.103715],[21.758231,46.106614],[21.762156,46.107243],[21.764281,46.106599],[21.767852,46.108141],[21.771056,46.108367],[21.775266,46.106639],[21.779227,46.106207],[21.785203,46.104543],[21.789497,46.10134],[21.789371,46.097753],[21.787989,46.095057],[21.789128,46.093781],[21.794052,46.09201],[21.797642,46.089776],[21.800545,46.089766],[21.805255,46.091382],[21.811938,46.095731],[21.814984,46.101314],[21.814559,46.108115],[21.815719,46.109374],[21.822819,46.111785],[21.834793,46.111655],[21.838743,46.111977],[21.844184,46.113277],[21.846965,46.112455],[21.8503,46.10987],[21.853978,46.109439],[21.856834,46.110123],[21.860536,46.10998],[21.866043,46.107992],[21.868025,46.105799],[21.873773,46.102049],[21.879713,46.09915],[21.885186,46.099216],[21.897701,46.098112],[21.9028,46.098479],[21.912898,46.097198],[21.917352,46.097912],[21.9268,46.102377],[21.928869,46.102895],[21.943222,46.103511],[21.948584,46.105024],[21.950821,46.106703],[21.951138,46.109213],[21.95407,46.112916],[21.956101,46.113495],[21.960769,46.113157],[21.965045,46.111897],[21.977819,46.110146],[21.983677,46.107306],[21.989908,46.106083],[21.994917,46.106049],[22.002554,46.10413],[22.013561,46.099691],[22.018189,46.096477],[22.020591,46.092927],[22.025178,46.087962],[22.02261,46.083993],[22.024181,46.081418],[22.029088,46.077052],[22.038076,46.071964],[22.041279,46.068497],[22.043609,46.063959],[22.043834,46.059193],[22.047925,46.054606],[22.05282,46.050259],[22.056563,46.049328],[22.059198,46.046713],[22.059599,46.039377],[22.06084,46.037685],[22.064903,46.035194],[22.067188,46.034816],[22.072609,46.035929],[22.075572,46.037207],[22.080599,46.036492],[22.088596,46.033801],[22.092177,46.033054],[22.097898,46.034344],[22.100823,46.033931],[22.107181,46.030992],[22.11756,46.03015],[22.119983,46.029314],[22.123125,46.026562],[22.126865,46.025378],[22.130412,46.025089],[22.136594,46.023486],[22.139234,46.023888],[22.145447,46.023233],[22.148251,46.019537],[22.149168,46.017131],[22.148848,46.012159],[22.15059,46.009014],[22.153703,46.006335],[22.165042,46.001251],[22.169862,46.002232],[22.175287,46.002417],[22.179472,46.003789],[22.185374,46.004735],[22.192633,46.005071],[22.203712,46.004943],[22.207833,46.005543],[22.218002,46.008884],[22.220673,46.010645],[22.227704,46.012734],[22.233834,46.014131],[22.237635,46.014367],[22.248293,46.015792],[22.253499,46.0158],[22.264768,46.013053],[22.267711,46.011806],[22.273042,46.008119],[22.276576,46.004003],[22.278398,46.002747],[22.287193,45.999856],[22.29315,45.99651],[22.298793,45.995594],[22.30104,45.99579],[22.307197,45.999092],[22.310195,45.999954],[22.31444,46.002396],[22.316152,46.004099],[22.320227,46.006118],[22.323779,46.006652],[22.331161,46.006442],[22.335895,46.004416],[22.33804,46.004814],[22.344475,46.008911],[22.34618,46.012982],[22.347539,46.014345],[22.357552,46.016053],[22.375637,46.010251],[22.381617,46.012091],[22.386916,46.016572],[22.388144,46.017045],[22.399295,46.017275],[22.404275,46.018383],[22.411189,46.018356],[22.419689,46.016424],[22.427316,46.013258],[22.435781,46.012094],[22.443016,46.009025],[22.443901,46.007626],[22.439587,45.998203],[22.435006,45.992948],[22.435437,45.988782],[22.430961,45.983547],[22.429996,45.980718],[22.431007,45.977613],[22.434779,45.975192],[22.447696,45.972786],[22.453175,45.973174],[22.469917,45.968828],[22.472234,45.967822],[22.479938,45.961178],[22.486346,45.952989],[22.488603,45.950631],[22.49748,45.944081],[22.504475,45.942129],[22.512177,45.942574],[22.530187,45.939292],[22.534489,45.939917],[22.539657,45.939512],[22.543644,45.938401],[22.547854,45.938574],[22.554616,45.939555],[22.562956,45.939706],[22.565394,45.940482],[22.572338,45.944728],[22.575277,45.947871],[22.581091,45.949609],[22.584981,45.949766],[22.588105,45.950987],[22.588523,45.949146],[22.592213,45.946818],[22.596474,45.94728],[22.605247,45.945701],[22.608644,45.944164],[22.619797,45.942736],[22.626214,45.943332],[22.630272,45.941882],[22.634498,45.94204],[22.648824,45.939883],[22.650158,45.938682],[22.652039,45.934311],[22.657188,45.930733],[22.659856,45.927949],[22.672193,45.922603],[22.675553,45.922657],[22.68332,45.924382],[22.690246,45.923846],[22.6993,45.923916],[22.702593,45.920651],[22.706886,45.920046],[22.7142,45.920057],[22.719808,45.919323],[22.726465,45.917077],[22.731921,45.91569],[22.741208,45.914997],[22.748738,45.915084],[22.756385,45.915865],[22.763622,45.914448],[22.767355,45.912736],[22.771502,45.909226],[22.775896,45.906454],[22.778577,45.905562],[22.785062,45.905093],[22.787811,45.903658],[22.797885,45.904348],[22.802,45.905522],[22.809154,45.909292],[22.831598,45.918698],[22.838423,45.920252],[22.843103,45.919775],[22.846737,45.918437],[22.850938,45.916078],[22.853762,45.915252],[22.86881,45.907517],[22.87313,45.907364],[22.876554,45.906382],[22.902382,45.893254],[22.905165,45.891118],[22.906558,45.889006],[22.908223,45.884306],[22.914278,45.877891],[22.927243,45.860627],[22.933163,45.860033],[22.950048,45.856711],[22.953038,45.856492],[22.982768,45.849219],[22.994039,45.848581],[23.003074,45.847625],[23.005554,45.845441],[23.013994,45.843761],[23.018953,45.840385],[23.025739,45.838415],[23.039507,45.833929],[23.0438,45.836881],[23.045014,45.842154],[23.044477,45.845902],[23.045656,45.84855],[23.048061,45.849126],[23.07369,45.84352],[23.098401,45.837353],[23.104791,45.836659],[23.113561,45.837467],[23.120907,45.839889],[23.125723,45.842818],[23.156029,45.86646],[23.163872,45.87105],[23.171357,45.873832],[23.177426,45.875265],[23.226679,45.883259],[23.233817,45.884703],[23.244865,45.887476],[23.255902,45.889653],[23.261943,45.890404],[23.26367,45.888615],[23.258148,45.887465],[23.256433,45.888711],[23.299417,45.918337],[23.303058,45.920041],[23.312285,45.922457],[23.31945,45.923819],[23.326716,45.924734],[23.332315,45.924453],[23.345422,45.921457],[23.350039,45.923075],[23.355411,45.927245],[23.366155,45.931084],[23.383985,45.940019],[23.391692,45.942605],[23.401464,45.94485],[23.410779,45.947999],[23.4168,45.949363],[23.425611,45.952396],[23.429037,45.954879],[23.433682,45.959964],[23.440712,45.965836],[23.446501,45.967574],[23.45874,45.971894],[23.466901,45.976243],[23.472256,45.977569],[23.48082,45.982647],[23.490821,45.986166],[23.501951,45.988522],[23.507856,45.98763],[23.511701,45.984687],[23.517722,45.981892],[23.52147,45.976605],[23.528841,45.968105],[23.534114,45.962616],[23.538298,45.960027],[23.555216,45.959485],[23.56014,45.95902],[23.565296,45.957857],[23.566107,45.955742],[23.571713,45.955123],[23.573461,45.956364],[23.578067,45.955344],[23.584433,45.949087],[23.610524,45.928141],[23.621011,45.924027],[23.635128,45.919991],[23.641464,45.920045],[23.6501,45.919529],[23.662606,45.920327],[23.67408,45.91961],[23.691624,45.91991],[23.713845,45.917062],[23.717302,45.916176],[23.725078,45.915045],[23.732495,45.911598],[23.748734,45.899761],[23.751089,45.898427],[23.761256,45.894929],[23.7667,45.892482],[23.775771,45.890514],[23.779773,45.888581],[23.785078,45.887785],[23.792756,45.887815],[23.798189,45.885596],[23.797836,45.88129],[23.805826,45.868973],[23.815093,45.859438],[23.818997,45.854915],[23.826277,45.849062],[23.833765,45.845505],[23.839026,45.840391],[23.84263,45.838517],[23.85132,45.836319],[23.855671,45.833732],[23.856562,45.832232],[23.857376,45.827302],[23.85513,45.822735],[23.85663,45.821044],[23.85727,45.817595],[23.856623,45.815584],[23.861681,45.813471],[23.867705,45.812999],[23.873956,45.809561],[23.883803,45.807564],[23.88918,45.804352],[23.894809,45.80258],[23.93792,45.784324],[23.946592,45.781408],[23.960088,45.77765],[23.962248,45.777925],[23.967078,45.780345],[23.974397,45.781815],[23.978191,45.781915],[24.019731,45.786907],[24.030372,45.788557],[24.033846,45.787884],[24.061787,45.789068],[24.079841,45.788383],[24.113953,45.793042],[24.123771,45.79351],[24.132179,45.793142],[24.135197,45.795433],[24.139196,45.796293],[24.140774,45.793574],[24.143789,45.793944],[24.145555,45.791317],[24.147886,45.791485],[24.150199,45.789117],[24.155694,45.78726],[24.166643,45.781879],[24.170059,45.779145],[24.175023,45.774003],[24.19356,45.761035],[24.197687,45.758705],[24.198871,45.756487],[24.2019,45.748255],[24.208189,45.738847],[24.217075,45.730563],[24.224219,45.725143],[24.229014,45.719582],[24.233009,45.717048],[24.236624,45.713751],[24.242211,45.711908],[24.244301,45.710205],[24.246643,45.703681],[24.248353,45.700353],[24.250225,45.70055],[24.259918,45.698795],[24.26226,45.698686],[24.268376,45.700243],[24.271119,45.697485],[24.272804,45.698478],[24.273739,45.701065],[24.281032,45.702836],[24.285313,45.702605],[24.291187,45.70522],[24.295265,45.705672],[24.29972,45.708736],[24.313541,45.712954],[24.321927,45.715192],[24.327912,45.718214],[24.335375,45.724688],[24.338505,45.725691],[24.347759,45.726338],[24.361838,45.726329],[24.364596,45.72659],[24.379538,45.736726],[24.383788,45.737272],[24.387426,45.736467],[24.390106,45.736907],[24.407097,45.743498],[24.616865,45.77738],[24.62152,45.779354],[24.632109,45.78162],[24.652526,45.787006],[24.661145,45.786925],[24.667852,45.78726],[24.693335,45.791176],[24.718179,45.794878],[24.726848,45.796378],[24.736141,45.796739],[24.760545,45.804209],[24.768388,45.804672],[24.813894,45.81238],[24.821627,45.812546],[24.830747,45.814404],[24.838373,45.817687],[24.84234,45.817552],[24.848709,45.818923],[24.879962,45.82318],[24.886603,45.823447],[24.917086,45.829522],[24.926487,45.832544],[24.960731,45.842908],[24.963452,45.843501],[24.975371,45.84314],[24.984706,45.840919],[25.037793,45.825254],[25.04633,45.822243],[25.049035,45.822719],[25.060762,45.823012],[25.072031,45.821921],[25.093051,45.824504],[25.102126,45.824925],[25.106893,45.826316],[25.125363,45.830963],[25.1344,45.830314],[25.139434,45.830699],[25.147635,45.829521],[25.156535,45.8238],[25.158925,45.819563],[25.16577,45.814543],[25.167527,45.811295],[25.173405,45.806446],[25.179003,45.799384],[25.180306,45.797118],[25.183189,45.7944],[25.195491,45.79005],[25.20159,45.785451],[25.211641,45.781043],[25.223306,45.773744],[25.230888,45.771165],[25.232234,45.76857],[25.231515,45.76377],[25.237293,45.759605],[25.246642,45.755938],[25.263135,45.750872],[25.267223,45.751152],[25.271405,45.754261],[25.275406,45.75521],[25.275405,45.752734],[25.280416,45.754642],[25.283381,45.753808],[25.287974,45.747202],[25.291855,45.745151],[25.298482,45.744368],[25.303961,45.745881],[25.305657,45.746965],[25.315985,45.756377],[25.337902,45.771566],[25.340066,45.772435],[25.348848,45.773239],[25.359553,45.77032],[25.363455,45.767659],[25.368772,45.766614],[25.371105,45.765416],[25.376012,45.7647],[25.383169,45.761526],[25.386438,45.758696],[25.388746,45.758004],[25.399169,45.757898],[25.400176,45.75588],[25.398136,45.755331],[25.395001,45.752865],[25.395177,45.751819],[25.39925,45.750121],[25.403935,45.750528],[25.405755,45.749543],[25.412696,45.747444],[25.414389,45.744618],[25.419563,45.741681],[25.427139,45.73973],[25.43204,45.741546],[25.434403,45.740487],[25.436605,45.735722],[25.451369,45.726097],[25.453348,45.721648],[25.455187,45.715728],[25.454943,45.712774],[25.452852,45.707553],[25.450916,45.704409],[25.444943,45.697656],[25.44841,45.693963],[25.449249,45.690333],[25.466252,45.683079],[25.475038,45.680299],[25.487065,45.675169],[25.502377,45.669866],[25.511945,45.665667],[25.513145,45.663461],[25.515731,45.662661],[25.521305,45.662399],[25.526743,45.662803],[25.533411,45.661886],[25.538547,45.662068],[25.552628,45.660998],[25.557217,45.659541],[25.563505,45.660391],[25.569204,45.659861],[25.577884,45.663204],[25.58162,45.65663],[25.586984,45.65078],[25.589554,45.646296],[25.588438,45.642179],[25.585382,45.640212],[25.587388,45.637185],[25.591497,45.641446],[25.59648,45.6432],[25.601202,45.646852],[25.608213,45.650514],[25.611814,45.651779],[25.615121,45.651358],[25.625169,45.642584],[25.649188,45.619963],[25.653722,45.615992],[25.658448,45.613118],[25.658647,45.610169],[25.656533,45.60765],[25.653314,45.606659],[25.645347,45.600349],[25.635155,45.59452],[25.62875,45.588406],[25.624269,45.58572],[25.619517,45.578458],[25.616306,45.576395],[25.612089,45.572349],[25.609046,45.570682],[25.60734,45.567131],[25.600729,45.562413],[25.598652,45.560317],[25.591738,45.555072],[25.588294,45.550913],[25.588847,45.548904],[25.588702,45.540178],[25.587981,45.537797],[25.578472,45.531423],[25.575999,45.526268],[25.570513,45.524139],[25.573761,45.522745],[25.572725,45.519077],[25.574627,45.519419],[25.579094,45.51806],[25.577047,45.518028],[25.578423,45.515404],[25.576669,45.511169],[25.571585,45.51361],[25.573137,45.511744],[25.574326,45.506857],[25.573863,45.499856],[25.571392,45.494618],[25.565026,45.48634],[25.565516,45.481132],[25.560648,45.467357],[25.562786,45.46592],[25.564246,45.463446],[25.56706,45.461049],[25.567602,45.459113],[25.566417,45.456183],[25.563049,45.451575],[25.558973,45.449929],[25.554755,45.445209],[25.55507,45.442784],[25.550092,45.438905],[25.551974,45.433789],[25.554688,45.429908],[25.552825,45.427888],[25.552522,45.424552],[25.549243,45.422585],[25.539948,45.418729],[25.550598,45.343031],[25.552614,45.338605],[25.55205,45.336723],[25.555159,45.334233],[25.562718,45.331085],[25.564368,45.329219],[25.563542,45.327291],[25.56414,45.324106],[25.563727,45.318524],[25.566996,45.315227],[25.569919,45.31129],[25.572702,45.310014],[25.573194,45.308016],[25.577158,45.305644],[25.580004,45.305545],[25.583759,45.30398],[25.586938,45.301095],[25.597172,45.29652],[25.59766,45.295509],[25.603745,45.293018],[25.613492,45.290121],[25.617001,45.287418],[25.619168,45.284558],[25.618084,45.282257],[25.619991,45.280945],[25.621615,45.277882],[25.620757,45.276438],[25.622617,45.271114],[25.624223,45.269557],[25.623909,45.264368],[25.62519,45.260288],[25.62882,45.25446],[25.630804,45.248735],[25.631324,45.245018],[25.634732,45.241481],[25.63703,45.236649],[25.636385,45.232702],[25.63926,45.226959],[25.641754,45.224009],[25.652305,45.21374],[25.656068,45.210677],[25.661591,45.204638],[25.664536,45.202034],[25.666223,45.199448],[25.672258,45.194822],[25.678169,45.188101],[25.679555,45.18559],[25.681902,45.179025],[25.686838,45.175268],[25.688841,45.1689],[25.691997,45.163035],[25.693408,45.159011],[25.695439,45.150738],[25.697485,45.145702],[25.69951,45.143394],[25.710062,45.1396],[25.71524,45.135848],[25.718326,45.132321],[25.720156,45.127216],[25.723141,45.123395],[25.72687,45.1206],[25.734032,45.114361],[25.738654,45.109834],[25.743615,45.106744],[25.754526,45.103442],[25.760279,45.100176],[25.764196,45.095454],[25.795806,45.059374],[25.816767,45.034965],[25.826092,45.028013],[25.856311,45.01484],[25.959312,44.969633],[25.963444,44.966205],[25.964445,44.961349],[25.962303,44.950531],[25.96098,44.940739],[25.972855,44.939689],[25.966936,44.940923],[25.967688,44.939929],[25.981793,44.938998],[25.989554,44.938238],[25.988986,44.932349],[25.9898,44.929877],[25.991583,44.928352],[25.980587,44.924873],[25.981752,44.92287],[25.991174,44.912053],[26.009324,44.890905],[26.013933,44.885886],[26.019056,44.884526],[26.031435,44.884987],[26.034061,44.881528],[26.039132,44.879796],[26.046913,44.879131],[26.061888,44.879794],[26.067966,44.880331],[26.078106,44.882256],[26.096035,44.88692],[26.106877,44.88875],[26.113039,44.888867],[26.120776,44.888468],[26.124159,44.887878],[26.128804,44.886173],[26.131452,44.88455],[26.135262,44.880459],[26.138417,44.874132],[26.141914,44.869161],[26.145754,44.865133],[26.151033,44.861928],[26.156564,44.860387],[26.161621,44.860077],[26.170768,44.861675],[26.177514,44.86243],[26.182546,44.862286],[26.188274,44.861253],[26.192926,44.859747],[26.19902,44.856421],[26.202284,44.853632],[26.205821,44.848766],[26.207436,44.844685],[26.213875,44.82574],[26.215503,44.822266],[26.219099,44.816683],[26.236011,44.796695],[26.239885,44.791308],[26.243207,44.785085],[26.253686,44.763359],[26.255704,44.757486],[26.256338,44.750225],[26.255905,44.736883],[26.254721,44.732134],[26.250985,44.725325],[26.245122,44.719305],[26.229957,44.707778],[26.22591,44.70336],[26.223957,44.698877],[26.223019,44.693762],[26.220383,44.68837],[26.217628,44.685487],[26.208973,44.67867],[26.203985,44.673493],[26.190711,44.655422],[26.188155,44.65107],[26.186507,44.646359],[26.185922,44.639779],[26.186911,44.628296],[26.186675,44.623837],[26.184696,44.617325],[26.179533,44.609208],[26.176797,44.603086],[26.175829,44.596709],[26.176758,44.589731],[26.17997,44.575315],[26.181106,44.566435],[26.181885,44.555875],[26.18452,44.545141],[26.184551,44.541211],[26.183266,44.535102],[26.180301,44.529559],[26.177804,44.528465],[26.172735,44.523206],[26.171526,44.522867],[26.166183,44.525532],[26.148211,44.5338],[26.140378,44.536219],[26.140172,44.539195],[26.142123,44.539279],[26.142606,44.537259],[26.143278,44.523587],[26.143016,44.520487],[26.139979,44.513382],[26.104998,44.515543],[26.102344,44.515321],[26.092208,44.516365],[26.092048,44.518132],[26.08097,44.511931],[26.081984,44.509089],[26.081595,44.505744],[26.079005,44.495903],[26.078982,44.490407],[26.077712,44.486848],[26.072317,44.47788],[26.072775,44.477484],[26.082603,44.458089],[26.085764,44.452176],[26.091063,44.445381],[26.095195,44.441074],[26.093054,44.44031],[26.091186,44.442959],[26.098055,44.444109],[26.102601,44.434899],[26.103643,44.42924],[26.101279,44.428779],[26.100994,44.427237],[26.103772,44.426637],[26.127503,44.425598],[26.131234,44.423118],[26.133413,44.420678],[26.145542,44.417878],[26.155176,44.414049],[26.162619,44.413113],[26.172422,44.410815],[26.207218,44.405294],[26.210912,44.405138],[26.215712,44.406362],[26.2215,44.406933],[26.226555,44.406583],[26.23283,44.406919],[26.243418,44.408826],[26.250509,44.409096],[26.267002,44.408371],[26.272197,44.408388],[26.278895,44.409221],[26.299475,44.413633],[26.320822,44.419936],[26.37662,44.436665],[26.38425,44.438312],[26.390657,44.438752],[26.402341,44.438545],[26.411337,44.43911],[26.416988,44.44029],[26.423106,44.442422],[26.443411,44.451782],[26.449358,44.453837],[26.456985,44.455193],[26.4635,44.455496],[26.478405,44.455171],[26.484119,44.454795],[26.494179,44.453079],[26.505862,44.449886],[26.512091,44.448904],[26.523343,44.448545],[26.530163,44.44784],[26.549389,44.444888],[26.55372,44.444519],[26.562104,44.444761],[26.574934,44.446008],[26.581461,44.446907],[26.597094,44.447933],[26.612225,44.449261],[26.618514,44.449287],[26.62565,44.448367],[26.633297,44.446182],[26.641739,44.442355],[26.646674,44.440762],[26.654545,44.439352],[26.6617,44.439122],[26.671386,44.440409],[26.685981,44.444077],[26.693947,44.445132],[26.713894,44.446694],[26.719088,44.44677],[26.731858,44.445972],[26.736388,44.445331],[26.745896,44.442999],[26.750316,44.442313],[26.756558,44.441998],[26.768236,44.442991],[26.773626,44.443174],[26.784752,44.442591],[26.811288,44.440862],[26.817607,44.44001],[26.825939,44.437488],[26.840849,44.429629],[26.847236,44.427412],[26.854003,44.426109],[26.858101,44.425774],[26.865892,44.425999],[26.871519,44.426913],[26.878341,44.428605],[26.883623,44.429402],[26.891583,44.429545],[26.956507,44.423355],[26.963464,44.422904],[26.978931,44.4228],[26.995793,44.424096],[27.011389,44.426186],[27.023658,44.427376],[27.03511,44.427923],[27.108394,44.428383],[27.117757,44.427796],[27.142253,44.42498],[27.154128,44.424361],[27.19473,44.425217],[27.228464,44.424554],[27.266526,44.423563],[27.27379,44.422834],[27.317364,44.416032],[27.380474,44.406055],[27.389031,44.40495],[27.440535,44.399505],[27.464267,44.397598],[27.485623,44.396623],[27.499979,44.396314],[27.522289,44.396487],[27.530782,44.396754],[27.618307,44.400748],[27.628346,44.401719],[27.636181,44.402978],[27.707821,44.416987],[27.717869,44.417837],[27.757612,44.416894],[27.765129,44.416568],[27.772055,44.415388],[27.778408,44.413371],[27.814551,44.398142],[27.820107,44.396346],[27.826526,44.395217],[27.837397,44.39506],[27.840944,44.394307],[27.843207,44.392169],[27.844055,44.388554],[27.845962,44.384566],[27.848727,44.382394],[27.854266,44.381112],[27.863512,44.378303],[27.86688,44.377918],[27.876677,44.375228],[27.954054,44.356143],[27.969663,44.352586],[27.982068,44.349308],[27.995699,44.346064],[28.002969,44.344872],[28.007623,44.341727],[28.013061,44.340697],[28.020992,44.338543],[28.024391,44.336395],[28.028744,44.328263],[28.03479,44.315309],[28.037091,44.311378],[28.03782,44.308822],[28.037529,44.305781],[28.036163,44.302132],[28.035908,44.299095],[28.037395,44.294371],[28.040332,44.290926],[28.047292,44.285107],[28.053193,44.279397],[28.057309,44.274163],[28.064698,44.263086],[28.068015,44.258848],[28.073569,44.253623],[28.078445,44.250141],[28.086552,44.245856],[28.09505,44.242792],[28.099718,44.24174],[28.106546,44.241475],[28.110454,44.241986],[28.119352,44.24435],[28.127075,44.244669],[28.132137,44.243452],[28.146105,44.237504],[28.151112,44.235638],[28.157675,44.233828],[28.168485,44.231392],[28.177768,44.228125],[28.192932,44.22037],[28.202004,44.217155],[28.213694,44.214899],[28.25189,44.210726],[28.259585,44.209537],[28.271061,44.206416],[28.280394,44.202395],[28.286614,44.198753],[28.326367,44.172238],[28.336597,44.165049],[28.349887,44.155242],[28.362797,44.145307],[28.370544,44.140393],[28.375703,44.137963],[28.381144,44.135989],[28.387409,44.134342],[28.396692,44.132916],[28.403695,44.132597],[28.411157,44.132919],[28.41857,44.133975],[28.432106,44.136629],[28.441673,44.137877],[28.452999,44.13979],[28.457871,44.140296],[28.480022,44.141195],[28.527754,44.143],[28.544356,44.144339],[28.550922,44.143046],[28.552621,44.14406],[28.557355,44.150693],[28.556115,44.15274],[28.551858,44.155495],[28.549917,44.162545],[28.549477,44.174642],[28.553066,44.207134],[28.552987,44.21157],[28.549275,44.236017],[28.548073,44.240445],[28.545708,44.245664],[28.544439,44.254892],[28.545136,44.257961],[28.54691,44.260006],[28.550691,44.261931],[28.554768,44.262224],[28.567658,44.249577],[28.575976,44.239882],[28.588669,44.227351],[28.613475,44.20963],[28.615892,44.208215],[28.628067,44.216736],[28.630305,44.219353],[28.629165,44.221167],[28.628443,44.225062],[28.624025,44.234852],[28.622406,44.237033],[28.620023,44.245085],[28.618285,44.260402],[28.619397,44.248725],[28.620656,44.242309],[28.622032,44.237591],[28.62546,44.231667],[28.628528,44.224228],[28.629606,44.21848],[28.627153,44.216236],[28.616222,44.208777],[28.61428,44.209097],[28.598512,44.220515],[28.588891,44.227289],[28.576308,44.239631],[28.567647,44.249591],[28.554912,44.26256],[28.54896,44.261467],[28.546381,44.259774],[28.544308,44.255913],[28.544841,44.248397],[28.547625,44.241089],[28.549018,44.236229],[28.552871,44.210794],[28.552869,44.206334],[28.549161,44.173161],[28.549826,44.161817],[28.550585,44.157966],[28.553617,44.150823],[28.552704,44.147886],[28.548804,44.14526],[28.546415,44.144779],[28.527339,44.143097],[28.459375,44.140493],[28.452956,44.139919],[28.44205,44.138056],[28.429302,44.13624],[28.414717,44.133461],[28.405589,44.132705],[28.396942,44.133008],[28.391784,44.133629],[28.381799,44.135962],[28.374873,44.138485],[28.365075,44.143824],[28.347024,44.15761],[28.333875,44.167224],[28.326025,44.172657],[28.287655,44.198197],[28.280762,44.202384],[28.269279,44.207136],[28.260692,44.209474],[28.249535,44.211075],[28.212465,44.215155],[28.202914,44.217023],[28.193869,44.220098],[28.182665,44.225871],[28.175564,44.229162],[28.165769,44.232179],[28.155014,44.234567],[28.14589,44.237733],[28.13292,44.243278],[28.127112,44.244728],[28.12283,44.244875],[28.117156,44.243919],[28.112439,44.242542],[28.106251,44.241552],[28.10137,44.241645],[28.095298,44.242829],[28.087334,44.245672],[28.077629,44.250837],[28.072592,44.25459],[28.067861,44.259238],[28.06542,44.262303],[28.055481,44.276917],[28.050689,44.282223],[28.040205,44.291273],[28.037364,44.294794],[28.036036,44.299179],[28.037762,44.306221],[28.037762,44.309884],[28.028971,44.328061],[28.02393,44.337999],[28.008015,44.342249],[28.002386,44.345292],[27.996605,44.346027],[27.964632,44.353688],[27.895071,44.370816],[27.859741,44.379748],[27.851855,44.382104],[27.847386,44.384264],[27.844378,44.388204],[27.843685,44.391438],[27.840569,44.394542],[27.837771,44.395148],[27.827661,44.395241],[27.821463,44.396183],[27.815374,44.397971],[27.779495,44.413028],[27.77437,44.414883],[27.76839,44.416239],[27.761257,44.416875],[27.721329,44.417933],[27.712372,44.41774],[27.707229,44.416993],[27.634122,44.402756],[27.62739,44.401733],[27.612942,44.400571],[27.533489,44.397009],[27.513658,44.396456],[27.497398,44.396427],[27.478826,44.396989],[27.465108,44.397596],[27.442083,44.399407],[27.422324,44.401619],[27.38524,44.405497],[27.380779,44.4061],[27.343838,44.412009],[27.273566,44.422999],[27.261205,44.423886],[27.197305,44.425368],[27.153397,44.424513],[27.142697,44.425065],[27.117844,44.427927],[27.107574,44.428511],[27.048627,44.428181],[27.031826,44.427946],[27.025206,44.427597],[27.010708,44.426229],[26.992258,44.423834],[26.981746,44.423042],[26.97152,44.422823],[26.954803,44.423618],[26.892119,44.429633],[26.88215,44.429383],[26.870958,44.426923],[26.862117,44.425872],[26.854912,44.426135],[26.846746,44.427708],[26.841157,44.429663],[26.826531,44.437387],[26.820905,44.439337],[26.811844,44.440971],[26.775899,44.443233],[26.767281,44.44309],[26.761079,44.442358],[26.753881,44.442121],[26.744362,44.443494],[26.737439,44.445264],[26.730813,44.446226],[26.715327,44.446967],[26.692728,44.445167],[26.684881,44.444028],[26.672607,44.440856],[26.664362,44.439434],[26.653965,44.439532],[26.647743,44.440639],[26.642787,44.442137],[26.633145,44.446392],[26.628647,44.447839],[26.620868,44.449267],[26.612792,44.449442],[26.594014,44.447849],[26.579915,44.446911],[26.571119,44.445772],[26.560573,44.444767],[26.552546,44.444676],[26.549036,44.445058],[26.530381,44.447955],[26.522635,44.448729],[26.513038,44.449013],[26.503474,44.450606],[26.496915,44.452579],[26.49102,44.453911],[26.481341,44.455172],[26.463499,44.45567],[26.459107,44.455557],[26.449803,44.454094],[26.442544,44.451563],[26.422989,44.442577],[26.416603,44.440342],[26.41248,44.43939],[26.404388,44.43866],[26.387283,44.438795],[26.378585,44.437356],[26.329439,44.422679],[26.317565,44.419016],[26.298936,44.413697],[26.280213,44.409648],[26.275025,44.408801],[26.269035,44.408449],[26.250099,44.409308],[26.243328,44.409012],[26.233632,44.407237],[26.226975,44.406702],[26.217853,44.40706],[26.208014,44.405553],[26.1757,44.410512],[26.165672,44.412789],[26.155347,44.414242],[26.146099,44.418],[26.13685,44.420267],[26.133592,44.420669],[26.127998,44.423334],[26.123965,44.424087],[26.12237,44.425945],[26.104343,44.426882],[26.103035,44.42897],[26.097058,44.429781],[26.093229,44.432928],[26.089935,44.433528],[26.086825,44.439539],[26.093043,44.440097],[26.091189,44.442575],[26.092252,44.443858],[26.09688,44.439353],[26.100659,44.438892],[26.10281,44.434694],[26.103643,44.429295],[26.101077,44.428371],[26.101274,44.425989],[26.103962,44.42559],[26.104106,44.413744],[26.096966,44.408923],[26.095588,44.40721],[26.097192,44.403063],[26.097057,44.400227],[26.092108,44.389475],[26.092328,44.381359],[26.088831,44.367921],[26.082512,44.344543],[26.077391,44.329828],[26.073513,44.325554],[26.068054,44.318456],[26.066606,44.317123],[26.063092,44.311231],[26.062401,44.3067],[26.060001,44.284519],[26.058306,44.270686],[26.055329,44.266971],[26.051184,44.266477],[26.043946,44.263641],[26.042116,44.261996],[26.039391,44.255453],[26.035028,44.249044],[26.036637,44.237225],[26.021113,44.214138],[26.001344,44.184306],[25.996284,44.172953],[25.996192,44.172026],[25.999491,44.16482],[25.998501,44.162026],[25.998113,44.157153],[25.999016,44.155145],[25.995183,44.151739],[25.994857,44.14756],[25.995504,44.144947],[25.990393,44.118062],[25.985377,44.091055],[25.977618,44.0481],[25.972983,44.022944],[25.973457,44.020637],[25.979282,44.008932],[25.981847,44.006817],[25.984014,44.003718],[25.990463,43.998813],[25.992275,43.994699],[25.989681,43.985754],[25.971952,43.915586],[25.971525,43.908148],[25.975582,43.907774],[25.980391,43.906225],[25.979239,43.903775],[25.981701,43.903248],[25.982856,43.905654],[25.985561,43.908035],[25.989947,43.905236],[25.988869,43.902953],[25.996781,43.897954],[26.014822,43.879762],[26.016241,43.877418],[26.014581,43.860224],[26.013262,43.856826],[26.008688,43.853534],[26.001409,43.850763],[25.969842,43.839265],[25.965187,43.835766],[25.978424,43.827285],[25.979545,43.825839],[25.982042,43.818715],[25.98172,43.813628],[25.982692,43.810105],[25.986036,43.804582],[26.000435,43.792795],[26.006007,43.787944],[26.015816,43.779965],[26.024756,43.77411],[26.027657,43.771854],[26.030881,43.768131],[26.034444,43.765848],[26.040327,43.763263],[26.050053,43.756968],[26.05581,43.751997],[26.059135,43.749836],[26.066635,43.746177],[26.080923,43.741616],[26.089348,43.737561],[26.093222,43.734494],[26.108437,43.718941],[26.124682,43.705018],[26.131034,43.698135],[26.139575,43.691769],[26.144374,43.687031],[26.150336,43.680372],[26.151981,43.677629],[26.152814,43.672375],[26.15459,43.670145],[26.159159,43.666973],[26.163253,43.662605],[26.165421,43.661244],[26.174655,43.656832],[26.177846,43.654437],[26.190511,43.640802],[26.199464,43.634835],[26.20223,43.631465],[26.206757,43.628122],[26.211117,43.62735],[26.213141,43.625809],[26.211537,43.621808],[26.21242,43.618385],[26.215038,43.615506],[26.220847,43.61375],[26.224789,43.613683],[26.233138,43.610829],[26.237932,43.60795],[26.244259,43.602495],[26.245921,43.600304],[26.25279,43.596571],[26.257727,43.595936],[26.269797,43.597723],[26.273688,43.597892],[26.278956,43.597205],[26.281278,43.596117],[26.283761,43.592158],[26.285983,43.59114],[26.292503,43.590548],[26.30202,43.585508],[26.318503,43.572299],[26.322109,43.568926],[26.325233,43.567469],[26.33819,43.564436],[26.344273,43.562361],[26.355266,43.561787],[26.359217,43.562113],[26.373636,43.560577],[26.378847,43.561266],[26.392803,43.560136],[26.39498,43.560168],[26.41316,43.562374],[26.4191,43.561893],[26.425828,43.560162],[26.436453,43.556618],[26.457983,43.550484],[26.467825,43.550612],[26.481448,43.54785],[26.49793,43.54476],[26.50331,43.543983],[26.516775,43.545368],[26.522281,43.544277],[26.525365,43.542729],[26.559925,43.523051],[26.570323,43.517879],[26.592828,43.507583],[26.60475,43.503126],[26.611256,43.501876],[26.621566,43.500579],[26.62517,43.500579],[26.628508,43.499509],[26.631998,43.494976],[26.63562,43.48039],[26.639833,43.47436],[26.642529,43.469645],[26.649632,43.460037],[26.655023,43.450945],[26.663404,43.442553],[26.674445,43.434232],[26.677556,43.430833],[26.681522,43.427592],[26.685378,43.425245],[26.702196,43.42043],[26.705279,43.419191],[26.716085,43.413021],[26.724326,43.410553],[26.732598,43.410149],[26.739945,43.410595],[26.744902,43.410059],[26.750557,43.407993],[26.754092,43.406026],[26.758546,43.402286],[26.7652,43.400274],[26.768759,43.398719],[26.773638,43.398145],[26.798372,43.394127],[26.8017,43.393101],[26.810854,43.388358],[26.824452,43.38295],[26.830949,43.381334],[26.839778,43.377128],[26.840717,43.376211],[26.84389,43.368735],[26.845689,43.366352],[26.85356,43.360126],[26.856407,43.357369],[26.862349,43.354171],[26.872824,43.347641],[26.885302,43.339304],[26.891283,43.332066],[26.894227,43.329493],[26.897508,43.328354],[26.903661,43.327511],[26.907321,43.326002],[26.917846,43.318676],[26.924986,43.314216],[26.936332,43.306333],[26.938974,43.305516],[26.954609,43.303763],[26.958626,43.302982],[26.963003,43.301241],[26.981122,43.292756],[26.983453,43.29028],[26.982136,43.283304],[26.985188,43.278107],[26.985705,43.276233],[26.976453,43.25287],[26.974802,43.250761],[26.970731,43.248146],[26.966284,43.246891],[26.978797,43.243],[26.980548,43.241315],[26.983745,43.234246],[26.995921,43.217843],[26.99739,43.215522],[27.001346,43.200689],[27.0041,43.185769],[27.006104,43.180777],[27.008338,43.177823],[27.015866,43.165765],[27.022929,43.147254],[27.021979,43.14427],[27.018633,43.139068],[27.018545,43.119744],[27.01979,43.114495],[27.019813,43.110794],[27.021203,43.106002],[27.022784,43.093316],[27.031226,43.076002],[27.038051,43.06439],[27.040016,43.057103],[27.041398,43.055556],[27.046322,43.052803],[27.049054,43.04998],[27.051034,43.043783],[27.05042,43.041498],[27.048859,43.028963],[27.050665,43.02454],[27.050664,43.021386],[27.049429,43.017566],[27.04468,43.011807],[27.04522,43.007295],[27.044765,43.00141],[27.043589,42.997981],[27.044125,42.995886],[27.043823,42.991544],[27.039434,42.988262],[27.037892,42.985862],[27.031927,42.983035],[27.026836,42.984162],[27.02016,42.984767],[27.013799,42.984312],[27.010319,42.983447],[26.997722,42.985221],[26.986114,42.982754],[26.975616,42.978918],[26.971957,42.978568],[26.968408,42.977271],[26.963673,42.976668],[26.961518,42.975437],[26.958367,42.970178],[26.953299,42.967812],[26.949856,42.963455],[26.946902,42.958346],[26.938826,42.951245],[26.936179,42.948188],[26.936254,42.946818],[26.938718,42.945293],[26.938211,42.940346],[26.93925,42.937513],[26.94284,42.93434],[26.944005,42.935622],[26.943773,42.930914],[26.94502,42.929196],[26.948354,42.930086],[26.945291,42.927527],[26.94282,42.923483],[26.938448,42.918052],[26.938548,42.916108],[26.940414,42.914113],[26.939515,42.911601],[26.940767,42.905516],[26.941317,42.899084],[26.940985,42.897014],[26.943638,42.891371],[26.944414,42.887765],[26.944011,42.884014],[26.930585,42.887812],[26.927155,42.887707],[26.924387,42.885728],[26.924572,42.884271],[26.936026,42.880912],[26.937976,42.880969],[26.941065,42.877955],[26.945699,42.874559],[26.949649,42.873208],[26.948135,42.87183],[26.948246,42.869458],[26.945789,42.868592],[26.950928,42.865098],[26.950478,42.862381],[26.946014,42.86119],[26.946078,42.858713],[26.940967,42.859481],[26.939019,42.855258],[26.931239,42.851532],[26.928635,42.849548],[26.915126,42.841045],[26.909708,42.829067],[26.906038,42.8242],[26.898037,42.820031],[26.89472,42.817306],[26.89233,42.813205],[26.888335,42.810113],[26.886331,42.809745],[26.877616,42.811147],[26.874174,42.810872],[26.871332,42.808219],[26.872557,42.804519],[26.877471,42.800084],[26.878112,42.798341],[26.877334,42.795535],[26.874186,42.791439],[26.873578,42.788254],[26.876495,42.780416],[26.878395,42.773092],[26.877358,42.76928],[26.880034,42.765719],[26.883807,42.762408],[26.886172,42.754077],[26.891679,42.745741],[26.893578,42.741205],[26.896862,42.738306],[26.895712,42.730997],[26.897424,42.725199],[26.900104,42.722111],[26.977542,42.679507],[26.98584,42.677486],[26.998776,42.671642],[27.001523,42.668735],[27.002951,42.663095],[27.003441,42.658718],[27.005972,42.653288],[27.011329,42.655012],[27.029661,42.663174],[27.038058,42.666307],[27.057835,42.671243],[27.090146,42.672929],[27.09576,42.67398],[27.110994,42.678711],[27.124378,42.681869],[27.145463,42.68706],[27.154591,42.68905],[27.17903,42.69481],[27.184092,42.695871],[27.201268,42.697228],[27.232986,42.705228],[27.23681,42.705331],[27.243407,42.703434],[27.246164,42.702102],[27.248338,42.699482],[27.250608,42.698444],[27.254969,42.69796],[27.263634,42.695824],[27.271186,42.690243],[27.27532,42.686774],[27.307665,42.662091],[27.314496,42.658093],[27.324419,42.651292],[27.333488,42.643659],[27.339221,42.638431],[27.340787,42.636385],[27.345041,42.62641],[27.347172,42.62394],[27.365381,42.613661],[27.370829,42.611137],[27.377458,42.610268],[27.380084,42.609149],[27.391946,42.596023],[27.394107,42.591221],[27.398014,42.589223],[27.423547,42.560138],[27.442689,42.538169],[27.458365,42.519949],[27.464409,42.512432],[27.462795,42.505901],[27.461868,42.504138],[27.439393,42.483695],[27.436036,42.47905],[27.435823,42.472538],[27.440367,42.457389],[27.442938,42.454585],[27.462834,42.444157],[27.465748,42.443237],[27.474557,42.441738],[27.476044,42.440774],[27.477994,42.434867],[27.487397,42.416013],[27.486204,42.409321],[27.483386,42.403167],[27.482019,42.401513],[27.481424,42.398279],[27.482682,42.393425],[27.478785,42.379779],[27.479833,42.376341],[27.488946,42.36822],[27.489891,42.366158],[27.490127,42.360283],[27.491231,42.358485],[27.496554,42.355565],[27.496631,42.350683],[27.498115,42.341362],[27.49921,42.339617],[27.503005,42.336327],[27.503372,42.333644],[27.501336,42.326891],[27.503258,42.322283],[27.50256,42.31819],[27.49762,42.312959],[27.497124,42.311448],[27.496477,42.30326],[27.494088,42.297661],[27.489426,42.295143],[27.488958,42.291867],[27.490058,42.288342],[27.489443,42.282051],[27.487993,42.276008],[27.483368,42.271569],[27.483347,42.26766],[27.485392,42.263964],[27.485709,42.261482],[27.483115,42.2554],[27.47753,42.249991],[27.472707,42.249654],[27.471252,42.245996],[27.468009,42.244222],[27.468614,42.240877],[27.462409,42.238891],[27.458428,42.236453],[27.457041,42.23339],[27.453057,42.229137],[27.450391,42.223687],[27.449674,42.22091],[27.44242,42.218469],[27.442215,42.216154],[27.439316,42.211481],[27.435941,42.209348],[27.433596,42.205445],[27.435566,42.203022],[27.434816,42.199603],[27.435581,42.19642],[27.432333,42.193229],[27.434444,42.186479],[27.437037,42.185323],[27.437423,42.183129],[27.435781,42.179838],[27.433869,42.174023],[27.433488,42.167658],[27.432127,42.165024],[27.432112,42.162753],[27.437811,42.155493],[27.440883,42.14752],[27.443857,42.145264],[27.44415,42.140167],[27.441436,42.137827],[27.438775,42.137906],[27.434913,42.14043],[27.430098,42.140548],[27.427604,42.135766],[27.427783,42.134428],[27.431329,42.130977],[27.431629,42.129381],[27.428149,42.124845],[27.423706,42.121003],[27.420216,42.116712],[27.419506,42.11412],[27.416929,42.110989],[27.41733,42.109462],[27.426393,42.105852],[27.427466,42.103561],[27.426748,42.101171],[27.42944,42.095697],[27.42893,42.09259],[27.426793,42.088739],[27.430004,42.086149],[27.429728,42.085125],[27.425586,42.08127],[27.421513,42.079637],[27.418853,42.075961],[27.419189,42.074057],[27.421406,42.072917],[27.424882,42.072646],[27.428438,42.067119],[27.428502,42.064585],[27.426756,42.060659],[27.427915,42.058106],[27.4334,42.054971],[27.437834,42.049643],[27.443025,42.047683],[27.448849,42.043183],[27.450099,42.041133],[27.453015,42.039649],[27.458364,42.034554],[27.464678,42.032314],[27.468641,42.029419],[27.473087,42.029884],[27.478036,42.024679],[27.481766,42.021687],[27.491179,42.017759],[27.496445,42.013827],[27.496954,42.012237],[27.500125,42.008948],[27.503763,42.00808],[27.50527,42.005196],[27.510162,42.000243],[27.511179,41.997097],[27.514988,41.991537],[27.516463,41.986916],[27.51962,41.986379],[27.522551,41.983913],[27.522864,41.977147],[27.526685,41.973797],[27.527616,41.972071],[27.524534,41.970796],[27.518944,41.975034],[27.517565,41.974842],[27.516527,41.976994],[27.514501,41.977506],[27.510474,41.975129],[27.506438,41.976071],[27.504235,41.974553],[27.499436,41.973522],[27.496944,41.9738],[27.495898,41.975533],[27.494138,41.975315],[27.494327,41.973613],[27.490343,41.973194],[27.488483,41.973784],[27.486775,41.972457],[27.482764,41.97222],[27.475451,41.970629],[27.472363,41.970825],[27.469516,41.97258],[27.466881,41.971674],[27.464366,41.971972],[27.459407,41.968065],[27.406377,41.971048],[27.400625,41.967543],[27.398631,41.964545],[27.393071,41.959605],[27.385801,41.957424],[27.376585,41.952257],[27.371148,41.946596],[27.369115,41.942254],[27.367055,41.93959],[27.357442,41.93418],[27.353673,41.930101],[27.354003,41.927547],[27.356171,41.924059],[27.357284,41.918656],[27.36123,41.913178],[27.361908,41.9112],[27.36181,41.903678],[27.359698,41.900816],[27.35808,41.895923],[27.355222,41.893334],[27.353083,41.88845],[27.349235,41.885797],[27.342913,41.884794],[27.340149,41.883663],[27.336521,41.88034],[27.332496,41.878519],[27.328883,41.87528],[27.326716,41.869675],[27.324699,41.86769],[27.314492,41.864863],[27.306497,41.861466],[27.302684,41.859017],[27.301425,41.85588],[27.308708,41.837558],[27.308527,41.833782],[27.310892,41.830508],[27.312124,41.825605],[27.30795,41.814383],[27.303571,41.809752],[27.301169,41.808057],[27.297336,41.806586],[27.286297,41.803806],[27.284008,41.801893],[27.282776,41.79886],[27.277533,41.79396],[27.275431,41.790267],[27.27319,41.788968],[27.268595,41.789349],[27.2665,41.788319],[27.265521,41.785546],[27.266694,41.782079],[27.266222,41.781009],[27.262241,41.77833],[27.263604,41.775562],[27.263267,41.77286],[27.260923,41.769531],[27.256471,41.759887],[27.253872,41.756189],[27.24457,41.748962],[27.238658,41.743647],[27.23845,41.742552],[27.242139,41.736909],[27.241816,41.734929],[27.238786,41.730799],[27.236172,41.729469],[27.220206,41.727014],[27.218672,41.726121],[27.186578,41.660627],[27.179567,41.645956],[27.17709,41.639746],[27.166791,41.612719],[27.159771,41.593942],[27.155198,41.584791],[27.141726,41.561536],[27.136515,41.552086],[27.119787,41.522854],[27.11835,41.518792],[27.11612,41.505237],[27.114917,41.502438],[27.104397,41.49314],[27.102678,41.490193],[27.092906,41.457387],[27.092513,41.455459],[27.091623,41.440914],[27.093047,41.45722],[27.102563,41.489324],[27.105159,41.493522],[27.111804,41.499456],[27.114583,41.498825],[27.116708,41.49988],[27.118737,41.503483],[27.120203,41.504484],[27.127177,41.505197],[27.135201,41.506634],[27.14046,41.506198],[27.154848,41.50256],[27.160119,41.501886],[27.166724,41.501796],[27.171831,41.502264],[27.178039,41.502038],[27.181092,41.501447],[27.193012,41.497155],[27.197725,41.495923],[27.206123,41.494565],[27.217313,41.494046],[27.222894,41.492957],[27.227855,41.490891],[27.233094,41.487784],[27.240747,41.48444],[27.247321,41.482636],[27.252055,41.481882],[27.261044,41.481229],[27.270865,41.479373],[27.275894,41.478946],[27.282419,41.479309],[27.28787,41.480271],[27.293627,41.480591],[27.29802,41.480135],[27.303269,41.478687],[27.308851,41.476377],[27.322301,41.472539],[27.327307,41.470429],[27.332095,41.467477],[27.339191,41.460738],[27.344293,41.456515],[27.351714,41.452513],[27.358834,41.450305],[27.3687,41.449276],[27.386353,41.449531],[27.388335,41.449304],[27.389435,41.447598],[27.388281,41.444863],[27.540538,41.293751],[27.553213,41.287942],[27.556327,41.286991],[27.578142,41.284014],[27.594045,41.281141],[27.629452,41.274205],[27.634029,41.273],[27.662163,41.260928],[27.690637,41.24716],[27.695622,41.241024],[27.719888,41.226173],[27.737096,41.210852],[27.741334,41.207971],[27.754825,41.20395],[27.757711,41.20166],[27.761862,41.191448],[27.771447,41.185485],[27.774145,41.182671],[27.776473,41.174152],[27.77776,41.172533],[27.784579,41.169549],[27.789889,41.168341],[27.794633,41.16818],[27.800343,41.170979],[27.803669,41.174175],[27.807793,41.177048],[27.811092,41.177591],[27.81438,41.176224],[27.817337,41.173969],[27.83632,41.154849],[27.842999,41.150164],[27.8516,41.146252],[27.866517,41.140583],[27.879532,41.136082],[27.883956,41.133542],[27.886121,41.131512],[27.89216,41.124449],[27.896261,41.121918],[27.909093,41.117978],[27.915175,41.115751],[27.940818,41.103923],[27.949395,41.099828],[27.953829,41.095868],[27.956238,41.095628],[27.96692,41.098065],[27.974414,41.097585],[27.988932,41.096186],[27.992714,41.09558],[28.002481,41.092966],[28.008547,41.089674],[28.074583,41.077049],[28.08112,41.076338],[28.102342,41.069844],[28.106698,41.067779],[28.108757,41.067819],[28.111422,41.070108],[28.123297,41.073135],[28.142053,41.075885],[28.173509,41.076591],[28.18829,41.078622],[28.220168,41.081598],[28.226403,41.081351],[28.241751,41.078221],[28.24141,41.076547],[28.245927,41.07411],[28.251039,41.07284],[28.258227,41.071821],[28.262662,41.071651],[28.266146,41.072753],[28.272061,41.072122],[28.32029,41.064759],[28.360941,41.05846],[28.366995,41.058304],[28.367837,41.055448],[28.373327,41.053654],[28.37646,41.054212],[28.443767,41.035664],[28.446778,41.034649],[28.505787,41.008032],[28.510208,41.007049],[28.515535,41.007318],[28.535369,41.0118],[28.537392,41.012107],[28.569656,41.01936],[28.578943,41.019886],[28.582742,41.021274],[28.585907,41.023613],[28.590401,41.024829],[28.597415,41.023595],[28.607572,41.025355],[28.609478,41.026822],[28.612493,41.025801],[28.615812,41.026033],[28.620407,41.025219],[28.626705,41.022136],[28.630949,41.019407],[28.663037,41.007206],[28.666816,41.006231],[28.682965,41.005223],[28.68587,41.003716],[28.689575,41.00073],[28.691863,40.999763],[28.697443,40.999718],[28.6999,40.998723],[28.731512,40.98008],[28.737218,40.977601],[28.739925,40.977238],[28.745053,40.977851],[28.767448,40.985756],[28.774679,40.986347],[28.778981,40.985275],[28.783662,40.985338],[28.786908,40.986049],[28.79139,40.98809],[28.793988,40.991203],[28.795248,40.994956],[28.797285,40.997587],[28.802041,41.000161],[28.8068,41.000528],[28.810212,40.999575],[28.814693,40.995432],[28.818388,40.993488],[28.820801,40.993057],[28.846312,40.991579],[28.850421,40.991667],[28.855641,40.992658],[28.870618,40.997305],[28.889498,41.002705],[28.892178,41.003967],[28.905979,41.013353],[28.917285,41.02011],[28.921836,41.024154],[28.925025,41.030134],[28.927301,41.032127],[28.931059,41.034144],[28.937419,41.038382],[28.944606,41.046792],[28.948959,41.050549],[28.956707,41.053943],[28.962483,41.057166],[28.96621,41.060384],[28.969383,41.064155],[28.973375,41.066783],[28.978134,41.067313],[29.000089,41.066444],[29.008915,41.066838],[29.012168,41.06642],[29.014675,41.064616],[29.016297,41.059769],[29.018541,41.057637],[29.027124,41.052298],[29.040096,41.039868],[29.043982,41.03561],[29.045245,41.032078],[29.045632,41.028174],[29.047493,41.022991],[29.049201,41.020672],[29.05288,41.01751],[29.059058,41.013125],[29.061372,41.010212],[29.060854,41.006944],[29.057879,41.000886],[29.055898,40.99856],[29.049664,40.994466],[29.044941,40.993172],[29.039873,40.990916],[29.037499,40.994294],[29.032088,40.991722],[29.02914,40.995991],[29.03113,40.995495],[29.035923,40.99083],[29.037043,40.98883],[29.044169,40.992659],[29.050299,40.994602],[29.054304,40.997153],[29.060749,40.996998],[29.08384,40.988463],[29.089918,40.985389],[29.093405,40.982576],[29.097813,40.977373],[29.103675,40.966837],[29.108317,40.961646],[29.119219,40.951655],[29.150439,40.92635],[29.154662,40.924013],[29.204281,40.908755],[29.210486,40.906302],[29.231457,40.892936],[29.247994,40.882135],[29.250336,40.881218],[29.258163,40.879686],[29.26114,40.878237],[29.269448,40.869431],[29.278177,40.861564],[29.28217,40.859504],[29.288192,40.857199],[29.291149,40.855558],[29.299862,40.847762],[29.30389,40.845079],[29.327718,40.834395],[29.354712,40.822164],[29.356885,40.820699],[29.387725,40.796038],[29.391923,40.794275],[29.409337,40.78939],[29.409994,40.788425],[29.416339,40.78542],[29.416731,40.779791],[29.421603,40.774943],[29.424483,40.773784],[29.424066,40.771379],[29.42578,40.770037],[29.42225,40.765788],[29.422406,40.761741],[29.427208,40.752611],[29.431954,40.742401],[29.434517,40.737613],[29.435912,40.733019],[29.436795,40.727855],[29.437713,40.718856],[29.438564,40.715639],[29.439764,40.703878],[29.439132,40.699189],[29.432693,40.692759],[29.432908,40.689166],[29.430869,40.687593],[29.421513,40.688223],[29.41589,40.687394],[29.389728,40.678468],[29.385817,40.677472],[29.378886,40.677319],[29.375651,40.678004],[29.364695,40.681598],[29.360547,40.682118],[29.355419,40.680485],[29.345087,40.673577],[29.335687,40.668131],[29.332281,40.666791],[29.312494,40.662228],[29.305614,40.661653],[29.297942,40.659148],[29.284653,40.657268],[29.283279,40.656403],[29.285405,40.65288],[29.285599,40.650308],[29.27313,40.631311],[29.270648,40.623711],[29.272643,40.614605],[29.272337,40.6108],[29.270561,40.603335],[29.272033,40.599654],[29.276581,40.597647],[29.285561,40.590136],[29.290204,40.589005],[29.29225,40.584692],[29.292803,40.580412],[29.294503,40.578804],[29.295268,40.576344],[29.294335,40.572209],[29.294984,40.568998],[29.297669,40.56598],[29.302014,40.564381],[29.303168,40.563235],[29.302581,40.559385],[29.304446,40.556633],[29.304684,40.553932],[29.30686,40.551333],[29.304333,40.545457],[29.303735,40.541706],[29.304369,40.53871],[29.306964,40.534485],[29.313585,40.525374],[29.315682,40.519194],[29.316023,40.516326],[29.315843,40.50145],[29.312351,40.496745],[29.311563,40.494337],[29.310466,40.48616],[29.307788,40.481242],[29.287172,40.455835],[29.284638,40.453622],[29.279406,40.450666],[29.257819,40.439129],[29.255181,40.437255],[29.250361,40.432599],[29.243311,40.427209],[29.240192,40.425955],[29.235212,40.426585],[29.231236,40.425099],[29.225436,40.426127],[29.220971,40.425772],[29.216162,40.423801],[29.210935,40.423288],[29.203391,40.424017],[29.196685,40.422983],[29.187913,40.424096],[29.165296,40.42261],[29.158776,40.422834],[29.154294,40.422308],[29.146925,40.420703],[29.144123,40.419566],[29.140286,40.419556],[29.138712,40.418068],[29.140103,40.412184],[29.139072,40.40993],[29.133687,40.401657],[29.132496,40.397146],[29.135812,40.391092],[29.135876,40.386467],[29.133245,40.376019],[29.131557,40.373286],[29.116751,40.359875],[29.115511,40.357971],[29.114143,40.352911],[29.113927,40.349262],[29.11228,40.344792],[29.110237,40.343573],[29.106408,40.343085],[29.103061,40.340065],[29.097928,40.337475],[29.094438,40.336831],[29.093229,40.335129],[29.088616,40.333777],[29.085436,40.331489],[29.076497,40.330325],[29.071654,40.328521],[29.06866,40.325068],[29.052291,40.27958],[29.05199,40.275024],[29.049618,40.27415],[29.046912,40.275037],[29.041667,40.281224],[29.040741,40.282995],[29.041009,40.28666],[29.039871,40.287244],[29.035196,40.285748],[29.031489,40.286795],[29.026966,40.289875],[29.024544,40.290736],[29.020068,40.28989],[29.012122,40.289256],[29.00417,40.28724],[28.999888,40.285305],[28.990839,40.279915],[28.973678,40.274683],[28.965708,40.272995],[28.962617,40.271962],[28.956054,40.267948],[28.948304,40.264222],[28.939599,40.261541],[28.933519,40.260792],[28.930471,40.261],[28.897531,40.265874],[28.885276,40.266414],[28.877359,40.265686],[28.84759,40.261178],[28.828652,40.257662],[28.817094,40.256053],[28.808965,40.255271],[28.802883,40.254189],[28.797158,40.252173],[28.791676,40.249151],[28.785859,40.243795],[28.783209,40.239877],[28.781354,40.23482],[28.778966,40.221253],[28.77811,40.218121],[28.77725,40.219206],[28.781282,40.218952],[28.783102,40.22055],[28.783893,40.226576],[28.785257,40.225787],[28.760343,40.218582],[28.747806,40.21516],[28.74063,40.21445],[28.718523,40.214427],[28.712852,40.213926],[28.690673,40.212883],[28.680263,40.213007],[28.642241,40.217904],[28.634822,40.217862],[28.630725,40.21709],[28.606538,40.210162],[28.601039,40.208737],[28.597576,40.208473],[28.592776,40.209135],[28.521099,40.230542],[28.514009,40.231739],[28.478182,40.232643],[28.471652,40.232234],[28.46434,40.230122],[28.458612,40.226826],[28.455078,40.223737],[28.448123,40.216501],[28.444229,40.213266],[28.4292,40.203048],[28.412584,40.194708],[28.404742,40.190412],[28.397994,40.18715],[28.395062,40.186203],[28.378032,40.182839],[28.369771,40.182415],[28.360098,40.183093],[28.35715,40.182227],[28.355198,40.180314],[28.354655,40.1779],[28.354719,40.140071],[28.355114,40.138252],[28.360273,40.126675],[28.360817,40.123765],[28.360814,40.111837],[28.352662,40.075758],[28.352415,40.073347],[28.354364,40.06903],[28.361396,40.062967],[28.363248,40.060041],[28.365737,40.053496],[28.367839,40.051597],[28.373423,40.048788],[28.376645,40.045343],[28.37763,40.042965],[28.377545,40.039726],[28.374166,40.034982],[28.368488,40.032739],[28.343524,40.031424],[28.320163,40.029727],[28.298739,40.029311],[28.293778,40.029659],[28.286673,40.031878],[28.280316,40.032668],[28.27607,40.031877],[28.246156,40.021074],[28.240998,40.018131],[28.22141,40.001875],[28.21623,39.997861],[28.212256,39.995388],[28.188635,39.98166],[28.17434,39.973495],[28.172904,39.971879],[28.170595,39.965274],[28.17021,39.962024],[28.170953,39.956299],[28.168976,39.948233],[28.15895,39.932805],[28.154248,39.926462],[28.154207,39.922914],[28.155612,39.921048],[28.163328,39.913464],[28.165356,39.910056],[28.16558,39.907379],[28.164364,39.904034],[28.157319,39.89804],[28.154579,39.894311],[28.154045,39.891981],[28.159483,39.886196],[28.164232,39.883067],[28.16572,39.879043],[28.168642,39.873408],[28.168691,39.870804],[28.165146,39.866881],[28.15999,39.865391],[28.154422,39.865133],[28.153041,39.863647],[28.153762,39.861092],[28.157036,39.857759],[28.157323,39.856047],[28.152231,39.852368],[28.144918,39.843876],[28.142953,39.839618],[28.13942,39.835869],[28.134371,39.833038],[28.125341,39.829487],[28.116702,39.827432],[28.107742,39.823713],[28.092497,39.8157],[28.083147,39.809934],[28.073741,39.80563],[28.065269,39.798469],[28.062869,39.793795],[28.054149,39.787947],[28.047846,39.78088],[28.043888,39.779435],[28.033911,39.777924],[28.024831,39.777032],[28.020723,39.775964],[28.016498,39.772757],[28.008043,39.762527],[28.003974,39.758859],[28.000262,39.752835],[27.99762,39.741797],[27.996768,39.73979],[27.993242,39.73686],[27.988431,39.735408],[27.980095,39.733967],[27.975114,39.732518],[27.971765,39.730493],[27.967653,39.726931],[27.966677,39.72527],[27.966787,39.722423],[27.970801,39.713704],[27.967528,39.709879],[27.966163,39.703297],[27.966711,39.69942],[27.964594,39.696254],[27.957025,39.693099],[27.952404,39.690261],[27.951455,39.687029],[27.953092,39.681569],[27.95233,39.678896],[27.942502,39.663611],[27.934167,39.650978],[27.932023,39.648622],[27.926725,39.644387],[27.905927,39.631967],[27.902327,39.628701],[27.901574,39.626949],[27.902459,39.619663],[27.91123,39.598932],[27.911055,39.596631],[27.907276,39.58741],[27.904056,39.580582],[27.900719,39.571556],[27.899319,39.561561],[27.902551,39.551596],[27.90238,39.547256],[27.898422,39.534592],[27.897948,39.531476],[27.899207,39.52648],[27.902944,39.507968],[27.903842,39.504976],[27.903348,39.486507],[27.904813,39.479609],[27.908068,39.474709],[27.90847,39.470339],[27.90651,39.466799],[27.905132,39.462353],[27.905628,39.458512],[27.907195,39.455994],[27.909773,39.453712],[27.915776,39.450949],[27.926675,39.441632],[27.934814,39.434272],[27.94034,39.425335],[27.943292,39.422296],[27.94759,39.416009],[27.947771,39.413803],[27.942108,39.388793],[27.942811,39.386796],[27.946473,39.384668],[27.949687,39.381288],[27.952196,39.379584],[27.958013,39.376824],[27.961851,39.372541],[27.962565,39.367611],[27.961264,39.364882],[27.958094,39.361301],[27.956233,39.357864],[27.954383,39.356697],[27.949348,39.355276],[27.947924,39.353749],[27.94781,39.34998],[27.939221,39.343289],[27.935941,39.339853],[27.927923,39.334451],[27.923159,39.330332],[27.921257,39.327876],[27.918109,39.321079],[27.917126,39.317537],[27.917508,39.312179],[27.916349,39.310007],[27.911927,39.306577],[27.905938,39.296209],[27.907237,39.291629],[27.905909,39.287095],[27.905576,39.282686],[27.895789,39.270674],[27.8946,39.26855],[27.893159,39.262712],[27.891266,39.25953],[27.8865,39.254395],[27.883301,39.250321],[27.878659,39.247073],[27.866301,39.233012],[27.864401,39.23],[27.863647,39.227114],[27.863105,39.219959],[27.861546,39.214621],[27.857772,39.207165],[27.851621,39.186051],[27.85194,39.180853],[27.850866,39.176505],[27.848886,39.17392],[27.845094,39.170697],[27.842564,39.167738],[27.837387,39.156426],[27.836808,39.152011],[27.83978,39.141711],[27.840015,39.138356],[27.838841,39.110639],[27.839573,39.105987],[27.841549,39.100621],[27.841643,39.094543],[27.839877,39.088053],[27.84,39.083697],[27.840872,39.081123],[27.845106,39.07269],[27.848744,39.068904],[27.854093,39.065416],[27.859071,39.061229],[27.862722,39.056875],[27.86475,39.053323],[27.865826,39.047581],[27.865194,39.04369],[27.861562,39.029493],[27.858677,39.023323],[27.854031,39.01851],[27.849175,39.014516],[27.8475,39.012062],[27.846535,39.008552],[27.846135,38.996204],[27.845281,38.980696],[27.844964,38.978923],[27.837535,38.955593],[27.835885,38.952091],[27.836364,38.9489],[27.834077,38.927895],[27.8343,38.924396],[27.832086,38.917131],[27.829005,38.914482],[27.791409,38.898627],[27.782543,38.894088],[27.769356,38.889446],[27.763302,38.885881],[27.752234,38.877018],[27.717581,38.838856],[27.703056,38.82573],[27.701014,38.822814],[27.695163,38.80891],[27.693396,38.806158],[27.690381,38.803255],[27.685856,38.796848],[27.683707,38.794467],[27.676908,38.789656],[27.671832,38.787377],[27.670219,38.785625],[27.669668,38.782477],[27.664489,38.778133],[27.658709,38.771509],[27.654658,38.76819],[27.639616,38.759274],[27.61476,38.74668],[27.581057,38.730427],[27.574221,38.726909],[27.560766,38.72045],[27.513086,38.696402],[27.485419,38.682596],[27.463667,38.671477],[27.453134,38.665903],[27.450979,38.664439],[27.448496,38.66097],[27.440659,38.638236],[27.439705,38.637171],[27.423461,38.640761],[27.410876,38.642489],[27.403484,38.64273],[27.390521,38.642123],[27.369766,38.639406],[27.364104,38.636276],[27.362579,38.634133],[27.357245,38.622967],[27.356374,38.618096],[27.357086,38.612251],[27.35961,38.607689],[27.360472,38.603996],[27.359378,38.600096],[27.357121,38.596718],[27.355167,38.590928],[27.353401,38.587998],[27.347422,38.579971],[27.339119,38.572447],[27.329854,38.568009],[27.326173,38.565286],[27.321086,38.562634],[27.319967,38.558756],[27.313654,38.556921],[27.309238,38.553655],[27.305635,38.552806],[27.30454,38.55117],[27.302156,38.551404],[27.300701,38.553209],[27.297983,38.549204],[27.292551,38.549511],[27.290978,38.54872],[27.282572,38.537644],[27.281455,38.532469],[27.279259,38.529537],[27.278688,38.52546],[27.275966,38.52288],[27.275674,38.521386],[27.277668,38.518372],[27.277494,38.516394],[27.274876,38.513397],[27.271664,38.511766],[27.269528,38.508307],[27.270052,38.504871],[27.272265,38.502615],[27.271553,38.500231],[27.268297,38.499544],[27.267127,38.496243],[27.263273,38.492107],[27.257546,38.491876],[27.255231,38.490339],[27.252975,38.486844],[27.248056,38.485206],[27.245011,38.482947],[27.241509,38.482656],[27.232716,38.476194],[27.227736,38.46871],[27.22662,38.461465],[27.228403,38.461542],[27.243492,38.458804],[27.242389,38.450402],[27.240631,38.446928],[27.236285,38.445197],[27.220385,38.444427],[27.217112,38.44242],[27.218638,38.440248],[27.224147,38.440754],[27.227544,38.439358],[27.229549,38.437098],[27.236222,38.425791],[27.23745,38.422522],[27.238096,38.414023],[27.236653,38.410204],[27.230672,38.402878],[27.229031,38.396847],[27.2306,38.386569],[27.229625,38.369972],[27.230013,38.36704],[27.233131,38.3546],[27.233594,38.342394],[27.236661,38.33002],[27.236677,38.326524],[27.235643,38.32344],[27.231498,38.314618],[27.225346,38.306227],[27.224051,38.303566],[27.223982,38.300241],[27.225852,38.290596],[27.225761,38.28698],[27.221549,38.265286],[27.221388,38.26093],[27.222396,38.256742],[27.226252,38.250281],[27.243821,38.22973],[27.248049,38.225718],[27.252689,38.222558],[27.300227,38.19719],[27.305478,38.193306],[27.308242,38.189177],[27.311335,38.180809],[27.314777,38.168869],[27.318091,38.160748],[27.321574,38.154534],[27.324608,38.150241],[27.336834,38.134816],[27.341937,38.127202],[27.349665,38.113487],[27.352867,38.108931],[27.358041,38.104346],[27.363368,38.101225],[27.389087,38.089225],[27.394916,38.085932],[27.401887,38.079963],[27.422175,38.058282],[27.426786,38.05097],[27.428211,38.046345],[27.428788,38.036844],[27.431282,38.031813],[27.435757,38.028105],[27.455989,38.017703],[27.462686,38.015842],[27.472237,38.015709],[27.480684,38.013919],[27.485786,38.011673],[27.489559,38.00878],[27.501614,37.99714],[27.503934,37.992901],[27.507263,37.964027],[27.51631,37.96028],[27.52013,37.957338],[27.521014,37.954957],[27.523764,37.937128],[27.527412,37.924002],[27.528931,37.91996],[27.53077,37.917128],[27.534622,37.913496],[27.543214,37.907367],[27.548274,37.903182],[27.561389,37.891163],[27.567118,37.887546],[27.580601,37.88347],[27.581765,37.881781],[27.580031,37.878828],[27.575107,37.877707],[27.573622,37.876513],[27.564269,37.862257],[27.55932,37.858065],[27.547329,37.850117],[27.544621,37.847917],[27.542184,37.844691],[27.538632,37.838545],[27.533216,37.835472],[27.529812,37.83474],[27.499844,37.830442],[27.494952,37.828323],[27.490349,37.824781],[27.488423,37.822404],[27.486637,37.816683],[27.485518,37.814893],[27.476412,37.804009],[27.467918,37.796022],[27.466186,37.792072],[27.46583,37.787312],[27.463,37.783904],[27.4586,37.782726],[27.451585,37.778517],[27.444856,37.775393],[27.432618,37.772339],[27.428588,37.770682],[27.422462,37.766703],[27.41777,37.750569],[27.415461,37.746303],[27.4126,37.743281],[27.396426,37.731514],[27.387355,37.718337],[27.386457,37.71521],[27.374737,37.657539],[27.361218,37.589864],[27.357352,37.575691],[27.337118,37.504226],[27.337365,37.500623],[27.340402,37.49759],[27.340768,37.495998],[27.339431,37.493194],[27.341109,37.488994],[27.338586,37.481669],[27.340422,37.478784],[27.352799,37.473753],[27.357365,37.47364],[27.359175,37.474791],[27.360932,37.477514],[27.363819,37.479324],[27.382676,37.483838],[27.39122,37.484345],[27.395833,37.485382],[27.399136,37.48477],[27.408679,37.479261],[27.415604,37.475847],[27.421314,37.473707],[27.426339,37.473396],[27.433332,37.475537],[27.441693,37.476111],[27.447023,37.474557],[27.455324,37.474048],[27.46369,37.475604],[27.469139,37.476115],[27.473611,37.475681],[27.478829,37.476676],[27.4841,37.475396],[27.48692,37.472266],[27.490465,37.466731],[27.494628,37.464052],[27.498355,37.463397],[27.501242,37.461411],[27.502981,37.455248],[27.506226,37.453054],[27.513007,37.452613],[27.518385,37.450675],[27.522011,37.451027],[27.527826,37.449234],[27.530912,37.449679],[27.534471,37.449094],[27.545753,37.442244],[27.552598,37.437065],[27.555667,37.432709],[27.556972,37.42827],[27.56008,37.426519],[27.562666,37.423913],[27.566245,37.42229],[27.573482,37.42569],[27.576539,37.425581],[27.59262,37.419895],[27.595543,37.419235],[27.609702,37.418713],[27.61761,37.416766],[27.622249,37.413322],[27.626409,37.411666],[27.639522,37.410591],[27.643336,37.40959],[27.650955,37.406191],[27.653924,37.403402],[27.655244,37.398283],[27.674307,37.370421],[27.686889,37.361068],[27.695712,37.356745],[27.7047,37.353493],[27.713498,37.34898],[27.729644,37.343079],[27.736771,37.341375],[27.756956,37.337227],[27.762606,37.334969],[27.768368,37.333231],[27.771674,37.328987],[27.777766,37.325885],[27.783805,37.321643],[27.790744,37.317424],[27.792159,37.315773],[27.792192,37.312692],[27.782493,37.302997],[27.781138,37.300218],[27.781391,37.289034],[27.774049,37.288203],[27.767969,37.288872],[27.764921,37.288433],[27.762103,37.286542],[27.761002,37.283907],[27.760497,37.273513],[27.758115,37.268937],[27.748602,37.267149],[27.743138,37.264886],[27.725037,37.250476],[27.714019,37.240864],[27.701108,37.229975],[27.698481,37.228468],[27.692948,37.227357],[27.673946,37.229527],[27.671368,37.229223],[27.655019,37.21305],[27.651376,37.209803],[27.64517,37.205891],[27.630502,37.198038],[27.622322,37.194843],[27.619476,37.193167],[27.616995,37.190153],[27.610385,37.180274],[27.604549,37.175282],[27.594923,37.169097],[27.592186,37.166915],[27.588858,37.162498],[27.586005,37.154623],[27.581799,37.145681],[27.582539,37.137929],[27.582005,37.135473],[27.574227,37.128094],[27.57253,37.127113],[27.568186,37.126875],[27.56486,37.127663],[27.561438,37.126522],[27.557299,37.127311],[27.555,37.126229],[27.549289,37.125959],[27.545188,37.1247],[27.539643,37.125037],[27.535661,37.123373],[27.532861,37.118889],[27.528794,37.116459],[27.52362,37.115919],[27.520517,37.11328],[27.517264,37.112072],[27.51637,37.110292],[27.512322,37.108228],[27.509424,37.108923],[27.504082,37.108321],[27.501868,37.105334],[27.50261,37.102523],[27.500021,37.100933],[27.499199,37.098059],[27.493911,37.096056],[27.493574,37.093483],[27.483336,37.091111],[27.481933,37.090117],[27.481767,37.084914],[27.480231,37.078728],[27.47549,37.076378],[27.472457,37.073673],[27.461486,37.058488],[27.456709,37.055047],[27.451287,37.052824],[27.443189,37.047227],[27.442223,37.045864],[27.441714,37.040439],[27.440436,37.039508],[27.436959,37.041728],[27.428404,37.042385],[27.423793,37.040064],[27.415529,37.039096],[27.412495,37.039367],[27.399887,37.046375],[27.383525,37.051462],[27.377163,37.054827],[27.362591,37.056878],[27.351115,37.053428],[27.342236,37.04797],[27.339202,37.045121],[27.336209,37.044495],[27.333133,37.044965],[27.331137,37.041922],[27.327666,37.04253],[27.324634,37.039216],[27.321763,37.038735],[27.318735,37.036924],[27.314678,37.037291],[27.311903,37.038404],[27.309436,37.038345],[27.300977,37.031143],[27.301845,37.031487],[27.309687,37.038271],[27.318739,37.036819],[27.322903,37.039051],[27.325246,37.039383],[27.325722,37.041205],[27.327782,37.042492],[27.33128,37.041768],[27.332374,37.044295],[27.339826,37.045239],[27.342567,37.048012],[27.350772,37.053114],[27.361556,37.056575],[27.365374,37.056478],[27.375949,37.054955],[27.37884,37.054036],[27.383222,37.0513],[27.393464,37.048045],[27.398256,37.046879],[27.412957,37.039009],[27.423319,37.039726],[27.428103,37.042218],[27.432881,37.041873],[27.433514,37.036706],[27.430747,37.034588],[27.426884,37.036394],[27.424202,37.03634],[27.421751,37.034608],[27.421222,37.032955],[27.417856,37.032691],[27.414412,37.029785],[27.410388,37.030357],[27.408416,37.033912],[27.413836,37.038871],[27.418654,37.039608],[27.42311,37.039598],[27.426543,37.04186],[27.428861,37.042223],[27.436915,37.041602],[27.440634,37.03954],[27.442017,37.041106],[27.442202,37.045646],[27.443541,37.04733],[27.449759,37.051853],[27.457268,37.055152],[27.461781,37.058532],[27.472713,37.073771],[27.475326,37.076092],[27.479798,37.078272],[27.481238,37.080003],[27.482042,37.085982],[27.482073,37.090004],[27.483966,37.091205],[27.493583,37.09323],[27.4942,37.09625],[27.499174,37.097731],[27.500577,37.101326],[27.503018,37.102914],[27.502094,37.105254],[27.50425,37.108221],[27.508935,37.108877],[27.512046,37.107919],[27.516413,37.110097],[27.517331,37.111906],[27.520648,37.11312],[27.523575,37.115824],[27.529131,37.11647],[27.533137,37.118953],[27.535631,37.123105],[27.53965,37.124928],[27.545403,37.124571],[27.55102,37.126088],[27.554248,37.125921],[27.557791,37.127251],[27.561241,37.126324],[27.565218,37.127548],[27.568695,37.126749],[27.574014,37.127733],[27.581993,37.13526],[27.582761,37.137651],[27.58193,37.145333],[27.586402,37.155146],[27.588835,37.162189],[27.592651,37.167121],[27.594954,37.168939],[27.605677,37.175876],[27.60982,37.179418],[27.618091,37.191427],[27.621599,37.194376],[27.630578,37.19792],[27.63775,37.201996],[27.648194,37.20745],[27.651721,37.209889],[27.655922,37.213693],[27.671309,37.229],[27.674698,37.229365],[27.691023,37.227397],[27.694072,37.227261],[27.700348,37.229197],[27.708646,37.236144],[27.726045,37.251135],[27.742902,37.264663],[27.748295,37.26703],[27.756914,37.268323],[27.758421,37.269041],[27.760706,37.273577],[27.761158,37.283765],[27.762916,37.287184],[27.765704,37.288533],[27.772968,37.288112],[27.785906,37.288451],[27.804907,37.28825],[27.81017,37.287559],[27.813047,37.286319],[27.819794,37.285142],[27.822717,37.285775],[27.834692,37.29219],[27.839182,37.293491],[27.84281,37.293145],[27.847058,37.2908],[27.850216,37.287554],[27.852288,37.286365],[27.856135,37.286011],[27.859207,37.287692],[27.862812,37.288177],[27.867029,37.287448],[27.868773,37.287832],[27.874384,37.291808],[27.877733,37.296231],[27.881432,37.299433],[27.88954,37.303359],[27.89282,37.303653],[27.895673,37.302508],[27.901016,37.302756],[27.90856,37.304928],[27.915512,37.305497],[27.920724,37.304535],[27.941953,37.303161],[27.948051,37.302224],[27.952101,37.303108],[27.957179,37.305751],[27.965719,37.30572],[27.970582,37.305205],[27.979934,37.303539],[27.989269,37.304098],[27.995,37.306614],[28.000826,37.308008],[28.015,37.308517],[28.02767,37.307214],[28.032333,37.306199],[28.038639,37.306932],[28.044126,37.306914],[28.050395,37.307992],[28.056102,37.308135],[28.060547,37.309318],[28.067232,37.3097],[28.070137,37.310477],[28.075619,37.313244],[28.081123,37.317668],[28.088811,37.318844],[28.091446,37.319809],[28.113009,37.331807],[28.116955,37.333643],[28.155363,37.34433],[28.156353,37.344079],[28.162894,37.330174],[28.169484,37.310628],[28.172704,37.305757],[28.194146,37.280916],[28.195782,37.278861],[28.20892,37.268891],[28.223122,37.258373],[28.229711,37.255047],[28.24967,37.251263],[28.255975,37.248697],[28.259861,37.246142],[28.264385,37.244884],[28.273694,37.245485],[28.27921,37.243566],[28.284407,37.242888],[28.300428,37.234542],[28.304836,37.233053],[28.313218,37.231003],[28.316287,37.229711],[28.326592,37.222559],[28.327636,37.217678],[28.330926,37.213892],[28.332058,37.211414],[28.335091,37.208788],[28.341526,37.206074],[28.35056,37.200213],[28.353248,37.195776],[28.354988,37.19411],[28.359387,37.192346],[28.366979,37.186463],[28.371168,37.18269],[28.372733,37.177288],[28.371733,37.170695],[28.370326,37.168033],[28.362446,37.157],[28.360372,37.152204],[28.36405,37.145171],[28.368932,37.139025],[28.371854,37.136069],[28.379678,37.122993],[28.38278,37.118881],[28.388881,37.113203],[28.389872,37.111012],[28.389188,37.108684],[28.385069,37.102754],[28.381169,37.099652],[28.370259,37.094451],[28.367154,37.091893],[28.36489,37.088562],[28.360215,37.076381],[28.363454,37.071167],[28.360771,37.070176],[28.363507,37.068331],[28.361772,37.067403],[28.355013,37.065687],[28.359885,37.065103],[28.362765,37.065815],[28.359136,37.0636],[28.352775,37.061048],[28.353943,37.05964],[28.356947,37.059866],[28.352827,37.0585],[28.349919,37.05956],[28.347274,37.061802],[28.338762,37.059732],[28.343311,37.058934],[28.35054,37.055378],[28.353423,37.052296],[28.357567,37.050021],[28.358764,37.048344],[28.358613,37.036646],[28.357206,37.033096],[28.348977,37.025719],[28.347829,37.023903],[28.349473,37.013376],[28.34879,37.012074],[28.345412,37.012046],[28.34067,37.010702],[28.337649,37.013966],[28.333781,37.014745],[28.331028,37.010292],[28.325961,37.010252],[28.323295,37.009064],[28.321367,37.006356],[28.309639,37.000377],[28.303563,36.996634],[28.297335,36.993794],[28.296523,36.991121],[28.296938,36.98787],[28.294529,36.982555],[28.29077,36.979788],[28.289145,36.975845],[28.285027,36.971927],[28.284275,36.96781],[28.284829,36.965622],[28.284784,36.958346],[28.286102,36.954372],[28.285816,36.950817],[28.282585,36.948181],[28.282253,36.943425],[28.279718,36.937782],[28.279382,36.927889],[28.280379,36.920158],[28.28005,36.916672],[28.277118,36.91307],[28.277669,36.910464],[28.27395,36.903008],[28.272471,36.899055],[28.275619,36.894774],[28.274608,36.89351],[28.272963,36.883698],[28.271012,36.877659],[28.273298,36.874965],[28.275358,36.874231],[28.272298,36.872222],[28.272272,36.867262],[28.273962,36.866514],[28.272896,36.862792],[28.270323,36.860142],[28.259695,36.857727],[28.244947,36.858704],[28.240676,36.858404],[28.239019,36.860354],[28.236161,36.859737],[28.2346,36.861756],[28.233178,36.859523],[28.230935,36.858228],[28.228175,36.85817],[28.226302,36.85479],[28.227239,36.852066],[28.224974,36.850531],[28.22446,36.84864],[28.220869,36.848696],[28.219217,36.847781],[28.214017,36.847879],[28.213142,36.845976],[28.209674,36.845213],[28.207396,36.847034],[28.206702,36.842307],[28.203675,36.840307],[28.201187,36.837191],[28.197605,36.834429],[28.194712,36.833489],[28.190923,36.829319],[28.189354,36.828388],[28.186215,36.828446],[28.182359,36.830053],[28.176106,36.83089],[28.16975,36.828604],[28.165076,36.830188],[28.16375,36.831985],[28.147198,36.834417],[28.14237,36.832709],[28.140173,36.829642],[28.137779,36.823243],[28.136819,36.817934],[28.13532,36.815771],[28.123193,36.806009],[28.120994,36.805224],[28.116638,36.805438],[28.113643,36.80448],[28.094803,36.803053],[28.091237,36.803555],[28.092118,36.800657],[28.091648,36.798286],[28.089404,36.799752],[28.086505,36.799456],[28.081155,36.800278],[28.077539,36.797905],[28.074845,36.797532],[28.068637,36.794527],[28.063159,36.794182],[28.056677,36.791501],[28.051403,36.791026],[28.04673,36.788951],[28.040615,36.788607],[28.037955,36.787833],[28.035777,36.78594],[28.030353,36.782768],[28.025058,36.78094],[28.021935,36.781329],[28.019502,36.780522],[28.015489,36.780763],[28.01185,36.782745],[28.009435,36.782912],[28.006309,36.781831],[28.004132,36.782314],[28.002527,36.780974],[27.999824,36.780523],[27.999131,36.776512],[27.996249,36.774462],[27.988431,36.775485],[27.986286,36.774707],[27.983877,36.77536],[27.979626,36.774735],[27.976417,36.775641],[27.973182,36.778096],[27.970123,36.77778],[27.968615,36.779271],[27.964344,36.778986],[27.961046,36.780621],[27.957545,36.780318],[27.95467,36.777954],[27.951963,36.780891],[27.94974,36.781136],[27.946045,36.779472],[27.943466,36.779153],[27.942076,36.777623],[27.935671,36.777502],[27.926735,36.77901],[27.921179,36.779393],[27.917265,36.777435],[27.914973,36.773234],[27.910148,36.769828],[27.90691,36.766206],[27.905967,36.764034],[27.906366,36.76151],[27.903616,36.755854],[27.898298,36.756334],[27.887241,36.759175],[27.876372,36.763992],[27.873861,36.763927],[27.871658,36.765951],[27.867635,36.766443],[27.866172,36.764748],[27.86006,36.766668],[27.854917,36.769471],[27.846919,36.773083],[27.840813,36.77535],[27.83864,36.777821],[27.835074,36.779618],[27.829563,36.780186],[27.825259,36.778198],[27.822538,36.777655],[27.819369,36.775197],[27.816421,36.775717],[27.815029,36.774946],[27.811403,36.775499],[27.802423,36.768493],[27.794524,36.766022],[27.790556,36.765233],[27.787053,36.765276],[27.767734,36.764086],[27.760974,36.764301],[27.750868,36.765857],[27.742502,36.766055],[27.737949,36.765018],[27.732703,36.764532],[27.729452,36.764973],[27.724929,36.764094],[27.711655,36.763004],[27.699895,36.761362],[27.691363,36.759403],[27.679586,36.754954],[27.675329,36.754321],[27.668275,36.754437],[27.663916,36.753655],[27.662216,36.752048],[27.65778,36.750049],[27.654782,36.749544],[27.648918,36.744984],[27.64578,36.741121],[27.64229,36.738587],[27.636385,36.737266],[27.632658,36.737413],[27.627645,36.736249],[27.615013,36.731706],[27.630832,36.737106],[27.636469,36.737223],[27.642438,36.738694],[27.647368,36.742605],[27.649235,36.745287],[27.652425,36.74789],[27.656214,36.749902],[27.662507,36.75211],[27.663962,36.753607],[27.668658,36.754457],[27.675051,36.754251],[27.67926,36.754821],[27.69063,36.759117],[27.699838,36.761316],[27.711333,36.762938],[27.72491,36.764046],[27.729598,36.764932],[27.732475,36.764423],[27.737391,36.764852],[27.741588,36.765901],[27.750353,36.765858],[27.76199,36.764114],[27.76753,36.763948],[27.771141,36.764455],[27.787306,36.76526],[27.790591,36.765152],[27.80167,36.768005],[27.806858,36.772043],[27.809919,36.775203],[27.814641,36.774862],[27.816863,36.775842],[27.819978,36.775448],[27.822851,36.777679],[27.824961,36.777957],[27.827972,36.779886],[27.835208,36.779497],[27.837592,36.778663],[27.841371,36.774845],[27.848148,36.772474],[27.860396,36.766555],[27.866374,36.764537],[27.867417,36.765847],[27.871629,36.765876],[27.873286,36.764202],[27.877648,36.763633],[27.889127,36.758539],[27.896278,36.757166],[27.926808,36.778876],[27.936136,36.777417],[27.942409,36.77761],[27.943701,36.778843],[27.94673,36.77917],[27.951735,36.780815],[27.955553,36.777731],[27.95739,36.780221],[27.961013,36.780436],[27.964534,36.77882],[27.966201,36.779405],[27.97291,36.777336],[27.9754,36.77518],[27.979965,36.774384],[27.983834,36.775198],[27.986352,36.774553],[27.987985,36.775285],[27.994077,36.774551],[27.998311,36.775314],[27.999638,36.776944],[27.999738,36.780524],[28.003024,36.780969],[28.004173,36.782172],[28.006621,36.781821],[28.009718,36.782924],[28.012461,36.782693],[28.015686,36.780912],[28.024887,36.780898],[28.033041,36.784141],[28.038055,36.787853],[28.040282,36.788564],[28.047292,36.789078],[28.050966,36.790855],[28.058075,36.791795],[28.062787,36.794115],[28.068818,36.79456],[28.074155,36.797226],[28.077765,36.79781],[28.081569,36.800263],[28.08694,36.799445],[28.08869,36.799987],[28.091704,36.798309],[28.092212,36.800959],[28.09126,36.803441],[28.095906,36.80295],[28.113042,36.804332],[28.116671,36.805433],[28.121295,36.805197],[28.123324,36.806062],[28.135047,36.815656],[28.136759,36.817841],[28.137754,36.823068],[28.139832,36.828727],[28.142399,36.832809],[28.147542,36.83444],[28.164212,36.831769],[28.165397,36.829991],[28.170908,36.828643],[28.17512,36.830695],[28.181722,36.830213],[28.188221,36.828155],[28.190836,36.829144],[28.207252,36.843326],[28.207251,36.846856],[28.209753,36.845144],[28.213281,36.84606],[28.214084,36.847936],[28.218795,36.847683],[28.220716,36.848716],[28.224582,36.848805],[28.226779,36.851465],[28.227665,36.854026],[28.226357,36.855045],[28.228092,36.858032],[28.230921,36.858152],[28.233282,36.859497],[28.233184,36.860909],[28.235383,36.861693],[28.235954,36.859878],[28.238188,36.860379],[28.240696,36.858375],[28.245542,36.858616],[28.260033,36.857665],[28.270822,36.860025],[28.272593,36.862061],[28.274335,36.865871],[28.272317,36.867544],[28.27257,36.872469],[28.275542,36.874294],[28.275936,36.875636],[28.272674,36.875438],[28.271166,36.87809],[28.274437,36.885757],[28.274621,36.893043],[28.275964,36.894829],[28.272742,36.89918],[28.274055,36.902668],[28.275676,36.904674],[28.277598,36.913819],[28.28059,36.916658],[28.280666,36.920969],[28.279541,36.927319],[28.279683,36.936422],[28.280367,36.939371],[28.282971,36.945419],[28.282874,36.948546],[28.285508,36.950258],[28.286274,36.954642],[28.284968,36.957642],[28.285,36.965855],[28.28447,36.967973],[28.285538,36.972446],[28.289084,36.975429],[28.29087,36.97953],[28.294074,36.98175],[28.297057,36.987947],[28.296707,36.99175],[28.298054,36.994127],[28.304429,36.996872],[28.309924,37.000491],[28.321284,37.006241],[28.324497,37.009909],[28.330877,37.010231],[28.332626,37.011622],[28.33327,37.013965],[28.33504,37.015053],[28.337896,37.01377],[28.340105,37.011002],[28.341996,37.010686],[28.345371,37.012042],[28.348462,37.012039],[28.349575,37.0137],[28.347939,37.023075],[28.348165,37.024599],[28.357145,37.032809],[28.358664,37.035563],[28.358901,37.047267],[28.359822,37.049142],[28.386142,37.039271],[28.417564,37.030985],[28.419962,37.030218],[28.434501,37.023044],[28.455121,37.016192],[28.467989,37.014716],[28.473699,37.0147],[28.478191,37.016168],[28.482914,37.015097],[28.485665,37.011973],[28.489088,37.010026],[28.492131,37.009627],[28.505434,37.012185],[28.557659,37.001549],[28.561793,36.999109],[28.567016,36.997278],[28.571738,36.994621],[28.578472,36.993447],[28.580839,36.992533],[28.596971,36.983545],[28.600286,36.98229],[28.605174,36.982049],[28.608322,36.982845],[28.618617,36.987715],[28.630773,36.991612],[28.633771,36.991924],[28.637617,36.991098],[28.646373,36.992039],[28.64994,36.993221],[28.653072,36.992713],[28.668243,36.985135],[28.68279,36.978357],[28.712972,36.965976],[28.723587,36.962763],[28.727261,36.960793],[28.729439,36.958088],[28.737777,36.942828],[28.739078,36.938688],[28.740073,36.930662],[28.742616,36.924093],[28.742835,36.918812],[28.741112,36.905987],[28.742756,36.895328],[28.743584,36.892924],[28.747862,36.886207],[28.753011,36.881595],[28.753398,36.87838],[28.756114,36.873672],[28.756403,36.871147],[28.755196,36.867572],[28.755281,36.865417],[28.757092,36.861867],[28.763404,36.85507],[28.765014,36.852741],[28.77189,36.838066],[28.775047,36.833738],[28.783593,36.829037],[28.807122,36.812724],[28.810667,36.811483],[28.813643,36.809497],[28.815149,36.807222],[28.816464,36.802688],[28.81934,36.798514],[28.823829,36.794444],[28.829763,36.791473],[28.832207,36.789434],[28.840361,36.778271],[28.84669,36.77337],[28.850987,36.769078],[28.860922,36.763967],[28.864139,36.763044],[28.869095,36.760235],[28.871707,36.75999],[28.88852,36.761005],[28.898829,36.762868],[28.901453,36.763729],[28.907516,36.763344],[28.911596,36.765135],[28.913891,36.765104],[28.924324,36.761864],[28.931026,36.758866],[28.93597,36.758587],[28.938893,36.761775],[28.940898,36.762866],[28.94383,36.762795],[28.951002,36.760493],[28.958272,36.758675],[28.958173,36.75636],[28.955195,36.755239],[28.958906,36.752794],[28.962992,36.751367],[28.96443,36.746983],[28.961431,36.744388],[28.962001,36.742275],[28.965288,36.740494],[28.969977,36.739009],[28.976397,36.738776],[28.988998,36.741821],[28.997864,36.746858],[29.003562,36.747538],[29.008523,36.745234],[29.013007,36.74634],[29.018912,36.74547],[29.021057,36.741637],[29.020462,36.738669],[29.022225,36.737288],[29.02333,36.732924],[29.026167,36.728686],[29.027081,36.723868],[29.029541,36.721168],[29.029611,36.714051],[29.032803,36.713681],[29.036152,36.715378],[29.037268,36.715035],[29.04049,36.711329],[29.041663,36.706864],[29.043489,36.706306],[29.047334,36.707355],[29.052798,36.706135],[29.057251,36.703123],[29.060691,36.699569],[29.059847,36.695614],[29.056428,36.698709],[29.05362,36.698112],[29.052114,36.695568],[29.049423,36.69599],[29.052765,36.699482],[29.052944,36.700883],[29.048518,36.706314],[29.049951,36.70697],[29.053873,36.705581],[29.059016,36.700987],[29.06149,36.699793],[29.066333,36.698897],[29.077818,36.692915],[29.083121,36.690952],[29.106419,36.686599],[29.119543,36.681484],[29.126786,36.677859],[29.130235,36.675593],[29.137283,36.668073],[29.140912,36.66534],[29.159031,36.656945],[29.163592,36.655193],[29.200723,36.644272],[29.206363,36.641946],[29.21628,36.634964],[29.220622,36.632941],[29.223384,36.632476],[29.246644,36.630391],[29.253182,36.630765],[29.259162,36.63311],[29.265381,36.63368],[29.273911,36.637527],[29.293412,36.641751],[29.298336,36.642344],[29.319519,36.643126],[29.345163,36.638993],[29.347696,36.637806],[29.351253,36.634669],[29.354336,36.633361],[29.362689,36.63393],[29.368749,36.636321],[29.371686,36.636588],[29.37651,36.635303],[29.380254,36.635524],[29.389182,36.638724],[29.390894,36.638528],[29.39561,36.639749],[29.396965,36.641396],[29.396707,36.643792],[29.397985,36.646103],[29.396048,36.650347],[29.397858,36.653293],[29.397289,36.654757],[29.399938,36.657353],[29.401735,36.65771],[29.400913,36.661125],[29.405751,36.666618],[29.407541,36.671373],[29.409238,36.674235],[29.409909,36.678225],[29.411974,36.680169],[29.415608,36.681961],[29.416298,36.683824],[29.415023,36.687655],[29.412438,36.690336],[29.411305,36.693816],[29.411658,36.698767],[29.410015,36.702374],[29.409558,36.706785],[29.414051,36.711955],[29.41936,36.71576],[29.42327,36.715249],[29.427141,36.717649],[29.431411,36.717326],[29.434695,36.71909],[29.440669,36.71945],[29.446956,36.722188],[29.448957,36.724803],[29.450416,36.728322],[29.453318,36.731311],[29.453076,36.732338],[29.446853,36.733628],[29.446126,36.736337],[29.449069,36.740619],[29.454738,36.745911],[29.455727,36.748213],[29.457774,36.757939],[29.45782,36.760881],[29.460098,36.766539],[29.464014,36.770666],[29.464795,36.774156],[29.466887,36.776161],[29.469019,36.780695],[29.474713,36.785951],[29.478214,36.786735],[29.48438,36.789692],[29.487202,36.790005],[29.492668,36.788206],[29.496039,36.788745],[29.497164,36.789856],[29.498959,36.79523],[29.501505,36.79788],[29.500184,36.799492],[29.501384,36.804851],[29.502951,36.806015],[29.512564,36.808945],[29.518833,36.813617],[29.524707,36.814147],[29.528409,36.815324],[29.536533,36.820177],[29.540702,36.820994],[29.545187,36.820783],[29.54971,36.823249],[29.556605,36.825342],[29.560959,36.826141],[29.567012,36.828572],[29.571484,36.832982],[29.573201,36.838888],[29.575221,36.840986],[29.57717,36.841283],[29.585115,36.840138],[29.588466,36.841142],[29.592581,36.844635],[29.599282,36.848732],[29.602786,36.853317],[29.606705,36.857056],[29.608935,36.860256],[29.611686,36.862121],[29.618368,36.864768],[29.628428,36.873201],[29.633073,36.879238],[29.63792,36.881873],[29.644245,36.887987],[29.645427,36.890139],[29.648145,36.891621],[29.653701,36.892354],[29.664842,36.892756],[29.669144,36.894834],[29.672871,36.893867],[29.67736,36.894272],[29.684532,36.900065],[29.687542,36.90468],[29.691353,36.907688],[29.696993,36.917454],[29.698172,36.921351],[29.700285,36.923704],[29.714666,36.926749],[29.725362,36.927379],[29.735584,36.926665],[29.738868,36.927407],[29.74252,36.929807],[29.7473,36.934704],[29.752882,36.937515],[29.754265,36.941351],[29.75966,36.946378],[29.759504,36.949416],[29.763002,36.953397],[29.763478,36.956228],[29.765703,36.957756],[29.77387,36.960392],[29.779729,36.964547],[29.784625,36.966759],[29.786013,36.969059],[29.788627,36.970271],[29.795438,36.970385],[29.804187,36.973562],[29.807568,36.975361],[29.812598,36.980703],[29.81389,36.9829],[29.814384,36.986966],[29.816114,36.989433],[29.82286,36.995461],[29.825994,37.000996],[29.825432,37.007034],[29.821156,37.013783],[29.819914,37.021026],[29.820496,37.021854],[29.835679,37.03414],[29.83793,37.036634],[29.841225,37.044982],[29.845855,37.052473],[29.849223,37.054713],[29.851841,37.054622],[29.862396,37.051665],[29.86573,37.048973],[29.867087,37.04593],[29.869763,37.042747],[29.872264,37.041314],[29.883158,37.036788],[29.887792,37.035219],[29.900703,37.031728],[29.903982,37.030034],[29.906209,37.027509],[29.913638,37.016634],[29.916553,37.013876],[29.929495,37.006321],[29.933873,37.005489],[29.937425,37.0063],[29.945676,37.010608],[29.951941,37.012811],[29.963645,37.014346],[29.969282,37.016279],[29.983559,37.026894],[29.987572,37.031018],[29.989763,37.032408],[29.993402,37.032907],[30.000646,37.032551],[30.006266,37.033312],[30.023435,37.033922],[30.028277,37.035976],[30.033755,37.041901],[30.039279,37.043625],[30.056615,37.042081],[30.061308,37.042917],[30.064268,37.042603],[30.069133,37.040887],[30.073981,37.039999],[30.082062,37.040959],[30.088713,37.038839],[30.091961,37.040548],[30.094301,37.040502],[30.096859,37.038646],[30.100869,37.037694],[30.107315,37.039052],[30.112308,37.037472],[30.118084,37.039976],[30.125305,37.04108],[30.129789,37.04376],[30.139497,37.04818],[30.147342,37.05045],[30.157454,37.051813],[30.161812,37.053858],[30.169438,37.055599],[30.172655,37.055216],[30.177948,37.053284],[30.183026,37.054627],[30.188492,37.053587],[30.194347,37.050942],[30.202037,37.051353],[30.214385,37.050604],[30.219337,37.051158],[30.228761,37.050726],[30.236468,37.052113],[30.243486,37.047768],[30.248876,37.042281],[30.250773,37.039257],[30.256013,37.032626],[30.261127,37.021311],[30.26227,37.017409],[30.265412,37.012456],[30.266086,37.009318],[30.26836,37.007596],[30.279198,37.004347],[30.286653,37.001342],[30.291984,36.998735],[30.295459,36.999178],[30.300256,37.003712],[30.304592,37.006178],[30.308239,37.009401],[30.316093,37.017224],[30.319265,37.018907],[30.324209,37.01894],[30.329476,37.017241],[30.333091,37.014503],[30.353481,37.007496],[30.360001,37.005923],[30.364071,37.006726],[30.366124,37.009544],[30.366642,37.014961],[30.368144,37.018033],[30.37267,37.022509],[30.376252,37.02379],[30.380227,37.027497],[30.383069,37.032485],[30.385942,37.035503],[30.389767,37.037255],[30.397611,37.03669],[30.404457,37.039572],[30.408707,37.038392],[30.41002,37.036822],[30.410316,37.034213],[30.416595,37.032865],[30.419513,37.03415],[30.422734,37.034313],[30.429291,37.036458],[30.432565,37.036359],[30.437299,37.038191],[30.441175,37.038396],[30.448162,37.035489],[30.450079,37.033385],[30.452691,37.02862],[30.45534,37.027187],[30.459757,37.026319],[30.463732,37.019732],[30.465219,37.018444],[30.470881,37.016473],[30.478844,37.014959],[30.483661,37.016969],[30.488425,37.017576],[30.493631,37.019116],[30.496026,37.019141],[30.500142,37.017793],[30.503281,37.017769],[30.511289,37.020659],[30.51327,37.020663],[30.524851,37.017553],[30.528605,37.015683],[30.535988,37.014033],[30.539219,37.012283],[30.544967,37.007462],[30.547229,37.00481],[30.551756,37.001459],[30.558195,36.995935],[30.56077,36.991973],[30.562346,36.98663],[30.563606,36.985242],[30.573426,36.980499],[30.578973,36.975545],[30.581995,36.974112],[30.586408,36.97039],[30.589524,36.966465],[30.591582,36.965274],[30.595808,36.964522],[30.59903,36.96324],[30.604271,36.959464],[30.611734,36.955905],[30.624494,36.952092],[30.627483,36.950287],[30.631406,36.95002],[30.63243,36.951948],[30.635831,36.952515],[30.638422,36.948894],[30.641773,36.947104],[30.645315,36.942388],[30.650352,36.939381],[30.664555,36.927299],[30.666855,36.924942],[30.668027,36.920613],[30.663843,36.911416],[30.663058,36.908703],[30.663482,36.905185],[30.665298,36.900514],[30.665375,36.897195],[30.663052,36.886544],[30.662925,36.884468],[30.665021,36.885364],[30.695636,36.891126],[30.701452,36.892663],[30.703425,36.888218],[30.699305,36.888127],[30.697277,36.887013],[30.698008,36.885767],[30.702604,36.886905],[30.702838,36.887827],[30.706783,36.888589],[30.708971,36.885186],[30.708882,36.883392],[30.706557,36.884539],[30.704538,36.882883],[30.70763,36.881706],[30.707174,36.884985],[30.712967,36.885695],[30.713679,36.88386],[30.722575,36.880775],[30.725245,36.877619],[30.730184,36.873906],[30.733832,36.875483],[30.739663,36.881382],[30.739424,36.888507],[30.752754,36.891945],[30.761132,36.897008],[30.77174,36.910164],[30.774399,36.912413],[30.804414,36.929652],[30.807628,36.929093],[30.808934,36.926082],[30.808421,36.922448],[30.806112,36.92102],[30.805351,36.913641],[30.802715,36.914374],[30.807308,36.921724],[30.808934,36.923147],[30.80915,36.926152],[30.807428,36.930837],[30.807982,36.931784],[30.830736,36.944846],[30.831411,36.945573],[30.794444,36.924419],[30.773595,36.912383],[30.771833,36.910923],[30.76589,36.903541],[30.761993,36.90057],[30.747907,36.90774],[30.736173,36.911622],[30.719396,36.913539],[30.702191,36.912092],[30.681183,36.906136],[30.664965,36.901296],[30.655248,36.900592],[30.65279,36.900982],[30.647926,36.909196],[30.647241,36.91108],[30.645125,36.925591],[30.643838,36.924209],[30.64463,36.919032],[30.640077,36.91747],[30.645413,36.917868],[30.646109,36.917323],[30.647186,36.910072],[30.651986,36.902453],[30.652398,36.900611],[30.656856,36.900278],[30.664826,36.901097],[30.701885,36.911927],[30.719617,36.913459],[30.722734,36.913438],[30.734143,36.91184],[30.740105,36.910238],[30.74863,36.907292],[30.762859,36.89989],[30.763458,36.899928],[30.77237,36.910903],[30.77375,36.912044],[30.78645,36.919419],[30.831862,36.945456],[30.835393,36.946599],[30.841676,36.947735],[30.848133,36.947631],[30.875563,36.94532],[30.891914,36.944077],[30.901967,36.942466],[30.945575,36.938178],[30.947756,36.937799],[30.964931,36.933484],[30.992966,36.926679],[30.996749,36.926039],[31.007608,36.926148],[31.022869,36.925961],[31.025142,36.92567],[31.047066,36.919779],[31.050984,36.918961],[31.075772,36.916487],[31.095625,36.912018],[31.099226,36.911841],[31.132833,36.915391],[31.136749,36.915088],[31.159264,36.909769],[31.161321,36.909734],[31.165029,36.911558],[31.168585,36.91191],[31.189446,36.906662],[31.192752,36.905586],[31.209766,36.898313],[31.217594,36.893532],[31.221334,36.891676],[31.227588,36.890413],[31.23074,36.890441],[31.240153,36.892869],[31.24264,36.893021],[31.247366,36.891839],[31.250941,36.889318],[31.255729,36.881258],[31.260632,36.874196],[31.26319,36.869384],[31.264844,36.867445],[31.268271,36.86582],[31.275012,36.864194],[31.277172,36.862511],[31.288114,36.85041],[31.293905,36.84623],[31.312782,36.837489],[31.317613,36.833265],[31.32518,36.829833],[31.33109,36.829691],[31.333725,36.828945],[31.349538,36.819634],[31.351515,36.818783],[31.358699,36.817452],[31.364568,36.815753],[31.3949,36.803478],[31.405656,36.798672],[31.410028,36.79556],[31.411626,36.793531],[31.41297,36.789715],[31.408513,36.788441],[31.407528,36.786567],[31.407254,36.782596],[31.401147,36.780163],[31.398336,36.777596],[31.403878,36.763423],[31.405775,36.76749],[31.408414,36.765659],[31.412658,36.765309],[31.415106,36.764076],[31.4214,36.763137],[31.424023,36.764541],[31.42492,36.766363],[31.425127,36.770253],[31.427404,36.774142],[31.427124,36.778069],[31.428879,36.780481],[31.434585,36.778795],[31.441464,36.775965],[31.446652,36.775344],[31.465394,36.777808],[31.469267,36.777691],[31.47715,36.776456],[31.484027,36.773519],[31.51319,36.76043],[31.517578,36.757308],[31.524352,36.748122],[31.527193,36.745102],[31.532599,36.740514],[31.536323,36.736522],[31.550256,36.726215],[31.55081,36.725318],[31.554468,36.728075],[31.560581,36.729421],[31.568709,36.727984],[31.579369,36.730692],[31.5839,36.73062],[31.589785,36.728506],[31.594074,36.730199],[31.600034,36.728731],[31.608389,36.729131],[31.611098,36.731348],[31.613927,36.739729],[31.615217,36.741632],[31.620684,36.746934],[31.62274,36.751304],[31.624322,36.752773],[31.632986,36.755741],[31.635679,36.75863],[31.640469,36.76063],[31.642045,36.763864],[31.644674,36.764858],[31.654031,36.764102],[31.659368,36.765276],[31.663569,36.769105],[31.669757,36.768857],[31.672055,36.767489],[31.674117,36.76788],[31.675239,36.770986],[31.679082,36.772707],[31.683564,36.773614],[31.684967,36.776739],[31.687825,36.778917],[31.691928,36.779941],[31.695233,36.784133],[31.70245,36.786757],[31.706035,36.786082],[31.710563,36.787251],[31.714745,36.789849],[31.72331,36.791547],[31.725441,36.790677],[31.727905,36.787111],[31.730534,36.785604],[31.742629,36.78329],[31.745376,36.784359],[31.748165,36.789411],[31.751056,36.789477],[31.75514,36.786576],[31.756334,36.788056],[31.754859,36.790889],[31.752078,36.791621],[31.752921,36.792835],[31.755077,36.791939],[31.760692,36.792014],[31.755162,36.79526],[31.756194,36.796289],[31.758112,36.795213],[31.763753,36.794524],[31.767235,36.795487],[31.768643,36.798041],[31.768131,36.80246],[31.764437,36.806827],[31.761064,36.808254],[31.762944,36.813008],[31.764924,36.814886],[31.77173,36.817908],[31.778265,36.820379],[31.780999,36.821897],[31.785164,36.826815],[31.786839,36.833348],[31.79053,36.838474],[31.791381,36.842815],[31.78937,36.847202],[31.787286,36.849022],[31.781852,36.851827],[31.779923,36.855123],[31.775521,36.858294],[31.771066,36.863541],[31.768823,36.867873],[31.769743,36.86995],[31.765999,36.872635],[31.764962,36.874244],[31.765934,36.879101],[31.764246,36.884663],[31.757913,36.89706],[31.758584,36.901391],[31.758037,36.908203],[31.761319,36.913056],[31.764694,36.915396],[31.765837,36.918838],[31.765546,36.927495],[31.76474,36.929663],[31.762093,36.931836],[31.756682,36.934711],[31.751954,36.940091],[31.750954,36.942227],[31.751552,36.95139],[31.749163,36.95741],[31.748638,36.964615],[31.747682,36.966934],[31.743532,36.973324],[31.737128,36.976865],[31.734175,36.9804],[31.735953,36.982356],[31.735234,36.984184],[31.735915,36.987652],[31.740145,36.990524],[31.744602,36.991298],[31.748373,36.99314],[31.755433,36.995544],[31.76052,36.999345],[31.762107,37.001461],[31.762236,37.0045],[31.760362,37.007055],[31.750211,37.014507],[31.748665,37.017075],[31.748691,37.018981],[31.751678,37.029363],[31.75489,37.032259],[31.756519,37.035592],[31.755236,37.044406],[31.753942,37.047007],[31.747019,37.051002],[31.744052,37.054702],[31.744175,37.057692],[31.74656,37.058778],[31.748925,37.057149],[31.750615,37.057277],[31.751049,37.059125],[31.748637,37.06192],[31.74798,37.063915],[31.750536,37.065985],[31.756033,37.066507],[31.758183,37.067297],[31.759859,37.072974],[31.758621,37.076833],[31.75893,37.078317],[31.76196,37.081386],[31.766848,37.084026],[31.767526,37.085435],[31.767855,37.092584],[31.766467,37.094545],[31.763131,37.096292],[31.758354,37.101845],[31.756775,37.106519],[31.758422,37.109748],[31.762968,37.114648],[31.765687,37.116209],[31.777411,37.118795],[31.788252,37.118857],[31.792561,37.11765],[31.79631,37.11864],[31.798541,37.1213],[31.803624,37.122932],[31.810546,37.118783],[31.820459,37.120197],[31.82228,37.121066],[31.830674,37.122504],[31.833693,37.124211],[31.838237,37.123585],[31.843336,37.124455],[31.84891,37.128576],[31.850302,37.130687],[31.851055,37.134636],[31.853588,37.135519],[31.858509,37.133025],[31.860323,37.132877],[31.861119,37.134621],[31.859569,37.137318],[31.859784,37.139255],[31.86312,37.139645],[31.866219,37.13483],[31.868036,37.133798],[31.870435,37.134318],[31.871786,37.136437],[31.872737,37.14025],[31.877029,37.142372],[31.87884,37.144344],[31.883806,37.146262],[31.888474,37.150596],[31.889764,37.152737],[31.894248,37.154362],[31.895581,37.156603],[31.898946,37.158414],[31.900578,37.161979],[31.903791,37.163268],[31.903264,37.16781],[31.906745,37.16793],[31.914538,37.169685],[31.922415,37.171002],[31.926199,37.172893],[31.933969,37.174958],[31.935236,37.176444],[31.93097,37.181623],[31.927714,37.18482],[31.924561,37.192121],[31.918588,37.201139],[31.918797,37.20888],[31.916118,37.213573],[31.916064,37.215718],[31.918277,37.218401],[31.914345,37.226999],[31.914674,37.230446],[31.912927,37.233427],[31.918569,37.237513],[31.919198,37.240444],[31.921837,37.244222],[31.923308,37.247647],[31.921172,37.255356],[31.920032,37.264839],[31.918111,37.267416],[31.907746,37.273067],[31.903736,37.277935],[31.897531,37.2827],[31.896534,37.285457],[31.895943,37.294949],[31.893948,37.298471],[31.88916,37.304179],[31.888738,37.309543],[31.887613,37.312056],[31.883473,37.317841],[31.880509,37.322883],[31.876548,37.330921],[31.872697,37.337048],[31.874354,37.339997],[31.877852,37.340576],[31.880178,37.339568],[31.882129,37.336712],[31.885236,37.337503],[31.882011,37.339762],[31.881078,37.342398],[31.881246,37.345804],[31.884486,37.350174],[31.884974,37.353722],[31.883495,37.35971],[31.879603,37.363205],[31.875092,37.364331],[31.872804,37.36613],[31.87003,37.37187],[31.868758,37.387417],[31.866501,37.391093],[31.861417,37.394897],[31.862747,37.396529],[31.870496,37.403574],[31.873073,37.407417],[31.874244,37.411785],[31.875761,37.414559],[31.877191,37.420129],[31.873401,37.427386],[31.866854,37.434186],[31.860897,37.44566],[31.860276,37.448801],[31.865567,37.458126],[31.86627,37.460644],[31.866261,37.465181],[31.86768,37.468583],[31.872717,37.476991],[31.874494,37.487228],[31.873997,37.490416],[31.872073,37.496335],[31.871314,37.502452],[31.871105,37.516408],[31.871764,37.519801],[31.875112,37.527457],[31.875985,37.531563],[31.875965,37.537566],[31.881554,37.555796],[31.883672,37.559684],[31.889275,37.56675],[31.890815,37.569539],[31.891796,37.576552],[31.892717,37.579848],[31.897267,37.588361],[31.89999,37.590492],[31.902934,37.591429],[31.905942,37.59344],[31.911812,37.599967],[31.921584,37.607917],[31.9243,37.612341],[31.925462,37.618125],[31.933517,37.631172],[31.937808,37.635255],[31.938686,37.63773],[31.942561,37.639504],[31.944135,37.642774],[31.951591,37.64679],[31.956054,37.651489],[31.960268,37.653454],[31.962075,37.655841],[31.961897,37.66031],[31.962584,37.661718],[31.965411,37.662783],[31.971499,37.660336],[31.976009,37.659619],[31.983049,37.661083],[31.988419,37.661384],[31.991676,37.66335],[31.999028,37.673619],[32.002103,37.67689],[32.008351,37.680813],[32.014824,37.682449],[32.022937,37.686906],[32.027991,37.692523],[32.035604,37.697534],[32.03956,37.705044],[32.042426,37.707197],[32.051377,37.709447],[32.053511,37.711112],[32.05677,37.716887],[32.057393,37.722846],[32.06148,37.725914],[32.062801,37.730836],[32.066412,37.735421],[32.065407,37.740228],[32.065792,37.742076],[32.070983,37.748875],[32.074321,37.750522],[32.077283,37.750872],[32.095706,37.750988],[32.099043,37.750586],[32.112196,37.747722],[32.120846,37.746199],[32.132181,37.74529],[32.140183,37.745183],[32.153878,37.745962],[32.158041,37.746956],[32.165391,37.750133],[32.171266,37.751622],[32.17699,37.753881],[32.180169,37.753704],[32.184451,37.752508],[32.191959,37.751291],[32.19518,37.751599],[32.199705,37.753823],[32.206611,37.755343],[32.213843,37.75818],[32.218884,37.75962],[32.252897,37.766837],[32.257916,37.766691],[32.278768,37.761509],[32.282629,37.761693],[32.286447,37.762952],[32.301358,37.765749],[32.312731,37.766201],[32.320947,37.76561],[32.330682,37.76564],[32.335591,37.766008],[32.341755,37.765627],[32.349649,37.767231],[32.35687,37.76955],[32.361356,37.772171],[32.365848,37.777137],[32.367232,37.781865],[32.368402,37.793445],[32.371474,37.798584],[32.384896,37.812777],[32.388438,37.81404],[32.394463,37.813078],[32.400583,37.808618],[32.404168,37.807995],[32.42599,37.807835],[32.433205,37.809794],[32.447392,37.814972],[32.466189,37.824436],[32.48326,37.830574],[32.486452,37.830555],[32.492823,37.828748],[32.509513,37.827684],[32.516549,37.828614],[32.515538,37.832557],[32.508401,37.848771],[32.503216,37.858337],[32.503064,37.866066],[32.506608,37.86736],[32.501849,37.869013],[32.501677,37.873737],[32.497608,37.873115],[32.493459,37.874456],[32.491176,37.874229],[32.490513,37.871472],[32.493294,37.871381],[32.494257,37.873037],[32.492292,37.874581],[32.489463,37.873838],[32.486087,37.874041],[32.485298,37.872284],[32.47687,37.872923],[32.475936,37.872263],[32.465762,37.872368],[32.458189,37.874365],[32.46011,37.8786],[32.453427,37.879846],[32.453436,37.880647],[32.463461,37.888692],[32.468214,37.890794],[32.4765,37.89221],[32.47896,37.893132],[32.48449,37.897685],[32.490475,37.900127],[32.494713,37.90309],[32.497589,37.908681],[32.508569,37.917471],[32.508967,37.919426],[32.508372,37.9246],[32.509107,37.927539],[32.510369,37.928388],[32.519101,37.926849],[32.52354,37.924918],[32.526942,37.924768],[32.523758,37.921162],[32.542002,37.939985],[32.551341,37.948164],[32.554535,37.949664],[32.615102,37.959],[32.657132,37.965537],[32.690001,37.970522],[32.69606,37.97199],[32.728129,37.984615],[32.764796,37.998943],[32.770066,38.000485],[32.815962,38.008318],[32.829219,38.01071],[32.887463,38.030178],[32.932451,38.045293],[32.936044,38.046181],[32.992561,38.056434],[32.99558,38.056891],[33.052872,38.061981],[33.058851,38.063518],[33.061348,38.064825],[33.107192,38.098161],[33.145578,38.125938],[33.147267,38.127016],[33.17183,38.138978],[33.17477,38.140234],[33.206078,38.149595],[33.242281,38.160567],[33.262334,38.166445],[33.313489,38.181713],[33.319468,38.18442],[33.373082,38.211935],[33.383593,38.217403],[33.433763,38.243126],[33.438838,38.24491],[33.460925,38.250397],[33.46681,38.251467],[33.49426,38.253251],[33.498341,38.25311],[33.533669,38.24848],[33.539644,38.248959],[33.554382,38.253323],[33.559794,38.25343],[33.565697,38.252334],[33.570795,38.252013],[33.578074,38.25302],[33.594049,38.255842],[33.641822,38.263983],[33.658416,38.267675],[33.696244,38.276325],[33.772148,38.293797],[33.782686,38.296581],[33.821505,38.307744],[33.824594,38.308497],[33.881749,38.324853],[33.937487,38.337221],[33.943663,38.339473],[33.967647,38.353444],[33.969275,38.356129],[33.971615,38.356054],[33.97365,38.357276],[34.005291,38.363923],[34.006849,38.366238],[34.001538,38.374506],[33.994657,38.384418],[33.995561,38.385212],[34.018164,38.400952],[34.022938,38.402396],[34.03128,38.402915],[34.034716,38.404145],[34.039553,38.407377],[34.048757,38.411317],[34.058569,38.412453],[34.061132,38.413065],[34.075166,38.41767],[34.078431,38.419763],[34.081563,38.423003],[34.085607,38.424585],[34.104564,38.428214],[34.107391,38.429415],[34.124599,38.439432],[34.127857,38.442215],[34.133169,38.449357],[34.13718,38.452088],[34.143609,38.453435],[34.152478,38.453639],[34.156876,38.455085],[34.16601,38.459067],[34.169549,38.459339],[34.184099,38.462707],[34.189775,38.462326],[34.19306,38.463166],[34.202305,38.469378],[34.205496,38.470235],[34.218901,38.472449],[34.231548,38.477141],[34.237874,38.480961],[34.245264,38.483435],[34.249609,38.48552],[34.263515,38.491177],[34.274927,38.494938],[34.27902,38.496864],[34.2859,38.499142],[34.302484,38.508948],[34.305043,38.509788],[34.319075,38.51201],[34.348619,38.515493],[34.353518,38.516521],[34.358831,38.518546],[34.367126,38.521141],[34.384488,38.524772],[34.389554,38.525418],[34.395538,38.525368],[34.40191,38.527185],[34.406543,38.527896],[34.424623,38.528687],[34.42795,38.529118],[34.444716,38.533483],[34.448705,38.535652],[34.454407,38.539839],[34.457226,38.540445],[34.473238,38.541623],[34.486429,38.544678],[34.49198,38.544737],[34.504282,38.54188],[34.507319,38.54167],[34.512287,38.542756],[34.518496,38.546438],[34.522755,38.54823],[34.542281,38.552827],[34.549308,38.553512],[34.565789,38.55245],[34.573153,38.553023],[34.578407,38.554471],[34.591539,38.555441],[34.598221,38.555411],[34.61821,38.558716],[34.639035,38.565376],[34.64541,38.565746],[34.652147,38.569135],[34.655945,38.572308],[34.667598,38.587257],[34.673207,38.593266],[34.679385,38.598915],[34.689659,38.61479],[34.694273,38.619449],[34.69926,38.627975],[34.700676,38.634105],[34.703938,38.635981],[34.711704,38.636034],[34.725342,38.631119],[34.736563,38.630435],[34.746939,38.631781],[34.750794,38.631958],[34.762594,38.630689],[34.765341,38.629559],[34.778135,38.626664],[34.788778,38.626508],[34.802065,38.628691],[34.804521,38.627514],[34.806863,38.630112],[34.806865,38.632801],[34.809197,38.63261],[34.812818,38.636016],[34.814628,38.638958],[34.817895,38.642537],[34.819681,38.64607],[34.823058,38.647088],[34.830759,38.6436],[34.821958,38.647042],[34.819872,38.646201],[34.817783,38.642233],[34.812643,38.635854],[34.810716,38.63465],[34.806361,38.635135],[34.802921,38.633259],[34.801079,38.6341],[34.798364,38.632559],[34.795338,38.627773],[34.787618,38.626532],[34.779232,38.626638],[34.768856,38.628766],[34.761637,38.631061],[34.750735,38.632055],[34.748172,38.632011],[34.735909,38.630499],[34.729003,38.63092],[34.72876,38.630328],[34.71999,38.626849],[34.719888,38.621465],[34.718316,38.610438],[34.71954,38.604826],[34.717165,38.591279],[34.717304,38.588755],[34.719371,38.586209],[34.727419,38.57889],[34.732958,38.574567],[34.734296,38.565663],[34.73581,38.562941],[34.738705,38.560102],[34.739749,38.557545],[34.742454,38.554448],[34.748106,38.550757],[34.750055,38.548084],[34.751801,38.542102],[34.754042,38.538065],[34.754049,38.532186],[34.752727,38.52763],[34.7526,38.523387],[34.749874,38.514675],[34.750137,38.508593],[34.75254,38.504568],[34.754158,38.496531],[34.753153,38.491323],[34.752857,38.484316],[34.753325,38.479586],[34.752238,38.474406],[34.752189,38.471267],[34.750325,38.458727],[34.751548,38.458668],[34.753392,38.50103],[34.752399,38.505257],[34.750251,38.508993],[34.75,38.513605],[34.750656,38.516997],[34.752479,38.521963],[34.75293,38.527576],[34.754154,38.531513],[34.754537,38.53585],[34.754033,38.538651],[34.752107,38.541902],[34.750605,38.547028],[34.747956,38.551017],[34.74273,38.554368],[34.739732,38.557884],[34.738382,38.560813],[34.734933,38.564121],[34.733634,38.573315],[34.73288,38.574976],[34.729396,38.57728],[34.717755,38.588136],[34.71739,38.591442],[34.719714,38.604975],[34.718366,38.611312],[34.720691,38.626939],[34.72871,38.630177],[34.730753,38.637536],[34.730616,38.640171],[34.732295,38.648626],[34.732691,38.654084],[34.734148,38.660615],[34.735492,38.663359],[34.740048,38.670232],[34.746692,38.672726],[34.757273,38.673151],[34.763154,38.676137],[34.77148,38.676873],[34.77768,38.677842],[34.783261,38.677791],[34.786949,38.678712],[34.792937,38.68129],[34.803512,38.684451],[34.808858,38.686836],[34.816228,38.691171],[34.818785,38.694238],[34.82259,38.69641],[34.826174,38.69996],[34.831756,38.704302],[34.824213,38.707342],[34.823039,38.709022],[34.821927,38.715421],[34.818063,38.720379],[34.818078,38.722003],[34.820939,38.726083],[34.819202,38.727457],[34.809928,38.730788],[34.79964,38.735952],[34.794089,38.735344],[34.78443,38.735139],[34.780055,38.737036],[34.776351,38.743479],[34.77201,38.748534],[34.770325,38.749449],[34.757815,38.752897],[34.750631,38.753351],[34.74418,38.754893],[34.726042,38.760492],[34.718612,38.761848],[34.711605,38.764514],[34.705742,38.765812],[34.685838,38.773531],[34.681069,38.772054],[34.675788,38.764461],[34.670765,38.762592],[34.663333,38.756299],[34.65999,38.755244],[34.657302,38.755404],[34.651552,38.75691],[34.646561,38.757007],[34.634634,38.755567],[34.624402,38.756611],[34.619119,38.757752],[34.614253,38.761869],[34.609093,38.762879],[34.599814,38.765739],[34.59286,38.768436],[34.590026,38.770141],[34.582249,38.777724],[34.579795,38.778717],[34.571203,38.779465],[34.565685,38.780639],[34.561027,38.784581],[34.559042,38.791163],[34.55942,38.793606],[34.564349,38.799957],[34.565696,38.807029],[34.564679,38.812267],[34.560635,38.82047],[34.558246,38.83677],[34.558148,38.840277],[34.556971,38.843089],[34.558107,38.845728],[34.558535,38.850204],[34.561797,38.852532],[34.566905,38.859323],[34.569799,38.864998],[34.569697,38.867644],[34.566674,38.873114],[34.559296,38.883892],[34.558224,38.886616],[34.55776,38.894873],[34.553435,38.91076],[34.55202,38.912903],[34.544937,38.919266],[34.545,38.921695],[34.548497,38.926669],[34.557237,38.932178],[34.565764,38.936128],[34.56921,38.938522],[34.57272,38.942702],[34.573371,38.947128],[34.570433,38.951137],[34.567208,38.953399],[34.558134,38.957561],[34.556975,38.959324],[34.556886,38.963823],[34.555805,38.966655],[34.550888,38.974616],[34.548417,38.976091],[34.537415,38.980447],[34.518487,38.989146],[34.511979,38.992348],[34.5014,38.99424],[34.48515,38.999988],[34.473556,39.004848],[34.464417,39.009803],[34.459861,39.014019],[34.453217,39.015671],[34.449082,39.019354],[34.44445,39.027712],[34.444487,39.031186],[34.443169,39.037914],[34.440527,39.043586],[34.439885,39.053771],[34.409482,39.055627],[34.404709,39.05665],[34.386746,39.06666],[34.380331,39.067667],[34.340233,39.063771],[34.333606,39.064022],[34.2761,39.083338],[34.227593,39.099426],[34.205994,39.106751],[34.202741,39.108705],[34.189478,39.130587],[34.184407,39.135956],[34.158493,39.16185],[34.154191,39.164914],[34.152371,39.166987],[34.150161,39.171528],[34.150247,39.173973],[34.152323,39.182717],[34.151471,39.188394],[34.150261,39.19142],[34.146356,39.198781],[34.146185,39.202579],[34.143698,39.21387],[34.137701,39.224333],[34.134768,39.230936],[34.129321,39.237547],[34.126345,39.246826],[34.117401,39.273376],[34.120123,39.275339],[34.121297,39.277688],[34.120768,39.286021],[34.124016,39.292377],[34.125925,39.301179],[34.130694,39.309396],[34.135909,39.313642],[34.142832,39.317799],[34.146759,39.32324],[34.149471,39.325874],[34.156908,39.329779],[34.1612,39.334422],[34.16599,39.34326],[34.1728,39.353426],[34.178244,39.361084],[34.180453,39.362659],[34.18383,39.363721],[34.201447,39.365352],[34.206866,39.366375],[34.213416,39.370096],[34.25089,39.40802],[34.271855,39.429323],[34.2783,39.437549],[34.283877,39.441954],[34.31847,39.458679],[34.32057,39.460934],[34.325343,39.46948],[34.331319,39.476998],[34.331697,39.478843],[34.328367,39.482048],[34.328712,39.483626],[34.332187,39.487465],[34.344422,39.497105],[34.349026,39.50252],[34.35145,39.506426],[34.353389,39.512229],[34.356813,39.515177],[34.360094,39.516076],[34.38372,39.51693],[34.389512,39.519214],[34.398462,39.530754],[34.399011,39.533235],[34.397981,39.536091],[34.3898,39.545255],[34.388488,39.549066],[34.390074,39.55554],[34.3887,39.558998],[34.383245,39.564467],[34.382901,39.566319],[34.387693,39.568627],[34.389878,39.571176],[34.392331,39.571761],[34.397672,39.571062],[34.404616,39.572069],[34.408412,39.574013],[34.409235,39.57588],[34.408706,39.578523],[34.406945,39.580759],[34.406855,39.584317],[34.40507,39.585707],[34.401185,39.585879],[34.401913,39.588795],[34.407925,39.588804],[34.408806,39.590115],[34.406704,39.596272],[34.406629,39.597991],[34.408342,39.598947],[34.412186,39.598755],[34.415809,39.600347],[34.426899,39.606179],[34.441676,39.617326],[34.444787,39.621658],[34.453191,39.631351],[34.464514,39.639699],[34.467874,39.641222],[34.472089,39.642217],[34.478353,39.647482],[34.48405,39.649793],[34.500739,39.663751],[34.50515,39.662981],[34.520173,39.659225],[34.538663,39.656168],[34.544513,39.65673],[34.564765,39.66287],[34.567445,39.664015],[34.570111,39.666349],[34.58039,39.682201],[34.585379,39.686017],[34.601569,39.692834],[34.608237,39.693881],[34.638278,39.690025],[34.645533,39.687637],[34.649601,39.687252],[34.662508,39.691583],[34.674786,39.701578],[34.678647,39.703817],[34.689617,39.708124],[34.702716,39.718939],[34.709808,39.721951],[34.711879,39.723366],[34.724911,39.737536],[34.726886,39.742796],[34.726894,39.747307],[34.728349,39.749443],[34.733538,39.753041],[34.734996,39.757516],[34.739026,39.76121],[34.741525,39.76679],[34.745712,39.769647],[34.747733,39.772711],[34.74921,39.778118],[34.756954,39.787294],[34.758539,39.79292],[34.765565,39.798494],[34.767634,39.802106],[34.76878,39.806181],[34.774326,39.809632],[34.780422,39.812025],[34.7833,39.816192],[34.784912,39.816953],[34.795549,39.818223],[34.809077,39.820904],[34.824284,39.824668],[34.834095,39.828485],[34.835893,39.828776],[34.846374,39.8281],[34.850272,39.828453],[34.860163,39.831125],[34.863066,39.833207],[34.865357,39.838543],[34.866689,39.84026],[34.870592,39.841933],[34.879477,39.848583],[34.88165,39.849343],[34.887272,39.849475],[34.890525,39.85084],[34.896858,39.855161],[34.901409,39.857373],[34.905865,39.858487],[34.91697,39.859934],[34.932065,39.860307],[34.938791,39.859624],[34.98406,39.844928],[34.988808,39.842548],[35.003198,39.834258],[35.001728,39.835317],[34.98775,39.843358],[34.978754,39.846861],[34.938268,39.859906],[34.934349,39.860572],[34.928745,39.860726],[34.927968,39.862934],[34.925439,39.86514],[34.924678,39.868115],[34.931045,39.881909],[34.931996,39.889548],[34.932742,39.892002],[34.937168,39.899873],[34.93679,39.905869],[34.93929,39.922083],[34.941093,39.92486],[34.9482,39.929861],[34.952366,39.93807],[34.958158,39.944849],[34.959115,39.94652],[34.960055,39.954848],[34.958823,39.959643],[34.96032,39.962388],[34.968896,39.967859],[34.970569,39.969654],[34.974694,39.978866],[34.976035,39.984975],[34.978648,39.990172],[34.978518,39.992539],[34.97664,39.995904],[34.979467,39.999902],[34.980093,40.003671],[34.982213,40.007853],[34.980788,40.010175],[34.977356,40.02212],[34.975836,40.024226],[34.959133,40.041043],[34.957428,40.043574],[34.956088,40.047935],[34.952171,40.049506],[34.933852,40.044671],[34.93054,40.045519],[34.921878,40.06037],[34.921936,40.06376],[34.929532,40.075989],[34.933465,40.082706],[34.93378,40.085789],[34.931431,40.092558],[34.931095,40.096987],[34.932081,40.102849],[34.935166,40.107014],[34.935107,40.110437],[34.92281,40.123381],[34.920633,40.125099],[34.916767,40.126581],[34.90947,40.128299],[34.904097,40.13132],[34.892731,40.14301],[34.890023,40.145244],[34.877369,40.153738],[34.8749,40.155678],[34.854589,40.175152],[34.851657,40.177131],[34.839124,40.181768],[34.836319,40.183222],[34.829799,40.189773],[34.825912,40.194927],[34.815107,40.203803],[34.810695,40.208676],[34.807208,40.211542],[34.803338,40.213219],[34.801052,40.215241],[34.79991,40.221022],[34.796991,40.222991],[34.796183,40.22488],[34.79722,40.229993],[34.797617,40.235548],[34.801203,40.24572],[34.801682,40.248052],[34.801553,40.26259],[34.803273,40.267939],[34.803242,40.270886],[34.800147,40.284809],[34.797379,40.290717],[34.796858,40.295303],[34.797105,40.300061],[34.796361,40.303775],[34.798383,40.309952],[34.801704,40.311354],[34.808604,40.316794],[34.813042,40.319152],[34.816489,40.322655],[34.82097,40.325262],[34.822169,40.326624],[34.820419,40.331132],[34.81736,40.332089],[34.815344,40.334502],[34.812709,40.335848],[34.810568,40.338206],[34.807392,40.339627],[34.80571,40.342957],[34.807155,40.349238],[34.808766,40.351322],[34.814131,40.355156],[34.814718,40.358529],[34.811442,40.361118],[34.809483,40.366121],[34.803897,40.372754],[34.802461,40.375567],[34.801087,40.383357],[34.802028,40.386119],[34.805892,40.392254],[34.808337,40.399246],[34.811455,40.4049],[34.811918,40.407889],[34.811038,40.414308],[34.81118,40.418157],[34.812522,40.424303],[34.812657,40.432222],[34.811375,40.43611],[34.811693,40.437599],[34.818709,40.441725],[34.840162,40.455471],[34.846101,40.459138],[34.856683,40.464028],[34.861465,40.465382],[34.866286,40.466121],[34.875608,40.469775],[34.879211,40.471981],[34.90129,40.491797],[34.905014,40.495408],[34.908618,40.501229],[34.915904,40.5239],[34.918678,40.529993],[34.923714,40.539691],[34.932637,40.556173],[34.935641,40.558619],[34.959126,40.565435],[34.963378,40.566243],[34.985526,40.568455],[34.991679,40.571268],[34.9984,40.573163],[35.003925,40.573543],[35.011708,40.575809],[35.015292,40.576473],[35.026715,40.577028],[35.033368,40.579168],[35.036328,40.582255],[35.045156,40.589171],[35.056205,40.594516],[35.061163,40.59757],[35.06404,40.600728],[35.067579,40.603134],[35.099404,40.613443],[35.103464,40.614342],[35.109979,40.614617],[35.127833,40.613643],[35.133204,40.606678],[35.167026,40.565466],[35.188914,40.546556],[35.19326,40.543626],[35.200079,40.541246],[35.20601,40.540544],[35.242897,40.541101],[35.250415,40.540788],[35.27483,40.537122],[35.281626,40.534353],[35.290802,40.527375],[35.296039,40.525028],[35.300371,40.524213],[35.305683,40.524387],[35.309584,40.525321],[35.388796,40.557407],[35.397278,40.560903],[35.402946,40.562509],[35.41118,40.562761],[35.414939,40.563584],[35.421398,40.566429],[35.433163,40.566416],[35.438827,40.567317],[35.453872,40.571532],[35.458961,40.571681],[35.489353,40.568427],[35.493401,40.567705],[35.511351,40.563363],[35.514672,40.563319],[35.518436,40.564409],[35.5235,40.568707],[35.527229,40.570694],[35.540216,40.574471],[35.559618,40.575763],[35.564791,40.5756],[35.574087,40.574129],[35.579898,40.57399],[35.625685,40.577982],[35.632056,40.57911],[35.643949,40.582195],[35.647973,40.582281],[35.675478,40.579436],[35.682829,40.577799],[35.706111,40.570919],[35.711661,40.569717],[35.719048,40.56922],[35.787002,40.569118],[35.7878,40.574111],[35.789486,40.577685],[35.78947,40.581154],[35.792071,40.582526],[35.794883,40.585314],[35.800179,40.587594],[35.801892,40.589257],[35.80359,40.594851],[35.810554,40.602676],[35.811887,40.605917],[35.813413,40.615152],[35.814303,40.616975],[35.819089,40.62044],[35.819568,40.626864],[35.80963,40.636624],[35.807905,40.641437],[35.808839,40.643507],[35.815528,40.648553],[35.819861,40.649917],[35.828042,40.649869],[35.834538,40.651768],[35.835382,40.656466],[35.839892,40.66117],[35.84083,40.668399],[35.849097,40.667421],[35.84994,40.666792],[35.845737,40.665167],[35.84266,40.663022],[35.837521,40.65665],[35.83574,40.657191],[35.839898,40.661072],[35.840863,40.668307],[35.835061,40.66963],[35.831792,40.671305],[35.826085,40.677692],[35.823541,40.682932],[35.822076,40.689105],[35.819514,40.692614],[35.812432,40.69638],[35.807292,40.699522],[35.805924,40.701351],[35.802588,40.710973],[35.801259,40.713124],[35.797099,40.716241],[35.792801,40.720898],[35.783244,40.72537],[35.776231,40.730507],[35.764211,40.737701],[35.757217,40.740117],[35.753916,40.741734],[35.723574,40.758879],[35.714714,40.7636],[35.698659,40.770084],[35.691647,40.773891],[35.684742,40.779845],[35.670592,40.795895],[35.665848,40.800697],[35.660921,40.80462],[35.642825,40.815495],[35.63768,40.819589],[35.633701,40.826137],[35.632936,40.829764],[35.632125,40.838266],[35.629701,40.845548],[35.629117,40.850262],[35.629582,40.853751],[35.632964,40.865502],[35.633707,40.871261],[35.635425,40.876937],[35.63543,40.881631],[35.631691,40.883042],[35.630333,40.885741],[35.631381,40.888036],[35.630494,40.889823],[35.63224,40.895332],[35.636547,40.906751],[35.640783,40.916076],[35.642998,40.919666],[35.646675,40.923612],[35.65658,40.937202],[35.657996,40.94076],[35.658091,40.945725],[35.664387,40.952478],[35.66558,40.955001],[35.666699,40.962531],[35.66862,40.966672],[35.670826,40.969723],[35.675966,40.972448],[35.682874,40.978332],[35.686078,40.979528],[35.676434,40.982347],[35.669804,40.985402],[35.666496,40.98557],[35.659914,40.984405],[35.657476,40.983003],[35.65562,40.980744],[35.651947,40.979739],[35.648246,40.980665],[35.644619,40.982565],[35.63873,40.987732],[35.628641,40.991285],[35.622333,40.996274],[35.615169,41.00001],[35.606954,41.002911],[35.600248,41.003292],[35.598427,41.003948],[35.596454,41.006526],[35.591359,41.008238],[35.586129,41.007652],[35.573762,41.014855],[35.572326,41.018036],[35.567723,41.023372],[35.56432,41.029695],[35.562167,41.031995],[35.561358,41.034536],[35.559898,41.034801],[35.549538,41.032394],[35.546519,41.033408],[35.545315,41.039439],[35.543283,41.040725],[35.530863,41.045156],[35.522613,41.046944],[35.520735,41.048078],[35.517966,41.051493],[35.510827,41.054273],[35.507168,41.057343],[35.503942,41.062997],[35.50004,41.066956],[35.498011,41.070896],[35.497812,41.079972],[35.493009,41.087029],[35.494526,41.089585],[35.498449,41.091365],[35.500061,41.093289],[35.500935,41.100834],[35.500749,41.103211],[35.496707,41.113906],[35.495113,41.116733],[35.486596,41.126161],[35.474608,41.135314],[35.472942,41.137123],[35.463532,41.151863],[35.459933,41.15522],[35.428788,41.17131],[35.421757,41.172724],[35.411761,41.172304],[35.403383,41.174088],[35.393596,41.173236],[35.383876,41.173287],[35.375115,41.169819],[35.363159,41.16949],[35.357411,41.16657],[35.352367,41.166035],[35.347543,41.166955],[35.342945,41.167202],[35.338687,41.168337],[35.334057,41.170545],[35.328666,41.171942],[35.324492,41.174223],[35.320843,41.177157],[35.314925,41.180139],[35.311994,41.180863],[35.302155,41.180894],[35.298187,41.178781],[35.294348,41.18008],[35.293827,41.181668],[35.294625,41.189926],[35.292482,41.203214],[35.291013,41.206843],[35.285384,41.215185],[35.282864,41.217226],[35.27891,41.219172],[35.276387,41.221451],[35.274417,41.224506],[35.270494,41.225941],[35.265046,41.225647],[35.260627,41.226645],[35.258429,41.227999],[35.252572,41.23309],[35.251276,41.236751],[35.245372,41.24007],[35.243231,41.240296],[35.238871,41.238688],[35.233257,41.233785],[35.226805,41.233703],[35.222277,41.235269],[35.219909,41.237666],[35.21563,41.23766],[35.2143,41.239322],[35.21785,41.242277],[35.219916,41.242706],[35.223986,41.249644],[35.225594,41.248579],[35.228699,41.250473],[35.230095,41.252646],[35.225151,41.255054],[35.217992,41.25547],[35.214405,41.256454],[35.212256,41.258109],[35.208881,41.258056],[35.203788,41.258841],[35.1955,41.256739],[35.191988,41.256922],[35.188543,41.259937],[35.184051,41.260474],[35.18125,41.2624],[35.179001,41.266548],[35.181249,41.271462],[35.18151,41.278],[35.183398,41.279524],[35.182119,41.282146],[35.184711,41.282211],[35.184662,41.283714],[35.181389,41.287113],[35.181924,41.288648],[35.185044,41.289355],[35.184135,41.292729],[35.18693,41.2946],[35.185925,41.295849],[35.189466,41.297722],[35.190116,41.302131],[35.188974,41.304062],[35.186225,41.305217],[35.185291,41.306926],[35.178706,41.311663],[35.173461,41.311502],[35.171431,41.310333],[35.169876,41.311918],[35.166563,41.311554],[35.158248,41.312839],[35.15532,41.315386],[35.149708,41.316629],[35.147607,41.318988],[35.141388,41.323934],[35.140473,41.327752],[35.139008,41.330245],[35.139108,41.334382],[35.137626,41.33531],[35.138727,41.337021],[35.136872,41.339466],[35.136714,41.341824],[35.133709,41.344298],[35.131767,41.344647],[35.130729,41.34647],[35.131977,41.347728],[35.128492,41.352339],[35.129508,41.354914],[35.129006,41.35798],[35.12647,41.358869],[35.128127,41.360404],[35.127654,41.365413],[35.125574,41.368449],[35.124413,41.371818],[35.122504,41.37382],[35.121844,41.37853],[35.119801,41.382428],[35.117154,41.389294],[35.118699,41.395648],[35.116765,41.397216],[35.113414,41.3952],[35.110026,41.388028],[35.106821,41.384489],[35.102,41.381233],[35.097324,41.379721],[35.095436,41.383078],[35.095859,41.384382],[35.09893,41.385482],[35.100081,41.388234],[35.103305,41.390403],[35.103788,41.395902],[35.103433,41.399104],[35.100705,41.400421],[35.097811,41.399249],[35.094683,41.399698],[35.094529,41.404847],[35.051729,41.415342],[35.05168,41.417362],[35.049714,41.419483],[35.041202,41.421285],[35.03704,41.420921],[35.033157,41.421765],[35.028534,41.421367],[35.019846,41.418241],[35.016209,41.418212],[35.011993,41.419526],[35.009277,41.418674],[35.00636,41.415157],[35.003707,41.413836],[34.997664,41.411937],[34.993631,41.41202],[34.990975,41.413563],[34.988152,41.416753],[34.982949,41.418306],[34.980056,41.42002],[34.964769,41.422322],[34.963262,41.423832],[34.961626,41.427657],[34.953679,41.431749],[34.94954,41.432599],[34.944097,41.435125],[34.93803,41.436483],[34.934077,41.438478],[34.9318,41.442039],[34.928859,41.444462],[34.923868,41.446239],[34.917483,41.447105],[34.91219,41.448642],[34.908106,41.449005],[34.904104,41.450826],[34.883037,41.455567],[34.877544,41.457228],[34.873586,41.457488],[34.869576,41.456772],[34.862147,41.457251],[34.857218,41.456961],[34.850945,41.457824],[34.846464,41.459333],[34.837596,41.460829],[34.831806,41.462522],[34.825607,41.465902],[34.816235,41.465178],[34.802081,41.467085],[34.797947,41.466307],[34.794807,41.464669],[34.789556,41.462873],[34.78594,41.462218],[34.775572,41.46413],[34.76958,41.466958],[34.766094,41.469953],[34.766562,41.472623],[34.768702,41.474876],[34.767904,41.478933],[34.768547,41.481942],[34.771235,41.484294],[34.776373,41.486935],[34.777164,41.489665],[34.773693,41.495328],[34.762397,41.505477],[34.756884,41.510893],[34.752843,41.511846],[34.782475,41.54503],[34.786566,41.548595],[34.792084,41.552383],[34.814168,41.564721],[34.821537,41.566736],[34.828039,41.570137],[34.831214,41.575154],[34.836538,41.579832],[34.840389,41.581309],[34.846683,41.581105],[34.84977,41.581938],[34.851389,41.584107],[34.852283,41.592313],[34.853428,41.594638],[34.857378,41.599143],[34.858001,41.602053],[34.86542,41.606704],[34.869875,41.607237],[34.875034,41.605491],[34.880422,41.605566],[34.882763,41.606334],[34.884776,41.611127],[34.88471,41.618666],[34.886491,41.621694],[34.894578,41.638885],[34.897049,41.643073],[34.901013,41.64841],[34.903595,41.656938],[34.908792,41.66164],[34.913159,41.663617],[34.917455,41.670478],[34.917076,41.673909],[34.911355,41.677908],[34.909079,41.682116],[34.909437,41.686561],[34.907155,41.691625],[34.907586,41.694214],[34.913968,41.700235],[34.917298,41.705078],[34.922481,41.707713],[34.925408,41.710351],[34.931425,41.712514],[34.934151,41.714682],[34.937884,41.721192],[34.941868,41.724882],[34.948622,41.730014],[34.953386,41.737175],[34.959656,41.744727],[34.963095,41.749937],[34.973229,41.758682],[34.976296,41.762511],[34.980287,41.766472],[34.981,41.771077],[34.98544,41.777834],[34.99044,41.782103],[34.998621,41.786177],[35.000959,41.788815],[35.006067,41.791154],[35.009006,41.7946],[35.010968,41.795424],[35.018976,41.796606],[35.023558,41.796588],[35.026431,41.797761],[35.033448,41.805505],[35.035018,41.806758],[35.045945,41.811774],[35.049876,41.815068],[35.058571,41.819183],[35.060891,41.819785],[35.06923,41.820192],[35.077462,41.82149],[35.082101,41.823353],[35.084317,41.825203],[35.092293,41.835153],[35.094747,41.841133],[35.095406,41.844122],[35.096302,41.853955],[35.095672,41.858888],[35.091637,41.858477],[35.079741,41.859215],[35.073605,41.861081],[35.060203,41.870069],[35.058318,41.873642],[35.059617,41.879266],[35.054292,41.892531],[35.054354,41.894905],[35.0573,41.900289],[35.061777,41.90473],[35.064778,41.90844],[35.071009,41.913886],[35.074551,41.917996],[35.085137,41.929247],[35.086233,41.93167],[35.086148,41.936724],[35.082884,41.939102],[35.081581,41.942421],[35.084606,41.945052],[35.089731,41.946019],[35.090037,41.9474],[35.085936,41.948926],[35.085682,41.95116],[35.090466,41.952643],[35.091316,41.953923],[35.090522,41.956908],[35.08979,41.965919],[35.087904,41.970277],[35.088608,41.973539],[35.095251,41.9844],[35.0952,41.988581],[35.091869,41.994032],[35.09135,41.996011],[35.091844,42.001619],[35.092543,42.00352],[35.095624,42.006079],[35.105672,42.01173],[35.108317,42.014658],[35.112959,42.016642],[35.114409,42.017889],[35.122001,42.019987],[35.126765,42.020705],[35.129363,42.02025],[35.133219,42.020753],[35.141307,42.025151],[35.150713,42.026627],[35.151988,42.023972],[35.145766,42.024628],[35.142758,42.023768],[35.138247,42.02355],[35.133656,42.020955],[35.129819,42.02031],[35.124568,42.020636],[35.125017,42.018792],[35.121109,42.01584],[35.118361,42.014979],[35.119324,42.013539],[35.122742,42.014348],[35.128534,42.017787],[35.132837,42.018697],[35.139228,42.024288],[35.144275,42.025686],[35.146513,42.024945],[35.151564,42.024807],[35.153112,42.022804],[35.162399,42.019213],[35.168124,42.017917],[35.171984,42.018242],[35.176705,42.017662],[35.180056,42.016105],[35.183763,42.016973],[35.188415,42.015285],[35.190892,42.015382],[35.190823,42.017244],[35.188108,42.01837],[35.19337,42.018383],[35.20115,42.017666],[35.202757,42.016901],[35.205095,42.018012],[35.204057,42.020239],[35.202297,42.021002],[35.20064,42.025135],[35.193386,42.030267],[35.19201,42.032366],[35.187951,42.034615],[35.188936,42.036212],[35.186841,42.038035],[35.182326,42.037698],[35.17849,42.038798],[35.175425,42.038453],[35.174416,42.036963],[35.168979,42.037208],[35.16319,42.035362],[35.158537,42.032049],[35.157399,42.029402],[35.149114,42.027013],[35.140963,42.026014],[35.138172,42.023452],[35.133209,42.020862],[35.128609,42.020381],[35.12656,42.020823],[35.121843,42.020104],[35.114787,42.018237],[35.108192,42.014617],[35.103353,42.010455],[35.095828,42.006251],[35.09603,42.007813],[35.079353,42.005735],[35.072695,42.006172],[35.060478,42.010011],[35.058355,42.011338],[35.048963,42.020514],[35.04673,42.022342],[35.033355,42.029435],[35.029186,42.030742],[35.018391,42.032033],[34.993919,42.028819],[34.990344,42.026733],[34.984318,42.020639],[34.982295,42.01908],[34.974352,42.014769],[34.965967,42.013073],[34.961839,42.009253],[34.957349,42.008372],[34.954051,42.009356],[34.950386,42.009223],[34.945772,42.006651],[34.941983,42.007116],[34.938638,42.006665],[34.930667,42.003339],[34.926797,42.00212],[34.919838,42.002035],[34.913552,42.000892],[34.906195,41.996428],[34.901923,41.995206],[34.890403,41.994939],[34.888087,41.993819],[34.884304,41.988772],[34.8801,41.984586],[34.875085,41.980988],[34.873967,41.978139],[34.866716,41.974701],[34.863813,41.972111],[34.862568,41.969457],[34.860932,41.968307],[34.853109,41.965651],[34.846306,41.965623],[34.843368,41.966732],[34.840299,41.969211],[34.83834,41.969755],[34.835439,41.965561],[34.836403,41.962196],[34.836043,41.960314],[34.834311,41.959735],[34.828859,41.959738],[34.825968,41.9585],[34.823502,41.958739],[34.821272,41.96081],[34.819135,41.958035],[34.820407,41.956909],[34.819718,41.955096],[34.815408,41.953271],[34.809272,41.955416],[34.807508,41.954953],[34.80649,41.951824],[34.804043,41.952335],[34.802434,41.954039],[34.796331,41.951531],[34.796986,41.949796],[34.794626,41.948948],[34.796352,41.946572],[34.787492,41.946485],[34.783458,41.946087],[34.780779,41.947128],[34.780027,41.949095],[34.778284,41.949201],[34.778267,41.946355],[34.77657,41.946027],[34.772131,41.949184],[34.766908,41.950119],[34.764419,41.949591],[34.758171,41.94481],[34.75639,41.946616],[34.749142,41.945617],[34.74373,41.946678],[34.739957,41.944163],[34.737199,41.944751],[34.73369,41.943214],[34.729437,41.943375],[34.723501,41.941846],[34.7232,41.939006],[34.718652,41.94103],[34.716052,41.941413],[34.714708,41.940369],[34.713439,41.941964],[34.710545,41.9407],[34.708265,41.942438],[34.706589,41.940502],[34.704466,41.942501],[34.698157,41.943059],[34.694555,41.944999],[34.692488,41.945234],[34.684701,41.943324],[34.680335,41.94275],[34.677665,41.941359],[34.676801,41.942],[34.672743,41.940799],[34.669963,41.938729],[34.667928,41.940935],[34.661106,41.940238],[34.653172,41.941603],[34.646731,41.940529],[34.642219,41.94165],[34.622498,41.941561],[34.612327,41.942239],[34.602829,41.9441],[34.597428,41.946003],[34.594911,41.946112],[34.590853,41.944903],[34.590432,41.947232],[34.58702,41.94903],[34.58212,41.946925],[34.576324,41.946943],[34.567501,41.948307],[34.558741,41.944971],[34.555723,41.947218],[34.552443,41.948191],[34.551936,41.946346],[34.549663,41.947716],[34.543989,41.947255],[34.541897,41.945606],[34.539379,41.94642],[34.541637,41.948935],[34.531773,41.946863],[34.530076,41.947534],[34.524669,41.94687],[34.521136,41.945397],[34.519116,41.947005],[34.515883,41.94677],[34.513966,41.948686],[34.508412,41.948158],[34.503834,41.953572],[34.50602,41.955914],[34.502142,41.959235],[34.499172,41.960357],[34.498794,41.963109],[34.496212,41.964534],[34.497579,41.966],[34.494199,41.967615],[34.489681,41.964817],[34.488763,41.961371],[34.48991,41.95632],[34.486795,41.956358],[34.484886,41.954039],[34.484119,41.951411],[34.481632,41.953573],[34.479948,41.953823],[34.480294,41.951732],[34.476506,41.950942],[34.478065,41.947789],[34.476447,41.945809],[34.476483,41.944052],[34.474638,41.942782],[34.469554,41.941356],[34.468968,41.939754],[34.463404,41.939904],[34.46002,41.938882],[34.449309,41.941582],[34.447272,41.940591],[34.448261,41.938984],[34.444858,41.936509],[34.438931,41.938055],[34.440195,41.939683],[34.43585,41.939378],[34.433922,41.940509],[34.42836,41.941038],[34.422377,41.944375],[34.418917,41.943514],[34.41718,41.944153],[34.415077,41.943159],[34.411394,41.943368],[34.408502,41.942379],[34.409039,41.94065],[34.405395,41.941888],[34.405573,41.939204],[34.401679,41.94078],[34.396485,41.94651],[34.392734,41.946926],[34.386024,41.95195],[34.382655,41.950578],[34.379619,41.950472],[34.377323,41.951946],[34.370262,41.948506],[34.363804,41.946686],[34.354314,41.945379],[34.343862,41.946855],[34.341151,41.948253],[34.335289,41.948472],[34.332432,41.944345],[34.326765,41.942779],[34.318443,41.941694],[34.313943,41.941926],[34.311469,41.940941],[34.304734,41.940438],[34.299528,41.940521],[34.291647,41.941785],[34.286518,41.942173],[34.285098,41.94319],[34.281078,41.943522],[34.277435,41.946256],[34.272822,41.946727],[34.25348,41.947609],[34.242322,41.949003],[34.236017,41.950751],[34.222963,41.953802],[34.213057,41.954422],[34.189582,41.956839],[34.178624,41.958223],[34.172525,41.959377],[34.167527,41.961064],[34.165551,41.962525],[34.162982,41.962626],[34.158935,41.963995],[34.157407,41.965995],[34.15488,41.965788],[34.153799,41.963699],[34.151408,41.962963],[34.149368,41.964054],[34.151108,41.96537],[34.148026,41.964911],[34.146084,41.963114],[34.142924,41.962865],[34.137883,41.960559],[34.135006,41.961343],[34.133771,41.964756],[34.131407,41.966198],[34.129848,41.969348],[34.122774,41.971031],[34.119623,41.969383],[34.116539,41.963915],[34.113483,41.963374],[34.110817,41.96401],[34.107371,41.963132],[34.104265,41.96455],[34.105672,41.967785],[34.092677,41.970032],[34.088888,41.969801],[34.082576,41.972963],[34.080112,41.972419],[34.082088,41.974887],[34.080819,41.9761],[34.06841,41.97849],[34.065183,41.978408],[34.057213,41.979807],[34.049279,41.979404],[34.046265,41.980227],[34.039196,41.979258],[34.022325,41.978745],[34.013754,41.978855],[34.007866,41.978479],[34.005044,41.977522],[33.99616,41.977185],[33.992001,41.978154],[33.98252,41.97852],[33.969967,41.980239],[33.967682,41.978152],[33.96353,41.976369],[33.958235,41.975547],[33.955618,41.974113],[33.951616,41.974504],[33.940568,41.972261],[33.93921,41.973262],[33.932079,41.97362],[33.930338,41.97415],[33.926008,41.973401],[33.923481,41.971348],[33.913739,41.972333],[33.910674,41.972955],[33.898417,41.971161],[33.892788,41.971289],[33.890004,41.971884],[33.886183,41.974022],[33.876535,41.972432],[33.86268,41.973895],[33.860639,41.972738],[33.853801,41.973816],[33.848594,41.973909],[33.844538,41.972926],[33.836291,41.973005],[33.83124,41.971704],[33.823481,41.973718],[33.817819,41.973944],[33.812459,41.975463],[33.808576,41.974997],[33.807849,41.973681],[33.804096,41.974726],[33.799246,41.9751],[33.794979,41.974506],[33.791219,41.972417],[33.780773,41.973062],[33.778665,41.974369],[33.770628,41.975529],[33.76669,41.97709],[33.764476,41.979799],[33.758095,41.978968],[33.754782,41.977563],[33.750077,41.976923],[33.732501,41.977459],[33.714747,41.979869],[33.711336,41.978029],[33.70763,41.977209],[33.70531,41.978064],[33.700815,41.977115],[33.697713,41.977636],[33.693831,41.976873],[33.686653,41.978556],[33.683347,41.978076],[33.680882,41.978862],[33.675748,41.978921],[33.672008,41.979789],[33.669307,41.981616],[33.663634,41.983753],[33.659599,41.984116],[33.65038,41.983757],[33.648663,41.983092],[33.637163,41.983724],[33.631081,41.984869],[33.628603,41.983385],[33.62696,41.98429],[33.620919,41.984806],[33.609274,41.986396],[33.599385,41.986426],[33.592866,41.987689],[33.590129,41.985733],[33.585445,41.984269],[33.587437,41.986125],[33.582497,41.987862],[33.580891,41.98723],[33.568679,41.988586],[33.562282,41.990933],[33.5574,41.990209],[33.556656,41.988289],[33.554757,41.988329],[33.553691,41.986038],[33.549862,41.986707],[33.551064,41.98935],[33.55019,41.989986],[33.552533,41.992334],[33.551731,41.994464],[33.549819,41.993901],[33.545781,41.99512],[33.541936,41.99497],[33.534861,41.997978],[33.533267,41.993672],[33.533751,41.991323],[33.530399,41.990853],[33.527098,41.993638],[33.528576,41.99667],[33.526732,41.998684],[33.524671,41.998622],[33.516742,42.000787],[33.51212,42.000014],[33.510471,42.001911],[33.508428,42.001587],[33.507264,41.998735],[33.503711,41.995465],[33.504677,42.000172],[33.503256,42.0018],[33.498116,42.001818],[33.49594,42.000827],[33.49146,42.00099],[33.49029,42.002639],[33.483547,42.000955],[33.4839,42.002419],[33.479209,42.002468],[33.475373,42.003632],[33.473497,42.003317],[33.469498,42.004837],[33.46304,42.005289],[33.46011,42.00448],[33.459199,42.006304],[33.452375,42.005085],[33.455928,42.007253],[33.453058,42.00663],[33.449446,42.007116],[33.448075,42.006181],[33.441443,42.00848],[33.440389,42.009794],[33.437928,42.00921],[33.437315,42.007215],[33.433081,42.00734],[33.428274,42.005569],[33.425898,42.006567],[33.41793,42.005725],[33.41568,42.004116],[33.414751,42.006466],[33.408968,42.007358],[33.406608,42.006938],[33.405875,42.011106],[33.404149,42.011322],[33.402007,42.009415],[33.400918,42.006013],[33.399824,42.006409],[33.398521,42.009803],[33.394946,42.010605],[33.393184,42.01255],[33.389355,42.010939],[33.388171,42.012687],[33.382391,42.013804],[33.381207,42.014988],[33.373237,42.01463],[33.369887,42.015039],[33.368058,42.011356],[33.365724,42.00995],[33.363361,42.010907],[33.362515,42.013278],[33.359093,42.015128],[33.352842,42.016175],[33.347479,42.014855],[33.345299,42.016081],[33.341744,42.014281],[33.338034,42.016301],[33.330572,42.014899],[33.327956,42.01531],[33.319543,42.012993],[33.315509,42.01146],[33.313018,42.00914],[33.309633,42.009358],[33.298831,42.007082],[33.295312,42.004017],[33.292346,42.002787],[33.283752,42.000279],[33.279276,41.998116],[33.27893,41.996232],[33.272166,41.99211],[33.270819,41.98972],[33.268791,41.990794],[33.26284,41.988386],[33.258174,41.987583],[33.252692,41.985861],[33.252102,41.984437],[33.244864,41.983369],[33.241996,41.982287],[33.236947,41.981513],[33.233209,41.980214],[33.233812,41.978522],[33.232424,41.975523],[33.230125,41.975792],[33.229447,41.978091],[33.227055,41.979135],[33.223438,41.979312],[33.221758,41.977812],[33.214104,41.976987],[33.210265,41.97332],[33.210844,41.969299],[33.212167,41.968643],[33.210554,41.965051],[33.211692,41.963887],[33.211095,41.960509],[33.203695,41.960703],[33.202155,41.962545],[33.202789,41.965134],[33.202394,41.968742],[33.197565,41.969017],[33.196109,41.967798],[33.190752,41.965546],[33.187086,41.963267],[33.181747,41.963596],[33.177055,41.962095],[33.175858,41.960884],[33.179154,41.95943],[33.177174,41.95746],[33.177026,41.954942],[33.180005,41.953823],[33.176395,41.952694],[33.178087,41.949213],[33.175392,41.948146],[33.171448,41.95039],[33.169102,41.954367],[33.164968,41.951791],[33.161592,41.952158],[33.152753,41.951927],[33.15073,41.949885],[33.147528,41.949259],[33.143293,41.947366],[33.138929,41.947882],[33.136512,41.945007],[33.134239,41.939115],[33.132474,41.938813],[33.130459,41.942713],[33.131947,41.945795],[33.131977,41.948053],[33.123362,41.946132],[33.122453,41.944267],[33.119543,41.944181],[33.118253,41.945681],[33.109653,41.941399],[33.110435,41.938944],[33.112176,41.938503],[33.112208,41.935954],[33.106215,41.936203],[33.10443,41.936906],[33.09905,41.933904],[33.094109,41.932843],[33.094673,41.93098],[33.09658,41.930885],[33.09949,41.92843],[33.093987,41.925831],[33.090181,41.92477],[33.090674,41.927444],[33.089781,41.929315],[33.086644,41.931159],[33.082659,41.93176],[33.080075,41.930437],[33.074541,41.929855],[33.071811,41.930878],[33.068933,41.927116],[33.065824,41.926176],[33.063608,41.927286],[33.064338,41.929054],[33.060062,41.931823],[33.057033,41.931019],[33.053383,41.928174],[33.051048,41.922904],[33.048586,41.924818],[33.044509,41.924684],[33.043443,41.926378],[33.037564,41.924319],[33.035433,41.924904],[33.033402,41.921498],[33.037972,41.916869],[33.034769,41.916499],[33.032811,41.915355],[33.030581,41.91713],[33.027629,41.917692],[33.026657,41.913669],[33.022245,41.913021],[33.016397,41.909634],[33.002144,41.90814],[33.000526,41.907316],[32.99482,41.906966],[32.992808,41.905437],[33.004833,41.903922],[33.006592,41.902351],[33.005675,41.900203],[33.002378,41.8999],[33.003738,41.901803],[33.001426,41.902275],[32.994423,41.899284],[32.994221,41.900957],[32.989814,41.900715],[32.982546,41.895979],[32.974794,41.891849],[32.966148,41.888476],[32.946196,41.882716],[32.941516,41.879537],[32.940714,41.878269],[32.936386,41.876728],[32.92936,41.877839],[32.908286,41.871585],[32.888955,41.866177],[32.883519,41.866048],[32.875007,41.867033],[32.866592,41.863237],[32.86606,41.858941],[32.858115,41.857761],[32.851343,41.859202],[32.846379,41.858839],[32.844689,41.859716],[32.833882,41.859361],[32.829775,41.860356],[32.825952,41.859311],[32.819422,41.855724],[32.818262,41.854548],[32.815024,41.854257],[32.814452,41.855602],[32.808191,41.856732],[32.806192,41.854867],[32.803154,41.856501],[32.797216,41.858151],[32.788694,41.858006],[32.783639,41.858549],[32.780948,41.857964],[32.777293,41.854583],[32.773117,41.852255],[32.770847,41.849215],[32.768832,41.844732],[32.765469,41.844577],[32.762665,41.845509],[32.761778,41.848764],[32.75778,41.846928],[32.754662,41.844063],[32.752099,41.843865],[32.750787,41.847096],[32.741335,41.846874],[32.738987,41.846045],[32.735866,41.847447],[32.733318,41.847356],[32.730222,41.843437],[32.727554,41.843136],[32.724382,41.843963],[32.72137,41.843562],[32.718333,41.845458],[32.716388,41.845254],[32.715697,41.843224],[32.712886,41.84193],[32.711414,41.838091],[32.709037,41.835793],[32.702105,41.836672],[32.699279,41.833327],[32.695578,41.833529],[32.694004,41.834874],[32.689975,41.833461],[32.689645,41.832238],[32.695292,41.830098],[32.695434,41.828093],[32.692999,41.826495],[32.68688,41.82593],[32.682057,41.828354],[32.680221,41.826715],[32.677163,41.829284],[32.671991,41.828202],[32.6707,41.826347],[32.667188,41.827362],[32.663343,41.827165],[32.658044,41.828003],[32.650091,41.826811],[32.647084,41.827618],[32.645807,41.826608],[32.641297,41.828329],[32.63953,41.827774],[32.635753,41.828725],[32.639388,41.824401],[32.634467,41.825356],[32.631631,41.826624],[32.62632,41.826394],[32.622634,41.827496],[32.619834,41.824269],[32.615894,41.824347],[32.609729,41.8207],[32.605153,41.82091],[32.600522,41.81951],[32.598642,41.819785],[32.597065,41.815465],[32.592356,41.812399],[32.591104,41.809296],[32.588722,41.806674],[32.589152,41.804778],[32.584574,41.803295],[32.581382,41.798725],[32.578732,41.797392],[32.579288,41.79642],[32.575989,41.796562],[32.573963,41.795439],[32.570982,41.79675],[32.565784,41.794754],[32.564188,41.79336],[32.559402,41.793193],[32.557298,41.79124],[32.551035,41.788892],[32.546304,41.784126],[32.543721,41.78407],[32.53947,41.785282],[32.534949,41.785497],[32.529303,41.783282],[32.523337,41.779535],[32.519601,41.77976],[32.516599,41.78286],[32.514251,41.781907],[32.514199,41.780435],[32.510744,41.781326],[32.50772,41.780486],[32.500976,41.773094],[32.497582,41.772614],[32.492219,41.774145],[32.483407,41.774818],[32.477292,41.773695],[32.470869,41.773255],[32.467924,41.771033],[32.465365,41.770683],[32.462362,41.771414],[32.46002,41.769816],[32.460998,41.764756],[32.463825,41.763694],[32.468011,41.759395],[32.466957,41.757088],[32.464996,41.755571],[32.45865,41.752298],[32.45606,41.750095],[32.452834,41.743438],[32.449128,41.740897],[32.444326,41.739602],[32.441442,41.737119],[32.439083,41.736288],[32.430856,41.73549],[32.430309,41.736807],[32.432101,41.738405],[32.431798,41.740224],[32.428963,41.740027],[32.424109,41.736938],[32.42324,41.73492],[32.419541,41.732081],[32.418847,41.72858],[32.416685,41.728279],[32.414954,41.730361],[32.412399,41.730834],[32.408562,41.729777],[32.405384,41.730424],[32.403486,41.727787],[32.402015,41.723142],[32.396546,41.718527],[32.392388,41.713417],[32.391873,41.709098],[32.387022,41.705842],[32.385172,41.703958],[32.383902,41.700846],[32.384036,41.697823],[32.37971,41.693246],[32.378655,41.686175],[32.374834,41.68101],[32.370482,41.678289],[32.364514,41.67275],[32.359479,41.667089],[32.357856,41.664325],[32.357014,41.65969],[32.355044,41.657606],[32.357229,41.653427],[32.358769,41.644716],[32.356138,41.642488],[32.353817,41.639181],[32.348361,41.635014],[32.34861,41.632825],[32.354226,41.626638],[32.351988,41.625749],[32.350667,41.62682],[32.346938,41.627104],[32.347258,41.624719],[32.345586,41.623698],[32.341464,41.625732],[32.337325,41.622878],[32.333466,41.622878],[32.325801,41.627423],[32.32067,41.625957],[32.322676,41.618578],[32.323411,41.613434],[32.321329,41.602733],[32.323144,41.589101],[32.325167,41.583264],[32.325342,41.580426],[32.322778,41.570167],[32.321555,41.567677],[32.317761,41.563808],[32.31443,41.561924],[32.304613,41.558057],[32.30029,41.557041],[32.291088,41.555771],[32.28669,41.554789],[32.26363,41.547785],[32.25718,41.546711],[32.240698,41.546021],[32.234784,41.545996],[32.22768,41.547355],[32.224866,41.547159],[32.221974,41.545518],[32.220009,41.542934],[32.215777,41.542],[32.214292,41.540413],[32.214625,41.537241],[32.212845,41.536379],[32.210608,41.53737],[32.207911,41.540564],[32.205957,41.541344],[32.203302,41.540609],[32.19862,41.536088],[32.195401,41.534705],[32.190109,41.534546],[32.187454,41.532987],[32.174565,41.523177],[32.171296,41.519544],[32.166437,41.510879],[32.159689,41.50085],[32.156512,41.497987],[32.147636,41.491815],[32.13814,41.482525],[32.136216,41.481387],[32.132357,41.480869],[32.128287,41.482208],[32.116299,41.491574],[32.113257,41.493324],[32.104263,41.495647],[32.098785,41.50028],[32.096061,41.501197],[32.093417,41.50081],[32.0913,41.499327],[32.09057,41.495757],[32.088676,41.491567],[32.090232,41.488241],[32.090068,41.482281],[32.093419,41.471133],[32.092469,41.466522],[32.092978,41.462457],[32.091418,41.456788],[32.094402,41.451338],[32.095409,41.447784],[32.095074,41.438187],[32.093158,41.434184],[32.091559,41.429334],[32.090789,41.424267],[32.092211,41.421665],[32.090243,41.414468],[32.088631,41.405669],[32.084015,41.3966],[32.083346,41.394217],[32.083771,41.391082],[32.089117,41.383102],[32.092177,41.374272],[32.092725,41.369359],[32.090915,41.361265],[32.090558,41.354786],[32.088145,41.350173],[32.08851,41.341598],[32.08783,41.337904],[32.09185,41.33597],[32.092712,41.334684],[32.101046,41.311552],[32.104121,41.3037],[32.10256,41.300694],[32.097123,41.296423],[32.092203,41.289759],[32.079797,41.281438],[32.075256,41.280231],[32.068362,41.279793],[32.064241,41.278064],[32.059999,41.27543],[32.051961,41.272607],[32.048288,41.270084],[32.045813,41.267061],[32.041186,41.264213],[32.033403,41.261996],[32.027991,41.259097],[32.022015,41.254619],[32.015512,41.252032],[32.010875,41.249676],[32.004721,41.247569],[31.997207,41.246553],[31.993872,41.24557],[31.986018,41.240243],[31.978443,41.238105],[31.976468,41.235938],[31.974874,41.231546],[31.973076,41.229922],[31.964882,41.226847],[31.961535,41.226173],[31.957862,41.223304],[31.953241,41.220963],[31.95144,41.217652],[31.952304,41.214895],[31.955611,41.210428],[31.954739,41.208582],[31.952167,41.206654],[31.949619,41.201791],[31.938374,41.191194],[31.932535,41.187399],[31.931388,41.184208],[31.929077,41.182341],[31.928098,41.180136],[31.930123,41.172737],[31.929364,41.170075],[31.930553,41.167835],[31.928431,41.166447],[31.929421,41.163627],[31.929611,41.159157],[31.934287,41.157607],[31.937105,41.155435],[31.944919,41.153938],[31.947185,41.152639],[31.95036,41.146337],[31.952387,41.144469],[31.957267,41.141809],[31.964664,41.139348],[31.975958,41.13492],[31.983422,41.133777],[31.986525,41.132097],[31.990049,41.127389],[31.995754,41.125617],[31.998383,41.122793],[31.999554,41.118368],[32.003382,41.113779],[32.006536,41.106371],[32.005997,41.104314],[32.006865,41.10036],[32.009237,41.098384],[32.010655,41.09544],[32.013435,41.09455],[32.021551,41.087866],[32.032888,41.079312],[32.035037,41.077245],[32.042546,41.073393],[32.048054,41.073248],[32.051644,41.07233],[32.054515,41.072505],[32.058092,41.070262],[32.062256,41.063459],[32.062554,41.059873],[32.066369,41.055451],[32.068701,41.054487],[32.070429,41.052467],[32.074593,41.051239],[32.076452,41.049868],[32.078252,41.045691],[32.077653,41.038498],[32.076252,41.036275],[32.078928,41.032686],[32.079556,41.030576],[32.078252,41.027134],[32.082026,41.020266],[32.081704,41.018257],[32.078509,41.01513],[32.07241,41.006233],[32.067457,41.003456],[32.066118,41.001287],[32.06434,40.993142],[32.064878,40.987293],[32.067601,40.980055],[32.068883,40.978032],[32.074495,40.973892],[32.075913,40.97224],[32.077017,40.967451],[32.081399,40.963235],[32.084697,40.9574],[32.085424,40.954869],[32.083816,40.951551],[32.076038,40.944868],[32.072686,40.941472],[32.070611,40.936976],[32.070435,40.934516],[32.071485,40.92692],[32.072725,40.924648],[32.078402,40.918852],[32.085382,40.905041],[32.085654,40.897311],[32.086637,40.891035],[32.088169,40.887379],[32.091187,40.882931],[32.090689,40.878568],[32.087234,40.872915],[32.084667,40.870588],[32.080337,40.868494],[32.078346,40.865601],[32.078262,40.862363],[32.076114,40.859742],[32.074961,40.85643],[32.072795,40.853968],[32.069285,40.851681],[32.057979,40.843319],[32.052513,40.840889],[32.050328,40.836169],[32.04785,40.833717],[32.046692,40.827706],[32.040901,40.819298],[32.036216,40.816553],[32.034907,40.81254],[32.034658,40.80855],[32.037881,40.804434],[32.050575,40.797113],[32.059454,40.792896],[32.061823,40.790434],[32.066258,40.781174],[32.064063,40.779774],[32.028339,40.771153],[32.022329,40.771241],[32.017077,40.77323],[32.013867,40.773629],[32.007881,40.772528],[32.009123,40.765911],[32.008148,40.76403],[32.001718,40.762746],[31.995425,40.762233],[31.981806,40.761946],[31.976461,40.760826],[31.96419,40.755176],[31.959892,40.753791],[31.948726,40.753536],[31.936543,40.750916],[31.930622,40.751366],[31.920234,40.754276],[31.915193,40.754702],[31.912675,40.75431],[31.900584,40.750976],[31.895846,40.749237],[31.887667,40.748163],[31.872432,40.744819],[31.865256,40.743756],[31.860362,40.74382],[31.849573,40.742393],[31.833962,40.739458],[31.826953,40.739619],[31.822265,40.7388],[31.811102,40.734657],[31.805654,40.73439],[31.802874,40.735107],[31.794551,40.738612],[31.787466,40.740989],[31.784781,40.742384],[31.778185,40.750858],[31.775805,40.752738],[31.772996,40.756671],[31.768097,40.760167],[31.759883,40.762367],[31.751673,40.766473],[31.749199,40.767312],[31.738233,40.769458],[31.733121,40.771397],[31.72318,40.778119],[31.718078,40.780187],[31.714904,40.780614],[31.710365,40.780298],[31.701897,40.778029],[31.690857,40.777117],[31.688009,40.776554],[31.675205,40.771962],[31.668215,40.77091],[31.659242,40.770524],[31.653275,40.768497],[31.647632,40.768517],[31.643861,40.767957],[31.639519,40.7662],[31.635871,40.765712],[31.628345,40.766222],[31.623151,40.765037],[31.608421,40.763708],[31.598426,40.760875],[31.590599,40.761352],[31.587538,40.76098],[31.580626,40.757407],[31.570568,40.754905],[31.567093,40.753359],[31.563031,40.750531],[31.561126,40.747517],[31.560893,40.743961],[31.559645,40.741564],[31.554894,40.739031],[31.55049,40.739127],[31.546402,40.740289],[31.541245,40.740502],[31.537453,40.739073],[31.531629,40.734271],[31.528718,40.733025],[31.518353,40.731485],[31.511231,40.728443],[31.507076,40.725679],[31.492545,40.721505],[31.486029,40.720786],[31.473727,40.722375],[31.464257,40.724872],[31.458784,40.725033],[31.451475,40.724001],[31.447167,40.725463],[31.445366,40.727092],[31.444318,40.730795],[31.445245,40.733158],[31.44979,40.736158],[31.44979,40.758123],[31.445672,40.758691],[31.438994,40.757581],[31.431712,40.757964],[31.425747,40.757825],[31.422159,40.759277],[31.408294,40.761695],[31.401869,40.761477],[31.395963,40.762074],[31.385847,40.764063],[31.377401,40.766324],[31.366058,40.770106],[31.362746,40.771742],[31.353534,40.777404],[31.350727,40.77861],[31.33921,40.781378],[31.333922,40.781096],[31.328596,40.780242],[31.324432,40.78024],[31.315816,40.782171],[31.30064,40.784949],[31.296478,40.786501],[31.290074,40.790221],[31.284874,40.790959],[31.281618,40.790093],[31.27527,40.786927],[31.268719,40.785528],[31.262708,40.786303],[31.25151,40.789666],[31.24471,40.790468],[31.21655,40.791388],[31.21015,40.79212],[31.199931,40.794432],[31.175014,40.802947],[31.16799,40.804267],[31.157373,40.805292],[31.15239,40.806409],[31.141212,40.810362],[31.136817,40.811193],[31.126797,40.810828],[31.118597,40.811334],[31.087558,40.815233],[31.081876,40.816555],[31.072968,40.819682],[31.049895,40.828178],[31.038222,40.833297],[31.023648,40.841938],[31.018542,40.844213],[31.014883,40.845118],[31.0085,40.845409],[31.000877,40.843908],[30.990963,40.84004],[30.986999,40.839667],[30.977914,40.841795],[30.974362,40.841868],[30.962558,40.839873],[30.952306,40.839374],[30.946427,40.83779],[30.942513,40.836007],[30.937357,40.832754],[30.927862,40.828999],[30.921574,40.825454],[30.912596,40.81772],[30.90806,40.81499],[30.89835,40.811264],[30.891639,40.809509],[30.880922,40.807988],[30.874827,40.807715],[30.865691,40.807823],[30.860251,40.807128],[30.853092,40.804473],[30.848588,40.801223],[30.841619,40.794653],[30.83684,40.791721],[30.828623,40.788319],[30.824483,40.787339],[30.815947,40.786262],[30.809752,40.784732],[30.801086,40.781111],[30.793997,40.779712],[30.787891,40.777378],[30.781175,40.77161],[30.775214,40.770265],[30.771255,40.770455],[30.766718,40.76992],[30.763646,40.768819],[30.757878,40.764319],[30.749966,40.75933],[30.74456,40.757124],[30.738275,40.755448],[30.730321,40.754435],[30.702175,40.753211],[30.700315,40.753497],[30.687619,40.750491],[30.67035,40.744268],[30.664091,40.742921],[30.658258,40.74217],[30.652113,40.740554],[30.644102,40.736702],[30.634542,40.729439],[30.626204,40.725502],[30.621264,40.724198],[30.609415,40.72204],[30.59623,40.720052],[30.580097,40.718199],[30.570146,40.717331],[30.548858,40.715949],[30.539761,40.714974],[30.524342,40.712439],[30.51706,40.711646],[30.505596,40.711914],[30.495848,40.713552],[30.481189,40.717665],[30.472466,40.719631],[30.461934,40.720689],[30.454504,40.720547],[30.433019,40.718444],[30.411872,40.718468],[30.403298,40.71807],[30.398834,40.717156],[30.393077,40.714916],[30.383977,40.710405],[30.375701,40.708077],[30.370062,40.707694],[30.363697,40.708316],[30.351024,40.710994],[30.343229,40.712148],[30.335703,40.712626],[30.329017,40.712493],[30.322353,40.710336],[30.317078,40.705859],[30.310894,40.703007],[30.305992,40.699779],[30.299196,40.697855],[30.291455,40.697552],[30.287532,40.695887],[30.283002,40.691214],[30.27905,40.688981],[30.268119,40.685238],[30.261424,40.6823],[30.255342,40.681533],[30.249871,40.682768],[30.24592,40.684535],[30.237149,40.691458],[30.227032,40.696261],[30.220044,40.700804],[30.215509,40.702604],[30.207268,40.703996],[30.185447,40.704892],[30.143091,40.710008],[30.128186,40.711049],[30.12115,40.712373],[30.117594,40.713635],[30.113038,40.716334],[30.108462,40.720475],[30.104422,40.722809],[30.097846,40.724317],[30.084393,40.725763],[30.028934,40.764097],[30.02608,40.765222],[30.01778,40.767436],[30.003946,40.77044],[30.000791,40.77078],[29.99213,40.770017],[29.98639,40.770762],[29.983619,40.772096],[29.980213,40.775606],[29.977482,40.781362],[29.974423,40.78397],[29.971013,40.785279],[29.965753,40.785678],[29.958787,40.785213],[29.950374,40.786109],[29.945699,40.78494],[29.939856,40.782616],[29.933305,40.783722],[29.93028,40.783756],[29.927427,40.782817],[29.921651,40.779253],[29.91775,40.777749],[29.912387,40.776583],[29.905045,40.775575],[29.900283,40.775578],[29.885639,40.779392],[29.882444,40.779181],[29.876663,40.777188],[29.870648,40.772777],[29.866958,40.768395],[29.863975,40.766482],[29.85776,40.765739],[29.850077,40.768252],[29.84165,40.768483],[29.833896,40.769356],[29.82745,40.769009],[29.819579,40.767656],[29.813976,40.767468],[29.80912,40.767848],[29.797197,40.77002],[29.79088,40.770591],[29.78095,40.770613],[29.77043,40.77241],[29.745086,40.778273],[29.740731,40.77868],[29.731293,40.777356],[29.725438,40.777226],[29.71549,40.779084],[29.703507,40.779038],[29.694226,40.779978],[29.688659,40.780054],[29.679198,40.778981],[29.67518,40.77911],[29.666822,40.780127],[29.657449,40.778788],[29.652174,40.778934],[29.636731,40.777091],[29.634182,40.777269],[29.63066,40.778875],[29.627374,40.782465],[29.622034,40.786682],[29.619168,40.788216],[29.61359,40.788228],[29.609901,40.786052],[29.6053,40.781655],[29.595386,40.77765],[29.588417,40.774235],[29.583966,40.772619],[29.578513,40.769701],[29.57363,40.76871],[29.568182,40.769601],[29.55915,40.77283],[29.55022,40.774174],[29.54524,40.776185],[29.542107,40.776738],[29.536141,40.775873],[29.531828,40.775909],[29.52749,40.778837],[29.525037,40.783914],[29.517715,40.789743],[29.514067,40.795695],[29.511003,40.79826],[29.501373,40.801644],[29.495225,40.804891],[29.488755,40.805728],[29.484456,40.805176],[29.480906,40.805402],[29.465685,40.809095],[29.458718,40.811439],[29.453587,40.814122],[29.445969,40.81993],[29.435383,40.828748],[29.428813,40.832369],[29.422904,40.834883],[29.418644,40.83744],[29.414841,40.84132],[29.412391,40.848284],[29.409021,40.854525],[29.400973,40.863628],[29.395078,40.871491],[29.390854,40.874924],[29.383864,40.87909],[29.380229,40.881737],[29.375346,40.886438],[29.372388,40.89057],[29.368435,40.898727],[29.366096,40.902408],[29.358788,40.90969],[29.355089,40.914476],[29.354433,40.916827],[29.349915,40.925998],[29.347278,40.929194],[29.343769,40.931608],[29.331372,40.936667],[29.324537,40.940444],[29.314568,40.944691],[29.309832,40.947946],[29.304147,40.951133],[29.296767,40.953946],[29.287744,40.958627],[29.282263,40.960705],[29.275505,40.964433],[29.269818,40.968798],[29.266316,40.970376],[29.255353,40.972456],[29.247773,40.975234],[29.243777,40.975908],[29.235636,40.975835],[29.229598,40.976456],[29.225905,40.977325],[29.217326,40.980738],[29.213692,40.981829],[29.203137,40.983309],[29.19872,40.985298],[29.192822,40.989068],[29.188773,40.990215],[29.180987,40.990543],[29.175386,40.99137],[29.170661,40.992988],[29.162787,40.994568],[29.150777,40.994821],[29.13803,40.99697],[29.131666,40.99703],[29.12007,40.995729],[29.116258,40.996399],[29.108939,40.988285],[29.102873,40.984103],[29.097461,40.982227],[29.093167,40.983352],[29.090264,40.985406],[29.084798,40.988275],[29.057769,40.998483],[29.055684,40.998465],[29.049782,40.994614],[29.044363,40.99304],[29.040327,40.990873],[29.037696,40.994099],[29.031643,40.99187],[29.029823,40.994167],[29.031497,40.995448],[29.037899,40.988878],[29.044577,40.992864],[29.049642,40.994249],[29.057546,40.999634],[29.061238,41.006938],[29.061618,41.010697],[29.058236,41.014109],[29.050632,41.019662],[29.047483,41.023037],[29.046255,41.026602],[29.045242,41.033098],[29.042149,41.038161],[29.027238,41.052483],[29.018147,41.058121],[29.016282,41.060281],[29.015335,41.064027],[29.013918,41.065793],[29.010573,41.067053],[29.001371,41.066687],[28.978302,41.067578],[28.973522,41.067144],[28.970428,41.065576],[28.964003,41.05869],[28.957215,41.054454],[28.950635,41.051659],[28.945535,41.048222],[28.938597,41.039811],[28.936735,41.038214],[28.925679,41.031381],[28.924081,41.029387],[28.922346,41.025413],[28.919273,41.021865],[28.916459,41.019906],[28.90428,41.012543],[28.89222,41.004317],[28.889616,41.003025],[28.875826,40.998843],[28.870532,40.997481],[28.856054,40.992943],[28.84739,40.991772],[28.820745,40.993313],[28.815755,40.994824],[28.813265,40.997599],[28.809872,40.999952],[28.806107,41.00081],[28.801204,41.000159],[28.797975,40.99845],[28.795253,40.9957],[28.793099,40.990243],[28.788671,40.986895],[28.782804,40.985478],[28.7758,40.986438],[28.768174,40.986228],[28.745305,40.978207],[28.740432,40.977447],[28.735318,40.97838],[28.719207,40.987568],[28.709755,40.993305],[28.699348,40.999222],[28.689812,41.000678],[28.685451,41.004336],[28.680326,41.00588],[28.668181,41.006225],[28.663947,41.007068],[28.63929,41.016532],[28.630581,41.019752],[28.628082,41.021664],[28.620225,41.025383],[28.615636,41.026247],[28.613016,41.025902],[28.610105,41.026956],[28.607461,41.025871],[28.604276,41.025816],[28.596036,41.024079],[28.593266,41.025128],[28.590211,41.025081],[28.585711,41.023628],[28.58168,41.020745],[28.579402,41.020051],[28.569698,41.019546],[28.515437,41.007461],[28.509308,41.007315],[28.504902,41.008548],[28.461821,41.02803],[28.459705,41.029524],[28.455792,41.030659],[28.444107,41.035706],[28.37792,41.053922],[28.367891,41.056765],[28.368818,41.059463],[28.36655,41.058509],[28.360765,41.058651],[28.265051,41.073445],[28.228288,41.081234],[28.219415,41.081726],[28.18918,41.078853],[28.17113,41.076603],[28.143109,41.076134],[28.125511,41.073695],[28.120755,41.074012],[28.116757,41.071936],[28.107744,41.069004],[28.093066,41.062509],[28.088468,41.060958],[28.073598,41.057386],[28.066472,41.055271],[28.017414,41.03728],[28.012538,41.035264],[28.009285,41.033269],[27.999672,41.026201],[27.99036,41.01896],[27.984406,41.013875],[27.98064,41.008843],[27.978433,41.006833],[27.975827,41.00157],[27.972738,40.993794],[27.972057,40.98922],[27.969727,40.986569],[27.95055,40.975862],[27.94637,40.974105],[27.940134,40.972751],[27.896078,40.969092],[27.887988,40.969813],[27.882068,40.97195],[27.845624,40.992358],[27.842089,40.993994],[27.773112,41.013179],[27.763905,41.015415],[27.75815,41.015527],[27.722468,41.011587],[27.718732,41.010795],[27.704852,41.005832],[27.698174,41.004231],[27.693494,41.004044],[27.684164,41.004717],[27.680144,41.004391],[27.593846,40.987663],[27.587577,40.987528],[27.566886,40.991199],[27.561973,40.993023],[27.542469,41.003677],[27.537192,41.005816],[27.534049,41.006376],[27.52811,41.006276],[27.524261,41.005346],[27.518744,41.002455],[27.508752,40.994564],[27.483894,40.977637],[27.482329,40.975763],[27.482141,40.973574],[27.484165,40.966571],[27.480647,40.954899],[27.470219,40.94783],[27.466312,40.946969],[27.460494,40.949504],[27.455866,40.950159],[27.430221,40.942424],[27.427034,40.942657],[27.425165,40.943863],[27.416749,40.955322],[27.415322,40.956537],[27.406684,40.959455],[27.386153,40.965905],[27.382085,40.966866],[27.378108,40.966924],[27.370915,40.965013],[27.324646,40.94973],[27.322071,40.948572],[27.298104,40.935944],[27.2943,40.934788],[27.291019,40.934578],[27.286412,40.93536],[27.277318,40.938854],[27.272703,40.939123],[27.248745,40.932785],[27.242675,40.932044],[27.225179,40.931799],[27.200565,40.932958],[27.196107,40.932643],[27.189502,40.930807],[27.18649,40.929354],[27.17553,40.922817],[27.164699,40.916663],[27.159204,40.915106],[27.139788,40.913401],[27.133851,40.912098],[27.130258,40.910135],[27.096263,40.887846],[27.089885,40.884673],[27.086936,40.883861],[27.025512,40.869259],[27.017804,40.868699],[26.951683,40.879508],[26.931234,40.882919],[26.908908,40.886412],[26.901516,40.886412],[26.896995,40.885476],[26.876506,40.878459],[26.831537,40.862678],[26.823919,40.861829],[26.819485,40.862149],[26.779103,40.86893],[26.774496,40.868833],[26.746937,40.862019],[26.744046,40.861638],[26.738482,40.862565],[26.725371,40.868071],[26.717397,40.870064],[26.688568,40.874691],[26.682125,40.87495],[26.654357,40.875063],[26.634491,40.875275],[26.619335,40.875106],[26.606198,40.875292],[26.520518,40.875969],[26.499822,40.876621],[26.483517,40.877336],[26.452804,40.87842],[26.417124,40.879821],[26.414186,40.880284],[26.409986,40.882271],[26.374597,40.906542],[26.353839,40.918471],[26.335115,40.929472],[26.331878,40.931218],[26.33095,40.933122],[26.328455,40.933026],[26.328766,40.934524],[26.326127,40.935359],[26.315011,40.94469],[26.295826,40.946331],[26.259145,40.949059],[26.25734,40.95014],[26.253601,40.950527],[26.249206,40.950007],[26.233307,40.950922],[26.226888,40.950955],[26.218813,40.949791],[26.211931,40.947554],[26.182277,40.93497],[26.174883,40.932634],[26.12943,40.920064],[26.123231,40.919336],[26.101671,40.920753],[26.082938,40.924171],[26.078075,40.924607],[26.072714,40.923929],[26.065177,40.920966],[26.056122,40.921238],[26.044822,40.924237],[26.032586,40.925837],[26.023983,40.924435],[26.020162,40.924851],[26.002642,40.928518],[25.997505,40.928918],[25.991502,40.928359],[25.984881,40.926214],[25.974971,40.920052],[25.965877,40.915632],[25.949123,40.909383],[25.937444,40.904646],[25.910779,40.895843],[25.904144,40.892789],[25.88663,40.881698],[25.882568,40.879841],[25.87445,40.878631],[25.855931,40.877888],[25.850955,40.876566],[25.834075,40.868267],[25.826835,40.866644],[25.822489,40.866827],[25.804424,40.86992],[25.794822,40.871389],[25.788907,40.870908],[25.780424,40.868309],[25.77261,40.86743],[25.767773,40.86631],[25.756207,40.860582],[25.750672,40.859762],[25.741173,40.860308],[25.738655,40.860795],[25.728141,40.866509],[25.721484,40.868715],[25.71136,40.875127],[25.710049,40.878778],[25.708034,40.882177],[25.704857,40.883826],[25.702933,40.886713],[25.697521,40.890052],[25.693684,40.893789],[25.692653,40.899476],[25.690806,40.902993],[25.690229,40.907205],[25.690952,40.914887],[25.689572,40.919356],[25.684537,40.921615],[25.67857,40.92525],[25.674548,40.933602],[25.669505,40.937915],[25.664282,40.943341],[25.662126,40.946646],[25.658973,40.949515],[25.657525,40.95241],[25.6476,40.958584],[25.644525,40.959922],[25.640475,40.960597],[25.613088,40.961761],[25.609088,40.962433],[25.590868,40.969473],[25.579681,40.975838],[25.563271,40.989129],[25.512423,41.030731],[25.495257,41.044856],[25.485448,41.054306],[25.474533,41.061686],[25.445883,41.090303],[25.443632,41.092164],[25.438675,41.094736],[25.434793,41.09601],[25.428784,41.096901],[25.425268,41.096854],[25.410556,41.094978],[25.404374,41.095044],[25.383806,41.097044],[25.373155,41.098625],[25.36529,41.100431],[25.363133,41.103117],[25.364401,41.109091],[25.369085,41.109946],[25.380039,41.114293],[25.388024,41.113517],[25.397519,41.117285],[25.397952,41.115098],[25.399706,41.115522],[25.401265,41.11793],[25.397379,41.117466],[25.387445,41.113722],[25.382374,41.113885],[25.380865,41.1151],[25.367889,41.109724],[25.357384,41.108594],[25.363267,41.10895],[25.362994,41.105398],[25.361513,41.102314],[25.357935,41.102301],[25.349872,41.105008],[25.339209,41.109852],[25.32726,41.116011],[25.321637,41.118489],[25.30998,41.122289],[25.305319,41.123157],[25.295433,41.123634],[25.285783,41.123313],[25.26966,41.120387],[25.230668,41.112833],[25.220291,41.111787],[25.211573,41.112711],[25.190144,41.116128],[25.182155,41.116753],[25.17534,41.116603],[25.136286,41.112544],[25.131074,41.113064],[25.108556,41.116721],[25.090847,41.119449],[25.081184,41.120548],[25.06644,41.120396],[25.048139,41.119512],[25.036634,41.11846],[25.020838,41.116345],[25.0142,41.116353],[24.993103,41.118766],[24.986251,41.118189],[24.95655,41.102286],[24.941386,41.095169],[24.924747,41.087622],[24.919277,41.085375],[24.889945,41.074982],[24.849781,41.063649],[24.844466,41.062383],[24.831998,41.060711],[24.823225,41.060861],[24.811191,41.062535],[24.794706,41.065357],[24.789879,41.066543],[24.782883,41.069238],[24.779306,41.070068],[24.769756,41.070153],[24.75749,41.069707],[24.750064,41.068321],[24.74529,41.065652],[24.742727,41.063524],[24.734967,41.055004],[24.724384,41.048077],[24.709851,41.031819],[24.705502,41.028747],[24.696569,41.025173],[24.677542,41.01716],[24.666334,41.011618],[24.660991,41.008173],[24.65248,41.002086],[24.638046,40.99142],[24.633652,40.989533],[24.62902,40.989206],[24.620404,40.991124],[24.615255,40.991534],[24.605822,40.990115],[24.581765,40.97918],[24.566765,40.97352],[24.560024,40.972485],[24.548416,40.971525],[24.543566,40.970825],[24.535624,40.968885],[24.52364,40.967075],[24.519381,40.967448],[24.514973,40.969007],[24.504155,40.970091],[24.495509,40.970557],[24.490934,40.969821],[24.484371,40.964825],[24.477914,40.962536],[24.46237,40.954825],[24.456542,40.953072],[24.451065,40.953906],[24.442731,40.96007],[24.437045,40.961268],[24.43212,40.965508],[24.427404,40.96336],[24.426043,40.963572],[24.41921,40.966784],[24.414315,40.967017],[24.411697,40.965548],[24.412323,40.963434],[24.410671,40.96143],[24.408244,40.962005],[24.398587,40.962336],[24.393446,40.961307],[24.391541,40.959275],[24.39207,40.956569],[24.391055,40.955448],[24.383222,40.954626],[24.380121,40.951816],[24.375612,40.949285],[24.373619,40.946919],[24.375046,40.943557],[24.375374,40.934958],[24.374171,40.932244],[24.368252,40.929759],[24.367314,40.928297],[24.370603,40.923072],[24.366924,40.919194],[24.366184,40.915721],[24.360058,40.914579],[24.358419,40.913619],[24.357557,40.909781],[24.34557,40.909498],[24.341693,40.907651],[24.33964,40.904209],[24.331889,40.901392],[24.327038,40.895862],[24.327769,40.89256],[24.326898,40.89016],[24.323615,40.886352],[24.312059,40.887087],[24.310239,40.886177],[24.30807,40.88207],[24.305429,40.880603],[24.303188,40.876794],[24.297953,40.874684],[24.29361,40.876158],[24.289412,40.879558],[24.286182,40.880444],[24.278178,40.87863],[24.271634,40.879462],[24.268234,40.878781],[24.265004,40.876145],[24.261745,40.874622],[24.25769,40.874717],[24.254706,40.875951],[24.241745,40.883828],[24.238617,40.885088],[24.235388,40.885456],[24.22916,40.884462],[24.2236,40.880927],[24.219471,40.879005],[24.207168,40.875188],[24.20108,40.871145],[24.196998,40.869113],[24.188215,40.86565],[24.176659,40.862993],[24.166133,40.859881],[24.154009,40.854469],[24.145434,40.851839],[24.13539,40.849411],[24.129301,40.847305],[24.122479,40.844144],[24.117579,40.841349],[24.108867,40.83458],[24.102757,40.83113],[24.096455,40.828293],[24.087238,40.82549],[24.075434,40.823483],[24.064684,40.821978],[24.056998,40.819696],[24.051599,40.817029],[24.045515,40.81307],[24.040989,40.810945],[24.025261,40.804421],[24.007444,40.794541],[24.000019,40.791937],[23.992123,40.792056],[23.986278,40.793477],[23.981012,40.793889],[23.976172,40.792812],[23.972417,40.790461],[23.968392,40.788776],[23.962629,40.787415],[23.956171,40.785068],[23.949231,40.785586],[23.94454,40.785214],[23.940994,40.783765],[23.935731,40.783723],[23.930595,40.784528],[23.925376,40.784033],[23.920245,40.782465],[23.910982,40.782808],[23.906275,40.782659],[23.898881,40.780993],[23.894317,40.781531],[23.888414,40.78432],[23.880127,40.792047],[23.868945,40.801885],[23.864165,40.803407],[23.859601,40.802996],[23.850733,40.799638],[23.841379,40.79932],[23.835837,40.797547],[23.831658,40.795478],[23.825737,40.788977],[23.822253,40.78607],[23.818278,40.78403],[23.813234,40.782447],[23.79567,40.780351],[23.791065,40.779081],[23.780556,40.772724],[23.769612,40.764767],[23.75882,40.760684],[23.751774,40.760502],[23.743933,40.759041],[23.739343,40.759386],[23.724016,40.756487],[23.719202,40.756227],[23.717205,40.7552],[23.704102,40.743666],[23.701431,40.740475],[23.698641,40.733082],[23.695648,40.729957],[23.689165,40.718308],[23.686564,40.714861],[23.681643,40.710335],[23.691765,40.704485],[23.691225,40.701525],[23.682896,40.691612],[23.673419,40.679904],[23.6716,40.675786],[23.66839,40.673514],[23.663132,40.67226],[23.666431,40.669864],[23.681775,40.667873],[23.68547,40.666553],[23.691875,40.665252],[23.701494,40.664769],[23.709062,40.662872],[23.713553,40.663343],[23.724315,40.660375],[23.728715,40.658221],[23.733752,40.657282],[23.73614,40.655469],[23.739596,40.655366],[23.741614,40.651762],[23.745861,40.649058],[23.743866,40.647698],[23.747543,40.643494],[23.74757,40.641758],[23.749887,40.640244],[23.751627,40.637379],[23.756969,40.633435],[23.761546,40.632461],[23.764231,40.630521],[23.767482,40.62553],[23.768228,40.622947],[23.770946,40.622135],[23.771895,40.620364],[23.776971,40.615151],[23.77847,40.611838],[23.775151,40.606496],[23.769501,40.600233],[23.768356,40.598115],[23.768722,40.591016],[23.770031,40.588929],[23.774437,40.587866],[23.784234,40.5892],[23.789308,40.588518],[23.79088,40.590006],[23.794977,40.587274],[23.794823,40.586257],[23.799541,40.58282],[23.800609,40.579993],[23.802931,40.578625],[23.807423,40.579677],[23.812859,40.578113],[23.817275,40.578473],[23.817603,40.574751],[23.821962,40.569011],[23.821407,40.567574],[23.822539,40.564738],[23.821479,40.561555],[23.824204,40.560395],[23.823071,40.556355],[23.82558,40.553512],[23.823405,40.551098],[23.822369,40.546739],[23.827928,40.548272],[23.829803,40.540221],[23.827376,40.535588],[23.829458,40.531346],[23.826589,40.530965],[23.823126,40.528864],[23.824797,40.525982],[23.823444,40.521726],[23.820254,40.523265],[23.81718,40.522296],[23.819146,40.519867],[23.813828,40.518848],[23.811393,40.520281],[23.808815,40.519064],[23.804327,40.518823],[23.803713,40.517821],[23.80537,40.515668],[23.803614,40.511066],[23.803176,40.508022],[23.806916,40.504693],[23.810612,40.508452],[23.809753,40.510195],[23.814215,40.511527],[23.821658,40.509759],[23.822985,40.508109],[23.820953,40.506793],[23.822257,40.505497],[23.819902,40.50402],[23.81906,40.500284],[23.82031,40.499945],[23.820143,40.497244],[23.821304,40.493957],[23.820166,40.492368],[23.820415,40.489892],[23.817518,40.484961],[23.818536,40.478287],[23.820136,40.472968],[23.819566,40.466687],[23.815496,40.461211],[23.815048,40.45851],[23.818592,40.449992],[23.831311,40.439557],[23.839258,40.43734],[23.841307,40.436002],[23.848083,40.423055],[23.854262,40.417809],[23.860201,40.409802],[23.862489,40.404252],[23.865167,40.402621],[23.869892,40.40095],[23.87566,40.39672],[23.872094,40.393766],[23.86609,40.391993],[23.862209,40.38998],[23.861336,40.388051],[23.858368,40.386971],[23.857417,40.383218],[23.853838,40.379759],[23.848359,40.378076],[23.845575,40.379196],[23.839436,40.379756],[23.833636,40.379028],[23.832387,40.379407],[23.831493,40.38289],[23.829377,40.38409],[23.824553,40.383391],[23.822306,40.38495],[23.819792,40.385345],[23.815261,40.387262],[23.810118,40.390256],[23.803345,40.391525],[23.801632,40.390023],[23.800137,40.390691],[23.798366,40.393945],[23.793152,40.396383],[23.772907,40.391108],[23.769975,40.388046],[23.764094,40.386039],[23.760478,40.387062],[23.752016,40.3863],[23.747588,40.38285],[23.742397,40.382122],[23.737957,40.38225],[23.732256,40.383206],[23.729452,40.38195],[23.721182,40.382443],[23.719862,40.385373],[23.710455,40.385428],[23.702474,40.38227],[23.696339,40.377321],[23.691718,40.368228],[23.688202,40.370539],[23.683791,40.37057],[23.679673,40.369555],[23.676329,40.37057],[23.671056,40.370144],[23.669241,40.367667],[23.664327,40.366223],[23.664592,40.361867],[23.666095,40.359657],[23.669868,40.35756],[23.669141,40.355165],[23.666709,40.354603],[23.66279,40.352492],[23.660839,40.349597],[23.657886,40.34864],[23.655064,40.345986],[23.657263,40.341462],[23.66033,40.339917],[23.660017,40.331744],[23.661815,40.324594],[23.65835,40.322792],[23.661622,40.321136],[23.66491,40.320618],[23.667148,40.318988],[23.669455,40.315527],[23.67359,40.312873],[23.681414,40.310182],[23.687572,40.304342],[23.693473,40.302739],[23.695075,40.300841],[23.693501,40.293533],[23.68579,40.294094],[23.68402,40.292735],[23.686833,40.291052],[23.688055,40.287738],[23.682266,40.288318],[23.681304,40.287023],[23.682552,40.283825],[23.685156,40.281595],[23.684329,40.279281],[23.681716,40.277008],[23.684165,40.276156],[23.690184,40.272154],[23.692255,40.268338],[23.697652,40.265065],[23.700005,40.25917],[23.705089,40.257026],[23.713507,40.251423],[23.711933,40.248089],[23.706852,40.242809],[23.711723,40.239296],[23.713319,40.23539],[23.71622,40.23286],[23.733081,40.232973],[23.737539,40.228982],[23.742924,40.226187],[23.755483,40.213571],[23.757141,40.209915],[23.759995,40.207952],[23.763012,40.202192],[23.767755,40.196794],[23.770569,40.190724],[23.773948,40.187474],[23.780339,40.184856],[23.784868,40.184004],[23.795777,40.182866],[23.814466,40.180333],[23.818764,40.179055],[23.825661,40.179823],[23.829771,40.177291],[23.83492,40.176637],[23.836803,40.174114],[23.838803,40.176164],[23.841137,40.174145],[23.844066,40.174246],[23.845106,40.171918],[23.849308,40.174525],[23.851286,40.170019],[23.855768,40.170252],[23.856048,40.172827],[23.859047,40.171859],[23.86077,40.168521],[23.865082,40.16632],[23.866016,40.163586],[23.872671,40.160713],[23.876487,40.160193],[23.878557,40.161435],[23.884026,40.160667],[23.884757,40.162005],[23.888224,40.161614],[23.889361,40.159392],[23.892941,40.158497],[23.89412,40.155895],[23.898558,40.159006],[23.901499,40.156812],[23.904364,40.157517],[23.90849,40.156157],[23.910414,40.156344],[23.911959,40.154748],[23.909994,40.153507],[23.912846,40.150092],[23.91656,40.149344],[23.918518,40.150295],[23.919165,40.146043],[23.922339,40.142268],[23.923055,40.13604],[23.924016,40.134501],[23.929098,40.13072],[23.941873,40.128345],[23.946604,40.126235],[23.954623,40.124434],[23.960995,40.126525],[23.962944,40.126266],[23.968445,40.122801],[23.970611,40.119826],[23.971051,40.116908],[23.977736,40.115949],[23.977289,40.113883],[23.982609,40.11369],[23.986895,40.112563],[23.984664,40.111544],[23.984192,40.109991],[23.985804,40.108543],[23.986915,40.104984],[23.98041,40.105202],[23.978849,40.103656],[23.980441,40.100528],[23.976633,40.101111],[23.975682,40.100429],[23.976811,40.082972],[23.977522,40.08064],[23.981098,40.074324],[23.986989,40.073367],[23.989248,40.068051],[23.988755,40.066267],[23.992084,40.063429],[23.991003,40.057542],[23.987398,40.056221],[23.986708,40.054896],[23.982202,40.053604],[23.983189,40.051268],[23.976096,40.047623],[23.973682,40.0439],[23.969216,40.042124],[23.968126,40.039699],[23.968274,40.035044],[23.97104,40.031786],[23.975451,40.031934],[23.981164,40.034376],[23.9837,40.033918],[23.983971,40.031735],[23.986061,40.030458],[23.98766,40.027789],[23.988626,40.02393],[23.986174,40.021164],[23.986569,40.014572],[23.983617,40.012099],[23.982048,40.007237],[23.983303,40.004883],[23.984096,40.000523],[23.983614,39.998639],[23.986704,39.996746],[23.987138,39.994707],[23.989944,39.993329],[23.986298,39.989978],[23.984694,39.989443],[23.979725,39.989963],[23.975329,39.989398],[23.972476,39.988039],[23.968561,39.990359],[23.965522,39.99045],[23.963218,39.992784],[23.958112,39.992887],[23.957603,39.989734],[23.961079,39.983189],[23.958962,39.981318],[23.958986,39.977438],[23.960009,39.976126],[23.957372,39.971476],[23.95759,39.969934],[23.955409,39.968397],[23.950906,39.967047],[23.948484,39.96496],[23.947952,39.962363],[23.943374,39.959946],[23.93995,39.961825],[23.934019,39.962932],[23.932089,39.962049],[23.928087,39.962318],[23.924104,39.96653],[23.920775,39.968728],[23.918435,39.971902],[23.913689,39.973537],[23.911037,39.976172],[23.911148,39.977164],[23.915735,39.978663],[23.915678,39.979683],[23.909761,39.982713],[23.909606,39.984145],[23.912108,39.987248],[23.910668,39.992224],[23.905971,39.989788],[23.905089,39.99244],[23.896045,39.996095],[23.893346,39.99623],[23.888764,39.999046],[23.88803,40.001686],[23.885154,40.005556],[23.88025,40.006069],[23.87815,40.008583],[23.874742,40.009973],[23.874269,40.014071],[23.871249,40.013956],[23.864911,40.018956],[23.864234,40.020867],[23.861186,40.021756],[23.860513,40.023675],[23.857859,40.023606],[23.855503,40.026641],[23.852642,40.025202],[23.848056,40.024681],[23.847852,40.027213],[23.844552,40.029001],[23.842028,40.028953],[23.840584,40.031146],[23.840926,40.033763],[23.83796,40.033639],[23.836562,40.03464],[23.836691,40.038282],[23.837745,40.039574],[23.835036,40.040926],[23.833429,40.043034],[23.830782,40.04296],[23.827645,40.045703],[23.828371,40.047624],[23.825197,40.049608],[23.823141,40.049672],[23.821498,40.053401],[23.816952,40.056256],[23.814243,40.056512],[23.809845,40.059038],[23.807314,40.063367],[23.809969,40.064844],[23.808826,40.065782],[23.806603,40.064904],[23.803487,40.065993],[23.806153,40.072785],[23.806144,40.07609],[23.805251,40.079479],[23.805775,40.081097],[23.808469,40.082513],[23.808368,40.084984],[23.803749,40.086512],[23.800347,40.090121],[23.793523,40.090601],[23.791808,40.091314],[23.788196,40.09555],[23.785167,40.098143],[23.782571,40.098933],[23.779866,40.102],[23.775211,40.108844],[23.776505,40.113445],[23.773413,40.117857],[23.771156,40.119069],[23.765357,40.124138],[23.765615,40.125592],[23.769377,40.128488],[23.769757,40.12989],[23.765388,40.133816],[23.763093,40.134238],[23.760142,40.131777],[23.754659,40.132906],[23.750019,40.135971],[23.742785,40.139695],[23.738489,40.144995],[23.736805,40.148223],[23.733683,40.149054],[23.733625,40.153171],[23.731938,40.155326],[23.731591,40.159016],[23.729706,40.162447],[23.725036,40.166624],[23.725404,40.168712],[23.723963,40.170579],[23.718595,40.173959],[23.715811,40.178068],[23.715894,40.180445],[23.711954,40.184474],[23.707658,40.18355],[23.704531,40.18673],[23.701838,40.188485],[23.693806,40.196679],[23.68888,40.207614],[23.688835,40.209155],[23.690787,40.212908],[23.686614,40.215326],[23.680926,40.214752],[23.664735,40.225483],[23.656052,40.22778],[23.650144,40.226717],[23.646998,40.227907],[23.642719,40.226831],[23.638905,40.228115],[23.63623,40.227703],[23.630366,40.229906],[23.626219,40.229135],[23.622963,40.231632],[23.620015,40.23087],[23.611481,40.231731],[23.60818,40.229976],[23.60659,40.232076],[23.601129,40.233935],[23.599287,40.237855],[23.596791,40.238797],[23.590696,40.239104],[23.587476,40.240112],[23.583052,40.245287],[23.578357,40.248565],[23.573799,40.250461],[23.566369,40.251588],[23.561664,40.253741],[23.554335,40.252618],[23.548193,40.253154],[23.518475,40.262497],[23.514064,40.262511],[23.508615,40.259932],[23.505432,40.25953],[23.495761,40.261343],[23.493026,40.261413],[23.477452,40.260409],[23.473516,40.261466],[23.47149,40.26405],[23.466583,40.264355],[23.463874,40.266321],[23.460312,40.265533],[23.458224,40.267891],[23.45444,40.269257],[23.452699,40.270693],[23.449948,40.270966],[23.44651,40.274805],[23.44414,40.276351],[23.420447,40.281739],[23.414376,40.282367],[23.366418,40.283859],[23.360801,40.282631],[23.349334,40.276994],[23.345766,40.2748],[23.3268,40.257794],[23.324008,40.255793],[23.301615,40.243843],[23.297762,40.24438],[23.286631,40.25641],[23.283885,40.258626],[23.278446,40.260323],[23.256759,40.262831],[23.240426,40.264555],[23.232979,40.266134],[23.188671,40.283198],[23.182328,40.284525],[23.156439,40.284276],[23.15083,40.285534],[23.146973,40.28832],[23.132479,40.303372],[23.130225,40.305321],[23.125715,40.307602],[23.111819,40.311988],[23.100815,40.312972],[23.096873,40.313616],[23.091745,40.316339],[23.078908,40.328291],[23.074755,40.334393],[23.070209,40.33832],[23.049628,40.363235],[23.046602,40.367823],[23.031953,40.398649],[23.029036,40.406682],[23.025711,40.410069],[23.023076,40.414037],[23.022994,40.42122],[23.020681,40.425092],[23.018274,40.431067],[23.011995,40.442254],[23.009612,40.450625],[23.007137,40.453658],[22.999467,40.459922],[22.997563,40.46612],[22.993207,40.472603],[22.992739,40.48143],[22.993521,40.483897],[22.997658,40.487415],[22.999292,40.491885],[23.005221,40.501547],[23.012614,40.524765],[23.01292,40.531149],[23.010461,40.537073],[23.000959,40.551076],[22.989188,40.564906],[22.980755,40.577533],[22.9781,40.581159],[22.978524,40.582472],[22.991733,40.592093],[22.995763,40.596072],[22.998675,40.602607],[23.000012,40.609113],[22.999891,40.611295],[22.996103,40.613703],[22.989861,40.614062],[22.987254,40.61476],[22.984182,40.616949],[22.982098,40.622965],[22.980217,40.625543],[22.976201,40.629413],[22.974005,40.633128],[22.972003,40.634306],[22.975094,40.630095],[22.980229,40.624846],[22.982174,40.62184],[22.98375,40.617147],[22.987044,40.614625],[22.994075,40.613719],[22.998713,40.61259],[22.999921,40.610452],[22.998518,40.603121],[22.997504,40.600705],[22.995082,40.600066],[22.998863,40.598581],[22.998481,40.600791],[22.99999,40.60897],[22.999282,40.612157],[22.997467,40.613519],[22.987331,40.614632],[22.983973,40.617198],[22.981783,40.623198],[22.975771,40.629754],[22.973788,40.632429],[22.970461,40.639091],[22.969403,40.644222],[22.966559,40.651389],[22.96656,40.654679],[22.968455,40.660098],[22.966811,40.663536],[22.963769,40.665811],[22.962385,40.668286],[22.960193,40.675112],[22.957319,40.681949],[22.95916,40.6871],[22.964556,40.690393],[22.964268,40.693488],[22.961677,40.694591],[22.956207,40.695244],[22.95177,40.69515],[22.949349,40.6968],[22.949604,40.698714],[22.953296,40.706393],[22.952452,40.705593],[22.948208,40.697214],[22.944744,40.695879],[22.937261,40.695218],[22.868842,40.696905],[22.857036,40.697128],[22.849838,40.695697],[22.837478,40.690389],[22.833391,40.686554],[22.83247,40.683506],[22.832384,40.674322],[22.834038,40.669711],[22.840985,40.656761],[22.842126,40.655477],[22.839968,40.653186],[22.820044,40.651547],[22.816792,40.651034],[22.810633,40.649026],[22.777759,40.632135],[22.738501,40.612094],[22.72757,40.607507],[22.722936,40.606426],[22.676825,40.599413],[22.669862,40.596989],[22.627932,40.5756],[22.613141,40.567404],[22.605497,40.562326],[22.600304,40.557758],[22.598505,40.556853],[22.594731,40.557171],[22.584709,40.55979],[22.579693,40.559666],[22.563962,40.557425],[22.553756,40.556198],[22.539162,40.554974],[22.524796,40.554088],[22.518421,40.554934],[22.514323,40.556599],[22.510538,40.559427],[22.508694,40.56172],[22.504429,40.56863],[22.500493,40.573267],[22.494702,40.577868],[22.489608,40.580734],[22.481446,40.584593],[22.476907,40.586229],[22.469265,40.588079],[22.46383,40.588753],[22.456046,40.588866],[22.428406,40.587218],[22.419352,40.585852],[22.414354,40.584263],[22.409388,40.581899],[22.402986,40.577906],[22.397836,40.575337],[22.345054,40.554557],[22.33572,40.550413],[22.312718,40.539379],[22.307855,40.537379],[22.282551,40.528531],[22.263583,40.520289],[22.25539,40.517349],[22.250102,40.515926],[22.239103,40.51394],[22.233769,40.512073],[22.229923,40.508063],[22.229225,40.504767],[22.23023,40.501556],[22.234885,40.493835],[22.235198,40.487141],[22.234473,40.483223],[22.232356,40.480066],[22.230942,40.475176],[22.22624,40.467503],[22.224098,40.464754],[22.217705,40.459808],[22.212131,40.456612],[22.208042,40.450952],[22.201502,40.447377],[22.197843,40.442531],[22.195471,40.440782],[22.192786,40.440316],[22.185474,40.441363],[22.18126,40.439671],[22.179934,40.435327],[22.182956,40.430246],[22.182878,40.428406],[22.180045,40.42123],[22.179921,40.415665],[22.17769,40.410981],[22.169198,40.403235],[22.163284,40.398758],[22.156566,40.391983],[22.153994,40.390525],[22.146701,40.388079],[22.140554,40.384781],[22.112752,40.382583],[22.103759,40.380651],[22.096081,40.380294],[22.092624,40.37923],[22.082583,40.372664],[22.075056,40.367253],[22.07209,40.366068],[22.068842,40.36583],[22.064463,40.366475],[22.048674,40.369684],[22.044996,40.369632],[22.038814,40.368614],[22.033098,40.369449],[22.030178,40.370962],[22.026759,40.374428],[22.022109,40.376774],[22.018515,40.376877],[22.010077,40.375948],[22.003691,40.374201],[21.983736,40.370836],[21.980575,40.370474],[21.969543,40.370298],[21.960295,40.3683],[21.937121,40.36476],[21.930089,40.364963],[21.906824,40.368152],[21.891852,40.369704],[21.878316,40.370129],[21.873758,40.369068],[21.856528,40.362833],[21.850818,40.36146],[21.845393,40.36108],[21.826153,40.362398],[21.821392,40.362018],[21.818536,40.360982],[21.815039,40.358342],[21.809616,40.351756],[21.803639,40.347984],[21.793192,40.345647],[21.788271,40.34369],[21.783138,40.339405],[21.773807,40.326785],[21.77158,40.324402],[21.768204,40.322186],[21.76354,40.320511],[21.760319,40.320014],[21.7316,40.317891],[21.723733,40.316948],[21.716554,40.315449],[21.7091,40.313219],[21.700023,40.309372],[21.695656,40.307013],[21.689599,40.30305],[21.649684,40.27316],[21.64684,40.27081],[21.641037,40.262563],[21.634921,40.257622],[21.623067,40.252042],[21.619076,40.250464],[21.607537,40.246761],[21.600057,40.245199],[21.590512,40.24367],[21.586325,40.241967],[21.5806,40.238141],[21.577021,40.234048],[21.571432,40.231138],[21.555028,40.227266],[21.550112,40.228033],[21.528046,40.23774],[21.521293,40.240337],[21.506368,40.244196],[21.503295,40.245432],[21.500412,40.248382],[21.499748,40.250656],[21.498994,40.263999],[21.49668,40.268489],[21.493984,40.270944],[21.489825,40.273078],[21.47571,40.278155],[21.470984,40.281106],[21.464222,40.288976],[21.45985,40.292855],[21.455601,40.294905],[21.44556,40.297901],[21.440131,40.300214],[21.434973,40.304495],[21.425083,40.316943],[21.420803,40.324671],[21.415626,40.331132],[21.414281,40.334359],[21.413429,40.342703],[21.410275,40.349143],[21.407697,40.356124],[21.406607,40.360721],[21.404647,40.364438],[21.401426,40.373602],[21.395062,40.383949],[21.390272,40.396615],[21.387366,40.399484],[21.38113,40.402738],[21.375951,40.40793],[21.363771,40.414595],[21.359039,40.415815],[21.355049,40.417587],[21.349053,40.419319],[21.346565,40.421307],[21.339114,40.425108],[21.328587,40.428387],[21.32364,40.430332],[21.31504,40.436922],[21.30219,40.445508],[21.300512,40.447467],[21.294165,40.459505],[21.290169,40.464734],[21.277724,40.47498],[21.269,40.478797],[21.264623,40.482219],[21.260682,40.482807],[21.254177,40.482141],[21.24829,40.482352],[21.243613,40.481635],[21.240074,40.482579],[21.238681,40.484301],[21.23946,40.488859],[21.238197,40.492746],[21.235818,40.494646],[21.230362,40.497742],[21.221748,40.504487],[21.217069,40.507164],[21.213235,40.508235],[21.187659,40.513446],[21.183118,40.517005],[21.181119,40.521146],[21.180727,40.523652],[21.181154,40.53116],[21.179147,40.533822],[21.175952,40.535352],[21.17586,40.538542],[21.181167,40.541639],[21.181738,40.544016],[21.180923,40.548558],[21.182709,40.54984],[21.189378,40.549104],[21.1911,40.550206],[21.189348,40.552827],[21.189226,40.556449],[21.191555,40.559644],[21.191047,40.563561],[21.188353,40.56658],[21.189946,40.571721],[21.188155,40.574282],[21.189999,40.578576],[21.188351,40.58193],[21.189192,40.583386],[21.193481,40.585877],[21.193867,40.587227],[21.191174,40.592307],[21.192029,40.599979],[21.191491,40.607196],[21.194368,40.610366],[21.195378,40.618977],[21.194606,40.624193],[21.192164,40.626677],[21.191657,40.628801],[21.1885,40.6296],[21.184842,40.631949],[21.181949,40.632772],[21.178699,40.638572],[21.177264,40.643841],[21.177788,40.647156],[21.176521,40.649349],[21.179325,40.651947],[21.181026,40.65603],[21.179691,40.657663],[21.180875,40.663107],[21.176559,40.667948],[21.173724,40.668276],[21.172578,40.6706],[21.175147,40.673082],[21.175689,40.674829],[21.167292,40.671005],[21.163556,40.67176],[21.15777,40.670975],[21.152986,40.671417],[21.145481,40.670794],[21.142553,40.671143],[21.137619,40.670615],[21.132382,40.669442],[21.12666,40.667415],[21.122855,40.66539],[21.120023,40.663091],[21.112737,40.659457],[21.106275,40.658578],[21.103248,40.65662],[21.100587,40.651445],[21.095274,40.649366],[21.092741,40.642987],[21.08996,40.639697],[21.085972,40.637127],[21.079315,40.634831],[21.070727,40.629187],[21.065202,40.626933],[21.060363,40.623663],[21.048853,40.623005],[21.044185,40.623332],[21.041349,40.622073],[21.039737,40.619656],[21.032064,40.616775],[21.027362,40.614549],[21.025189,40.611275],[21.021648,40.60933],[21.012272,40.608689],[21.008623,40.60764],[21.006251,40.607827],[20.998106,40.611739],[20.993025,40.617283],[20.990206,40.618692],[20.983873,40.625522],[20.98192,40.628643],[20.94542,40.664133],[20.936893,40.672188],[20.918059,40.690579],[20.914075,40.695243],[20.90941,40.697145],[20.902748,40.695511],[20.888071,40.700789],[20.877089,40.698851],[20.861386,40.696652],[20.856763,40.694612],[20.854342,40.692853],[20.851693,40.692135],[20.842661,40.691048],[20.839643,40.689123],[20.830252,40.675706],[20.822785,40.669484],[20.82007,40.664179],[20.810654,40.654386],[20.808674,40.647232],[20.804858,40.643972],[20.786768,40.639523],[20.766065,40.633192],[20.764369,40.63393],[20.737372,40.663729],[20.733514,40.670054],[20.730808,40.677936],[20.727181,40.686301],[20.723472,40.691343],[20.722661,40.693424],[20.71808,40.700175],[20.717474,40.702256],[20.713575,40.708013],[20.708801,40.717489],[20.708339,40.722315],[20.711476,40.728769],[20.71368,40.737402],[20.717569,40.74281],[20.71986,40.749446],[20.719761,40.754034],[20.717648,40.76293],[20.718021,40.766645],[20.716694,40.772801],[20.715844,40.780488],[20.71756,40.792206],[20.719427,40.797401],[20.721272,40.799942],[20.724886,40.801037],[20.727832,40.805614],[20.73214,40.809309],[20.738498,40.812001],[20.739776,40.814223],[20.739112,40.822656],[20.737824,40.825871],[20.737309,40.829909],[20.734708,40.83241],[20.731516,40.834298],[20.722475,40.840922],[20.720459,40.846356],[20.716616,40.849282],[20.708701,40.852673],[20.701325,40.85536],[20.694827,40.859388],[20.694831,40.863049],[20.696537,40.86244],[20.698217,40.867193],[20.697184,40.866789],[20.696894,40.869531],[20.689895,40.873212],[20.684781,40.876484],[20.682957,40.880578],[20.679264,40.885071],[20.665879,40.898243],[20.661995,40.89979],[20.65846,40.902369],[20.651735,40.906074],[20.638123,40.988599],[20.637411,40.989919],[20.637818,40.993299],[20.636129,40.998504],[20.634956,40.99971],[20.632734,41.006038],[20.633783,41.008754],[20.633566,41.012363],[20.634143,41.017389],[20.636276,41.019838],[20.635219,41.025006],[20.635813,41.02871],[20.634009,41.03381],[20.633637,41.036603],[20.634929,41.038222],[20.632768,41.0461],[20.635094,41.056042],[20.63387,41.058211],[20.633105,41.062958],[20.630556,41.06372],[20.629077,41.067068],[20.624401,41.062693],[20.622685,41.062287],[20.621812,41.066082],[20.619011,41.063908],[20.613325,41.067189],[20.608929,41.065502],[20.602858,41.065919],[20.598042,41.067964],[20.599119,41.066086],[20.595519,41.064087],[20.590494,41.064614],[20.592591,41.066535],[20.588356,41.068469],[20.592486,41.068657],[20.587736,41.073423],[20.585962,41.070327],[20.576935,41.070278],[20.572891,41.0693],[20.564759,41.069328],[20.56232,41.071273],[20.558282,41.071448],[20.552336,41.070409],[20.542301,41.066796],[20.53495,41.065475],[20.529527,41.063274],[20.526993,41.063252],[20.51795,41.067034],[20.51517,41.067845],[20.511444,41.073389],[20.501694,41.073541],[20.497341,41.074979],[20.492944,41.07445],[20.487209,41.075446],[20.486126,41.074771],[20.480879,41.074493],[20.47518,41.073407],[20.472429,41.074778],[20.467418,41.072803],[20.463771,41.07391],[20.459265,41.079287],[20.452449,41.08352],[20.450116,41.088057],[20.447178,41.089291],[20.445166,41.09185],[20.443795,41.096631],[20.443893,41.099368],[20.441263,41.098118],[20.438135,41.099829],[20.436875,41.103003],[20.43401,41.103441],[20.433334,41.106815],[20.428361,41.109257],[20.42238,41.11132],[20.419166,41.115673],[20.413789,41.118997],[20.410616,41.121942],[20.410765,41.122921],[20.407766,41.126055],[20.402426,41.127476],[20.39991,41.132202],[20.396759,41.133882],[20.394984,41.135963],[20.389147,41.137243],[20.38596,41.137125],[20.383912,41.135356],[20.381967,41.135958],[20.383945,41.141139],[20.378926,41.144356],[20.377489,41.145906],[20.373719,41.152048],[20.368714,41.153584],[20.36535,41.152603],[20.361658,41.154765],[20.359106,41.155467],[20.357709,41.160158],[20.354571,41.163743],[20.348003,41.164524],[20.346032,41.166567],[20.342992,41.166847],[20.341383,41.165869],[20.334409,41.168343],[20.332041,41.171071],[20.328093,41.173914],[20.325565,41.174144],[20.320046,41.177251],[20.313693,41.177966],[20.311616,41.179173],[20.310461,41.182921],[20.303964,41.186201],[20.300948,41.186301],[20.298075,41.187703],[20.295441,41.187739],[20.292521,41.188908],[20.290683,41.18864],[20.288062,41.186325],[20.283444,41.187943],[20.280205,41.185365],[20.278296,41.184773],[20.272752,41.185504],[20.271764,41.184462],[20.273761,41.182593],[20.27069,41.179583],[20.262889,41.177476],[20.258294,41.173135],[20.253967,41.170941],[20.250492,41.167844],[20.244128,41.166448],[20.242126,41.16474],[20.235634,41.166267],[20.231746,41.166252],[20.228449,41.164189],[20.226935,41.164134],[20.220986,41.166114],[20.215157,41.167473],[20.210688,41.167338],[20.206675,41.166329],[20.200653,41.166155],[20.197624,41.165251],[20.192576,41.160378],[20.18208,41.159112],[20.175471,41.160376],[20.169303,41.157628],[20.159472,41.147092],[20.151147,41.141567],[20.138924,41.132784],[20.131302,41.128588],[20.119687,41.124294],[20.115395,41.123905],[20.109617,41.122441],[20.103386,41.121617],[20.101823,41.119535],[20.096108,41.115733],[20.091312,41.109299],[20.088644,41.106337],[20.083957,41.104619],[20.075518,41.105146],[20.071528,41.108302],[20.06358,41.105967],[20.056909,41.102228],[20.052847,41.100693],[20.036884,41.098718],[20.029719,41.100302],[20.025428,41.105247],[20.02414,41.111682],[20.02314,41.108154],[20.020979,41.10878],[20.017642,41.108057],[20.014288,41.103908],[20.013613,41.101036],[20.010017,41.099222],[20.008043,41.097383],[20.008778,41.101047],[20.006277,41.101102],[20.008261,41.104466],[20.008917,41.107345],[20.006271,41.109245],[20.005232,41.111333],[20.002398,41.111017],[20.000897,41.108757],[19.996296,41.109731],[19.992642,41.11299],[19.94352,41.218902],[19.939346,41.2204],[19.937682,41.218871],[19.935337,41.220331],[19.934232,41.222811],[19.934879,41.225557],[19.929955,41.226947],[19.928456,41.228024],[19.929656,41.230718],[19.92536,41.234847],[19.920818,41.234852],[19.916069,41.236281],[19.916219,41.238319],[19.912466,41.243581],[19.909779,41.245917],[19.906421,41.247677],[19.899331,41.250157],[19.895958,41.251765],[19.893444,41.253889],[19.889872,41.258569],[19.887006,41.260412],[19.872136,41.264421],[19.871404,41.265145],[19.866821,41.264671],[19.856332,41.262146],[19.84777,41.264021],[19.844367,41.26334],[19.840421,41.266819],[19.84243,41.268095],[19.840218,41.271204],[19.845331,41.273254],[19.851266,41.274777],[19.853836,41.276279],[19.854933,41.279186],[19.853843,41.283031],[19.851124,41.288389],[19.84832,41.291888],[19.836256,41.303471],[19.833073,41.303928],[19.829347,41.303024],[19.821571,41.30514],[19.817324,41.305469],[19.81315,41.307421],[19.811262,41.309889],[19.815832,41.313696],[19.81464,41.318381],[19.811552,41.31801],[19.81167,41.322244],[19.817372,41.323184],[19.819327,41.316847],[19.821635,41.317514],[19.819714,41.323665],[19.818688,41.328864],[19.816321,41.328939],[19.785071,41.339831],[19.777848,41.342592],[19.776552,41.343732],[19.770703,41.35183],[19.774671,41.354995],[19.77213,41.360014],[19.771561,41.363958],[19.758398,41.387195],[19.748623,41.404218],[19.744454,41.410036],[19.736189,41.431008],[19.727719,41.451823],[19.72219,41.466247],[19.721112,41.468209],[19.712386,41.478707],[19.700629,41.496744],[19.694974,41.506996],[19.67489,41.541182],[19.67256,41.545528],[19.671911,41.548767],[19.672376,41.554731],[19.674735,41.569366],[19.674672,41.575825],[19.668609,41.597086],[19.667946,41.600515],[19.66805,41.605829],[19.671026,41.636648],[19.672721,41.65937],[19.674028,41.672836],[19.673437,41.678513],[19.663605,41.719094],[19.663059,41.720563],[19.642269,41.753824],[19.637236,41.760821],[19.628619,41.773887],[19.629093,41.774745],[19.641208,41.780378],[19.638813,41.791514],[19.636657,41.794444],[19.634425,41.795902],[19.630411,41.801327],[19.630486,41.802959],[19.637613,41.813831],[19.641595,41.817594],[19.642435,41.821513],[19.638943,41.828368],[19.638569,41.831157],[19.640005,41.834877],[19.64373,41.839736],[19.643659,41.843163],[19.638256,41.861163],[19.637152,41.864294],[19.634143,41.868671],[19.605374,41.903294],[19.596631,41.91337],[19.592981,41.918253],[19.586358,41.923895],[19.576132,41.930662],[19.5713,41.935069],[19.561671,41.945589],[19.556959,41.949103],[19.55329,41.954691],[19.55219,41.961902],[19.550941,41.964936],[19.547039,41.970026],[19.546976,41.974505],[19.544632,41.979682],[19.536681,41.989274],[19.532368,41.993702],[19.527921,41.996642],[19.525216,41.999526],[19.522374,42.006718],[19.517,42.012579],[19.516985,42.018399],[19.518936,42.02505],[19.517647,42.026354],[19.512459,42.028643],[19.51007,42.030494],[19.503869,42.031842],[19.497662,42.038014],[19.49145,42.042855],[19.489821,42.045028],[19.494043,42.049488],[19.494337,42.050944],[19.489243,42.045122],[19.485464,42.046185],[19.481872,42.041017],[19.481217,42.038567],[19.476848,42.032967],[19.470626,42.028163],[19.468404,42.025187],[19.462417,42.024885],[19.457227,42.021015],[19.455454,42.018797],[19.450339,42.01691],[19.446942,42.017165],[19.440502,42.015311],[19.435874,42.015575],[19.430474,42.015046],[19.427386,42.015534],[19.421534,42.010502],[19.418047,42.010435],[19.40747,42.012628],[19.400957,42.015001],[19.397143,42.017755],[19.393908,42.018213],[19.385073,42.018245],[19.381606,42.020387],[19.378392,42.020929],[19.374742,42.017765],[19.364478,42.014211],[19.361975,42.011465],[19.359353,42.010844],[19.356887,42.012642],[19.35447,42.01214],[19.350494,42.009538],[19.348598,42.009281],[19.34491,42.010576],[19.339559,42.010988],[19.336172,42.010513],[19.332966,42.012211],[19.330371,42.009799],[19.32774,42.005384],[19.32513,42.005554],[19.322147,42.007464],[19.318411,42.008221],[19.314156,42.009983],[19.309886,42.009639],[19.308297,42.007628],[19.306395,42.007544],[19.305388,42.0051],[19.302963,42.003616],[19.299124,42.00289],[19.295596,42.00513],[19.29224,42.005791],[19.285274,42.008365],[19.282618,42.009916],[19.278313,42.010359],[19.276495,42.011866],[19.265298,42.015129],[19.262741,42.01409],[19.262026,42.011664],[19.262071,42.00469],[19.265403,42.000018],[19.26146,41.996366],[19.26058,41.990011],[19.261411,41.986102],[19.264252,41.985036],[19.265438,41.982272],[19.261466,41.979783],[19.258899,41.979325],[19.256053,41.976765],[19.256854,41.972873],[19.261024,41.970838],[19.263585,41.968088],[19.267382,41.966528],[19.266255,41.964754],[19.271625,41.960014],[19.272417,41.95663],[19.271344,41.955392],[19.272651,41.951248],[19.270509,41.945404],[19.267824,41.942295],[19.258205,41.939863],[19.256536,41.938236],[19.252089,41.936178],[19.249743,41.93367],[19.24432,41.930717],[19.239735,41.929736],[19.238369,41.928681],[19.233639,41.927329],[19.229468,41.927765],[19.224114,41.932243],[19.218736,41.937479],[19.210193,41.943063],[19.202783,41.946975],[19.195761,41.949716],[19.191661,41.95412],[19.190812,41.958107],[19.191613,41.961911],[19.190222,41.965491],[19.18712,41.967951],[19.180423,41.971377],[19.172062,41.973557],[19.164262,41.977314],[19.161287,41.982094],[19.159172,41.98403],[19.158003,41.986919],[19.156095,41.988761],[19.156096,41.991502],[19.153904,41.993078],[19.153094,41.994996],[19.153619,41.999159],[19.150388,42.00166],[19.149311,42.008044],[19.150745,42.009402],[19.153408,42.009196],[19.155436,42.010469],[19.155316,42.012412],[19.153685,42.014272],[19.155385,42.015766],[19.155649,42.018094],[19.153522,42.019735],[19.155571,42.0241],[19.154938,42.025929],[19.149171,42.02756],[19.146455,42.029563],[19.150741,42.032981],[19.150714,42.033936],[19.14618,42.037027],[19.144414,42.039692],[19.144264,42.041608],[19.142139,42.045156],[19.138629,42.047484],[19.136705,42.047897],[19.129174,42.051252],[19.126079,42.053267],[19.125035,42.054996],[19.13007,42.058638],[19.130043,42.060152],[19.126926,42.062717],[19.126627,42.065191],[19.12744,42.068687],[19.124695,42.076022],[19.126223,42.080355],[19.125495,42.084757],[19.121274,42.088092],[19.114667,42.089469],[19.112508,42.090479],[19.111662,42.09231],[19.099203,42.093664],[19.098334,42.094829],[19.098606,42.104777],[19.097274,42.10692],[19.090688,42.10689],[19.088928,42.110066],[19.083397,42.113688],[19.074693,42.117924],[19.070875,42.1207],[19.063454,42.123735],[19.064896,42.127464],[19.063318,42.129622],[19.063263,42.136029],[19.059681,42.137217],[19.055159,42.136991],[19.050504,42.13881],[19.045407,42.142869],[19.042887,42.14582],[19.040522,42.147097],[19.039259,42.150385],[19.033042,42.153502],[19.030444,42.156889],[19.028069,42.157968],[19.022096,42.15919],[19.020872,42.16138],[19.018281,42.163602],[19.013766,42.165426],[19.010186,42.167605],[19.010378,42.170004],[19.008182,42.172947],[19.006489,42.173525],[19.002323,42.172142],[18.997977,42.175341],[18.995855,42.180477],[18.993467,42.184542],[18.988444,42.186362],[18.989027,42.189979],[18.985855,42.191672],[18.983031,42.194703],[18.982875,42.196312],[18.978688,42.196979],[18.976905,42.198309],[18.972897,42.196945],[18.969616,42.197608],[18.967642,42.199106],[18.960887,42.201784],[18.956748,42.204129],[18.952425,42.203591],[18.949939,42.20543],[18.949059,42.207865],[18.943208,42.211903],[18.940469,42.210633],[18.933671,42.209708],[18.929067,42.208155],[18.927818,42.209445],[18.931838,42.214713],[18.926918,42.21586],[18.922186,42.216167],[18.919865,42.217651],[18.911631,42.220994],[18.910717,42.224105],[18.911774,42.226737],[18.9114,42.228693],[18.90886,42.230181],[18.908742,42.233017],[18.906126,42.23754],[18.905654,42.239498],[18.903556,42.24196],[18.902373,42.24477],[18.902843,42.248155],[18.900481,42.250735],[18.900568,42.254145],[18.897655,42.255885],[18.89714,42.259661],[18.897836,42.261157],[18.896014,42.262654],[18.894407,42.267179],[18.89618,42.268871],[18.890695,42.270974],[18.891386,42.27327],[18.886553,42.276486],[18.883371,42.276537],[18.882478,42.278027],[18.884892,42.28099],[18.880919,42.281867],[18.878178,42.281724],[18.87674,42.283404],[18.871012,42.283429],[18.866843,42.282326],[18.86422,42.283721],[18.860821,42.283553],[18.858822,42.28254],[18.856552,42.283635],[18.853798,42.286336],[18.848388,42.288109],[18.844485,42.288513],[18.841167,42.288043],[18.836674,42.285787],[18.828782,42.28863],[18.821598,42.292559],[18.819151,42.293122],[18.812423,42.303583],[18.808965,42.304946],[18.809571,42.303411],[18.800467,42.308914],[18.793694,42.310641],[18.791954,42.312041],[18.790118,42.315196],[18.785371,42.320763],[18.782239,42.323255],[18.778811,42.327054],[18.774301,42.331126],[18.77286,42.33312],[18.771648,42.339359],[18.769364,42.343938],[18.767511,42.349482],[18.761975,42.355694],[18.760461,42.359961],[18.754752,42.367211],[18.751681,42.375716],[18.748385,42.380644],[18.737712,42.391801],[18.744772,42.395183],[18.748227,42.39887],[18.752542,42.40209],[18.764532,42.414115],[18.76602,42.417514],[18.767897,42.417929],[18.770557,42.42071],[18.771212,42.423282],[18.768465,42.425295],[18.769355,42.428671],[18.769317,42.432576],[18.767251,42.436313],[18.766251,42.435117],[18.767684,42.430208],[18.769091,42.428635],[18.768951,42.433373],[18.765335,42.438827],[18.763593,42.439703],[18.762809,42.442003],[18.765306,42.443594],[18.766451,42.447551],[18.76542,42.450322],[18.76676,42.45495],[18.76501,42.460813],[18.764389,42.4673],[18.765031,42.469707],[18.763976,42.471942],[18.764818,42.475795],[18.763401,42.478137],[18.764465,42.481462],[18.766938,42.485966],[18.76278,42.490518],[18.753484,42.490262],[18.749724,42.488029],[18.739777,42.485195],[18.738194,42.4843],[18.731656,42.483601],[18.730198,42.484438],[18.720961,42.48425],[18.715261,42.48369],[18.708083,42.484045],[18.704878,42.484753],[18.7033,42.486227],[18.698908,42.487169],[18.692928,42.490129],[18.691508,42.49236],[18.69102,42.496265],[18.692682,42.500563],[18.692099,42.501847],[18.694499,42.503427],[18.693605,42.505702],[18.695467,42.507252],[18.696719,42.509903],[18.694788,42.514093],[18.692458,42.51644],[18.68718,42.517144],[18.682782,42.515177],[18.681378,42.512117],[18.679079,42.511058],[18.676576,42.505561],[18.674995,42.504734],[18.672511,42.50533],[18.667963,42.504681],[18.662926,42.500906],[18.661565,42.500711],[18.657606,42.496841],[18.65187,42.494524],[18.649049,42.489177],[18.652228,42.486933],[18.659727,42.486849],[18.661856,42.487217],[18.650088,42.488255],[18.648957,42.489514],[18.65269,42.494884],[18.657913,42.496851],[18.661654,42.500722],[18.663621,42.501177],[18.668316,42.504733],[18.672862,42.505288],[18.674767,42.504733],[18.676932,42.505965],[18.677096,42.507603],[18.679347,42.511248],[18.681505,42.512249],[18.683032,42.51536],[18.688254,42.517291],[18.692628,42.516345],[18.695114,42.513516],[18.696695,42.50964],[18.693638,42.50535],[18.6945,42.503637],[18.69215,42.502242],[18.692599,42.500486],[18.691073,42.496331],[18.691588,42.49229],[18.69303,42.489966],[18.699335,42.487061],[18.702696,42.486343],[18.705653,42.484421],[18.715066,42.483719],[18.721409,42.484288],[18.730177,42.484566],[18.732363,42.4835],[18.738797,42.484448],[18.740306,42.485344],[18.749832,42.488051],[18.753965,42.49038],[18.757638,42.490631],[18.763993,42.490044],[18.766866,42.485863],[18.765273,42.483659],[18.764398,42.479706],[18.763292,42.478333],[18.764588,42.476],[18.763923,42.472039],[18.764908,42.470131],[18.764336,42.467137],[18.76506,42.460315],[18.766687,42.454678],[18.765563,42.4529],[18.76543,42.449754],[18.766468,42.447446],[18.764466,42.442791],[18.762803,42.442039],[18.763618,42.439619],[18.765351,42.438882],[18.767049,42.436276],[18.76772,42.430083],[18.769116,42.428537],[18.768399,42.425161],[18.771177,42.423234],[18.769888,42.420351],[18.767742,42.417795],[18.765878,42.417483],[18.764325,42.413377],[18.751174,42.401041],[18.748203,42.398815],[18.744099,42.394721],[18.737639,42.392098],[18.73368,42.397326],[18.729722,42.401338],[18.723149,42.406941],[18.719765,42.411077],[18.71732,42.417421],[18.715436,42.420092],[18.712337,42.421986],[18.706991,42.424023],[18.704232,42.426032],[18.702338,42.429687],[18.69916,42.431607],[18.699183,42.434354],[18.696056,42.438367],[18.693758,42.439274],[18.689154,42.443211],[18.68836,42.445992],[18.685044,42.450263],[18.683959,42.453837],[18.681579,42.456103],[18.681988,42.459533],[18.683264,42.460624],[18.682605,42.462417],[18.68516,42.465094],[18.683848,42.467356],[18.673272,42.46598],[18.672901,42.462252],[18.675517,42.459903],[18.67187,42.459447],[18.668452,42.457774],[18.661967,42.457198],[18.653956,42.454296],[18.647996,42.450533],[18.643687,42.448583],[18.641529,42.446252],[18.637616,42.444194],[18.628607,42.443402],[18.619339,42.440161],[18.61587,42.440433],[18.610411,42.439112],[18.609083,42.437396],[18.606284,42.438593],[18.598174,42.437942],[18.588149,42.43953],[18.584676,42.441123],[18.58323,42.44347],[18.577999,42.444858],[18.572231,42.451493],[18.567699,42.454914],[18.565391,42.455799],[18.554419,42.454819],[18.551374,42.455699],[18.543742,42.453756],[18.541875,42.454096],[18.53811,42.453123],[18.534066,42.453136],[18.527776,42.455798],[18.526426,42.458802],[18.522583,42.458472],[18.520258,42.461907],[18.515895,42.460968],[18.513229,42.462346],[18.508791,42.461514],[18.504796,42.456172],[18.503074,42.45536],[18.498239,42.455116],[18.494959,42.456766],[18.49179,42.457301],[18.485789,42.462432],[18.484841,42.464419],[18.4801,42.470787],[18.472768,42.47449],[18.465552,42.476166],[18.458455,42.479657],[18.456836,42.481188],[18.449678,42.481791],[18.445875,42.483685],[18.438128,42.486258],[18.43387,42.49084],[18.428446,42.49318],[18.423737,42.495915],[18.42272,42.497367],[18.418004,42.50121],[18.413427,42.504194],[18.405603,42.506352],[18.403002,42.505883],[18.394749,42.50769],[18.38883,42.510155],[18.386065,42.510555],[18.383427,42.51209],[18.378053,42.513573],[18.372985,42.515919],[18.365014,42.51781],[18.358696,42.517354],[18.354132,42.518388],[18.343591,42.522722],[18.339376,42.524937],[18.334718,42.528284],[18.330021,42.53031],[18.320382,42.535242],[18.318453,42.536825],[18.30965,42.542342],[18.30555,42.543652],[18.299511,42.5465],[18.296519,42.548484],[18.288444,42.550514],[18.281311,42.551509],[18.274517,42.553581],[18.26737,42.557786],[18.258717,42.55969],[18.2508,42.5635],[18.245747,42.565248],[18.244921,42.567666],[18.24536,42.570122],[18.240269,42.574396],[18.238431,42.577692],[18.236014,42.579384],[18.234419,42.583387],[18.229976,42.589218],[18.229983,42.593516],[18.230878,42.597488],[18.233074,42.599686],[18.231479,42.602241],[18.232728,42.606683],[18.228195,42.610154],[18.225633,42.613612],[18.219692,42.615085],[18.216676,42.616531],[18.212301,42.620343],[18.210474,42.624127],[18.207193,42.624728],[18.204022,42.623927],[18.201185,42.625383],[18.193852,42.625257],[18.187977,42.623439],[18.179151,42.622479],[18.176554,42.623158],[18.174641,42.625203],[18.170555,42.627352],[18.165003,42.627999],[18.160104,42.629199],[18.151818,42.630173],[18.144666,42.632112],[18.141369,42.633721],[18.13785,42.63335],[18.133394,42.637919],[18.13148,42.638432],[18.127583,42.641322],[18.123319,42.641942],[18.115416,42.644821],[18.108323,42.645461],[18.099495,42.650747],[18.094857,42.655008],[18.090159,42.661717],[18.087426,42.662129],[18.081368,42.666073],[18.078484,42.669377],[18.076075,42.670345],[18.072726,42.669959],[18.070762,42.670829],[18.069592,42.673371],[18.065701,42.6742],[18.056666,42.678471],[18.058588,42.680137],[18.051126,42.685129],[18.053368,42.687868],[18.051066,42.68826],[18.047272,42.691075],[18.045415,42.694161],[18.046642,42.699307],[18.045706,42.701945],[18.04384,42.702535],[18.040272,42.701159],[18.038977,42.699817],[18.039302,42.695321],[18.0416,42.694335],[18.040902,42.692567],[18.036998,42.690536],[18.032844,42.69005],[18.027983,42.691934],[18.023544,42.692506],[18.020716,42.694625],[18.020493,42.696131],[18.016141,42.697437],[18.010558,42.700043],[18.005966,42.699653],[18.00123,42.702157],[17.991605,42.703861],[17.985887,42.706753],[17.979767,42.712001],[17.97956,42.713556],[17.974701,42.715517],[17.971179,42.715051],[17.968711,42.716364],[17.966416,42.718756],[17.967445,42.721431],[17.962667,42.723115],[17.957456,42.728802],[17.952902,42.7311],[17.951548,42.729395],[17.949133,42.729405],[17.945844,42.731273],[17.940406,42.732274],[17.936255,42.735483],[17.931821,42.735873],[17.929924,42.737],[17.92871,42.740897],[17.925119,42.74117],[17.921214,42.743205],[17.919607,42.743178],[17.913693,42.745664],[17.905311,42.746188],[17.900202,42.749567],[17.886624,42.756917],[17.880026,42.761777],[17.875461,42.767208],[17.876227,42.770003],[17.877837,42.770676],[17.88109,42.770181],[17.882061,42.771737],[17.887167,42.773267],[17.887854,42.774856],[17.886965,42.777897],[17.890552,42.779925],[17.890921,42.782522],[17.894559,42.785211],[17.894315,42.787124],[17.892017,42.788258],[17.888,42.788888],[17.886961,42.79037],[17.884326,42.790913],[17.879938,42.789805],[17.876412,42.787189],[17.871731,42.786839],[17.866698,42.787983],[17.859699,42.786039],[17.856808,42.786913],[17.854402,42.789937],[17.854117,42.795556],[17.850379,42.798337],[17.849923,42.800643],[17.846757,42.803453],[17.84109,42.805133],[17.838117,42.80477],[17.836814,42.803507],[17.829989,42.801542],[17.826359,42.802116],[17.82157,42.804006],[17.815312,42.807506],[17.81174,42.806109],[17.807792,42.809444],[17.801962,42.810945],[17.795207,42.810812],[17.791922,42.812609],[17.786132,42.81444],[17.781828,42.814429],[17.778329,42.816495],[17.774,42.818151],[17.766367,42.82257],[17.759207,42.824221],[17.757104,42.82548],[17.75137,42.831059],[17.747363,42.833969],[17.744083,42.83762],[17.737922,42.841054],[17.730237,42.843776],[17.727347,42.846062],[17.725038,42.846675],[17.719632,42.849562],[17.714876,42.853142],[17.706593,42.858607],[17.704128,42.861361],[17.702321,42.86631],[17.700146,42.868137],[17.694377,42.867807],[17.688847,42.869614],[17.683013,42.872444],[17.670625,42.87753],[17.661206,42.882499],[17.653391,42.887643],[17.650617,42.890297],[17.64799,42.891048],[17.646202,42.893509],[17.645708,42.896003],[17.642262,42.899398],[17.640317,42.899822],[17.640123,42.905576],[17.628198,42.911813],[17.624267,42.917024],[17.626812,42.918962],[17.623743,42.91994],[17.621149,42.919586],[17.61645,42.921951],[17.61677,42.924647],[17.613746,42.927281],[17.611675,42.927964],[17.610651,42.929699],[17.608241,42.930093],[17.602066,42.929519],[17.595751,42.930918],[17.591171,42.934256],[17.585019,42.935129],[17.582439,42.936948],[17.580698,42.939551],[17.57828,42.940448],[17.578028,42.943717],[17.574516,42.942283],[17.56622,42.941876],[17.564849,42.943679],[17.564885,42.946091],[17.562436,42.947114],[17.560461,42.943146],[17.556773,42.942239],[17.553575,42.94336],[17.550388,42.943052],[17.544757,42.945963],[17.541528,42.945442],[17.534207,42.947922],[17.531834,42.950299],[17.526716,42.957033],[17.518032,42.964075],[17.517969,42.966699],[17.516084,42.970477],[17.517668,42.971273],[17.520471,42.970058],[17.526697,42.969878],[17.533145,42.967837],[17.535494,42.968546],[17.534196,42.972045],[17.535243,42.974056],[17.534505,42.975934],[17.535873,42.977838],[17.538899,42.979592],[17.541225,42.979944],[17.547222,42.984141],[17.545178,42.987225],[17.545778,42.990579],[17.544587,42.992615],[17.541366,42.994675],[17.541272,42.995713],[17.547798,42.998488],[17.54921,42.998495],[17.552083,43.000853],[17.550417,43.006866],[17.551457,43.017602],[17.551386,43.02975],[17.550581,43.032164],[17.547322,43.035981],[17.542084,43.037681],[17.534655,43.039371],[17.52609,43.042512],[17.519311,43.044171],[17.515156,43.044302],[17.505144,43.043162],[17.497519,43.0412],[17.495554,43.040155],[17.490345,43.035484],[17.488677,43.034678],[17.486488,43.035505],[17.481689,43.044914],[17.478046,43.050616],[17.473005,43.053436],[17.462824,43.054568],[17.460274,43.052196],[17.456583,43.051984],[17.453322,43.05269],[17.449664,43.055023],[17.446842,43.054325],[17.444778,43.055551],[17.444999,43.060529],[17.440523,43.064397],[17.435869,43.064633],[17.431218,43.067641],[17.433774,43.067747],[17.436781,43.071144],[17.437002,43.072675],[17.440175,43.074854],[17.44296,43.0753],[17.443928,43.077066],[17.443513,43.080268],[17.445768,43.082199],[17.445199,43.083665],[17.448369,43.087691],[17.448004,43.091789],[17.45117,43.093258],[17.448501,43.097671],[17.445497,43.100082],[17.44402,43.099907],[17.442845,43.101761],[17.445651,43.103515],[17.443711,43.105685],[17.443848,43.107059],[17.446918,43.108269],[17.445976,43.113056],[17.443173,43.116836],[17.438413,43.11974],[17.436628,43.11978],[17.436114,43.123111],[17.437399,43.12488],[17.436683,43.127725],[17.437026,43.1309],[17.435648,43.134527],[17.429216,43.138291],[17.426322,43.139237],[17.420671,43.142167],[17.417559,43.144819],[17.415296,43.148808],[17.41458,43.152711],[17.416496,43.156208],[17.415754,43.161591],[17.412402,43.163516],[17.406107,43.164213],[17.403396,43.162453],[17.400827,43.163465],[17.395618,43.163057],[17.393593,43.160967],[17.38887,43.163263],[17.389296,43.166639],[17.385468,43.167746],[17.384031,43.170391],[17.386185,43.175117],[17.389501,43.174782],[17.386221,43.176292],[17.381719,43.176742],[17.383809,43.177952],[17.382244,43.178877],[17.383099,43.182864],[17.384655,43.184812],[17.383468,43.186717],[17.379909,43.189309],[17.380104,43.192845],[17.379129,43.193121],[17.377983,43.190184],[17.371143,43.191755],[17.352768,43.1927],[17.334769,43.194787],[17.330273,43.196077],[17.325388,43.199303],[17.321635,43.201075],[17.313226,43.204203],[17.305759,43.205948],[17.299291,43.206138],[17.294131,43.205455],[17.288591,43.205444],[17.284705,43.206281],[17.278754,43.20909],[17.271811,43.21175],[17.267667,43.214279],[17.263727,43.218345],[17.260118,43.22093],[17.25228,43.22381],[17.243054,43.224425],[17.239702,43.225128],[17.235655,43.227588],[17.23395,43.230546],[17.233859,43.233094],[17.234886,43.236891],[17.234655,43.240751],[17.231334,43.24601],[17.226972,43.249226],[17.223369,43.252948],[17.221757,43.256127],[17.220589,43.263625],[17.219342,43.266859],[17.215601,43.272366],[17.212812,43.278083],[17.208518,43.282701],[17.203735,43.285671],[17.199902,43.289252],[17.196743,43.293181],[17.193076,43.298922],[17.187917,43.308673],[17.180934,43.315885],[17.170811,43.323341],[17.16621,43.320942],[17.167272,43.320027],[17.171141,43.323781],[17.168437,43.324711],[17.165943,43.327054],[17.162637,43.331549],[17.159046,43.334653],[17.154671,43.336855],[17.147188,43.338548],[17.142766,43.340033],[17.138789,43.342312],[17.134242,43.34652],[17.129113,43.349482],[17.124861,43.350597],[17.11725,43.351249],[17.112252,43.353214],[17.107221,43.356787],[17.0972,43.362605],[17.09447,43.364585],[17.091585,43.368295],[17.090145,43.371973],[17.08805,43.374923],[17.084779,43.377294],[17.07493,43.381428],[17.063099,43.387231],[17.047529,43.393007],[17.037779,43.397612],[17.034314,43.400011],[17.029875,43.404119],[17.02581,43.408853],[17.022025,43.411939],[17.01233,43.417994],[17.006088,43.420694],[17.0025,43.42271],[16.997387,43.423549],[16.988977,43.422149],[16.979774,43.423904],[16.970588,43.424664],[16.965004,43.426173],[16.955584,43.427186],[16.948748,43.42908],[16.942017,43.433121],[16.938011,43.434533],[16.929784,43.436614],[16.926623,43.437943],[16.921178,43.441237],[16.917718,43.442759],[16.911346,43.444003],[16.904313,43.443835],[16.898122,43.445779],[16.891456,43.450709],[16.883528,43.453572],[16.868663,43.456304],[16.864395,43.457809],[16.856398,43.462251],[16.844881,43.464555],[16.840599,43.467616],[16.838417,43.47125],[16.827998,43.477999],[16.821683,43.479414],[16.81296,43.479131],[16.806294,43.481076],[16.802607,43.483784],[16.799456,43.488807],[16.795901,43.491463],[16.790838,43.492715],[16.78385,43.492999],[16.779225,43.494598],[16.775805,43.497227],[16.766618,43.507487],[16.761724,43.510285],[16.757658,43.511305],[16.745729,43.512791],[16.741116,43.514516],[16.738277,43.517583],[16.737002,43.522343],[16.731856,43.52918],[16.72709,43.531974],[16.722048,43.536533],[16.718465,43.538936],[16.715279,43.543124],[16.709972,43.547768],[16.7083,43.550463],[16.70462,43.553069],[16.699157,43.554889],[16.693461,43.559771],[16.687183,43.563441],[16.682257,43.567308],[16.677037,43.570675],[16.673708,43.576018],[16.660051,43.581851],[16.657298,43.582402],[16.651755,43.58204],[16.646912,43.58263],[16.64073,43.586019],[16.637573,43.587182],[16.633518,43.587702],[16.630164,43.588845],[16.627269,43.591404],[16.624277,43.599341],[16.621389,43.601964],[16.617735,43.603195],[16.612997,43.60314],[16.599203,43.601398],[16.588284,43.601602],[16.580232,43.601298],[16.547141,43.597928],[16.536637,43.597399],[16.524599,43.597326],[16.5146,43.595776],[16.507798,43.595967],[16.496548,43.597615],[16.481423,43.592743],[16.475823,43.590569],[16.456182,43.586655],[16.450313,43.586715],[16.436186,43.589144],[16.430799,43.589724],[16.423065,43.589464],[16.415555,43.588357],[16.40867,43.588806],[16.380955,43.59595],[16.376396,43.596975],[16.371592,43.597398],[16.366582,43.597128],[16.359515,43.595706],[16.354549,43.595219],[16.350059,43.595489],[16.34522,43.59659],[16.336498,43.600896],[16.33219,43.602085],[16.325477,43.60235],[16.316584,43.603581],[16.312795,43.604914],[16.307772,43.608075],[16.301872,43.610034],[16.285752,43.61354],[16.280422,43.61531],[16.273379,43.618372],[16.268574,43.619027],[16.252637,43.618504],[16.248696,43.618925],[16.243541,43.621094],[16.238882,43.624943],[16.22951,43.630611],[16.220548,43.63315],[16.216303,43.634676],[16.212503,43.636745],[16.201807,43.645045],[16.19967,43.647987],[16.198055,43.652297],[16.193488,43.657496],[16.182761,43.662023],[16.176131,43.662982],[16.171051,43.664692],[16.167821,43.666534],[16.161041,43.671946],[16.15516,43.675274],[16.149035,43.677682],[16.144848,43.678851],[16.135567,43.680491],[16.123433,43.683018],[16.111747,43.683754],[16.104184,43.683359],[16.097873,43.682489],[16.09263,43.682283],[16.085451,43.683168],[16.076889,43.682452],[16.057637,43.683812],[16.05374,43.684452],[16.047769,43.686207],[16.043827,43.688035],[16.036586,43.69238],[16.03109,43.694504],[16.020383,43.697541],[16.01122,43.70257],[15.996039,43.707855],[15.991878,43.71005],[15.98947,43.712913],[15.986295,43.719401],[15.984606,43.721921],[15.978703,43.726881],[15.968803,43.736887],[15.965799,43.741086],[15.951596,43.750896],[15.944497,43.754307],[15.93618,43.761224],[15.932388,43.767952],[15.926076,43.772769],[15.922488,43.778312],[15.919678,43.781468],[15.918335,43.786605],[15.919458,43.791316],[15.917398,43.796843],[15.917103,43.799269],[15.917973,43.804213],[15.913083,43.813958],[15.911393,43.816222],[15.896995,43.828931],[15.881265,43.840878],[15.876133,43.844211],[15.867152,43.848956],[15.86095,43.851597],[15.851606,43.854795],[15.845848,43.85632],[15.83593,43.858415],[15.827854,43.860628],[15.819639,43.863923],[15.814942,43.866438],[15.808958,43.870412],[15.805005,43.873725],[15.785176,43.893391],[15.78165,43.896627],[15.773883,43.901302],[15.763712,43.905061],[15.755867,43.908865],[15.751377,43.911655],[15.742968,43.917712],[15.735079,43.921911],[15.726305,43.925489],[15.715438,43.930829],[15.708408,43.935243],[15.697646,43.943411],[15.687714,43.949848],[15.681078,43.953245],[15.670326,43.957897],[15.662906,43.96146],[15.655807,43.965556],[15.648385,43.970808],[15.630906,43.985345],[15.622614,43.990989],[15.615727,43.994805],[15.591967,44.006829],[15.586208,44.010253],[15.578201,44.016238],[15.573337,44.020795],[15.569376,44.025265],[15.564399,44.031631],[15.557928,44.037852],[15.550715,44.043323],[15.544624,44.051373],[15.54049,44.055551],[15.532475,44.060755],[15.527187,44.064716],[15.509091,44.07993],[15.503845,44.083914],[15.498286,44.087369],[15.493329,44.089922],[15.486242,44.092884],[15.477552,44.095986],[15.468822,44.099932],[15.456977,44.107342],[15.445619,44.113947],[15.439633,44.118447],[15.430666,44.123659],[15.425988,44.12742],[15.42167,44.133753],[15.420317,44.139094],[15.42094,44.14929],[15.420435,44.15464],[15.419423,44.158991],[15.419794,44.164971],[15.421822,44.169121],[15.427925,44.176499],[15.432886,44.186749],[15.435842,44.191023],[15.439914,44.195734],[15.443273,44.201291],[15.445328,44.207826],[15.447529,44.211818],[15.451393,44.215393],[15.457517,44.21844],[15.465236,44.21981],[15.471014,44.219531],[15.480667,44.217196],[15.484081,44.216801],[15.490539,44.216979],[15.498179,44.218899],[15.50642,44.223908],[15.508459,44.225771],[15.512777,44.232885],[15.515779,44.234838],[15.519543,44.236099],[15.547275,44.24192],[15.550666,44.242066],[15.561278,44.24051],[15.572358,44.239908],[15.579534,44.241131],[15.582566,44.241027],[15.591259,44.239424],[15.599709,44.238416],[15.604654,44.238603],[15.607626,44.239878],[15.609707,44.242493],[15.609033,44.246424],[15.605081,44.249395],[15.600225,44.254688],[15.597107,44.256109],[15.590179,44.258163],[15.587965,44.260645],[15.588624,44.26276],[15.593433,44.264092],[15.600086,44.259611],[15.605416,44.257035],[15.606726,44.253416],[15.608294,44.251618],[15.617833,44.249935],[15.621989,44.249933],[15.628899,44.248886],[15.632829,44.249072],[15.645989,44.253409],[15.649427,44.25547],[15.677931,44.304576],[15.677977,44.312582],[15.676777,44.318226],[15.67382,44.325208],[15.671282,44.328621],[15.667269,44.330968],[15.659176,44.332884],[15.656424,44.33395],[15.652711,44.336532],[15.646934,44.343605],[15.643757,44.348997],[15.640674,44.357221],[15.638195,44.366138],[15.633135,44.374758],[15.631018,44.380763],[15.630645,44.384556],[15.631438,44.390334],[15.632767,44.394174],[15.637301,44.403021],[15.638788,44.409061],[15.638382,44.416619],[15.636323,44.422356],[15.633045,44.427551],[15.630067,44.430845],[15.621954,44.438643],[15.617649,44.444024],[15.613023,44.451158],[15.609966,44.455022],[15.601943,44.462738],[15.596269,44.466873],[15.589834,44.470704],[15.580365,44.475019],[15.570255,44.478314],[15.562862,44.480103],[15.555735,44.482418],[15.550978,44.48455],[15.543991,44.488833],[15.540298,44.491885],[15.534352,44.498401],[15.528969,44.50327],[15.520824,44.50847],[15.515754,44.510836],[15.505834,44.51411],[15.498067,44.515584],[15.486711,44.516474],[15.478959,44.517397],[15.468563,44.519927],[15.461431,44.522605],[15.451943,44.527766],[15.445035,44.533203],[15.441476,44.536918],[15.437853,44.541847],[15.42923,44.558028],[15.427615,44.562442],[15.426675,44.56977],[15.428129,44.577849],[15.430802,44.583573],[15.434148,44.588624],[15.437133,44.594358],[15.439754,44.60348],[15.440192,44.607697],[15.439778,44.613635],[15.437986,44.621264],[15.438252,44.625159],[15.439893,44.63247],[15.439014,44.637035],[15.434918,44.644697],[15.433924,44.650071],[15.431576,44.653299],[15.428485,44.656238],[15.426026,44.659668],[15.423116,44.665393],[15.418886,44.670625],[15.4136,44.675497],[15.408253,44.682516],[15.404081,44.690342],[15.400271,44.695563],[15.393299,44.703043],[15.389222,44.709131],[15.386809,44.716595],[15.386068,44.723038],[15.384572,44.728508],[15.379631,44.737238],[15.377887,44.744577],[15.376675,44.747814],[15.374515,44.751074],[15.371491,44.754075],[15.367288,44.75685],[15.360349,44.760098],[15.357948,44.761935],[15.352358,44.768085],[15.346205,44.772541],[15.339128,44.784933],[15.334772,44.787164],[15.327553,44.789387],[15.32203,44.794298],[15.317691,44.796878],[15.312374,44.798417],[15.307525,44.801239],[15.303204,44.80649],[15.299898,44.809461],[15.272563,44.819083],[15.267363,44.821279],[15.265044,44.822938],[15.261458,44.828465],[15.259854,44.83007],[15.253076,44.833848],[15.248878,44.836901],[15.243883,44.8421],[15.238419,44.846068],[15.233078,44.848943],[15.221035,44.85662],[15.213427,44.860255],[15.208824,44.864944],[15.207712,44.867926],[15.20715,44.874269],[15.204675,44.878348],[15.202236,44.881003],[15.196952,44.885159],[15.193271,44.890777],[15.191435,44.892607],[15.185649,44.896331],[15.182071,44.902119],[15.178574,44.904843],[15.175275,44.910062],[15.171413,44.913438],[15.167037,44.922316],[15.167363,44.92659],[15.171485,44.931893],[15.17206,44.933747],[15.171462,44.937374],[15.168129,44.940768],[15.164305,44.943281],[15.160246,44.946859],[15.155446,44.948598],[15.147716,44.9491],[15.142216,44.950474],[15.13198,44.954734],[15.127069,44.956038],[15.112556,44.958303],[15.106697,44.958775],[15.100829,44.960061],[15.096372,44.962366],[15.093285,44.965366],[15.091341,44.970018],[15.091438,44.973009],[15.096116,44.988376],[15.099905,44.992372],[15.106736,44.995679],[15.110912,44.998311],[15.116349,45.000593],[15.122965,45.004743],[15.129765,45.007049],[15.133172,45.009062],[15.136815,45.012128],[15.149573,45.017561],[15.15361,45.020513],[15.156909,45.025549],[15.162848,45.030111],[15.172165,45.034049],[15.175434,45.03656],[15.177936,45.04134],[15.178059,45.044566],[15.179381,45.048062],[15.183742,45.051453],[15.189061,45.05282],[15.195702,45.053296],[15.200608,45.055614],[15.206763,45.061767],[15.207985,45.064582],[15.20772,45.067533],[15.205778,45.074115],[15.246797,45.116582],[15.243893,45.122501],[15.243409,45.125634],[15.245521,45.129319],[15.247836,45.130817],[15.25663,45.133784],[15.262656,45.138466],[15.268304,45.140401],[15.272369,45.143225],[15.273701,45.145469],[15.273777,45.149226],[15.272402,45.153154],[15.272328,45.155756],[15.274103,45.163856],[15.277437,45.169322],[15.278511,45.173205],[15.278079,45.175604],[15.275791,45.179054],[15.270007,45.184066],[15.2686,45.18608],[15.267793,45.190506],[15.26517,45.196218],[15.265556,45.200826],[15.264912,45.204728],[15.259612,45.212117],[15.258701,45.216258],[15.259099,45.218867],[15.261039,45.222647],[15.264251,45.226279],[15.266629,45.229913],[15.268002,45.234288],[15.268814,45.240464],[15.270744,45.244718],[15.275125,45.250197],[15.276334,45.252547],[15.276733,45.256458],[15.274969,45.260584],[15.270927,45.264716],[15.269752,45.266879],[15.26978,45.270798],[15.270582,45.272533],[15.275197,45.278418],[15.275867,45.282594],[15.274165,45.289145],[15.275403,45.293499],[15.278056,45.297502],[15.27901,45.30138],[15.279088,45.305947],[15.281069,45.311459],[15.283245,45.31495],[15.283937,45.319468],[15.281236,45.325666],[15.277417,45.330912],[15.275539,45.33497],[15.274924,45.340809],[15.277916,45.350989],[15.277757,45.354859],[15.27503,45.360863],[15.271912,45.364796],[15.270139,45.369084],[15.269668,45.373322],[15.268425,45.377],[15.26685,45.379143],[15.26149,45.384236],[15.259343,45.388455],[15.259003,45.394028],[15.256578,45.397739],[15.252176,45.399887],[15.249916,45.401699],[15.24934,45.403629],[15.250456,45.406116],[15.255522,45.408039],[15.260958,45.40784],[15.272052,45.409183],[15.27653,45.410748],[15.283409,45.415299],[15.288589,45.417496],[15.29553,45.421445],[15.30122,45.423919],[15.316821,45.429741],[15.322071,45.431983],[15.333264,45.438123],[15.338342,45.440402],[15.343869,45.442077],[15.349933,45.443181],[15.359539,45.444435],[15.367857,45.447241],[15.372129,45.450211],[15.376703,45.456073],[15.380176,45.459504],[15.385163,45.462066],[15.39042,45.463342],[15.403113,45.465187],[15.408154,45.467015],[15.414859,45.47151],[15.423243,45.474832],[15.433678,45.482691],[15.441074,45.48646],[15.445464,45.489835],[15.44801,45.496167],[15.449659,45.498096],[15.461338,45.505204],[15.468757,45.511308],[15.473598,45.513906],[15.479371,45.515496],[15.485855,45.51596],[15.490811,45.515437],[15.504928,45.510918],[15.510737,45.509867],[15.516721,45.509633],[15.523085,45.510054],[15.535432,45.511553],[15.544384,45.513198],[15.549605,45.514858],[15.554944,45.517714],[15.584657,45.539008],[15.595163,45.547134],[15.601416,45.552621],[15.60685,45.558029],[15.61655,45.569194],[15.623284,45.579258],[15.626722,45.585429],[15.633052,45.597813],[15.638103,45.605751],[15.645458,45.615378],[15.6526,45.623301],[15.660463,45.630765],[15.670261,45.638769],[15.68386,45.648095],[15.691054,45.652289],[15.702912,45.658448],[15.708656,45.660969],[15.710048,45.660765],[15.714093,45.663364],[15.727876,45.668486],[15.737763,45.671628],[15.750034,45.674857],[15.757221,45.676404],[15.798749,45.684864],[15.813936,45.688998],[15.82388,45.692622],[15.833309,45.696788],[15.840308,45.700432],[15.84642,45.704037],[15.852835,45.708354],[15.860109,45.714071],[15.866878,45.72062],[15.871071,45.725651],[15.874507,45.730663],[15.878306,45.737767],[15.880904,45.743954],[15.884305,45.74908],[15.891814,45.755099],[15.895786,45.75673],[15.897746,45.761228],[15.894929,45.764139],[15.889313,45.768818],[15.880471,45.774225],[15.860327,45.784777],[15.850408,45.788343],[15.848789,45.789651],[15.84543,45.795326],[15.842288,45.798991],[15.829056,45.811483],[15.825695,45.815128],[15.822886,45.819197],[15.819962,45.82627],[15.819154,45.834235],[15.820384,45.840588],[15.822761,45.845945],[15.829641,45.857461],[15.831295,45.861269],[15.831967,45.865913],[15.830435,45.874012],[15.82926,45.876861],[15.827397,45.884999],[15.825784,45.889307],[15.822272,45.896717],[15.820995,45.900918],[15.820627,45.907006],[15.822165,45.913615],[15.825916,45.921358],[15.828171,45.927716],[15.830649,45.941678],[15.832717,45.947684],[15.835025,45.95163],[15.837963,45.955351],[15.84728,45.964141],[15.852463,45.971261],[15.863492,45.997311],[15.864717,45.999394],[15.86815,46.002641],[15.870863,46.004217],[15.878289,46.007121],[15.903344,46.019165],[15.912848,46.024503],[15.923072,46.031495],[15.924795,46.033398],[15.926848,46.039022],[15.925967,46.04351],[15.919912,46.053235],[15.919065,46.056918],[15.919726,46.062845],[15.918902,46.071314],[15.916867,46.077669],[15.91462,46.081818],[15.909214,46.08886],[15.902309,46.096181],[15.896699,46.103495],[15.893365,46.109768],[15.892306,46.113448],[15.891041,46.122169],[15.889534,46.126008],[15.887703,46.128304],[15.883351,46.130859],[15.873515,46.133062],[15.868553,46.136813],[15.863373,46.13871],[15.860672,46.140437],[15.85911,46.144188],[15.855718,46.149718],[15.854201,46.155666],[15.854454,46.161446],[15.849484,46.180141],[15.846282,46.183869],[15.845832,46.192585],[15.844064,46.196424],[15.844171,46.198941],[15.845549,46.200945],[15.845497,46.204961],[15.84661,46.209206],[15.846049,46.211594],[15.842181,46.214883],[15.841694,46.216811],[15.84383,46.224748],[15.844882,46.227177],[15.845109,46.232967],[15.847106,46.238674],[15.846675,46.242157],[15.847302,46.244098],[15.852835,46.249672],[15.857456,46.258462],[15.860854,46.260782],[15.865525,46.261431],[15.869198,46.264197],[15.869364,46.267126],[15.866761,46.272645],[15.866941,46.274562],[15.864451,46.277089],[15.854112,46.297668],[15.855514,46.30141],[15.860791,46.305128],[15.866495,46.309922],[15.870911,46.31525],[15.874423,46.317732],[15.877489,46.320767],[15.879468,46.325799],[15.878908,46.328929],[15.876534,46.334442],[15.876149,46.338553],[15.874744,46.341389],[15.870016,46.346679],[15.86833,46.350864],[15.868008,46.360725],[15.866179,46.371293],[15.865591,46.383646],[15.864498,46.386233],[15.861497,46.389064],[15.856338,46.392564],[15.848357,46.396748],[15.831118,46.400872],[15.827178,46.402481],[15.818223,46.407207],[15.8088,46.413892],[15.802142,46.420302],[15.797731,46.42575],[15.74461,46.456863],[15.738667,46.457693],[15.728895,46.458235],[15.721435,46.458205],[15.715581,46.458611],[15.708111,46.459884],[15.701511,46.461768],[15.692459,46.465595],[15.674324,46.475077],[15.669039,46.477509],[15.661979,46.479565],[15.65926,46.483283],[15.6618,46.487192],[15.668228,46.492221],[15.670415,46.496288],[15.670412,46.498595],[15.668758,46.505022],[15.669831,46.510772],[15.672799,46.514389],[15.679809,46.518344],[15.688172,46.521339],[15.694797,46.524988],[15.696862,46.526674],[15.699731,46.530643],[15.700618,46.534563],[15.700327,46.537139],[15.698777,46.540446],[15.694786,46.545417],[15.69233,46.5494],[15.686244,46.561863],[15.685787,46.563669],[15.686948,46.569457],[15.689774,46.577592],[15.689756,46.58136],[15.68747,46.586681],[15.683981,46.590187],[15.679861,46.592749],[15.671717,46.59592],[15.667548,46.598195],[15.664128,46.601407],[15.663166,46.603519],[15.662727,46.611305],[15.661735,46.614563],[15.658561,46.620914],[15.657851,46.62502],[15.657839,46.630539],[15.657024,46.634178],[15.655054,46.637687],[15.651959,46.641711],[15.64998,46.64534],[15.649008,46.649073],[15.648083,46.655895],[15.64529,46.664024],[15.644876,46.666956],[15.645829,46.672383],[15.647608,46.675937],[15.651315,46.681162],[15.650625,46.685933],[15.648541,46.687271],[15.639991,46.697115],[15.638352,46.701188],[15.63955,46.705664],[15.644727,46.711654],[15.646989,46.715538],[15.647955,46.71999],[15.646532,46.726447],[15.643598,46.730522],[15.639762,46.733574],[15.634436,46.736163],[15.622145,46.738936],[15.616212,46.741297],[15.608796,46.745173],[15.602321,46.749669],[15.598268,46.753292],[15.594997,46.75694],[15.587725,46.766979],[15.582977,46.772704],[15.578981,46.778255],[15.575903,46.784238],[15.572925,46.792851],[15.56951,46.804716],[15.56517,46.815315],[15.559623,46.82333],[15.552571,46.830314],[15.548251,46.833657],[15.538784,46.839664],[15.501796,46.860432],[15.4955,46.864725],[15.482422,46.875098],[15.476161,46.881126],[15.473572,46.885438],[15.472224,46.892808],[15.472443,46.904503],[15.472158,46.912064],[15.471131,46.91751],[15.468477,46.92485],[15.466464,46.928575],[15.462163,46.934813],[15.457435,46.940428],[15.433255,46.967821],[15.421901,46.980517],[15.414016,46.990095],[15.409765,46.997709],[15.407694,47.005675],[15.407505,47.010841],[15.408507,47.016633],[15.409889,47.020533],[15.413168,47.027649],[15.413622,47.031689],[15.412198,47.032825],[15.406875,47.033219],[15.378439,47.108851],[15.376085,47.111772],[15.371204,47.119282],[15.368332,47.123081],[15.362099,47.128686],[15.354767,47.13703],[15.350826,47.139365],[15.347401,47.140503],[15.334745,47.143808],[15.330166,47.147025],[15.325876,47.154348],[15.325292,47.158044],[15.326135,47.160497],[15.331059,47.165866],[15.332639,47.170125],[15.331296,47.179916],[15.331512,47.186879],[15.323057,47.202555],[15.320787,47.20424],[15.313173,47.207455],[15.310801,47.209229],[15.304902,47.215799],[15.300549,47.218606],[15.294821,47.21983],[15.292179,47.219799],[15.283875,47.218224],[15.278364,47.216678],[15.272688,47.216033],[15.260724,47.215977],[15.253712,47.216768],[15.244858,47.219071],[15.231406,47.223766],[15.220304,47.228359],[15.215879,47.230804],[15.211217,47.234243],[15.205781,47.236945],[15.200376,47.238738],[15.195719,47.241895],[15.189894,47.24391],[15.183402,47.244427],[15.174854,47.246523],[15.16835,47.247342],[15.164298,47.248335],[15.159213,47.248626],[15.073112,47.297573],[15.065602,47.301782],[15.059322,47.307339],[15.05302,47.314936],[15.047811,47.317915],[15.0358,47.320485],[15.032065,47.322105],[15.028174,47.325124],[15.023031,47.331513],[15.020441,47.333168],[15.011774,47.335726],[15.009056,47.337495],[15.007148,47.341494],[15.007393,47.345511],[15.006149,47.349561],[15.001813,47.355559],[14.998488,47.363455],[14.993604,47.368738],[14.990773,47.370451],[14.984889,47.372549],[14.978429,47.373398],[14.971698,47.373499],[14.965075,47.374249],[14.958894,47.375511],[14.950379,47.377895],[14.941434,47.381523],[14.93474,47.382983],[14.924844,47.384328],[14.912521,47.387344],[14.908822,47.387497],[14.894917,47.386553],[14.888592,47.387383],[14.876315,47.391149],[14.869853,47.392021],[14.856253,47.394669],[14.850097,47.395248],[14.836749,47.394682],[14.830351,47.394767],[14.820259,47.396281],[14.806719,47.396638],[14.799696,47.397538],[14.793773,47.398955],[14.785221,47.402486],[14.778156,47.404955],[14.773917,47.40764],[14.77056,47.412096],[14.760149,47.420525],[14.755055,47.423334],[14.742651,47.427757],[14.738974,47.42856],[14.732765,47.428499],[14.723983,47.426733],[14.717464,47.42772],[14.707181,47.43203],[14.698929,47.436163],[14.666873,47.453346],[14.660152,47.454999],[14.655947,47.458167],[14.651742,47.463592],[14.647167,47.466463],[14.640322,47.468245],[14.626668,47.469676],[14.62004,47.47094],[14.610505,47.473637],[14.603615,47.474295],[14.599623,47.474097],[14.592838,47.472856],[14.588696,47.4726],[14.581796,47.473421],[14.574665,47.475556],[14.565317,47.478817],[14.562032,47.479427],[14.551254,47.479703],[14.537627,47.481515],[14.52855,47.485686],[14.514513,47.488556],[14.508057,47.490502],[14.492158,47.496389],[14.488659,47.497005],[14.478203,47.496661],[14.471147,47.497165],[14.464286,47.499384],[14.456467,47.504407],[14.45123,47.506725],[14.447457,47.507576],[14.433726,47.509416],[14.415931,47.513654],[14.40917,47.514656],[14.394028,47.514974],[14.387789,47.516377],[14.373299,47.522611],[14.370172,47.523407],[14.362729,47.523327],[14.355899,47.522142],[14.35142,47.522556],[14.341158,47.52423],[14.334642,47.525931],[14.328438,47.528431],[14.319927,47.532334],[14.312766,47.533898],[14.308184,47.536984],[14.30661,47.539315],[14.300103,47.550899],[14.300412,47.554298],[14.302519,47.558411],[14.313542,47.572589],[14.31956,47.578498],[14.324049,47.581685],[14.328207,47.583423],[14.341924,47.587251],[14.344254,47.588251],[14.34776,47.591019],[14.329492,47.641564],[14.333932,47.648286],[14.334256,47.652616],[14.33583,47.659173],[14.334758,47.663303],[14.330579,47.670387],[14.326394,47.679758],[14.323673,47.684035],[14.31795,47.690578],[14.316826,47.692804],[14.314685,47.699758],[14.308589,47.708503],[14.305034,47.715926],[14.303144,47.722796],[14.300642,47.727038],[14.298507,47.729267],[14.287297,47.73831],[14.280928,47.740143],[14.273528,47.740173],[14.266166,47.741231],[14.261192,47.744005],[14.258373,47.747516],[14.252358,47.750043],[14.244424,47.751602],[14.213104,47.759469],[14.192393,47.76586],[14.187263,47.767669],[14.177925,47.771738],[14.175669,47.77369],[14.175588,47.777979],[14.174757,47.785988],[14.169597,47.8122],[14.169771,47.816899],[14.168418,47.819297],[14.170467,47.839936],[14.169881,47.844827],[14.164153,47.849761],[14.161184,47.851379],[14.151196,47.862616],[14.145639,47.865999],[14.139409,47.867399],[14.135904,47.866441],[14.124048,47.869799],[14.114929,47.874542],[14.10547,47.892038],[14.102062,47.901343],[14.1011,47.906887],[14.101135,47.912106],[14.101943,47.922414],[14.096625,47.931808],[14.095654,47.936349],[14.096735,47.939228],[14.100631,47.946349],[14.101781,47.951179],[14.101106,47.955685],[14.095833,47.966233],[14.093826,47.972151],[14.092045,47.9852],[14.090763,47.988865],[14.087248,47.994119],[14.075011,48.005523],[14.069989,48.012639],[14.067854,48.017196],[14.060056,48.039013],[14.057979,48.043569],[14.051942,48.051937],[14.045641,48.057666],[14.027808,48.069867],[14.022309,48.073392],[14.020949,48.075534],[14.01956,48.080635],[14.019591,48.085197],[14.022091,48.095057],[14.021505,48.099664],[14.008115,48.120577],[14.00599,48.123072],[14.004998,48.125677],[14.00452,48.130528],[14.001941,48.135633],[13.982597,48.150031],[13.979829,48.154956],[13.978906,48.159395],[13.979422,48.161897],[13.982746,48.16573],[13.991066,48.170838],[13.992562,48.173183],[13.992249,48.175712],[13.990685,48.177841],[13.987968,48.17949],[13.981623,48.180602],[13.97406,48.183839],[13.964531,48.18544],[13.954788,48.188151],[13.944747,48.187982],[13.931761,48.189216],[13.924449,48.189217],[13.91786,48.188083],[13.911297,48.1856],[13.906345,48.182905],[13.897358,48.179406],[13.891124,48.178055],[13.881066,48.177348],[13.874342,48.177816],[13.863111,48.179459],[13.856718,48.179105],[13.846985,48.176482],[13.840402,48.176047],[13.834364,48.177737],[13.826806,48.182121],[13.821089,48.183559],[13.814388,48.18338],[13.805234,48.182009],[13.79482,48.183106],[13.787314,48.182455],[13.777984,48.179442],[13.774078,48.178772],[13.764126,48.178209],[13.749839,48.178315],[13.747704,48.179288],[13.74267,48.178043],[13.732596,48.177393],[13.714268,48.175476],[13.709611,48.175291],[13.703031,48.176307],[13.699646,48.177563],[13.690636,48.183281],[13.684636,48.186519],[13.681486,48.18768],[13.674097,48.189401],[13.670357,48.189837],[13.658705,48.190238],[13.654962,48.190928],[13.648232,48.193504],[13.64582,48.195039],[13.641081,48.199545],[13.637116,48.204495],[13.632572,48.209304],[13.624385,48.215291],[13.609568,48.224174],[13.596311,48.230477],[13.582905,48.235401],[13.573246,48.238147],[13.565786,48.239684],[13.55771,48.240763],[13.53871,48.242857],[13.531034,48.244417],[13.524055,48.246683],[13.518272,48.25019],[13.515715,48.252628],[13.512528,48.257263],[13.50818,48.261591],[13.499694,48.267277],[13.492735,48.273858],[13.489875,48.278437],[13.487397,48.286431],[13.484675,48.291596],[13.480385,48.296317],[13.475259,48.300066],[13.472032,48.301817],[13.464949,48.304639],[13.457217,48.306409],[13.450177,48.307085],[13.441979,48.307316],[13.434048,48.308718],[13.430361,48.310009],[13.424498,48.313247],[13.419723,48.317847],[13.410455,48.329788],[13.407403,48.334389],[13.4063,48.336999],[13.405193,48.34232],[13.405295,48.347401],[13.406773,48.350157],[13.411639,48.354317],[13.414454,48.358546],[13.414799,48.361207],[13.413076,48.369166],[13.414481,48.374478],[13.421671,48.386088],[13.423834,48.390838],[13.425784,48.398084],[13.42819,48.403722],[13.428216,48.407076],[13.426238,48.410637],[13.423875,48.41264],[13.417312,48.415325],[13.406021,48.417606],[13.39816,48.420075],[13.391802,48.422886],[13.385806,48.426456],[13.380791,48.43055],[13.377135,48.435553],[13.375481,48.440565],[13.375891,48.449865],[13.375715,48.456645],[13.374804,48.460894],[13.372596,48.467176],[13.37153,48.471768],[13.371197,48.47694],[13.371877,48.483226],[13.373057,48.487194],[13.377765,48.496165],[13.383969,48.503264],[13.388886,48.508034],[13.393228,48.513289],[13.395619,48.517085],[13.398737,48.524328],[13.39968,48.528526],[13.399996,48.536365],[13.399274,48.541196],[13.396461,48.549193],[13.391652,48.556725],[13.387281,48.561439],[13.382432,48.565676],[13.376627,48.569643],[13.369956,48.573461],[13.365472,48.577237],[13.363931,48.580103],[13.364062,48.585147],[13.36912,48.593529],[13.370809,48.598704],[13.370414,48.60409],[13.367799,48.607881],[13.360707,48.612796],[13.352978,48.618906],[13.348431,48.621331],[13.340734,48.623879],[13.333409,48.625475],[13.327191,48.627386],[13.322449,48.62951],[13.316717,48.632824],[13.311219,48.63463],[13.302018,48.635449],[13.299186,48.636232],[13.294393,48.639069],[13.290623,48.64296],[13.28527,48.647326],[13.282326,48.651412],[13.277165,48.655882],[13.270809,48.659248],[13.268125,48.66138],[13.263766,48.666294],[13.260692,48.668762],[13.254828,48.671809],[13.24497,48.674868],[13.231153,48.676827],[13.224083,48.679158],[13.214624,48.68498],[13.204532,48.688362],[13.198444,48.691432],[13.195239,48.69404],[13.189859,48.700598],[13.186386,48.702808],[13.183036,48.703964],[13.175973,48.705222],[13.171413,48.706629],[13.165967,48.709756],[13.157733,48.717852],[13.151818,48.720829],[13.144788,48.722594],[13.138781,48.725612],[13.1298,48.733065],[13.124293,48.736323],[13.114931,48.740364],[13.107273,48.74289],[13.092642,48.749341],[13.085804,48.751529],[13.07846,48.753176],[13.071542,48.755323],[13.064491,48.758877],[13.05552,48.764231],[13.043283,48.770077],[13.043341,48.771491],[13.041175,48.771053],[13.040907,48.769546],[13.045381,48.766109],[13.041288,48.768276],[13.041979,48.770467],[13.035707,48.773403],[13.025851,48.779216],[13.01843,48.784247],[13.012475,48.787414],[12.997001,48.794623],[12.983367,48.802093],[12.977334,48.80562],[12.967017,48.810615],[12.955315,48.814474],[12.939841,48.818523],[12.931132,48.821454],[12.920058,48.826233],[12.914221,48.82934],[12.908054,48.833152],[12.89306,48.844202],[12.886488,48.848234],[12.878424,48.852215],[12.871066,48.855187],[12.862592,48.857891],[12.855645,48.860478],[12.851031,48.862661],[12.844718,48.866357],[12.83963,48.87039],[12.834444,48.875913],[12.830171,48.881958],[12.825708,48.886819],[12.819832,48.891506],[12.809998,48.897006],[12.802411,48.899906],[12.790952,48.902685],[12.778866,48.904604],[12.775497,48.905829],[12.768568,48.909916],[12.764467,48.911573],[12.753192,48.913724],[12.74667,48.916091],[12.739688,48.919362],[12.732976,48.921428],[12.722883,48.923679],[12.713486,48.927438],[12.705216,48.932502],[12.698782,48.934462],[12.695897,48.934782],[12.683061,48.933959],[12.674159,48.934855],[12.659632,48.938428],[12.646362,48.939956],[12.637805,48.940044],[12.628925,48.94056],[12.616947,48.942474],[12.609946,48.944249],[12.602681,48.945434],[12.595092,48.945522],[12.584394,48.94436],[12.575931,48.944652],[12.570921,48.945594],[12.5641,48.947912],[12.560651,48.949751],[12.551517,48.955669],[12.544642,48.959021],[12.533114,48.96275],[12.519916,48.9658],[12.508773,48.969342],[12.504822,48.970327],[12.491835,48.972769],[12.4771,48.976686],[12.469579,48.979362],[12.458825,48.983714],[12.451443,48.986202],[12.443312,48.988454],[12.435375,48.990138],[12.409126,48.994952],[12.385408,48.999162],[12.374413,49.000177],[12.360893,48.999861],[12.307276,48.994359],[12.292159,48.993605],[12.279774,48.99393],[12.272153,48.993831],[12.239299,48.992006],[12.231898,48.99203],[12.225043,48.992686],[12.217857,48.993933],[12.193197,48.998686],[12.179388,49.000599],[12.170573,49.000669],[12.15812,48.999277],[12.116779,48.993135],[12.113118,48.992695],[12.085844,48.99054],[12.07624,48.99137],[12.06925,48.990648],[12.065014,48.991983],[12.064897,48.993957],[12.06333,48.995649],[12.062831,49.00227],[12.06075,49.007388],[12.061339,49.010628],[12.065553,49.015652],[12.069221,49.021692],[12.070708,49.025882],[12.072454,49.027214],[12.078817,49.029422],[12.088668,49.037006],[12.09262,49.03884],[12.095616,49.04106],[12.096109,49.044699],[12.092489,49.049962],[12.092076,49.052478],[12.092914,49.056175],[12.092077,49.064541],[12.093024,49.068132],[12.095199,49.071204],[12.098838,49.074934],[12.10078,49.0783],[12.101015,49.082182],[12.09915,49.08631],[12.093543,49.094611],[12.093347,49.099525],[12.094517,49.101902],[12.098209,49.106723],[12.108777,49.1254],[12.109005,49.131469],[12.1059,49.139923],[12.105014,49.145495],[12.106514,49.151368],[12.113313,49.160751],[12.114838,49.165302],[12.115483,49.170732],[12.116671,49.173145],[12.122774,49.179629],[12.123885,49.184239],[12.122616,49.18831],[12.117828,49.194728],[12.115597,49.199849],[12.116119,49.205164],[12.118382,49.20819],[12.123579,49.21335],[12.127083,49.218759],[12.130907,49.227376],[12.132344,49.233061],[12.13292,49.238573],[12.13158,49.244626],[12.130176,49.247306],[12.12447,49.255082],[12.12255,49.261015],[12.123686,49.266657],[12.127089,49.271948],[12.138286,49.28381],[12.144267,49.291068],[12.14757,49.296181],[12.150744,49.302453],[12.152719,49.307853],[12.15394,49.312841],[12.15473,49.318714],[12.154489,49.324046],[12.150211,49.338774],[12.150024,49.344512],[12.15272,49.367518],[12.152728,49.370321],[12.151582,49.376068],[12.148345,49.384245],[12.148218,49.387225],[12.149359,49.389877],[12.15156,49.392254],[12.157765,49.396598],[12.160249,49.399105],[12.16298,49.404314],[12.165085,49.413154],[12.16742,49.418711],[12.170539,49.423932],[12.176774,49.431226],[12.185609,49.439965],[12.189393,49.444777],[12.191848,49.449003],[12.193944,49.454478],[12.194984,49.459554],[12.195034,49.464701],[12.193442,49.47276],[12.190242,49.479938],[12.188899,49.484731],[12.189028,49.492988],[12.187359,49.49796],[12.185421,49.500848],[12.181386,49.505053],[12.170094,49.513067],[12.163387,49.519182],[12.158521,49.522858],[12.14698,49.52867],[12.140959,49.532263],[12.135975,49.536664],[12.132045,49.541415],[12.126634,49.549289],[12.123897,49.554755],[12.122039,49.560425],[12.121682,49.564986],[12.122348,49.569151],[12.123934,49.573919],[12.126474,49.578415],[12.132344,49.585136],[12.141047,49.592765],[12.145807,49.597276],[12.149452,49.601676],[12.151929,49.606404],[12.152789,49.609454],[12.153012,49.614476],[12.151963,49.619406],[12.14935,49.627531],[12.148341,49.632435],[12.14769,49.640569],[12.148201,49.648633],[12.147101,49.654053],[12.144442,49.658289],[12.142342,49.663476],[12.134755,49.66923],[12.129368,49.676218],[12.127107,49.681026],[12.127357,49.683498],[12.131765,49.69077],[12.135489,49.700761],[12.138615,49.705899],[12.144705,49.712087],[12.148506,49.717025],[12.151718,49.722199],[12.156249,49.728087],[12.157276,49.731915],[12.154756,49.73897],[12.153622,49.744405],[12.154136,49.752016],[12.15399,49.756166],[12.152029,49.764757],[12.152039,49.767608],[12.154192,49.772263],[12.156629,49.775033],[12.176321,49.794311],[12.179616,49.798363],[12.182211,49.803151],[12.182632,49.805539],[12.181019,49.810323],[12.178278,49.813021],[12.170968,49.81678],[12.168034,49.818811],[12.165795,49.821358],[12.164791,49.824367],[12.165772,49.829149],[12.168409,49.832944],[12.175155,49.841118],[12.176815,49.843874],[12.178632,49.84876],[12.180301,49.859779],[12.182775,49.864712],[12.184836,49.86728],[12.189925,49.87207],[12.196309,49.876614],[12.209463,49.884183],[12.215276,49.88895],[12.218545,49.893236],[12.22002,49.896217],[12.221232,49.901249],[12.221369,49.90429],[12.219854,49.911871],[12.220213,49.914816],[12.226216,49.927461],[12.226463,49.929811],[12.223786,49.940556],[12.222274,49.942932],[12.216345,49.946976],[12.210211,49.949974],[12.196071,49.954039],[12.191743,49.958511],[12.182156,49.966718],[12.175605,49.974729],[12.171158,49.977676],[12.164309,49.979835],[12.157865,49.98034],[12.153613,49.979944],[12.143068,49.977883],[12.139902,49.977837],[12.135838,49.978868],[12.132037,49.981691],[12.130063,49.984633],[12.128492,49.988833],[12.125182,49.993617],[12.11916,49.999141],[12.111023,50.004716],[12.109081,50.00695],[12.108677,50.009151],[12.109552,50.011832],[12.11811,50.021857],[12.119273,50.024763],[12.118374,50.028015],[12.115475,50.030488],[12.107998,50.033864],[12.106284,50.035881],[12.103662,50.046664],[12.103794,50.049437],[12.102913,50.054582],[12.10168,50.057277],[12.09857,50.061494],[12.097478,50.064089],[12.098067,50.066414],[12.102276,50.071379],[12.101865,50.077071],[12.104481,50.082914],[12.103886,50.085297],[12.099754,50.090752],[12.099638,50.096892],[12.094883,50.10247],[12.094236,50.105894],[12.096964,50.112664],[12.096647,50.116138],[12.093544,50.12517],[12.091262,50.128508],[12.090032,50.133259],[12.087755,50.137099],[12.085069,50.139217],[12.08359,50.141832],[12.083706,50.144183],[12.085151,50.146449],[12.091359,50.150109],[12.09858,50.153161],[12.107472,50.159862],[12.108081,50.162972],[12.107342,50.169296],[12.109782,50.173127],[12.118833,50.176519],[12.12193,50.179118],[12.122407,50.181175],[12.121188,50.183863],[12.115507,50.186855],[12.105504,50.189285],[12.102258,50.19135],[12.100779,50.193644],[12.101218,50.197343],[12.107423,50.203052],[12.109181,50.205533],[12.109184,50.208321],[12.10657,50.211751],[12.103184,50.213349],[12.092098,50.215227],[12.087136,50.216464],[12.083553,50.218124],[12.078189,50.222606],[12.073513,50.225732],[12.069463,50.227528],[12.0667,50.229717],[12.065166,50.236236],[12.062372,50.242954],[12.05783,50.25007],[12.055338,50.253123],[12.048955,50.258443],[12.040695,50.264042],[12.032537,50.268721],[12.026858,50.272646],[12.023913,50.276097],[12.022449,50.279228],[12.022069,50.285885],[12.023246,50.289725],[12.026469,50.295721],[12.027494,50.300905],[12.023667,50.308365],[12.022991,50.311529],[12.023859,50.318897],[12.023906,50.323807],[12.024742,50.324971],[12.023063,50.326337],[12.016715,50.335069],[12.012118,50.338399],[12.003643,50.342195],[11.992378,50.345261],[11.973176,50.351248],[11.971295,50.361876],[11.971703,50.374639],[11.965451,50.378015],[11.960584,50.382813],[11.956506,50.38223],[11.952486,50.379655],[11.948009,50.377874],[11.942694,50.376789],[11.930037,50.375419],[11.921834,50.376734],[11.9163,50.376832],[11.912619,50.376055],[11.89113,50.369158],[11.887825,50.367543],[11.880863,50.362622],[11.863203,50.35274],[11.858576,50.35091],[11.85044,50.348645],[11.845381,50.344834],[11.841755,50.343114],[11.836904,50.342629],[11.827707,50.342996],[11.820911,50.341153],[11.817642,50.338521],[11.814272,50.334622],[11.810376,50.332323],[11.804157,50.330741],[11.794931,50.325443],[11.792119,50.325676],[11.791009,50.326993],[11.786751,50.339511],[11.787641,50.347865],[11.78121,50.358268],[11.783314,50.362427],[11.792334,50.372088],[11.763983,50.395944],[11.763718,50.400669],[11.764997,50.402387],[11.771229,50.404201],[11.774602,50.406136],[11.776879,50.410241],[11.779427,50.413276],[11.783132,50.416381],[11.787281,50.418705],[11.790598,50.421873],[11.792375,50.42464],[11.798787,50.431758],[11.802414,50.437388],[11.803592,50.440182],[11.803466,50.442565],[11.799983,50.451034],[11.799391,50.453538],[11.79973,50.457234],[11.803296,50.465301],[11.804125,50.469609],[11.801923,50.478949],[11.805881,50.488124],[11.8056,50.490535],[11.803385,50.493375],[11.796179,50.497203],[11.793009,50.501017],[11.792644,50.503785],[11.794151,50.507398],[11.796573,50.510232],[11.798246,50.513864],[11.799084,50.52334],[11.800823,50.526379],[11.803915,50.530074],[11.80536,50.534205],[11.805434,50.536538],[11.80402,50.540744],[11.801968,50.543508],[11.793494,50.549962],[11.791727,50.553142],[11.789521,50.559341],[11.787743,50.561369],[11.778707,50.567574],[11.775015,50.571906],[11.774957,50.576335],[11.790462,50.604798],[11.792041,50.610217],[11.792995,50.62097],[11.793745,50.62397],[11.800603,50.642731],[11.803704,50.648242],[11.813102,50.656647],[11.815775,50.65951],[11.823117,50.672262],[11.830651,50.682338],[11.841697,50.697886],[11.84372,50.700428],[11.851129,50.707329],[11.8532,50.71155],[11.852859,50.716811],[11.848878,50.724027],[11.847742,50.727583],[11.847947,50.730624],[11.849219,50.733453],[11.861931,50.749296],[11.863721,50.751239],[11.876459,50.76118],[11.878682,50.764661],[11.879937,50.772757],[11.880806,50.775162],[11.882886,50.777502],[11.891911,50.782954],[11.894019,50.784945],[11.895427,50.789736],[11.895671,50.807902],[11.893956,50.812851],[11.885899,50.819547],[11.883704,50.821985],[11.879145,50.829977],[11.867574,50.839849],[11.863176,50.844289],[11.85732,50.853382],[11.854722,50.857982],[11.847472,50.876285],[11.843854,50.897726],[11.840485,50.920106],[11.839905,50.923009],[11.835906,50.937044],[11.834161,50.944583],[11.834135,50.946964],[11.838635,50.953897],[11.841035,50.956026],[11.853821,50.961459],[11.90056,50.985497],[11.901641,50.985805],[11.914329,50.99332],[11.91601,50.99547],[11.941054,51.037347],[11.941207,51.04419],[11.942616,51.048236],[11.952194,51.06337],[11.955123,51.070655],[11.955694,51.075374],[11.956103,51.115482],[11.957468,51.121815],[11.961121,51.127673],[11.997874,51.169437],[12.000619,51.1729],[12.016103,51.195871],[12.020531,51.201102],[12.029778,51.208388],[12.037281,51.214656],[12.06068,51.238438],[12.070506,51.248278],[12.073394,51.250754],[12.078642,51.254224],[12.110904,51.272409],[12.119755,51.279041],[12.133967,51.288275],[12.149563,51.30103],[12.151235,51.302589],[12.174268,51.328247],[12.184568,51.342732],[12.186749,51.346785],[12.189535,51.361472],[12.18927,51.365877],[12.181313,51.390626],[12.181103,51.396849],[12.182708,51.400584],[12.194302,51.420723],[12.199591,51.429639],[12.215293,51.457209],[12.21651,51.460841],[12.216723,51.46717],[12.214855,51.476145],[12.212414,51.48228],[12.206855,51.489821],[12.198346,51.512948],[12.197428,51.513581],[12.196963,51.530522],[12.196513,51.532943],[12.190564,51.54927],[12.189275,51.553466],[12.190466,51.557352],[12.194817,51.562812],[12.197793,51.563062],[12.196669,51.564531],[12.191717,51.559106],[12.189307,51.55788],[12.187267,51.559914],[12.190891,51.574215],[12.191197,51.577399],[12.190546,51.580578],[12.183846,51.595958],[12.183474,51.602148],[12.184752,51.605794],[12.19856,51.639236],[12.201436,51.649664],[12.217108,51.732282],[12.218086,51.736021],[12.221524,51.743357],[12.226305,51.750077],[12.236447,51.762861],[12.239942,51.765941],[12.243706,51.768179],[12.260941,51.777389],[12.265374,51.779964],[12.268512,51.782673],[12.273223,51.789659],[12.283418,51.802067],[12.28655,51.805274],[12.289604,51.80745],[12.298677,51.812866],[12.30235,51.815453],[12.316993,51.829946],[12.319753,51.832999],[12.326245,51.843517],[12.328763,51.846915],[12.332158,51.850028],[12.335818,51.852404],[12.340816,51.854794],[12.362396,51.864153],[12.367524,51.866161],[12.377495,51.86946],[12.382331,51.871526],[12.386604,51.874123],[12.390325,51.877214],[12.410234,51.900215],[12.415791,51.904573],[12.435705,51.91451],[12.441371,51.919514],[12.443118,51.922417],[12.449259,51.936166],[12.456078,51.952591],[12.4584,51.956334],[12.464658,51.961318],[12.484045,51.970056],[12.503787,51.975288],[12.513649,51.97855],[12.533027,51.98554],[12.536928,51.98741],[12.554861,51.999384],[12.558389,52.001929],[12.568135,52.010256],[12.575675,52.014442],[12.594178,52.021997],[12.598104,52.024056],[12.603841,52.029085],[12.608755,52.031489],[12.613985,52.03263],[12.618927,52.034693],[12.62599,52.041317],[12.641303,52.048362],[12.646051,52.051756],[12.649108,52.055365],[12.658058,52.069149],[12.660652,52.072726],[12.666631,52.079079],[12.670385,52.082243],[12.682635,52.091127],[12.687049,52.093895],[12.696217,52.098549],[12.712096,52.109537],[12.716698,52.112273],[12.7351,52.120149],[12.743034,52.124511],[12.783565,52.159734],[12.78726,52.16253],[12.792355,52.165048],[12.79823,52.16679],[12.828236,52.173894],[12.836389,52.177285],[12.852108,52.18889],[12.856458,52.190946],[12.862015,52.19263],[12.871278,52.194686],[12.876179,52.196306],[12.88044,52.198407],[12.883947,52.200923],[12.891595,52.207946],[12.913373,52.248092],[12.908997,52.255758],[12.907717,52.258799],[12.907323,52.262062],[12.907936,52.26525],[12.915075,52.28614],[12.917228,52.289559],[12.921661,52.291242],[12.947104,52.297062],[12.975024,52.303327],[12.980906,52.303632],[13.024358,52.300205],[13.033209,52.298143],[13.038619,52.298675],[13.044904,52.300721],[13.050527,52.301111],[13.070049,52.300315],[13.076224,52.299673],[13.08129,52.299775],[13.085163,52.30215],[13.094502,52.316338],[13.104098,52.325547],[13.107311,52.328292],[13.112637,52.33045],[13.133697,52.336625],[13.138109,52.339246],[13.140449,52.34217],[13.141114,52.345823],[13.140796,52.359492],[13.142137,52.363035],[13.148239,52.36708],[13.150239,52.370368],[13.150166,52.379637],[13.153561,52.385619],[13.156594,52.389074],[13.160864,52.390866],[13.175246,52.3943],[13.179381,52.395876],[13.183384,52.398581],[13.194613,52.408635],[13.196947,52.411121],[13.197348,52.41501],[13.195267,52.423437],[13.192812,52.425314],[13.191045,52.428112],[13.192525,52.43303],[13.19443,52.435713],[13.238988,52.470942],[13.253116,52.483185],[13.275807,52.50105],[13.279508,52.501756],[13.280824,52.499193],[13.28624,52.494299],[13.291035,52.49371],[13.297595,52.489674],[13.306671,52.482881],[13.313333,52.479664],[13.318696,52.478095],[13.330161,52.477878],[13.33952,52.478613],[13.345955,52.477644],[13.349615,52.474777],[13.353519,52.473498],[13.359244,52.474138],[13.363302,52.473772],[13.367619,52.471721],[13.376062,52.470025],[13.385644,52.469711],[13.390376,52.469041],[13.399395,52.465615],[13.406672,52.461806],[13.414792,52.460634],[13.442206,52.462731],[13.454179,52.463956],[13.457403,52.46621],[13.46445,52.470166],[13.45897,52.472425],[13.438597,52.482467],[13.436388,52.482209]]]}}"

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	var _elements = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuHeight = _elements.articles[0].fixed.getElementsByClassName('language-switch')[0].getBoundingClientRect().bottom;
	
	var menuShortened = false;
	
	init();
	_windowDimensions2.default.onResize(init);
	
	function init() {
	    var shouldShorten = menuHeight > _windowDimensions2.default.height;
	
	    if (shouldShorten === menuShortened) {
	        return;
	    }
	
	    (0, _lodash.forEach)(_elements.articles, function (article) {
	        article.fixed.classList.toggle('is-short-menu', shouldShorten);
	    });
	
	    menuShortened = shouldShorten;
	}

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	var leftButton = document.getElementsByClassName('mode-switch-bar-left')[0];
	var rightButton = document.getElementsByClassName('mode-switch-bar-right')[0];
	
	var nav = false;
	var map = false;
	
	window.addEventListener('hashchange', reset);
	
	rightButton.addEventListener('click', function () {
	    if (nav) {
	        return reset();
	    }
	
	    toggleMap(true);
	});
	
	leftButton.addEventListener('click', function () {
	    if (map) {
	        return reset();
	    }
	
	    toggleNav(true);
	});
	
	function reset() {
	    toggleMap(false);
	    toggleNav(false);
	}
	
	function toggleMap(toggle) {
	    map = toggle;
	    document.body.classList.toggle('is-showing-map', toggle);
	}
	
	function toggleNav(toggle) {
	    nav = toggle;
	    document.body.classList.toggle('is-showing-nav', toggle);
	}

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** app.js
 **/